/*
 * @license
 * Pipeline Theme (c) Groupthought Themes
 *
 * The contents of this file should not be modified.
 * add any minor changes to assets/custom.js
 *
 */
!(function (e, t, i, s, r, n, o, a, l, c, h) {
  "use strict";
  function d(e) {
    var t = Object.create(null);
    return (
      e &&
        Object.keys(e).forEach(function (i) {
          if ("default" !== i) {
            var s = Object.getOwnPropertyDescriptor(e, i);
            Object.defineProperty(
              t,
              i,
              s.get
                ? s
                : {
                    enumerable: !0,
                    get: function () {
                      return e[i];
                    },
                  }
            );
          }
        }),
      (t.default = e),
      Object.freeze(t)
    );
  }
  var u = d(r);
  function p(e) {
    const t = e.querySelectorAll("[data-modal]"),
      i = document.querySelector("[data-modal-container]");
    t.forEach((e) => {
      i.querySelector(`[id="${e.id}"]`) || i.appendChild(e);
    });
  }
  function m(e) {
    e.querySelectorAll(".float__wrapper").forEach((e) => {
      const t = e.querySelector("label"),
        i = e.querySelector("input, textarea");
      t &&
        i.addEventListener("keyup", (e) => {
          "" !== e.target.value
            ? t.classList.add("label--float")
            : t.classList.remove("label--float");
        }),
        i && i.value && i.value.length && t.classList.add("label--float");
    });
  }
  function f(e) {
    e.querySelectorAll(".errors").forEach((e) => {
      e.setAttribute("tabindex", "0"),
        e.setAttribute("aria-live", "assertive"),
        e.setAttribute("role", "alert");
    });
  }
  function g(e) {
    e.querySelectorAll("img").forEach((e) => {
      e.complete && e.parentNode.classList.remove("loading-shimmer");
    });
  }
  function y() {
    const e = {};
    return (
      (e.windowHeight = window.innerHeight),
      (e.announcementHeight = w("[data-announcement-bar]")),
      (e.toolbarHeight = w("[data-toolbar-height]")),
      (e.footerHeight = w('[data-section-type*="footer"]')),
      (e.menuHeight = w("[data-header-height]")),
      (e.headerHeight = e.menuHeight + e.announcementHeight),
      (e.logoHeight = (function () {
        const e = w("[data-footer-logo]");
        return e > 0 ? e + 20 : 0;
      })()),
      (e.stickyHeader = document.querySelector('[data-header-sticky="sticky"]')
        ? e.menuHeight
        : 0),
      (e.backfillHeight = w("[data-header-backfill]")),
      e
    );
  }
  function v() {
    document.addEventListener("theme:resize", b),
      (function () {
        const {
          windowHeight: e,
          announcementHeight: t,
          toolbarHeight: i,
          headerHeight: s,
          logoHeight: r,
          menuHeight: n,
          footerHeight: o,
          stickyHeader: a,
          backfillHeight: l,
        } = y();
        document.documentElement.style.setProperty(
          "--scrollbar-width",
          `${S()}px`
        ),
          document.documentElement.style.setProperty("--footer-logo", `${r}px`),
          document.documentElement.style.setProperty("--full-screen", `${e}px`),
          document.documentElement.style.setProperty(
            "--three-quarters",
            0.75 * e + "px"
          ),
          document.documentElement.style.setProperty(
            "--two-thirds",
            0.66 * e + "px"
          ),
          document.documentElement.style.setProperty(
            "--one-half",
            0.5 * e + "px"
          ),
          document.documentElement.style.setProperty(
            "--one-third",
            0.33 * e + "px"
          ),
          document.documentElement.style.setProperty(
            "--one-fifth",
            0.2 * e + "px"
          ),
          document.documentElement.style.setProperty("--menu-height", `${n}px`),
          document.documentElement.style.setProperty(
            "--announcement-height",
            `${t}px`
          ),
          document.documentElement.style.setProperty(
            "--toolbar-height",
            `${i}px`
          ),
          document.documentElement.style.setProperty(
            "--header-height",
            `${s}px`
          ),
          document.documentElement.style.setProperty(
            "--footer-height",
            `${o}px`
          ),
          document.documentElement.style.setProperty(
            "--content-full",
            e - s - r / 2 + "px"
          ),
          document.documentElement.style.setProperty(
            "--menu-height-sticky",
            `${a}px`
          );
        let c = Math.abs(l - n) > 1 ? `${n}px` : "auto";
        document.documentElement.style.setProperty("--menu-backfill-height", c);
      })();
  }
  function b() {
    const {
      windowHeight: e,
      announcementHeight: t,
      toolbarHeight: i,
      headerHeight: s,
      logoHeight: r,
      menuHeight: n,
      footerHeight: o,
      stickyHeader: a,
      backfillHeight: l,
    } = y();
    document.documentElement.style.setProperty("--scrollbar-width", `${S()}px`),
      document.documentElement.style.setProperty("--full-screen", `${e}px`),
      document.documentElement.style.setProperty("--menu-height", `${n}px`),
      document.documentElement.style.setProperty(
        "--announcement-height",
        `${t}px`
      ),
      document.documentElement.style.setProperty("--toolbar-height", `${i}px`),
      document.documentElement.style.setProperty("--header-height", `${s}px`),
      document.documentElement.style.setProperty("--footer-height", `${o}px`),
      document.documentElement.style.setProperty(
        "--content-full",
        e - s - r / 2 + "px"
      ),
      document.documentElement.style.setProperty(
        "--menu-height-sticky",
        `${a}px`
      );
    let c = Math.abs(l - n) > 1 ? `${n}px` : "auto";
    document.documentElement.style.setProperty("--menu-backfill-height", c);
  }
  function w(e) {
    const t = document.querySelector(e);
    return t ? t.clientHeight : 0;
  }
  function S() {
    const e = document.createElement("div");
    (e.style.visibility = "hidden"),
      (e.style.overflow = "scroll"),
      (e.style.msOverflowStyle = "scrollbar"),
      document.body.appendChild(e);
    const t = document.createElement("div");
    e.appendChild(t);
    const i = e.offsetWidth - t.offsetWidth;
    return e.parentNode.removeChild(e), i;
  }
  function E(e, t) {
    let i = 64,
      s = 0;
    t.forEach((e) => {
      if (e.offsetHeight > s) {
        const t =
          parseInt(window.getComputedStyle(e).marginTop) +
          parseInt(window.getComputedStyle(e).marginBottom);
        t > i && (i = t), (s = e.offsetHeight);
      }
    });
    const r = e.querySelectorAll("[data-overflow-background]");
    [e, ...r].forEach((e) => {
      e.style.setProperty(
        "min-height",
        `calc(${s + i}px + var(--menu-height))`
      );
    });
  }
  function L(e) {
    let t = document.querySelector("[data-footer-logo]")
      ? document.querySelector("[data-footer-logo]").clientHeight + 20
      : 0;
    const i = document.querySelector(
        "#MainContent .shopify-section:last-child [data-section-id]"
      ),
      s = i ? i.getAttribute("data-section-id") : null;
    if (
      (((null !== s && e.getAttribute("data-section-id") !== s) || !i) &&
        (t = 0),
      window.innerWidth < window.theme.sizes.medium)
    ) {
      return void e.querySelectorAll("[data-overflow-frame]").forEach((e) => {
        const t = e.querySelectorAll("[data-overflow-content]");
        E(e, t);
      });
    }
    const r = document.createElement("div");
    e.prepend(r),
      (r.style.display = "none"),
      (r.style.width = getComputedStyle(e).getPropertyValue("--outer"));
    const n = 2 * parseInt(getComputedStyle(r).getPropertyValue("width"));
    e.firstChild.remove();
    let o = 0;
    const a = e.querySelectorAll("[data-overflow-frame]");
    e.querySelectorAll("[data-overflow-content]").forEach((e) => {
      e.offsetHeight > o && (o = e.offsetHeight);
    });
    [...a, ...e.querySelectorAll("[data-overflow-background]")].forEach((e) => {
      e.style.setProperty("min-height", `${o + n}px`);
    }),
      e.style.setProperty("min-height", `${o + n + 2 + t}px`);
  }
  function k(e) {
    const i = e.querySelectorAll(".js-overflow-container");
    if (i) {
      i.forEach((e) => {
        const t = e.querySelectorAll(".js-overflow-content");
        E(e, t),
          document.addEventListener("theme:resize", () => {
            E(e, t);
          });
      });
      const s = e.querySelectorAll("[data-slideshow-wrapper]");
      s.length &&
        s.forEach((e) => {
          const i = t.data(e);
          void 0 !== i && i.reloadCells();
        });
    }
    const s = e.querySelectorAll("[data-overflow-wrapper]");
    s &&
      s.forEach((e) => {
        L(e),
          document.addEventListener("theme:resize", () => {
            L(e);
          });
      });
  }
  function T(e, t = 500, i = !1) {
    var s, r, n, o, a;
    function l() {
      var c = Date.now() - o;
      c < t && c >= 0
        ? (s = setTimeout(l, t - c))
        : ((s = null), i || ((a = e.apply(n, r)), (n = r = null)));
    }
    null == t && (t = 100);
    var c = function () {
      (n = this), (r = arguments), (o = Date.now());
      var c = i && !s;
      return (
        s || (s = setTimeout(l, t)),
        c && ((a = e.apply(n, r)), (n = r = null)),
        a
      );
    };
    return (
      (c.clear = function () {
        s && (clearTimeout(s), (s = null));
      }),
      (c.flush = function () {
        s && ((a = e.apply(n, r)), (n = r = null), clearTimeout(s), (s = null));
      }),
      c
    );
  }
  !(function () {
    const e = { NODE_ENV: "production" };
    try {
      if (process)
        return (
          (process.env = Object.assign({}, process.env)),
          void Object.assign(process.env, e)
        );
    } catch (e) {}
    globalThis.process = { env: e };
  })(),
    (window.requestIdleCallback =
      window.requestIdleCallback ||
      function (e) {
        var t = Date.now();
        return setTimeout(function () {
          e({
            didTimeout: !1,
            timeRemaining: function () {
              return Math.max(0, 50 - (Date.now() - t));
            },
          });
        }, 1);
      }),
    (window.cancelIdleCallback =
      window.cancelIdleCallback ||
      function (e) {
        clearTimeout(e);
      });
  let x,
    _ = window.innerWidth,
    A = window.innerHeight;
  function q() {
    document.dispatchEvent(new CustomEvent("theme:resize", { bubbles: !0 })),
      _ !== window.innerWidth &&
        (document.dispatchEvent(
          new CustomEvent("theme:resize:width", { bubbles: !0 })
        ),
        (_ = window.innerWidth)),
      A !== window.innerHeight &&
        (document.dispatchEvent(
          new CustomEvent("theme:resize:height", { bubbles: !0 })
        ),
        (A = window.innerHeight));
  }
  let C = window.pageYOffset,
    P = null,
    $ = null,
    I = null,
    M = null,
    D = 0;
  function O() {
    const e = window.pageYOffset;
    e > C
      ? (($ = !0), (P = !1))
      : e < C
      ? (($ = !1), (P = !0))
      : ((P = null), ($ = null)),
      (C = e),
      document.dispatchEvent(
        new CustomEvent("theme:scroll", {
          detail: { up: P, down: $, position: e },
          bubbles: !1,
        })
      ),
      P &&
        !I &&
        document.dispatchEvent(
          new CustomEvent("theme:scroll:up", {
            detail: { position: e },
            bubbles: !1,
          })
        ),
      $ &&
        !M &&
        document.dispatchEvent(
          new CustomEvent("theme:scroll:down", {
            detail: { position: e },
            bubbles: !1,
          })
        ),
      (M = $),
      (I = P);
  }
  function H(e) {
    setTimeout(() => {
      D && clearTimeout(D),
        i.disablePageScroll(e.detail, {
          allowTouchMove: (e) => "TEXTAREA" === e.tagName,
        }),
        document.documentElement.setAttribute("data-scroll-locked", "");
    });
  }
  function F(e) {
    const t = e.detail;
    t ? (D = setTimeout(B, t)) : B();
  }
  function B() {
    i.clearQueueScrollLocks(),
      i.enablePageScroll(),
      document.documentElement.removeAttribute("data-scroll-locked");
  }
  window.addEventListener("resize", () => {
    x && window.cancelAnimationFrame(x),
      (x = window.requestAnimationFrame(T(q, 50)));
  }),
    (function () {
      let e;
      window.addEventListener(
        "scroll",
        function () {
          e && window.cancelAnimationFrame(e),
            (e = window.requestAnimationFrame(O));
        },
        { passive: !0 }
      ),
        window.addEventListener("theme:scroll:lock", H),
        window.addEventListener("theme:scroll:unlock", F);
    })(),
    g(document),
    document.addEventListener(
      "load",
      (e) => {
        !(function (e) {
          "IMG" == e.tagName &&
            e.parentNode.classList.contains("loading-shimmer") &&
            e.parentNode.classList.remove("loading-shimmer");
        })(e.target);
      },
      !0
    ),
    window.addEventListener("DOMContentLoaded", () => {
      v(),
        m(document),
        f(document),
        p(document),
        window.theme.settings.animate_scroll && e.refresh();
    }),
    window.addEventListener("load", () => {
      k(document), g(document);
    }),
    document.addEventListener("shopify:section:load", (t) => {
      const i = t.target;
      m(i),
        f(i),
        p(i),
        k(i),
        window.theme.settings.animate_scroll && e.refresh();
    }),
    document.addEventListener("shopify:section:reorder", () => {
      document.dispatchEvent(
        new CustomEvent("theme:header:check", { bubbles: !1 })
      );
    });
  const W = (e, t = !1, i = "block") => {
    e && (t ? e.style.removeProperty("display") : (e.style.display = i));
  };
  function N(e) {
    (this.status = e.status || null),
      (this.headers = e.headers || null),
      (this.json = e.json || null),
      (this.body = e.body || null);
  }
  N.prototype = Error.prototype;
  const R = "data-scrollbar-slider",
    j = "[data-scrollbar-arrow-prev]",
    z = "[data-scrollbar-arrow-next]",
    V = "is-hidden",
    U = 200;
  let G = class {
    init() {
      this.arrowNext &&
        this.arrowPrev &&
        (window.isRTL ? this.togglePrevArrow() : this.toggleNextArrow(),
        this.events());
    }
    resize() {
      document.addEventListener("theme:resize", () => {
        window.isRTL ? this.togglePrevArrow() : this.toggleNextArrow();
      });
    }
    events() {
      this.arrowNext.addEventListener("click", (e) => {
        e.preventDefault(), this.goToNext();
      }),
        this.arrowPrev.addEventListener("click", (e) => {
          e.preventDefault(), this.goToPrev();
        }),
        this.scrollbar.addEventListener("scroll", () => {
          this.togglePrevArrow(), this.toggleNextArrow();
        });
    }
    goToNext() {
      const e =
        this.scrollbar.getBoundingClientRect().width / 2 +
        this.scrollbar.scrollLeft;
      this.move(e), this.arrowPrev.classList.remove(V), this.toggleNextArrow();
    }
    goToPrev() {
      const e =
        this.scrollbar.scrollLeft -
        this.scrollbar.getBoundingClientRect().width / 2;
      this.move(e), this.arrowNext.classList.remove(V), this.togglePrevArrow();
    }
    toggleNextArrow() {
      setTimeout(() => {
        window.isRTL
          ? this.arrowNext.classList.toggle(V, 0 === this.scrollbar.scrollLeft)
          : this.arrowNext.classList.toggle(
              V,
              Math.round(
                this.scrollbar.scrollLeft +
                  this.scrollbar.getBoundingClientRect().width +
                  1
              ) >= this.scrollbar.scrollWidth
            );
      }, U);
    }
    togglePrevArrow() {
      setTimeout(() => {
        window.isRTL
          ? this.arrowPrev.classList.toggle(
              V,
              Math.abs(this.scrollbar.scrollLeft) +
                this.scrollbar.getBoundingClientRect().width +
                1 >=
                this.scrollbar.scrollWidth
            )
          : this.arrowPrev.classList.toggle(V, this.scrollbar.scrollLeft <= 0);
      }, U);
    }
    scrollToVisibleElement() {
      [].forEach.call(this.scrollbar.children, (e) => {
        e.addEventListener("click", (t) => {
          ("a" === t.target.tagName.toLowerCase() ||
            (t.currentTarget &&
              "a" === t.currentTarget.tagName.toLowerCase()) ||
            (t.currentTarget && t.currentTarget.querySelector("a"))) &&
            t.preventDefault(),
            this.move(e.offsetLeft - e.clientWidth);
        });
      });
    }
    move(e) {
      this.scrollbar.scrollTo({ top: 0, left: e, behavior: "smooth" });
    }
    constructor(e) {
      (this.scrollbar = e),
        (this.arrowNext = this.scrollbar.parentNode.querySelector(z)),
        (this.arrowPrev = this.scrollbar.parentNode.querySelector(j)),
        this.init(),
        this.resize(),
        this.scrollbar.hasAttribute(R) && this.scrollToVisibleElement();
    }
  };
  const J = "[data-sibling-inner]";
  let Q = class {
    init() {
      this.siblings.forEach((e) => {
        new G(e);
      });
    }
    constructor(e) {
      (this.siblings = e.querySelectorAll(J)), this.init();
    }
  };
  const K = {
      onLoad() {
        new Q(this.container);
      },
    },
    Y = { expires: 7, path: "/", domain: window.location.hostname };
  let X = class {
    write(e) {
      document.cookie = `${this.options.name}=${e}; expires=${this.options.expires}; path=${this.options.path}; domain=${this.options.domain}`;
    }
    read() {
      let e = [];
      const t = document.cookie
        .split("; ")
        .find((e) => e.startsWith(this.options.name));
      if (-1 !== document.cookie.indexOf("; ") && t) {
        const t = document.cookie
          .split("; ")
          .find((e) => e.startsWith(this.options.name))
          .split("=")[1];
        null !== t && (e = t.split(","));
      }
      return e;
    }
    destroy() {
      document.cookie = `${this.options.name}=null; expires=${this.options.expires}; path=${this.options.path}; domain=${this.options.domain}`;
    }
    remove(e) {
      const t = this.read(),
        i = t.indexOf(e);
      -1 !== i && (t.splice(i, 1), this.write(t));
    }
    constructor(e = {}) {
      this.options = { ...Y, ...e };
    }
  };
  const Z = 4,
    ee = 10,
    te = "[data-recently-viewed-products]",
    ie = "data-limit",
    se = "[data-recent-link-tab]",
    re = "[data-recent-wrapper]",
    ne = "[data-recently-viewed-tab]",
    oe = "[data-tabs-holder-scroll]",
    ae = "[data-api-content]",
    le = "data-minimum",
    ce = "data-item-id",
    he = "hide",
    de = "section-without-title--skip",
    ue = { expires: 90, name: "shopify_recently_viewed" },
    pe = [],
    me = [];
  const fe = {
    onLoad() {
      pe[this.id] = new (class {
        renderProducts() {
          const e = this.cookie.read(),
            t = [];
          let i = 0;
          if (e.length > 0) {
            for (let s = 0; s < e.length; s++) {
              const r = e[s];
              if (me.includes(r)) continue;
              const n = `${window.theme.routes.root_url}products/${r}?section_id=api-product-grid-item`;
              if (
                (t.push(n), i++, i === this.howManyToShow || i === e.length - 1)
              )
                break;
            }
            if (t.length > 0 && t.length >= this.minimum) {
              this.container.classList.remove(he),
                this.recentViewedLink &&
                  this.recentViewedLink.previousElementSibling &&
                  (this.tabsHolderScroll.classList.remove(he),
                  this.container.classList.add(de));
              const e = t.map((e) =>
                  fetch(e, { mode: "no-cors" }).then(this.handleErrors)
                ),
                i = [];
              Promise.allSettled(e)
                .then((e) =>
                  Promise.all(
                    e.map(async (e) => {
                      "fulfilled" === e.status && i.push(await e.value.text());
                    })
                  )
                )
                .then(() => {
                  i.forEach((e) => {
                    const t = document.createElement("div"),
                      i = document.createElement("div");
                    (t.innerHTML = e),
                      "" === t.querySelector(`[${ce}]`).getAttribute(ce) ||
                        (i.classList.add("product-grid-slide"),
                        i.setAttribute("data-carousel-slide", null),
                        i.setAttribute("data-item", null),
                        (i.innerHTML = t.querySelector(ae).innerHTML),
                        this.wrapper.appendChild(i));
                  }),
                    new Q(this.container);
                })
                .then(() => {
                  W(this.wrapper, !0),
                    this.container.dispatchEvent(
                      new CustomEvent("theme:recent-products:added", {
                        bubbles: !0,
                      })
                    );
                });
            } else if (this.recentViewedTab) {
              const e =
                Array.prototype.filter.call(
                  this.recentViewedTab.parentNode.children,
                  (e) => e !== this.recentViewedTab
                ).length > 1;
              this.recentViewedLink &&
                this.recentViewedLink.previousElementSibling &&
                (this.tabsHolderScroll.classList.add(he),
                this.container.classList.remove(de)),
                e || this.container.classList.add(he);
            } else this.container.classList.add(he);
          }
        }
        handleErrors(e) {
          return e.ok
            ? e
            : e.text().then(function (t) {
                throw new N({
                  status: e.statusText,
                  headers: e.headers,
                  text: t,
                });
              });
        }
        constructor(e) {
          (this.container = e.container),
            (this.cookie = new X(ue)),
            (this.wrapper = this.container.querySelector(te)),
            null !== this.wrapper &&
              ((this.howManyToShow =
                parseInt(this.container.querySelector(re).getAttribute(ie)) ||
                Z),
              (this.minimum = parseInt(
                this.container.querySelector(re).getAttribute(le)
              )),
              (this.recentViewedTab = this.container.querySelector(ne)),
              (this.recentViewedLink = this.container.querySelector(se)),
              (this.tabsHolderScroll = this.container.querySelector(oe)),
              this.renderProducts());
        }
      })(this);
    },
  };
  function ge() {
    const e = "(any-pointer: coarse)",
      t = `(max-width: ${window.theme.sizes.medium}px)`,
      i = `(min-width: ${window.theme.sizes.medium + 1}px) and (max-width: ${
        window.theme.sizes.large
      }px)`,
      s = `(min-width: ${window.theme.sizes.large + 1}px)`;
    (ge.isTouch = () => {
      const t = window.matchMedia(e).matches;
      return document.documentElement.classList.toggle("supports-touch", t), t;
    }),
      (ge.isMobile = () => window.matchMedia(t).matches),
      (ge.isTablet = () => window.matchMedia(i).matches),
      (ge.isDesktop = () => window.matchMedia(s).matches);
    const r = [
      [e, ge.isTouch],
      [t, ge.isMobile],
      [i, ge.isTablet],
      [s, ge.isDesktop],
    ];
    ge.onChange = (e) => {
      r.forEach((t) => {
        window.matchMedia(t[0]).addEventListener("change", () => {
          t[1]() && e && e();
        });
      });
    };
  }
  function ye() {
    this.entries = [];
  }
  function ve(e, t) {
    be(e);
    var i = (function (e, t) {
      be(e),
        (function (e) {
          if (!Array.isArray(e)) throw new TypeError(e + " is not an array.");
          if (0 === e.length) throw new Error(e + " is empty.");
          if (!e[0].hasOwnProperty("name"))
            throw new Error(e[0] + "does not contain name key.");
          if ("string" != typeof e[0].name)
            throw new TypeError(
              "Invalid value type passed for name of option " +
                e[0].name +
                ". Value should be string."
            );
        })(t);
      var i = [];
      return (
        t.forEach(function (t) {
          for (var s = 0; s < e.options.length; s++) {
            if (
              (e.options[s].name || e.options[s]).toLowerCase() ===
              t.name.toLowerCase()
            ) {
              i[s] = t.value;
              break;
            }
          }
        }),
        i
      );
    })(e, t);
    return (function (e, t) {
      return (
        be(e),
        (function (e) {
          if (Array.isArray(e) && "object" == typeof e[0])
            throw new Error(e + "is not a valid array of options.");
        })(t),
        e.variants.filter(function (e) {
          return t.every(function (t, i) {
            return e.options[i] === t;
          });
        })[0] || null
      );
    })(e, i);
  }
  function be(e) {
    if ("object" != typeof e) throw new TypeError(e + " is not an object.");
    if (0 === Object.keys(e).length && e.constructor === Object)
      throw new Error(e + " is empty.");
  }
  ge(),
    (ye.prototype.add = function (e, t, i) {
      this.entries.push({ element: e, event: t, fn: i }),
        e.addEventListener(t, i);
    }),
    (ye.prototype.removeAll = function () {
      this.entries = this.entries.filter(function (e) {
        return e.element.removeEventListener(e.event, e.fn), !1;
      });
    });
  var we = '[name="id"]',
    Se = '[name="selling_plan"]',
    Ee = '[name^="options"]',
    Le = '[name="quantity"]',
    ke = '[name^="properties"]';
  const Te = {};
  function xe(e = {}) {
    if ((e.type || (e.type = "json"), e.url))
      return Te[e.url]
        ? Te[e.url]
        : (function (e, t) {
            const i = new Promise((i, s) => {
              "text" === t
                ? fetch(e)
                    .then((e) => e.text())
                    .then((e) => {
                      i(e);
                    })
                    .catch((e) => {
                      s(e);
                    })
                : (function (e, t, i) {
                    let s = document.getElementsByTagName("head")[0],
                      r = !1,
                      n = document.createElement("script");
                    (n.src = e),
                      (n.onload = n.onreadystatechange =
                        function () {
                          r ||
                          (this.readyState &&
                            "loaded" != this.readyState &&
                            "complete" != this.readyState)
                            ? i()
                            : ((r = !0), t());
                        }),
                      s.appendChild(n);
                  })(
                    e,
                    function () {
                      i();
                    },
                    function () {
                      s();
                    }
                  );
            });
            return (Te[e] = i), i;
          })(e.url, e.type);
    if (e.json) {
      if (Te[e.json]) return Promise.resolve(Te[e.json]);
      {
        const t = window
          .fetch(e.json)
          .then((e) => e.json())
          .then((t) => ((Te[e.json] = t), t))
          .catch((t) => {
            Te[e.json] = null;
          });
        return (Te[e.json] = t), t;
      }
    }
    if (e.name) {
      const t = "".concat(e.name, e.version);
      return Te[t]
        ? Te[t]
        : (function (e) {
            const t = "".concat(e.name, e.version),
              i = new Promise((t, i) => {
                try {
                  window.Shopify.loadFeatures([
                    {
                      name: e.name,
                      version: e.version,
                      onLoad: (e) => {
                        !(function (e, t, i) {
                          i ? t(i) : e();
                        })(t, i, e);
                      },
                    },
                  ]);
                } catch (e) {
                  i(e);
                }
              });
            return (Te[t] = i), i;
          })(e);
    }
    return Promise.reject();
  }
  const _e = "[data-swapper-wrapper]",
    Ae = "[data-swapper-target]",
    qe = "data-swapper-hover";
  let Ce = {};
  function Pe(e) {
    Ce[e.id] = [];
    e.querySelectorAll(_e).forEach((t) => {
      Ce[e.id].push(
        new (class {
          init() {
            this.hovers.forEach((e) => {
              e.addEventListener(
                "mouseenter",
                function () {
                  const t = e.getAttribute(qe);
                  this.target.innerHTML = `${t}`;
                }.bind(this)
              );
            }),
              this.hovers.forEach((e) => {
                e.addEventListener(
                  "mouseleave",
                  function () {
                    this.target.innerHTML = this.deafaultContent;
                  }.bind(this)
                );
              }),
              this.hovers.forEach((e) => {
                e.addEventListener(
                  "click",
                  function () {
                    const t = e.getAttribute(qe);
                    this.deafaultContent = `${t}`;
                  }.bind(this)
                );
              });
          }
          constructor(e) {
            (this.container = e),
              (this.target = this.container.querySelector(Ae)),
              (this.hovers = this.container.querySelectorAll(`[${qe}]`)),
              this.target &&
                this.hovers.length &&
                ((this.deafaultContent = this.target.innerHTML), this.init());
          }
        })(t)
      );
    });
  }
  const $e = {
      onLoad() {
        Pe(this.container);
      },
    },
    Ie = { color: "ash" },
    Me = "data-swatch",
    De = "[data-grid-item]",
    Oe = "data-grid-image-default",
    He = "data-grid-image-target",
    Fe = "data-swatch-image",
    Be = "data-swatch-image-id",
    We = "data-swatch-variant",
    Ne = "[data-grid-swatches]",
    Re = "[data-swatch-template]",
    je = "data-swatch-handle",
    ze = "data-swatch-label",
    Ve = "is-fade";
  let Ue = class extends HTMLElement {
    init() {
      this.setStyles(),
        this.variant &&
          this.outer &&
          this.outer.addEventListener("theme:quickview:media", (e) => {
            e && e.detail && e.detail.media && (this.media = e.detail.media);
          });
    }
    setStyles() {
      this.colorMatch.hex &&
        this.element.style.setProperty("--swatch", `${this.colorMatch.hex}`),
        this.colorMatch.path &&
          (this.element.style.setProperty(
            "background-image",
            `url(${this.colorMatch.path})`
          ),
          this.element.style.setProperty("background-size", "cover"));
    }
    replaceImage() {
      if (this.imageReplace && this.imageSlide && this.imageId) {
        if (
          this.imageSlide.hasAttribute(He) &&
          this.imageSlide.getAttribute(He) !== this.imageId
        ) {
          this.imageSlide.classList.add(Ve);
          const e =
            1e3 *
            parseFloat(
              window
                .getComputedStyle(this.imageSlide)
                .getPropertyValue("animation-duration")
            );
          setTimeout(() => {
            this.imageSlide.classList.remove(Ve);
          }, e);
        }
        this.imageSlide.setAttribute(He, this.imageId),
          this.imageSlide.style.setProperty("background-color", "#fff"),
          this.imageSlide.hasAttribute(Oe) ||
            this.imageSlide.setAttribute(
              Oe,
              window.getComputedStyle(this.imageSlide).backgroundImage
            ),
          this.imageSlide.style.setProperty(
            "background-image",
            this.imageReplace
          );
      }
    }
    constructor() {
      super(),
        (this.element = this.querySelector(`[${Me}]`)),
        (this.colorString = this.element.getAttribute(Me)),
        (this.image = this.element.getAttribute(Fe)),
        (this.imageId = this.element.getAttribute(Be)),
        (this.variant = this.element.getAttribute(We)),
        (this.outer = this.element.closest(De)),
        (this.media = null),
        (this.imageSlide = null),
        (this.imageDefault = null),
        (this.stopSlideAnimation = !1);
      const e = new (class {
        getColor() {
          return this.match;
        }
        init() {
          return xe({ json: window.theme.assets.swatches })
            .then((e) => this.matchColors(e, this.settings.color))
            .catch((e) => {
              console.log("failed to load swatch colors script"),
                console.log(e);
            });
        }
        matchColors(e, t) {
          let i = "#E5E5E5",
            s = null;
          const r = window.theme.assets.base || "/",
            n = t.toLowerCase().replace(/\s/g, ""),
            o = e.colors;
          if (o) {
            const e = (e) =>
                Object.keys(e).toString().toLowerCase().replace(/\s/g, "") ===
                n,
              t = o.findIndex(e);
            if (t > -1) {
              const e = Object.values(o[t])[0],
                n = e.toLowerCase();
              n.includes(".jpg") ||
              n.includes(".jpeg") ||
              n.includes(".png") ||
              n.includes(".svg")
                ? ((s = `${r}${encodeURIComponent(e)}`), (i = "#888888"))
                : (i = e);
            }
          }
          return { color: this.settings.color, path: s, hex: i };
        }
        constructor(e = {}) {
          (this.settings = { ...Ie, ...e }), (this.match = this.init());
        }
      })({ color: this.colorString });
      e.getColor().then((e) => {
        (this.colorMatch = e), this.init();
      });
    }
  };
  function Ge(e) {
    e.querySelectorAll(Ne).forEach((e) => {
      new (class {
        init() {
          (this.wrap.innerHTML = ""),
            this.swatches.forEach((e, t) => {
              let i = this.product.variants.find((t) => t.options.includes(e));
              const s = i.featured_media
                  ? i.featured_media.preview_image.src
                  : "",
                r = i.featured_media ? i.featured_media.id : "",
                n = Math.floor(9999 * Math.random());
              this.wrap.innerHTML += u.render(this.template, {
                color: e,
                uniq: `${this.product.id}-${i.id}-${n}`,
                variant: i.id,
                product_id: this.product.id,
                image_id: r,
                image: s,
                index: t,
              });
            }),
            new G(this.wrap);
        }
        constructor(e) {
          (this.template = document.querySelector(Re).innerHTML),
            (this.wrap = e),
            (this.handle = e.getAttribute(je));
          const t = e.getAttribute(ze).trim().toLowerCase();
          (function (e) {
            const t = `${window.theme.routes.root_url}products/${e}.js`;
            return window
              .fetch(t)
              .then((e) => e.json())
              .catch((e) => {
                console.error(e);
              });
          })(this.handle).then((e) => {
            (this.product = e),
              (this.colorOption = e.options.find(function (e) {
                return e.name.toLowerCase() === t || null;
              })),
              this.colorOption &&
                ((this.swatches = this.colorOption.values), this.init());
          });
        }
      })(e);
    });
  }
  const Je = {
      onLoad() {
        Ge(this.container), Pe(this.container);
      },
    },
    Qe = "[data-custom-scrollbar-items]",
    Ke = "[data-custom-scrollbar]",
    Ye = "[data-custom-scrollbar-track]",
    Xe = "hide",
    Ze = {};
  let et = class {
    events() {
      this.holderItems.addEventListener(
        "scroll",
        this.calculatePosition.bind(this)
      ),
        this.holderItems.addEventListener(
          "theme:carousel:scroll",
          this.calculatePosition.bind(this)
        ),
        document.addEventListener(
          "theme:resize:width",
          this.calculateTrackWidth.bind(this)
        ),
        document.addEventListener(
          "theme:resize:width",
          this.calculatePosition.bind(this)
        );
    }
    calculateTrackWidth() {
      const e = document.createElement("div");
      this.holderItems.prepend(e),
        (e.style.display = "none"),
        (e.style.width = getComputedStyle(this.holderItems).getPropertyValue(
          "--outer"
        ));
      const t = parseInt(getComputedStyle(e).getPropertyValue("width"));
      this.holderItems.firstChild.remove(),
        (this.scrollbarWidth =
          0 === this.scrollbar.clientWidth
            ? this.scrollbar.parentNode.getBoundingClientRect().width
            : this.scrollbar.clientWidth),
        setTimeout(() => {
          const e = this.children[0].clientWidth,
            i = Number(
              getComputedStyle(this.children[0]).marginRight.replace("px", "")
            ),
            s = Number(
              getComputedStyle(this.children[0]).marginLeft.replace("px", "")
            );
          (this.scrollWidth = this.children.length * (e + i + s) + t - i),
            (this.trackWidth =
              ((this.scrollbarWidth + t) / this.scrollWidth) * 100),
            (this.trackWidth = this.trackWidth < 5 ? 5 : this.trackWidth),
            this.scrollbar.style.setProperty(
              "--track-width",
              `${this.trackWidth}%`
            );
          const r = Math.ceil(this.trackWidth) >= 100;
          this.scrollbar.classList.toggle(Xe, r);
        }, 100);
    }
    calculatePosition() {
      let e =
        this.holderItems.scrollLeft /
        (this.holderItems.scrollWidth - this.holderItems.clientWidth);
      (e *= this.scrollbar.clientWidth - this.scrollbarTrack.clientWidth),
        (e = e < 0 ? 0 : e),
        (e = isNaN(e) ? 0 : e),
        this.scrollbar.style.setProperty("--position", `${Math.round(e)}px`),
        document.dispatchEvent(
          new CustomEvent("theme:scrollbar:scroll", {
            bubbles: !0,
            detail: { holder: this.holderItems },
          })
        );
    }
    constructor(e, t = null) {
      (this.holderItems = e.querySelector(Qe)),
        (this.scrollbar = e.querySelector(Ke)),
        (this.scrollbarTrack = e.querySelector(Ye)),
        (this.trackWidth = 0),
        (this.scrollWidth = 0),
        this.scrollbar &&
          this.holderItems &&
          ((this.children = t || this.holderItems.children),
          this.events(),
          this.calculateTrackWidth());
    }
  };
  const tt = {
      onLoad() {
        Ze[this.id] = new et(this.container);
      },
    },
    it = "[data-carousel]",
    st = "data-carousel-progress",
    rt = "[data-carousel-slide]",
    nt = "[data-grid-slide]",
    ot = "[data-wrapper]",
    at = "[data-carousel-track]",
    lt = "data-options",
    ct = "data-custom-scrollbar-items",
    ht = ".flickity-button.previous",
    dt = ".flickity-button.next",
    ut = "data-recently-viewed-products",
    pt = "data-related-products",
    mt = "[data-section-id]",
    ft = "flickity-force-arrows-top",
    gt = "not-moved-arrows",
    yt = "hide",
    vt = "flickity-enabled",
    bt = "hidden-arrows",
    wt = "flickity-static",
    St = 112;
  let Et = class extends HTMLElement {
    connectedCallback() {
      (this.carousel = this.container.querySelector(it)),
        (this.carouselTrack = this.container.querySelector(at)),
        (this.wrapper = this.container.closest(ot)),
        (this.section = this.container.closest(mt)),
        (this.slidesVisible = null),
        (this.carouselInstance = null),
        (this.carouselPrev = null),
        (this.carouselNext = null),
        (this.customOptions = {}),
        (this.toggleWrapperModifierEvent = () => this.toggleWrapperModifier()),
        this.carousel && this.carousel.hasAttribute(ut)
          ? this.section.addEventListener("theme:recent-products:added", () => {
              this.init();
            })
          : this.carousel && this.carousel.hasAttribute(pt)
          ? this.section.addEventListener(
              "theme:related-products:added",
              () => {
                this.init();
              }
            )
          : this.init();
    }
    init() {
      this.carousel &&
        ((this.slidesTotal = this.carousel.querySelectorAll(rt).length),
        this.getGridLayout(),
        this.trackVisibleSlides(),
        this.carousel.hasAttribute(lt) &&
          (this.customOptions = JSON.parse(
            decodeURIComponent(this.carousel.getAttribute(lt))
          )),
        this.initCarousel(),
        this.calculatedArrowsTopPosition(),
        this.toggleWrapperModifier(),
        document.addEventListener(
          "theme:resize:width",
          this.toggleWrapperModifierEvent
        ),
        this.carousel.hasAttribute(st) && this.progressBarCalculate(),
        this.carousel.hasAttribute(ct) && new et(this.container));
    }
    initCarousel() {
      (this.options = {
        accessibility: !0,
        contain: !0,
        freeScroll: !0,
        prevNextButtons: !0,
        wrapArround: !1,
        groupCells: !1,
        autoPlay: !1,
        pageDots: !1,
        cellAlign: window.isRTL ? "right" : "left",
        rightToLeft: window.isRTL,
        dragThreshold: 10,
        arrowShape: { x0: 10, x1: 60, y1: 50, x2: 65, y2: 45, x3: 20 },
        on: {
          resize: () => {
            this.toggleArrows(),
              this.calculatedArrowsTopPosition(),
              setTimeout(() => {
                this.visibleSlides();
              }, 100);
          },
        },
        ...this.customOptions,
      }),
        (this.carouselInstance = new s(this.carousel, this.options)),
        (this.carouselPrev = this.carousel.querySelector(ht)),
        (this.carouselNext = this.carousel.querySelector(dt)),
        this.container.addEventListener("theme:tab:change", () => {
          this.carouselInstance.resize(),
            (this.carouselPrev = this.carousel.querySelector(ht)),
            (this.carouselNext = this.carousel.querySelector(dt));
        }),
        this.carouselInstance.on("dragStart", () => {
          (this.carouselInstance.slider.style.pointerEvents = "none"),
            ge.isMobile || this.containDrag();
        }),
        this.carouselInstance.on("dragEnd", () => {
          (this.carouselInstance.slider.style.pointerEvents = "auto"),
            ge.isMobile || this.containDrag();
        }),
        this.carouselInstance.on("change", (e) => this.lockArrows(e)),
        setTimeout(() => {
          this.visibleSlides();
        }, 100),
        Shopify.designMode &&
          setTimeout(() => {
            this.carouselInstance.options.watchCSS &&
            !this.carousel.classList.contains(vt)
              ? (this.carouselInstance.destroy(),
                (this.carouselInstance = new s(this.carousel, this.options)),
                this.carouselInstance.resize(),
                (this.carouselPrev = this.carousel.querySelector(ht)),
                (this.carouselNext = this.carousel.querySelector(dt)))
              : this.carouselInstance.resize();
          }, 10),
        this.carousel.classList.toggle(
          wt,
          this.smallItems === this.carousel.querySelectorAll(rt).length
        ),
        Ge(this.container),
        new Q(this.container);
    }
    calculatedArrowsTopPosition() {
      const e = this.container.querySelector(nt);
      if (e) {
        const t = e.offsetHeight / 2;
        this.carousel.style.setProperty("--buttons-top", `${t}px`);
      }
    }
    toggleWrapperModifier() {
      if (!this.wrapper) return;
      const e = Number(
          getComputedStyle(document.documentElement)
            .getPropertyValue("--scrollbar-width")
            .replace("px", "")
        ),
        t = this.wrapper.clientWidth;
      (this.wrapperWidthWithGutter = t + St + e),
        window.innerWidth >= this.wrapperWidthWithGutter &&
          (this.wrapper.classList.remove(ft), this.section.classList.add(gt)),
        window.innerWidth < this.wrapperWidthWithGutter &&
          (this.wrapper.classList.add(ft), this.section.classList.remove(gt));
    }
    progressBarCalculate() {
      null !== this.carouselInstance &&
        this.carouselTrack &&
        this.carouselInstance.on("scroll", (e) => {
          (e = 100 * Math.max(0, Math.min(1, e)) + "%"),
            (this.carouselTrack.style.width = e);
        });
    }
    getGridLayout() {
      (this.largeItems =
        Number(
          getComputedStyle(this.carousel).getPropertyValue("--grid-large-items")
        ) || 3),
        (this.mediumItems =
          Number(
            getComputedStyle(this.carousel).getPropertyValue(
              "--grid-medium-items"
            )
          ) || this.largeItems),
        (this.smallItems =
          Number(
            getComputedStyle(this.carousel).getPropertyValue(
              "--grid-small-items"
            )
          ) ||
          this.mediumItems ||
          this.largeItems);
    }
    visibleSlides() {
      if (!this.carousel) return;
      this.getGridLayout();
      const e = this.carousel.clientWidth || this.carouselInstance.size.width,
        t =
          null !== this.carouselInstance &&
          this.carouselInstance.selectedElement
            ? this.carouselInstance.selectedElement.clientWidth
            : this.carousel.querySelector(rt).clientWidth,
        i =
          null !== this.carouselInstance && this.carouselInstance.slides
            ? this.carouselInstance.slides.length
            : this.carousel.querySelectorAll(rt).length,
        s = Math.floor(e / t);
      this.section.classList.remove(bt),
        this.carouselPrev &&
          this.carouselNext &&
          (this.carouselPrev.classList.remove(yt),
          this.carouselNext.classList.remove(yt)),
        window.innerWidth > window.theme.sizes.large &&
          !this.options.groupCells &&
          s <= this.largeItems &&
          i <= this.largeItems &&
          this.carouselPrev &&
          this.carouselNext &&
          this.hideArrows(),
        window.innerWidth >= window.theme.sizes.medium &&
          window.innerWidth <= window.theme.sizes.large &&
          !this.options.groupCells &&
          s <= this.mediumItems &&
          i <= this.mediumItems &&
          this.carouselPrev &&
          this.carouselNext &&
          this.hideArrows(),
        window.innerWidth < window.theme.sizes.medium &&
          !this.options.groupCells &&
          s <= this.smallItems &&
          i <= this.smallItems &&
          this.carouselPrev &&
          this.carouselNext &&
          this.hideArrows();
    }
    trackVisibleSlides() {
      const e = window.matchMedia(
          `(max-width: ${window.theme.sizes.medium - 1}px)`
        ),
        t = window.matchMedia(
          `(min-width: ${window.theme.sizes.medium}px) and (max-width: ${
            window.theme.sizes.large - 1
          }px)`
        ),
        i = window.matchMedia(`(min-width: ${window.theme.sizes.large}px)`);
      e.addEventListener("change", (e) => {
        !e.matches || (this.slidesVisible = this.smallItems);
      }),
        !e.matches || (this.slidesVisible = this.smallItems),
        t.addEventListener("change", (e) => {
          !e.matches || (this.slidesVisible = this.mediumItems);
        }),
        !t.matches || (this.slidesVisible = this.mediumItems),
        i.addEventListener("change", (e) => {
          !e.matches || (this.slidesVisible = this.largeItems);
        }),
        !i.matches || (this.slidesVisible = this.largeItems);
    }
    containDrag() {
      const e = this.slidesTotal - this.slidesVisible;
      this.carouselInstance.selectedIndex >= e &&
        (this.carouselInstance.select(e),
        this.lockArrows(this.carouselInstance.selectedIndex));
    }
    lockArrows(e) {
      if (this.options.wrapAround || this.options.groupCells) return;
      const t = parseInt(e),
        i = this.slidesTotal - this.slidesVisible;
      this.carouselNext.disabled = t >= i;
    }
    showArrows() {
      this.carouselPrev.classList.remove(yt),
        this.carouselNext.classList.remove(yt),
        this.section.classList.remove(bt);
    }
    hideArrows() {
      this.carouselPrev.classList.add(yt),
        this.carouselNext.classList.add(yt),
        this.section.classList.add(bt);
    }
    toggleArrows() {
      this.carouselPrev &&
        this.carouselNext &&
        (this.carouselPrev.disabled && this.carouselNext.disabled
          ? this.hideArrows()
          : this.showArrows());
    }
    constructor() {
      super(), (this.container = this);
    }
  };
  customElements.get("flickity-carousel") ||
    customElements.define("flickity-carousel", Et);
  const Lt = "[data-address-wrapper]",
    kt = "[data-new-address-form]",
    Tt = "[new-address-form-inner]",
    xt = ".address-new-toggle",
    _t = ".address-edit-toggle",
    At = ".address-delete",
    qt = "hide",
    Ct = "data-form-id",
    Pt = "data-confirm-message",
    $t = "Are you sure you wish to delete this address?",
    It = "#EditAddress",
    Mt = "AddressCountryNew",
    Dt = "AddressProvinceNew",
    Ot = "AddressProvinceContainerNew",
    Ht = ".address-country-option",
    Ft = "AddressCountry",
    Bt = "AddressProvince",
    Wt = "AddressProvinceContainer";
  const Nt = document.querySelector(Lt);
  Nt &&
    new (class {
      init() {
        if (this.addressNewForm) {
          const e = this.section,
            t = this.addressNewForm.querySelector(Tt);
          this.customerAddresses();
          const i = e.querySelectorAll(xt);
          i.length &&
            i.forEach((e) => {
              e.addEventListener("click", function () {
                t.classList.toggle(qt);
              });
            });
          const s = e.querySelectorAll(_t);
          s.length &&
            s.forEach((t) => {
              t.addEventListener("click", function () {
                const t = this.getAttribute(Ct);
                e.querySelector(`${It}_${t}`).classList.toggle(qt);
              });
            });
          const r = e.querySelectorAll(At);
          r.length &&
            r.forEach((e) => {
              e.addEventListener("click", function () {
                const e = this.getAttribute(Ct),
                  t = this.getAttribute(Pt);
                confirm(t || $t) &&
                  Shopify.postLink(
                    window.theme.routes.account_addresses_url + "/" + e,
                    { parameters: { _method: "delete" } }
                  );
              });
            });
        }
      }
      customerAddresses() {
        Shopify.CountryProvinceSelector &&
          new Shopify.CountryProvinceSelector(Mt, Dt, { hideElement: Ot }),
          this.section.querySelectorAll(Ht).forEach((e) => {
            const t = e.getAttribute(Ct),
              i = `${Ft}_${t}`,
              s = `${Bt}_${t}`,
              r = `${Wt}_${t}`;
            new Shopify.CountryProvinceSelector(i, s, { hideElement: r });
          });
      }
      constructor(e) {
        (this.section = e),
          (this.addressNewForm = this.section.querySelector(kt)),
          this.init();
      }
    })(Nt),
    document.querySelector("#RecoverPassword") &&
      (function () {
        var e = {
          recoverPasswordForm: "#RecoverPassword",
          hideRecoverPasswordLink: "#HideRecoverPasswordLink",
        };
        function t(e) {
          e.preventDefault(), s();
        }
        function i() {
          "#recover" === window.location.hash && s();
        }
        function s() {
          var e = document.querySelector("#CustomerEmail").value;
          (document.querySelector("#RecoverEmail").value = e),
            document
              .querySelector("#RecoverPasswordForm")
              .classList.toggle("display-none"),
            document
              .querySelector("#CustomerLoginForm")
              .classList.toggle("display-none");
        }
        function r() {
          document.querySelector(".reset-password-success") &&
            document
              .querySelector("#ResetSuccess")
              .classList.remove("display-none");
        }
        i(),
          r(),
          document
            .querySelector(e.recoverPasswordForm)
            .addEventListener("click", t),
          document
            .querySelector(e.hideRecoverPasswordLink)
            .addEventListener("click", t);
      })(),
    (window.Shopify = window.Shopify || {}),
    (window.Shopify.theme = window.Shopify.theme || {}),
    (window.Shopify.theme.sections = window.Shopify.theme.sections || {}),
    (window.Shopify.theme.sections.registered =
      window.Shopify.theme.sections.registered || {}),
    (window.Shopify.theme.sections.instances =
      window.Shopify.theme.sections.instances || []);
  const Rt = window.Shopify.theme.sections.registered,
    jt = window.Shopify.theme.sections.instances,
    zt = "data-section-id",
    Vt = "data-section-type";
  let Ut = class {
    callFunctions(e, t = null) {
      this.callStack[e].forEach((e) => {
        const i = { id: this.id, type: this.type, container: this.container };
        t ? e.call(i, t) : e.call(i);
      });
    }
    onLoad() {
      this.callFunctions("onLoad");
    }
    onUnload() {
      this.callFunctions("onUnload");
    }
    onSelect(e) {
      this.callFunctions("onSelect", e);
    }
    onDeselect(e) {
      this.callFunctions("onDeselect", e);
    }
    onBlockSelect(e) {
      this.callFunctions("onBlockSelect", e);
    }
    onBlockDeselect(e) {
      this.callFunctions("onBlockDeselect", e);
    }
    onReorder(e) {
      this.callFunctions("onReorder", e);
    }
    constructor(e, t) {
      (this.container = (function (e) {
        if (!(e instanceof Element))
          throw new TypeError(
            "Theme Sections: Attempted to load section. The section container provided is not a DOM element."
          );
        if (null === e.getAttribute(zt))
          throw new Error(
            "Theme Sections: The section container provided does not have an id assigned to the " +
              zt +
              " attribute."
          );
        return e;
      })(e)),
        (this.id = e.getAttribute(zt)),
        (this.type = t.type),
        (this.callStack = t.getStack());
      try {
        this.onLoad();
      } catch (e) {
        console.warn(`Error in section: ${this.id}`),
          console.warn(this),
          console.error(e);
      }
    }
  };
  function Gt(e, t) {
    if ("string" != typeof e)
      throw new TypeError(
        "Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered"
      );
    if (void 0 !== Rt[e])
      throw new Error(
        'Theme Sections: A section of type "' +
          e +
          '" has already been registered. You cannot register the same section type twice'
      );
    Array.isArray(t) || (t = [t]);
    const i = new (class {
      getStack() {
        return this.callStack;
      }
      constructor(e = null, t = []) {
        (this.type = e),
          (this.components = (function (e) {
            if ((void 0 !== e && "object" != typeof e) || null === e)
              throw new TypeError(
                "Theme Sections: The components object provided is not a valid"
              );
            return e;
          })(t)),
          (this.callStack = {
            onLoad: [],
            onUnload: [],
            onSelect: [],
            onDeselect: [],
            onBlockSelect: [],
            onBlockDeselect: [],
            onReorder: [],
          }),
          t.forEach((e) => {
            for (const [t, i] of Object.entries(e)) {
              const e = this.callStack[t];
              Array.isArray(e) && "function" == typeof i
                ? e.push(i)
                : (console.warn(
                    `Unregisted function: '${t}' in component: '${this.type}'`
                  ),
                  console.warn(i));
            }
          });
      }
    })(e, t);
    return (Rt[e] = i), Rt;
  }
  function Jt(e, t) {
    (e = Yt(e)),
      void 0 === t && (t = document.querySelectorAll("[" + Vt + "]")),
      (t = Xt(t)),
      e.forEach(function (e) {
        const i = Rt[e];
        void 0 !== i &&
          (t = t.filter(function (t) {
            return (
              !(Qt(t).length > 0) &&
              null !== t.getAttribute(Vt) &&
              (t.getAttribute(Vt) !== e || (jt.push(new Ut(t, i)), !1))
            );
          }));
      });
  }
  function Qt(e) {
    var t = [];
    if (NodeList.prototype.isPrototypeOf(e) || Array.isArray(e)) var i = e[0];
    if (e instanceof Element || i instanceof Element)
      Xt(e).forEach(function (e) {
        t = t.concat(
          jt.filter(function (t) {
            return t.container === e;
          })
        );
      });
    else if ("string" == typeof e || "string" == typeof i) {
      Yt(e).forEach(function (e) {
        t = t.concat(
          jt.filter(function (t) {
            return t.type === e;
          })
        );
      });
    }
    return t;
  }
  function Kt(e) {
    for (var t, i = 0; i < jt.length; i++)
      if (jt[i].id === e) {
        t = jt[i];
        break;
      }
    return t;
  }
  function Yt(e) {
    return (
      "*" === e
        ? (e = Object.keys(Rt))
        : "string" == typeof e
        ? (e = [e])
        : e.constructor === Ut
        ? (e = [e.prototype.type])
        : Array.isArray(e) &&
          e[0].constructor === Ut &&
          (e = e.map(function (e) {
            return e.type;
          })),
      (e = e.map(function (e) {
        return e.toLowerCase();
      }))
    );
  }
  function Xt(e) {
    return (
      NodeList.prototype.isPrototypeOf(e) && e.length > 0
        ? (e = Array.prototype.slice.call(e))
        : (NodeList.prototype.isPrototypeOf(e) && 0 === e.length) || null === e
        ? (e = [])
        : !Array.isArray(e) && e instanceof Element && (e = [e]),
      e
    );
  }
  function Zt(e, t) {
    (t = t || {}),
      e.focus(),
      void 0 !== t.className && e.classList.add(t.className),
      e.addEventListener("blur", function i(s) {
        s.target.removeEventListener(s.type, i),
          void 0 !== t.className && e.classList.remove(t.className);
      });
  }
  function ei(e) {
    e = e || {};
    var t = window.location.hash,
      i = document.getElementById(t.slice(1));
    if (i && e.ignore && i.matches(e.ignore)) return !1;
    t && i && Zt(i, e);
  }
  function ti(e) {
    return (
      (e = e || {}),
      Array.prototype.slice
        .call(document.querySelectorAll('a[href^="#"]'))
        .filter(function (t) {
          if ("#" === t.hash || "" === t.hash) return !1;
          if (e.ignore && t.matches(e.ignore)) return !1;
          if (((i = t.hash.substr(1)), null === document.getElementById(i)))
            return !1;
          var i,
            s = document.querySelector(t.hash);
          return (
            !!s &&
            (t.addEventListener("click", function () {
              Zt(s, e);
            }),
            !0)
          );
        })
    );
  }
  function ii(e) {
    return Array.prototype.slice
      .call(
        e.querySelectorAll(
          "[tabindex],[draggable],a[href],area,button:enabled,input:not([type=hidden]):enabled,object,select:enabled,textarea:enabled[data-focus-element]"
        )
      )
      .filter(function (e) {
        return Boolean(
          e.offsetWidth || e.offsetHeight || e.getClientRects().length
        );
      });
  }
  window.Shopify.designMode &&
    (document.addEventListener("shopify:section:load", function (e) {
      var t = e.detail.sectionId,
        i = e.target.querySelector("[" + zt + '="' + t + '"]');
      null !== i && Jt(i.getAttribute(Vt), i);
    }),
    document.addEventListener("shopify:section:reorder", function (e) {
      var t = e.detail.sectionId,
        i = e.target.querySelector("[" + zt + '="' + t + '"]');
      "object" == typeof Qt(i)[0] &&
        Qt(i).forEach(function (e) {
          e.onReorder();
        });
    }),
    document.addEventListener("shopify:section:unload", function (e) {
      var t = e.detail.sectionId,
        i = e.target.querySelector("[" + zt + '="' + t + '"]');
      "object" == typeof Qt(i)[0] &&
        Qt(i).forEach(function (e) {
          var t = jt
            .map(function (e) {
              return e.id;
            })
            .indexOf(e.id);
          jt.splice(t, 1), e.onUnload();
        });
    }),
    document.addEventListener("shopify:section:select", function (e) {
      var t = Kt(e.detail.sectionId);
      "object" == typeof t && t.onSelect(e);
    }),
    document.addEventListener("shopify:section:deselect", function (e) {
      var t = Kt(e.detail.sectionId);
      "object" == typeof t && t.onDeselect(e);
    }),
    document.addEventListener("shopify:block:select", function (e) {
      var t = Kt(e.detail.sectionId);
      "object" == typeof t && t.onBlockSelect(e);
    }),
    document.addEventListener("shopify:block:deselect", function (e) {
      var t = Kt(e.detail.sectionId);
      "object" == typeof t && t.onBlockDeselect(e);
    }));
  var si = {};
  function ri(e, t) {
    t = t || {};
    var i = ii(e),
      s = t.elementToFocus || e,
      r = i[0],
      n = i[i.length - 1];
    ni(),
      (si.focusin = function (t) {
        e !== t.target &&
          !e.contains(t.target) &&
          r &&
          r === t.target &&
          r.focus(),
          (t.target !== e && t.target !== n && t.target !== r) ||
            document.addEventListener("keydown", si.keydown);
      }),
      (si.focusout = function () {
        document.removeEventListener("keydown", si.keydown);
      }),
      (si.keydown = function (t) {
        "Tab" === t.code &&
          (t.target !== n || t.shiftKey || (t.preventDefault(), r.focus()),
          (t.target !== e && t.target !== r) ||
            !t.shiftKey ||
            (t.preventDefault(), n.focus()));
      }),
      document.addEventListener("focusout", si.focusout),
      document.addEventListener("focusin", si.focusin),
      Zt(s, t);
  }
  function ni() {
    document.removeEventListener("focusin", si.focusin),
      document.removeEventListener("focusout", si.focusout),
      document.removeEventListener("keydown", si.keydown);
  }
  var oi = Object.freeze({
    __proto__: null,
    forceFocus: Zt,
    focusHash: ei,
    bindInPageLinks: ti,
    focusable: ii,
    trapFocus: ri,
    removeTrapFocus: ni,
    accessibleLinks: function (e, t) {
      if ("string" != typeof e) throw new TypeError(e + " is not a String.");
      if (0 !== (e = document.querySelectorAll(e)).length) {
        (t = t || {}).messages = t.messages || {};
        var i,
          s,
          r,
          n = {
            newWindow: t.messages.newWindow || "Opens in a new window.",
            external: t.messages.external || "Opens external website.",
            newWindowExternal:
              t.messages.newWindowExternal ||
              "Opens external website in a new window.",
          },
          o = t.prefix || "a11y",
          a = {
            newWindow: o + "-new-window-message",
            external: o + "-external-message",
            newWindowExternal: o + "-new-window-external-message",
          };
        e.forEach(function (e) {
          var t = e.getAttribute("target"),
            i = e.getAttribute("rel"),
            s = (function (e) {
              return e.hostname !== window.location.hostname;
            })(e),
            r = "_blank" === t,
            n = null === i || -1 === i.indexOf("noopener");
          if (r && n) {
            var o = null === i ? "noopener" : i + " noopener";
            e.setAttribute("rel", o);
          }
          s && r
            ? e.setAttribute("aria-describedby", a.newWindowExternal)
            : s
            ? e.setAttribute("aria-describedby", a.external)
            : r && e.setAttribute("aria-describedby", a.newWindow);
        }),
          (i = n),
          (s = document.createElement("ul")),
          (r = Object.keys(i).reduce(function (e, t) {
            return e + "<li id=" + a[t] + ">" + i[t] + "</li>";
          }, "")),
          s.setAttribute("hidden", !0),
          (s.innerHTML = r),
          document.body.appendChild(s);
      }
    },
  });
  const ai =
    'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])';
  function li(e) {
    const t = `data-popup-${e}`;
    n.init({
      openTrigger: t,
      disableScroll: !0,
      onShow: (e, t, i) => {
        i.preventDefault();
        const s = e.querySelector(ai);
        ri(e, { elementToFocus: s });
      },
      onClose: (e, t, i) => {
        i.preventDefault(), ni(), t.focus();
      },
    });
  }
  const ci = "[data-toggle-password-modal]",
    hi = ".storefront-password-form .errors",
    di = {};
  Gt("password", {
    onLoad() {
      di[this.id] = new (class {
        init() {
          li("password"), this.errors && this.trigger.click();
        }
        constructor(e) {
          (this.container = e.container),
            (this.trigger = this.container.querySelector(ci)),
            (this.errors = this.container.querySelector(hi)),
            this.init();
        }
      })(this);
    },
  }),
    (function () {
      var e = "#QrCode",
        t = ".giftcard__code";
      const i = document.querySelector(e);
      if (i) {
        function r() {
          const e = i.getAttribute("data-identifier");
          new QRCode(i, { text: e, width: 120, height: 120 });
        }
        window.addEventListener("load", r);
      }
      const s = document.querySelector(t);
      if (s) {
        function n() {
          var e = document.querySelector("#GiftCardDigits"),
            t = "";
          if (document.body.createTextRange)
            (t = document.body.createTextRange()).moveToElementText(e),
              t.select();
          else if (window.getSelection) {
            var i = window.getSelection();
            (t = document.createRange()).selectNodeContents(e),
              i.removeAllRanges(),
              i.addRange(t);
          }
        }
        s.addEventListener("click", n());
      }
    })();
  const ui = "[data-parallax-wrapper]",
    pi = "[data-parallax-img]";
  let mi = {};
  const fi = {
    onLoad() {
      mi[this.id] = [];
      this.container.querySelectorAll(ui).forEach((e) => {
        const t = e.querySelector(pi);
        mi[this.id].push(new o(t, { center: !0, round: !0, frame: e }));
      });
    },
    onUnload: function () {
      mi[this.id].forEach((e) => {
        "function" == typeof e.destroy && e.destroy();
      });
    },
  };
  Gt("article", fi);
  const gi = "[data-ticker-frame]",
    yi = "[data-ticker-scale]",
    vi = "[data-ticker-text]",
    bi = "data-clone",
    wi = "ticker--animated",
    Si = "ticker--unloaded",
    Ei = "ticker__comparitor",
    Li = 1.63,
    ki = 100,
    Ti = {};
  let xi = class {
    unload() {
      document.removeEventListener("theme:resize", this.resizeEvent);
    }
    listen() {
      document.addEventListener("theme:resize", this.resizeEvent),
        this.checkWidth();
    }
    checkWidth() {
      const e =
        2 * window.getComputedStyle(this.frame).paddingLeft.replace("px", "");
      if (
        this.frame.clientWidth - e < this.comparitor.clientWidth ||
        this.stopClone
      ) {
        if (
          (this.text.classList.add(wi),
          1 === this.scale.childElementCount &&
            ((this.clone = this.text.cloneNode(!0)),
            this.clone.setAttribute("aria-hidden", !0),
            this.clone.setAttribute(bi, ""),
            this.scale.appendChild(this.clone),
            this.stopClone))
        )
          for (let e = 0; e < 10; e++) {
            const e = this.text.cloneNode(!0);
            e.setAttribute("aria-hidden", !0),
              e.setAttribute(bi, ""),
              this.scale.appendChild(e);
          }
        const e = (this.text.clientWidth / ki) * Li;
        this.scale.style.setProperty("--animation-time", `${e}s`);
      } else {
        this.text.classList.add(wi);
        let e = this.scale.querySelector(`[${bi}]`);
        e && this.scale.removeChild(e), this.text.classList.remove(wi);
      }
    }
    constructor(e, t = !1) {
      (this.frame = e),
        (this.stopClone = t),
        (this.scale = this.frame.querySelector(yi)),
        (this.text = this.frame.querySelector(vi)),
        (this.comparitor = this.text.cloneNode(!0)),
        this.comparitor.classList.add(Ei),
        this.frame.appendChild(this.comparitor),
        this.scale.classList.remove(Si),
        (this.resizeEvent = T(() => this.checkWidth(), 300)),
        this.listen();
    }
  };
  const _i = {
      onLoad() {
        Ti[this.id] = [];
        this.container.querySelectorAll(gi).forEach((e) => {
          Ti[this.id].push(new xi(e));
        });
      },
      onUnload() {
        Ti[this.id].forEach((e) => {
          "function" == typeof e.unload && e.unload();
        });
      },
    },
    Ai = "data-slider-speed",
    qi = "data-slide",
    Ci = "data-slide-index";
  const Pi = "[data-cart-message]",
    $i = "data-cart-message",
    Ii = "[data-left-to-spend]",
    Mi = "[data-cart-progress]",
    Di = "data-limit",
    Oi = "data-percent",
    Hi = "is-success";
  let Fi = class {
    init() {
      (this.cartFreeLimitShipping =
        100 * Number(this.cartMessage[0].getAttribute(Di)) * this.rate),
        (this.shippingAmount = 0),
        (this.circumference = 28 * Math.PI),
        this.exchangeRateConversions(
          this.cartFreeLimitShipping,
          this.shippingAmount
        ),
        this.cartBarProgress(),
        this.listen();
    }
    listen() {
      document.addEventListener(
        "theme:cart:change",
        function (e) {
          (this.cart = e.detail.cart), this.render();
        }.bind(this)
      );
    }
    render() {
      const e = this.cart.total_price;
      this.freeShippingMessageHandle(e),
        this.cart &&
          this.cart.total_price &&
          this.cartMessage.length > 0 &&
          ((this.shippingAmount = e), this.updateProgress());
    }
    freeShippingMessageHandle(e) {
      this.cartMessage.length > 0 &&
        this.container.querySelectorAll(Pi).forEach((t) => {
          const i =
            t.hasAttribute($i) &&
            "true" === t.getAttribute($i) &&
            e >= this.cartFreeLimitShipping &&
            0 !== e;
          t.classList.toggle(Hi, i);
        });
    }
    cartBarProgress(e = null) {
      this.container.querySelectorAll(Mi).forEach((t) => {
        this.setProgress(t, null === e ? t.getAttribute(Oi) : e);
      });
    }
    setProgress(e, t) {
      const i = this.circumference - ((t / 100) * this.circumference) / 2;
      e.style.strokeDashoffset = i;
    }
    updateProgress() {
      const e = (this.shippingAmount / this.cartFreeLimitShipping) * 100;
      this.exchangeRateConversions(
        this.cartFreeLimitShipping,
        this.shippingAmount
      ),
        this.cartBarProgress(e > 100 ? 100 : e);
    }
    exchangeRateConversions(e, t) {
      const i = theme.settings.currency_code_enable
        ? a.formatMoney(e - t, theme.moneyFormat) + ` ${theme.currencyCode}`
        : a.formatMoney(e - t, theme.moneyFormat);
      this.container.querySelectorAll(Ii).forEach((e) => {
        e.innerHTML = i.replace(".00", "");
      });
    }
    constructor(e) {
      (this.container = e),
        (this.cartMessage = this.container.querySelectorAll(Pi)),
        (this.rate = window.Shopify.currency.rate),
        this.cartMessage.length > 0 && this.init();
    }
  };
  const Bi = "[data-bar]",
    Wi = "[data-slide]",
    Ni = "[data-ticker-frame]",
    Ri = "[data-announcement-slider]",
    ji = "data-slide",
    zi = "[data-ticker-scale]",
    Vi = "[data-ticker-text]",
    Ui = "data-target-referrer",
    Gi = "data-slide",
    Ji = "mobile",
    Qi = "desktop",
    Ki = "ticker--animated",
    Yi = {};
  Gt("announcement", {
    onLoad() {
      (Yi[this.id] = []),
        Yi[this.id].push(
          new (class {
            init() {
              this.removeAnnouncement(),
                this.slider
                  ? this.slider && this.slides && this.slides.length > 1
                    ? this.initSliders()
                    : this.initTickers()
                  : this.initTickers(!0);
            }
            removeAnnouncement() {
              for (let e = 0; e < this.slides.length; e++) {
                const t = this.slides[e];
                t.hasAttribute(Ui) &&
                  (-1 !== document.referrer.indexOf(t.getAttribute(Ui)) ||
                    window.Shopify.designMode ||
                    t.parentNode.removeChild(t));
              }
            }
            initSliders() {
              (this.slider = new (class {
                init() {
                  const e = {
                    initialIndex: 0,
                    autoPlay: this.speed,
                    contain: !0,
                    pageDots: !1,
                    adaptiveHeight: !0,
                    wrapAround: !0,
                    groupCells: !1,
                    cellAlign: "left",
                    freeScroll: !1,
                    prevNextButtons: !0,
                    draggable: !0,
                    rightToLeft: window.isRTL,
                    on: {
                      ready: () => {
                        setTimeout(() => {
                          this.slideshow.dispatchEvent(
                            new CustomEvent("theme:announcement:loaded", {
                              bubbles: !0,
                              detail: { slider: this },
                            })
                          );
                        }, 50);
                      },
                    },
                  };
                  (this.flkty = new s(this.slideshow, e)),
                    this.flkty &&
                      (document.addEventListener(
                        "theme:resize",
                        this.resizeEvent
                      ),
                      document.addEventListener(
                        "theme:scroll",
                        this.scrollEvent
                      ));
                }
                resizeEvents() {
                  this.flkty.resize();
                }
                scrollEvents() {
                  if (this.flkty && this.speed) {
                    const e = this.flkty.element,
                      t =
                        e.getBoundingClientRect().top +
                        window.scrollY +
                        e.offsetHeight;
                    window.pageYOffset > t
                      ? "playing" === this.flkty.player.state &&
                        this.flkty.pausePlayer()
                      : "paused" === this.flkty.player.state &&
                        this.flkty.playPlayer();
                  }
                }
                onUnload() {
                  this.slideshow &&
                    this.flkty &&
                    (document.removeEventListener(
                      "theme:resize",
                      this.resizeEvent
                    ),
                    document.removeEventListener(
                      "theme:scroll",
                      this.scrollEvent
                    ),
                    (this.flkty.options.watchCSS = !1),
                    this.flkty.destroy());
                }
                onBlockSelect(e) {
                  if (!this.slideshow) return;
                  const t = this.slideshow.querySelector(
                    `[${qi}="${e.detail.blockId}"]`
                  );
                  if (!t) return;
                  const i = parseInt(t.getAttribute(Ci));
                  this.flkty.selectCell(i), this.flkty.stopPlayer();
                }
                onBlockDeselect() {
                  this.flkty.playPlayer();
                }
                constructor(e, t) {
                  (this.container = e), (this.slideshow = t);
                  const i = this.slideshow.getAttribute(Ai);
                  (this.speed = !!i && parseInt(i)),
                    (this.scrollEvent = () => this.scrollEvents()),
                    (this.resizeEvent = () => this.resizeEvents()),
                    this.slideshow && ((this.flkty = null), this.init());
                }
              })(this.container, this.slider)),
                this.slider.flkty.reposition(),
                this.barHolder.addEventListener(
                  "theme:announcement:loaded",
                  () => {
                    this.initTickers();
                  }
                );
            }
            initTickers(e = !1) {
              this.barHolder.querySelectorAll(Ni).forEach((t) => new xi(t, e));
            }
            toggleTicker(e, t) {
              const i = document.querySelector(zi),
                s = document.querySelector(`[${ji}="${e.detail.blockId}"]`);
              t &&
                s &&
                (i.setAttribute("data-stop", ""),
                i.querySelectorAll(Vi).forEach((e) => {
                  e.classList.remove(Ki),
                    (e.style.transform = `translate3d(${-(
                      s.offsetLeft - s.clientWidth
                    )}px, 0, 0)`);
                })),
                !t &&
                  s &&
                  (i.querySelectorAll(Vi).forEach((e) => {
                    e.classList.add(Ki), e.removeAttribute("style");
                  }),
                  i.removeAttribute("data-stop"));
            }
            onBlockSelect(e) {
              this.slider && "function" == typeof this.slider.onBlockSelect
                ? this.slider.onBlockSelect(e)
                : (document
                    .querySelectorAll(`[${Gi}="${e.detail.blockId}"]`)
                    .forEach((e) => {
                      e.classList.contains(Ji) && (this.hasDeviceClass = Ji),
                        e.classList.contains(Qi) && (this.hasDeviceClass = Qi),
                        "" !== this.hasDeviceClass &&
                          e.classList.remove(this.hasDeviceClass);
                    }),
                  this.toggleTicker(e, !0));
            }
            onBlockDeselect(e) {
              this.slider && "function" == typeof this.slider.onBlockDeselect
                ? this.slider.onBlockDeselect(e)
                : ("" !== this.hasDeviceClass &&
                    document
                      .querySelectorAll(`[${Gi}="${e.detail.blockId}"]`)
                      .forEach((e) => {
                        e.classList.add(this.hasDeviceClass);
                      }),
                  this.toggleTicker(e, !1));
            }
            onUnload() {
              this.slider &&
                "function" == typeof this.slider.onUnload &&
                this.slider.onUnload();
            }
            constructor(e) {
              (this.container = e.container),
                (this.barHolder = this.container.querySelector(Bi)),
                (this.locationPath = location.href),
                (this.slides = this.barHolder.querySelectorAll(Wi)),
                (this.slider = this.barHolder.querySelector(Ri)),
                (this.hasDeviceClass = ""),
                new Fi(this.container),
                this.init();
            }
          })(this)
        );
    },
    onUnload() {
      Yi[this.id].forEach((e) => {
        "function" == typeof e.onUnload && e.onUnload();
      });
    },
    onBlockSelect(e) {
      Yi[this.id].forEach((t) => {
        "function" == typeof t.onBlockSelect && t.onBlockSelect(e);
      });
    },
    onBlockDeselect(e) {
      Yi[this.id].forEach((t) => {
        "function" == typeof t.onBlockSelect && t.onBlockDeselect(e);
      });
    },
  });
  const Xi = "[data-ticker-frame]",
    Zi = "data-slide",
    es = "[data-ticker-scale]",
    ts = "[data-ticker-text]",
    is = "ticker--animated",
    ss = {};
  Gt("logos", {
    onLoad() {
      (ss[this.id] = []),
        ss[this.id].push(
          new (class {
            init() {
              this.initTickers(!0);
            }
            initTickers(e = !1) {
              const t = this.container.querySelector(Xi);
              t && new xi(t, e);
            }
            toggleTicker(e, t) {
              const i = this.container.querySelector(es),
                s = this.container.querySelector(
                  `[${Zi}="${e.detail.blockId}"]`
                );
              t &&
                s &&
                i &&
                (i.setAttribute("data-stop", ""),
                i.querySelectorAll(ts).forEach((e) => {
                  e.classList.remove(is),
                    (e.style.transform = `translate3d(${-(
                      s.offsetLeft - s.clientWidth
                    )}px, 0, 0)`);
                })),
                !t &&
                  s &&
                  i &&
                  (i.querySelectorAll(ts).forEach((e) => {
                    e.classList.add(is), e.removeAttribute("style");
                  }),
                  i.removeAttribute("data-stop"));
            }
            onBlockSelect(e) {
              this.toggleTicker(e, !0);
            }
            onBlockDeselect(e) {
              this.toggleTicker(e, !1);
            }
            constructor(e) {
              (this.container = e.container), this.init();
            }
          })(this)
        );
    },
    onBlockSelect(e) {
      ss[this.id].forEach((t) => {
        "function" == typeof t.onBlockSelect && t.onBlockSelect(e);
      });
    },
    onBlockDeselect(e) {
      ss[this.id].forEach((t) => {
        "function" == typeof t.onBlockSelect && t.onBlockDeselect(e);
      });
    },
  }),
    Gt("blog", fi);
  var rs = "[data-drawer]",
    ns = "[data-drawer-scrolls]",
    os = "[data-predictive-search-input]",
    as = "[data-drawer-underlay]",
    ls = "[data-stagger-animation]",
    cs = "data-drawer-toggle",
    hs = ":scope > * > [data-animates]",
    ds = 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
    us = "drawer--visible",
    ps = "display-none",
    ms = {};
  const fs = {
      onLoad() {
        ms[this.id] = [];
        this.container.querySelectorAll(rs).forEach((e) => {
          ms[this.id].push(
            new (class {
              unload() {}
              connectToggle() {
                this.buttons.forEach((e) => {
                  e.addEventListener(
                    "click",
                    function (e) {
                      e.preventDefault(),
                        this.drawer.dispatchEvent(
                          new CustomEvent("theme:drawer:toggle", {
                            bubbles: !1,
                          })
                        );
                    }.bind(this)
                  );
                });
              }
              connectDrawer() {
                this.drawer.addEventListener(
                  "theme:drawer:toggle",
                  function () {
                    this.drawer.classList.contains(us)
                      ? this.drawer.dispatchEvent(
                          new CustomEvent("theme:drawer:close", { bubbles: !1 })
                        )
                      : this.drawer.dispatchEvent(
                          new CustomEvent("theme:drawer:open", { bubbles: !1 })
                        );
                  }.bind(this)
                ),
                  this.drawer.addEventListener(
                    "theme:drawer:close",
                    this.hideDrawer.bind(this)
                  ),
                  this.drawer.addEventListener(
                    "theme:drawer:open",
                    this.showDrawer.bind(this)
                  );
              }
              staggerChildAnimations() {
                this.staggers.forEach((e) => {
                  e.querySelectorAll(hs).forEach((e, t) => {
                    e.style.transitionDelay = 50 * t + 10 + "ms";
                  });
                });
              }
              closers() {
                this.drawer.addEventListener(
                  "keyup",
                  function (e) {
                    "Escape" === e.code &&
                      (this.hideDrawer(), this.buttons[0].focus());
                  }.bind(this)
                ),
                  this.underlay.addEventListener(
                    "click",
                    function () {
                      this.hideDrawer();
                    }.bind(this)
                  );
              }
              focusFirst() {
                const e = this.drawer.querySelector(os);
                if (e) e.focus();
                else {
                  const e = this.drawer.querySelector(ds);
                  ri(this.drawer, { elementToFocus: e });
                }
              }
              showDrawer() {
                this.drawer.classList.remove(ps),
                  setTimeout(() => {
                    this.buttons.forEach((e) =>
                      e.setAttribute("aria-expanded", !0)
                    ),
                      this.drawer.classList.add(us),
                      document.dispatchEvent(
                        new CustomEvent("theme:scroll:lock", {
                          bubbles: !0,
                          detail: this.drawerScrolls,
                        })
                      ),
                      this.drawer.addEventListener(
                        "transitionend",
                        this.focusFirst.bind(this),
                        { once: !0 }
                      ),
                      this.drawer.addEventListener(
                        "transitioncancel",
                        this.focusFirst.bind(this),
                        { once: !0 }
                      );
                  }, 1);
              }
              hideDrawer() {
                (window.theme.state.cartOpen = !1),
                  this.buttons.forEach((e) =>
                    e.setAttribute("aria-expanded", !0)
                  ),
                  this.drawer.classList.remove(us),
                  this.drawerScrolls.dispatchEvent(
                    new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
                  ),
                  document.dispatchEvent(
                    new CustomEvent("theme:sliderule:close", { bubbles: !1 })
                  ),
                  ni(),
                  setTimeout(() => {
                    this.drawer.classList.contains(us) ||
                      this.drawer.classList.add(ps);
                  }, 800);
              }
              constructor(e) {
                (this.drawer = e),
                  (this.drawerScrolls = this.drawer.querySelector(ns)),
                  (this.underlay = this.drawer.querySelector(as)),
                  (this.key = this.drawer.dataset.drawer);
                const t = `[${cs}='${this.key}']`;
                (this.buttons = document.querySelectorAll(t)),
                  (this.staggers = this.drawer.querySelectorAll(ls)),
                  this.connectToggle(),
                  this.connectDrawer(),
                  this.closers(),
                  this.staggerChildAnimations();
              }
            })(e)
          );
        });
      },
      onUnload: function () {
        ms[this.id].forEach((e) => {
          "function" == typeof e.unload && e.unload();
        });
      },
    },
    gs = "[data-announcement-bar]",
    ys = "data-header-transparent",
    vs = "[data-header-wrapper] header",
    bs = "js__header__stuck",
    ws = "js__header__stuck--animated",
    Ss = "js__header__stuck--trigger-animation",
    Es = "js__header__stuck__backdrop";
  let Ls = {};
  const ks = {
      onLoad() {
        Ls = new (class {
          unload() {
            document.removeEventListener("theme:scroll", this.listen),
              document.removeEventListener(
                "theme:scroll:up",
                this.scrollUpDirectional
              ),
              document.removeEventListener(
                "theme:scroll:down",
                this.scrollDownDirectional
              );
          }
          listen() {
            (this.sticks || this.animated) &&
              document.addEventListener("theme:scroll", (e) => {
                e.detail.down
                  ? (!this.currentlyStuck &&
                      e.detail.position > this.stickDown &&
                      this.stickSimple(),
                    !this.currentlyBlurred &&
                      e.detail.position > this.blur &&
                      this.addBlur())
                  : (e.detail.position <= this.stickUp && this.unstickSimple(),
                    e.detail.position <= this.blur && this.removeBlur());
              }),
              this.animated &&
                (document.addEventListener(
                  "theme:scroll:up",
                  this.scrollUpDirectional.bind(this)
                ),
                document.addEventListener(
                  "theme:scroll:down",
                  this.scrollDownDirectional.bind(this)
                ));
          }
          stickSimple() {
            this.animated && this.cls.add(ws),
              this.cls.add(bs),
              this.wrapper.setAttribute(ys, !1),
              (this.currentlyStuck = !0);
          }
          unstickSimple() {
            this.cls.remove(bs),
              this.wrapper.setAttribute(ys, this.transparent),
              this.animated && this.cls.remove(ws),
              (this.currentlyStuck = !1);
          }
          scrollDownInit() {
            window.scrollY > this.stickDown && this.stickSimple(),
              window.scrollY > this.blur && this.addBlur();
          }
          stickDirectional() {
            this.cls.add(Ss);
          }
          unstickDirectional() {
            this.cls.remove(Ss);
          }
          scrollDownDirectional() {
            this.unstickDirectional();
          }
          scrollUpDirectional() {
            window.scrollY <= this.stickDown
              ? this.unstickDirectional()
              : this.stickDirectional();
          }
          addBlur() {
            this.cls.add(Es), (this.currentlyBlurred = !0);
          }
          removeBlur() {
            this.cls.remove(Es), (this.currentlyBlurred = !1);
          }
          constructor(e) {
            (this.wrapper = e),
              (this.type = this.wrapper.dataset.headerSticky),
              (this.transparent = this.wrapper.dataset.headerTransparent),
              (this.sticks = "sticky" === this.type),
              (this.animated = "directional" === this.type),
              (this.currentlyStuck = !1),
              (this.cls = this.wrapper.classList);
            const t = document.querySelector(gs),
              i = t ? t.clientHeight : 0,
              s = document.querySelector(vs).clientHeight;
            (this.blur = s + i),
              (this.stickDown = s + i),
              (this.stickUp = i),
              "false" !== this.wrapper.getAttribute(ys) && (this.blur = i),
              this.sticks && ((this.stickDown = i), this.scrollDownInit()),
              this.listen();
          }
        })(this.container);
      },
      onUnload: function () {
        "function" == typeof Ls.unload && Ls.unload();
      },
    },
    Ts = "data-hover-disclosure-toggle",
    xs = "[data-hover-disclosure]",
    _s = "[data-top-link]",
    As = "[data-header-wrapper]",
    qs = "[data-stagger]",
    Cs = "[data-stagger-first]",
    Ps = "[data-stagger-second]",
    $s = "[data-grid-item], [data-header-image]",
    Is = "is-visible",
    Ms = "meganav--visible",
    Ds = "grandparent";
  let Os = {},
    Hs = {};
  const Fs = {
      onLoad() {
        (Os[this.id] = []),
          (Hs = this.container.querySelectorAll(xs)),
          Hs.forEach((e) => {
            Os[this.id].push(
              new (class {
                onBlockSelect(e) {
                  this.disclosure.contains(e.target) && this.showDisclosure();
                }
                onBlockDeselect(e) {
                  this.disclosure.contains(e.target) && this.hideDisclosure();
                }
                showDisclosure() {
                  this.grandparent
                    ? this.wrapper.classList.add(Ms)
                    : this.wrapper.classList.remove(Ms),
                    this.trigger.setAttribute("aria-expanded", !0),
                    this.trigger.classList.add(Is),
                    this.disclosure.classList.add(Is);
                }
                hideDisclosure() {
                  this.disclosure.classList.remove(Is),
                    this.trigger.classList.remove(Is),
                    this.trigger.setAttribute("aria-expanded", !1),
                    this.wrapper.classList.remove(Ms);
                }
                staggerChildAnimations() {
                  this.disclosure.querySelectorAll(qs).forEach((e, t) => {
                    e.style.transitionDelay = 50 * t + 10 + "ms";
                  }),
                    this.disclosure.querySelectorAll(Cs).forEach((e, t) => {
                      const i = 150 * t;
                      (e.style.transitionDelay = `${i}ms`),
                        e.parentElement.querySelectorAll(Ps).forEach((e, t) => {
                          const s = 20 * (t + 1);
                          e.style.transitionDelay = `${i + s}ms`;
                        });
                    }),
                    this.disclosure.querySelectorAll($s).forEach((e, t) => {
                      e.style.transitionDelay = 80 * (t + 1) + "ms";
                    });
                }
                handleTablets() {
                  this.trigger.addEventListener(
                    "touchstart",
                    function (e) {
                      this.disclosure.classList.contains(Is) ||
                        (e.preventDefault(), this.showDisclosure());
                    }.bind(this),
                    { passive: !0 }
                  );
                }
                connectHoverToggle() {
                  this.trigger.addEventListener(
                    "pointerenter",
                    this.showDisclosure.bind(this)
                  ),
                    this.link.addEventListener(
                      "focus",
                      this.showDisclosure.bind(this)
                    ),
                    this.trigger.addEventListener(
                      "pointerleave",
                      this.hideDisclosure.bind(this)
                    ),
                    this.trigger.addEventListener(
                      "focusout",
                      function (e) {
                        this.trigger.contains(e.relatedTarget) ||
                          this.hideDisclosure();
                      }.bind(this)
                    ),
                    this.disclosure.addEventListener(
                      "keyup",
                      function (e) {
                        "Escape" === e.code && this.hideDisclosure();
                      }.bind(this)
                    );
                }
                constructor(e) {
                  (this.disclosure = e),
                    (this.wrapper = e.closest(As)),
                    (this.key = this.disclosure.id);
                  const t = `[${Ts}='${this.key}']`;
                  (this.trigger = document.querySelector(t)),
                    (this.link = this.trigger.querySelector(_s)),
                    (this.grandparent = this.trigger.classList.contains(Ds)),
                    this.trigger.setAttribute("aria-haspopup", !0),
                    this.trigger.setAttribute("aria-expanded", !1),
                    this.trigger.setAttribute("aria-controls", this.key),
                    this.connectHoverToggle(),
                    this.handleTablets(),
                    this.staggerChildAnimations();
                }
              })(e)
            );
          });
      },
      onBlockSelect(e) {
        Os[this.id].forEach((t) => {
          "function" == typeof t.onBlockSelect && t.onBlockSelect(e);
        });
      },
      onBlockDeselect(e) {
        Os[this.id].forEach((t) => {
          "function" == typeof t.onBlockDeselect && t.onBlockDeselect(e);
        });
      },
      onUnload: function () {
        Os[this.id].forEach((e) => {
          "function" == typeof e.unload && e.unload();
        });
      },
    },
    Bs = "[data-main-menu-text-item]",
    Ws = "[data-text-items-wrapper]",
    Ns = ".navtext",
    Rs = "data-menu-active",
    js = "[data-header-wrapper]",
    zs = "data-underline-current",
    Vs =
      ".menu__item.main-menu--active .navtext, .header__desktop__button.main-menu--active .navtext";
  let Us = {},
    Gs = null;
  const Js = {
      onLoad() {
        Us[this.id] = [];
        this.container.querySelectorAll(Ws).forEach((e) => {
          Us[this.id].push(
            new (class {
              init() {
                if (this.itemList.length) {
                  if (
                    (this.listen(),
                    this.listenResize(),
                    (this.textBottom = null),
                    this.setHeight(),
                    Gs)
                  ) {
                    if (this.defaultItem) {
                      const e = this.defaultItem.offsetLeft || 0;
                      this.sectionOuter.style.setProperty(
                        "--bar-left",
                        `${e}px`
                      );
                    }
                    this.reset();
                  } else {
                    const e = this.sectionOuter.querySelector(Bs).offsetLeft;
                    this.sectionOuter.style.setProperty("--bar-left", `${e}px`),
                      this.sectionOuter.style.setProperty("--bar-width", "0px");
                  }
                  this.sectionOuter.style.setProperty("--bar-opacity", "1");
                }
              }
              unload() {
                document.removeEventListener("theme:resize", this.reset),
                  (Gs = null);
              }
              listenResize() {
                document.addEventListener(
                  "theme:resize",
                  this.reset.bind(this)
                );
              }
              setDefault() {
                this.defaultItem &&
                  (Gs = {
                    left: this.defaultItem.offsetLeft || null,
                    width: this.defaultItem.clientWidth || null,
                  });
              }
              setHeight() {
                const e = this.wrapper.clientHeight,
                  t = this.itemList[0].querySelector(Ns).clientHeight,
                  i = Math.floor(e / 2 - t / 2) - 4;
                this.textBottom !== i &&
                  (this.sectionOuter.style.setProperty("--bar-text", `${t}px`),
                  this.sectionOuter.style.setProperty("--bar-bottom", `${i}px`),
                  (this.textBottom = i));
              }
              listen() {
                this.itemList.forEach((e) => {
                  e.addEventListener("pointerenter", (e) => {
                    const t = e.target.querySelector(Ns);
                    this.startBar(t);
                  });
                }),
                  this.wrapper.addEventListener(
                    "pointerleave",
                    this.clearBar.bind(this)
                  );
              }
              startBar(e) {
                this.setHeight();
                let t = "false" !== this.sectionOuter.getAttribute(Rs),
                  i = e.offsetLeft,
                  s = e.clientWidth;
                t
                  ? this.render(s, i)
                  : (this.sectionOuter.setAttribute(Rs, !0),
                    this.render(0, i),
                    setTimeout(() => {
                      this.render(s, i);
                    }, 10));
              }
              render(e, t) {
                this.sectionOuter.style.setProperty("--bar-left", `${t}px`),
                  this.sectionOuter.style.setProperty("--bar-width", `${e}px`);
              }
              reset() {
                this.setDefault(),
                  Gs && Gs.left && Gs.width
                    ? (this.sectionOuter.style.setProperty(
                        "--bar-left",
                        `${Gs.left}px`
                      ),
                      this.sectionOuter.style.setProperty(
                        "--bar-width",
                        `${Gs.width}px`
                      ))
                    : this.sectionOuter.style.setProperty("--bar-width", "0px");
              }
              clearBar() {
                this.sectionOuter.setAttribute(Rs, !1),
                  setTimeout(() => {
                    "false" !== this.sectionOuter.getAttribute(Rs) ||
                      this.reset();
                  }, 150);
              }
              constructor(e) {
                (this.wrapper = e),
                  (this.itemList = this.wrapper.querySelectorAll(Bs)),
                  (this.sectionOuter = document.querySelector(js)),
                  (this.underlineCurrent =
                    "true" === this.sectionOuter.getAttribute(zs)),
                  (this.defaultItem = null),
                  this.underlineCurrent &&
                    (this.defaultItem = this.wrapper.querySelector(Vs)),
                  this.setDefault(),
                  document.fonts.ready.then(() => {
                    this.init();
                  });
              }
            })(e)
          );
        });
      },
      onUnload: function () {
        Us[this.id].forEach((e) => {
          "function" == typeof e.unload && e.unload();
        }),
          delete Us[this.id];
      },
    },
    Qs = "data-header-cart-price",
    Ks = "data-header-cart-count",
    Ys = "data-header-cart-full";
  const Xs = {
      onLoad() {
        new (class {
          listen() {
            document.addEventListener(
              "theme:cart:change",
              function (e) {
                (this.cart = e.detail.cart), this.update();
              }.bind(this)
            );
          }
          update() {
            this.cart &&
              (this.prices.forEach((e) => {
                e.setAttribute(Qs, this.cart.total_price);
                const t = a.formatMoney(
                  this.cart.total_price,
                  theme.moneyFormat
                );
                e.innerHTML = t;
              }),
              this.counts.forEach((e) => {
                e.setAttribute(Ks, this.cart.item_count),
                  (e.innerHTML = `(${this.cart.item_count})`);
              }),
              this.dots.forEach((e) => {
                const t = this.cart.item_count > 0;
                e.setAttribute(Ys, t);
              }));
          }
          constructor(e) {
            (this.section = e),
              (this.counts = this.section.querySelectorAll(`[${Ks}]`)),
              (this.prices = this.section.querySelectorAll(`[${Qs}]`)),
              (this.dots = this.section.querySelectorAll(`[${Ys}]`)),
              (this.cart = null),
              this.listen();
          }
        })(this.container);
      },
    },
    Zs = "[data-search-popdown-wrap]",
    er = "data-popdown-toggle",
    tr = "[data-close-popdown]",
    ir = "[data-predictive-search-input]",
    sr = "[data-search-underlay]",
    rr = "underlay--visible",
    nr = "is-visible";
  let or = {};
  const ar = {
      onLoad() {
        or[this.id] = {};
        const e = this.container.querySelector(`[${er}]`);
        e &&
          (or[this.id] = new (class {
            initTriggerEvents() {
              this.trigger.setAttribute("aria-haspopup", !0),
                this.trigger.setAttribute("aria-expanded", !1),
                this.trigger.setAttribute("aria-controls", this.key),
                this.trigger.addEventListener(
                  "click",
                  function (e) {
                    e.preventDefault(), this.showPopdown();
                  }.bind(this)
                ),
                this.trigger.addEventListener(
                  "keyup",
                  function (e) {
                    "Space" === e.code && this.showPopdown();
                  }.bind(this)
                );
            }
            initPopdownEvents() {
              this.popdown.addEventListener(
                "keyup",
                function (e) {
                  "Escape" === e.code && this.hidePopdown();
                }.bind(this)
              ),
                this.close.addEventListener(
                  "click",
                  function () {
                    this.hidePopdown();
                  }.bind(this)
                ),
                this.underlay.addEventListener(
                  "click",
                  function () {
                    this.hidePopdown();
                  }.bind(this)
                );
            }
            hidePopdown() {
              this.popdown.classList.remove(nr),
                this.underlay.classList.remove(rr),
                this.trigger.focus(),
                ni(),
                this.popdown.dispatchEvent(
                  new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
                );
            }
            showPopdown() {
              this.popdown.classList.add(nr),
                this.underlay.classList.add(rr),
                ri(this.popdown, { elementToFocus: this.input }),
                this.popdown.dispatchEvent(
                  new CustomEvent("theme:scroll:lock", { bubbles: !0 })
                );
            }
            constructor(e) {
              (this.trigger = e),
                (this.key = this.trigger.getAttribute(er)),
                (this.popdown = document.querySelector(`[id='${this.key}']`)),
                (this.input = this.popdown.querySelector(ir)),
                (this.close = this.popdown.querySelector(tr)),
                (this.wrapper = this.popdown.closest(Zs)),
                (this.underlay = this.wrapper.querySelector(sr)),
                this.initTriggerEvents(),
                this.initPopdownEvents();
            }
          })(e));
      },
      onUnload: function () {
        "function" == typeof or[this.id].unload && or[this.id].unload();
      },
    },
    lr = "[data-product-add-popdown-wrapper]",
    cr = "[data-close-popdown]",
    hr = "[data-api-content]",
    dr = '[data-ajax-disable="false"]',
    ur = '[data-ajax-disable="true"]',
    pr = '[data-drawer-toggle="drawer-cart"]',
    mr = '[data-drawer="drawer-cart"]',
    fr = "is-visible";
  let gr;
  const yr = {
      onLoad() {
        new (class {
          renderPopdown(e) {
            const t = e.detail.variant,
              i = `${window.theme.routes.root_url}variants/${t.id}/?section_id=api-product-popdown`,
              s = this;
            l.get(i)
              .then(function (e) {
                const t = document.createElement("div");
                (t.innerHTML = e.data),
                  (s.drawer.innerHTML = t.querySelector(hr).innerHTML),
                  s.connectCartButton(),
                  s.connectCloseButton();
              })
              .catch(function (e) {
                console.warn(e);
              });
          }
          connectCloseButton() {
            this.drawer.classList.add(fr),
              this.drawer.querySelector(cr).addEventListener(
                "click",
                function (e) {
                  e.preventDefault(), this.drawer.classList.remove(fr);
                }.bind(this)
              ),
              this.popdownTimer();
          }
          connectCartButton() {
            const e = this.drawer.querySelector(pr),
              t = document.querySelector(mr);
            t &&
              e.addEventListener(
                "click",
                function (e) {
                  e.preventDefault(),
                    this.drawer.classList.remove(fr),
                    t.dispatchEvent(
                      new CustomEvent("theme:drawer:open", { bubbles: !1 })
                    );
                }.bind(this)
              );
          }
          popdownTimer() {
            clearTimeout(gr),
              (gr = setTimeout(() => {
                this.drawer.classList.remove(fr);
              }, 5e3));
          }
          constructor() {
            (this.drawer = document.querySelector(lr)),
              (this.cartAjaxEnabled = document.querySelector(dr)),
              (this.cartAjaxDisabled = document.querySelector(ur)),
              document.addEventListener("theme:cart:popdown", (e) => {
                this.cartAjaxEnabled
                  ? this.cartAjaxEnabled.dispatchEvent(
                      new CustomEvent("theme:cart:reload", { bubbles: !0 })
                    )
                  : this.cartAjaxDisabled
                  ? window.location.reload()
                  : this.renderPopdown(e);
              });
          }
        })(this);
      },
    },
    vr = "data-grid-item-variant";
  let br = class extends HTMLElement {
    connectedCallback() {
      this.gridItemVariantLinks.length &&
        this.gridItemVariantLinks.forEach((e) => {
          e.hasAttribute(vr) &&
            (this.swatchHoverEvent(e), this.swatchClickEvent(e));
        });
    }
    swatchHoverEvent(e) {
      e.addEventListener("mouseenter", () => {
        if (e.hasAttribute(vr)) {
          const t = e.getAttribute(vr);
          this.container
            .querySelectorAll(
              `product-grid-item-variant[${vr}="${t}"] product-grid-item-image`
            )
            .forEach((e) => {
              e.setAttribute("loading", "eager");
            });
        }
      });
    }
    swatchClickEvent(e) {
      e.addEventListener("click", (t) => {
        if (
          (t.preventDefault(),
          this.container
            .querySelectorAll(`a[${vr}]`)
            .forEach((e) => e.removeAttribute("aria-selected")),
          e.setAttribute("aria-selected", "true"),
          e.hasAttribute(vr))
        ) {
          const t = e.getAttribute(vr);
          this.container
            .querySelectorAll(`product-grid-item-variant[${vr}]`)
            .forEach((e) => {
              e.getAttribute(vr) === t
                ? e.removeAttribute("hidden")
                : e.setAttribute("hidden", "");
            });
        }
      });
    }
    constructor() {
      super(),
        (this.container = this),
        (this.gridItemVariantLinks = this.container.querySelectorAll(
          `a[${vr}]`
        ));
    }
  };
  const wr = "[data-grid-link]",
    Sr = "data-grid-images",
    Er = "data-grid-image",
    Lr = "data-grid-image-target",
    kr = "data-grid-current-image",
    Tr = "data-grid-pagination",
    xr = "data-grid-page",
    _r = "data-slide-for-filter-selected-variant",
    Ar = "data-slide-for-variant-media",
    qr = "data-slideshow-style",
    Cr = "--width",
    Pr = "is-active",
    $r = "is-mobile",
    Ir = "product-grid-item__pagination";
  let Mr = class extends HTMLElement {
    static get observedAttributes() {
      return ["hidden"];
    }
    preloadImage(e) {
      if (this.isMobile) return;
      const t = [...this.images][e];
      if (!t) throw new Error(`No child element at index ${e}`);
      t.setAttribute("loading", "eager");
    }
    preloadImages() {
      [...this.imagesHolder.children].forEach((e, t) => this.preloadImage(t));
    }
    connectedCallback() {
      this.toggleMobile(),
        document.addEventListener("theme:resize:width", () =>
          this.toggleMobile()
        ),
        this.isMobile ||
          (this.imageCount > 1 &&
            (this.createPaging(),
            this.container.addEventListener(
              "theme:swatch:change",
              this.swatchChangeEvent
            ),
            this.container.addEventListener("mouseenter", this.mouseEnterEvent),
            this.container.addEventListener(
              "mouseleave",
              this.mouseLeaveEvent
            )),
          this.intersectionObserver.observe(this.container));
    }
    disconnectedCallback() {
      this.container.removeEventListener(
        "theme:swatch:change",
        this.swatchChangeEvent
      ),
        this.container.removeEventListener("mouseenter", this.mouseEnterEvent),
        this.container.removeEventListener("mouseleave", this.mouseLeaveEvent);
    }
    swatchChangeEvent(e) {
      const t = e.detail.id,
        i = this.container.querySelector(`[${Lr}="${t}"]`);
      if (i) {
        const t = i.getAttribute(Er);
        (this.pagingProgressCounter = 0),
          this.changeImage(t),
          e.detail.stopSlideAnimation && this.stopPaging();
      }
    }
    mouseEnterEvent() {
      switch ((this.preloadImages(), this.slideshowStyle)) {
        case "cycle_images":
          (this.pagingProgressPause = this.isMobile), this.progressPaging();
          break;
        case "second_immediately":
          this.changeImage(this.getNextIndex());
          break;
        case "disabled":
          break;
        default:
          throw new Error(`Unknown option ${this.slideshowStyle}`);
      }
    }
    mouseLeaveEvent() {
      (this.pagingProgressPause = !0),
        this.resetSlideshow(),
        this.progressPaging();
    }
    attributeChangedCallback(e, t, i) {
      "hidden" === e && null == t && null != i && this.showVariant();
    }
    toggleMobile() {
      this.container.classList.toggle($r, this.isMobile);
    }
    get isMobile() {
      return (
        (window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth) < window.theme.sizes.medium
      );
    }
    resetSlideshow() {
      const e = this.container.querySelector(`[${_r}]`);
      if (e) {
        let t = Number(e.getAttribute(Er));
        this.changeImage(t);
      } else this.changeImage(0);
      this.pagingProgressPause = !0;
    }
    showVariant() {
      const e = this.container.querySelector(`[${Ar}]`);
      if (e) {
        let t = Number(e.getAttribute(Er));
        this.changeImage(t);
      } else this.changeImage(0);
      this.pagingProgressPause = !0;
    }
    getNextIndex() {
      let e = this.container.querySelector(`[${Er}][${kr}]`);
      if (e) {
        return (Number(e.getAttribute(Er)) + 1) % this.imageCount;
      }
      return 0;
    }
    changeImage(e) {
      const t = this.images[e % this.imageCount];
      t &&
        (this.activeImages.forEach((e) => e.removeAttribute(kr)),
        t.setAttribute(kr, "true"),
        "cycle_images" === this.slideshowStyle && this.changePaging(e));
    }
    changePaging(e = 0) {
      const t = this.container.querySelector(`[${xr}].${Pr}`),
        i = this.container.querySelector(`[${xr}="${e}"]`);
      t && (t.style.setProperty(Cr, "100%"), t.classList.remove(Pr)),
        i && (i.classList.add(Pr), this.progressPaging());
    }
    progressPaging() {
      const e = this.container.querySelector(`[${xr}].${Pr}`);
      e &&
        !this.isMobile &&
        (this.stopPaging(),
        0 === this.pagingProgressCounter && e.style.setProperty(Cr, "0%"),
        (this.interval = setInterval(() => {
          this.pagingProgressCounter >= 100 && !this.pagingProgressPause
            ? (this.stopPaging(),
              (this.pagingProgressCounter = 0),
              this.changeImage(this.getNextIndex()))
            : this.pagingProgressPause ||
              (this.pagingProgressCounter++,
              e.style.setProperty(Cr, `${this.pagingProgressCounter}%`));
        }, this.timeout / 100)));
    }
    stopPaging() {
      this.interval && clearInterval(this.interval);
    }
    createPaging() {
      if (this.imagesHolder && "cycle_images" === this.slideshowStyle) {
        let e = "";
        for (let t = 0; t < this.imageCount; t++) {
          let i = "";
          0 === t && (i = `class="${Pr}"`),
            (e += `<span ${i} ${xr}="${t}">${t + 1}</span>`);
        }
        if ("" !== e) {
          let t = this.container.querySelector(`[${Tr}]`);
          t ||
            ((t = document.createElement("div")),
            (t.className = Ir),
            t.setAttribute(Tr, "")),
            (t.innerHTML = e),
            this.imagesHolder.parentElement.prepend(t);
        }
      }
    }
    removePaging() {
      const e = this.container.querySelector(`[${Tr}]`);
      e && e.remove();
    }
    get imagesHolder() {
      return this.container.querySelector(`[${Sr}]`);
    }
    get images() {
      return this.imagesHolder.querySelectorAll(`[${Er}]`);
    }
    get activeImages() {
      return this.imagesHolder.querySelectorAll(`[${Er}][${kr}]`);
    }
    get links() {
      return this.container.querySelectorAll(wr);
    }
    get slideshowStyle() {
      return this.container.getAttribute(qr);
    }
    get imageCount() {
      return this.images.length;
    }
    constructor() {
      super(),
        (this.container = this),
        (this.mobileStopSlideshow = "true"),
        (this.timeout =
          1e3 * window.theme.settings.cycle_images_hover_delay || 1500),
        (this.interval = null),
        (this.pagingProgressPause = !1),
        (this.pagingProgressCounter = 0),
        (this.siblingsFetchCounter = 0),
        (this.siblingLoadImageIndex = null),
        (this.intersectionObserver = new IntersectionObserver(
          (e) => {
            e.forEach((e) => {
              e.isIntersecting && this.imageCount > 1 && this.preloadImage(1);
            });
          },
          { threshold: 0.1 }
        ));
    }
  };
  const Dr = "data-grid-current-image",
    Or = "is-active";
  let Hr = class extends HTMLElement {
    static get observedAttributes() {
      return ["loading", Dr];
    }
    connectedCallback() {
      null === this.getAttribute(Dr) ? this.hide() : this.show();
    }
    attributeChangedCallback(e, t, i) {
      switch (e) {
        case "loading":
          (null !== i && "eager" !== i) || this.eagerLoad();
          break;
        case Dr:
          null === i ? this.hide() : this.show();
      }
    }
    show() {
      this.classList.add(Or);
    }
    hide() {
      this.classList.remove(Or);
    }
    eagerLoad() {
      const e = this.firstElementChild;
      switch (e.nodeName) {
        case "TEMPLATE":
          const t = e,
            i = t.content;
          i.querySelectorAll("img").forEach((e) => {
            e.setAttribute("loading", "eager"),
              e.setAttribute("fetchpriority", "high");
          }),
            t.replaceWith(i);
          break;
        case "IMG":
          e.setAttribute("loading", "eager"),
            e.setAttribute("fetchpriority", "high");
      }
    }
  };
  const Fr = "[data-popout]",
    Br = "[data-popout-list]",
    Wr = "data-popout-list-scroll",
    Nr = "data-popout-toggle",
    Rr = "[data-popout-input]",
    jr = "[data-popout-option]",
    zr = "data-popout-prevent",
    Vr = "data-quantity-field",
    Ur = "data-value",
    Gr = "aria-expanded",
    Jr = "aria-current",
    Qr = "popout-list--visible",
    Kr = "--current";
  let Yr = class extends HTMLElement {
    unload() {
      this.popoutOptions.length &&
        this.popoutOptions.forEach((e) => {
          e.removeEventListener(
            "theme:popout:click",
            this.popupOptionsClick.bind(this)
          ),
            e.removeEventListener(
              "click",
              this._connectOptionsDispatch.bind(this)
            );
        }),
        this.popoutToggle.removeEventListener(
          "click",
          this.popupToggleClick.bind(this)
        ),
        this.popoutToggle.removeEventListener(
          "focusout",
          this.popupToggleFocusout.bind(this)
        ),
        this.popoutList.removeEventListener(
          "focusout",
          this.popupListFocusout.bind(this)
        ),
        this.container.removeEventListener(
          "keyup",
          this.containerKeyup.bind(this)
        ),
        this.outsidePopupToggle &&
          (this.outsidePopupToggle.removeEventListener(
            "click",
            this.popupToggleClick.bind(this)
          ),
          this.outsidePopupToggle.removeEventListener(
            "focusout",
            this.popupToggleFocusout.bind(this)
          ));
    }
    popupToggleClick(e) {
      const t = "true" === e.currentTarget.getAttribute(Gr);
      e.currentTarget.setAttribute(Gr, !t),
        this.popoutList.classList.toggle(Qr),
        this.popupListMaxWidth(),
        this.popoutList.hasAttribute(Wr) &&
          setTimeout(() => {
            this.popoutList.dispatchEvent(
              new CustomEvent("theme:scroll:lock", { bubbles: !0 })
            );
          }, 1);
    }
    popupToggleFocusout(e) {
      this.container.contains(e.relatedTarget) || this._hideList();
    }
    popupListFocusout(e) {
      const t = e.currentTarget.contains(e.relatedTarget);
      this.popoutList.classList.contains(Qr) && !t && this._hideList();
    }
    popupListMaxWidth() {
      this.popoutList.style.maxWidth = `${parseInt(
        document.body.clientWidth - this.popoutList.getBoundingClientRect().left
      )}px`;
    }
    popupOptionsClick(e) {
      if ("#" === e.target.closest(jr).attributes.href.value) {
        e.preventDefault();
        let t = "";
        if (
          (e.currentTarget.getAttribute(Ur) &&
            (t = e.currentTarget.getAttribute(Ur)),
          (this.popoutInput.value = t),
          this.popoutPrevent)
        ) {
          this.popoutInput.dispatchEvent(new Event("change")),
            !e.detail.preventTrigger &&
              this.popoutInput.hasAttribute(Vr) &&
              this.popoutInput.dispatchEvent(new Event("input"));
          const i = this.popoutList.querySelector(`[class*="${Kr}"]`);
          let s = Kr;
          if (i && i.classList.length)
            for (const e of i.classList)
              if (e.includes(Kr)) {
                s = e;
                break;
              }
          const r = this.popoutList.querySelector(`.${s}`);
          r &&
            (r.classList.remove(`${s}`),
            e.currentTarget.parentElement.classList.add(`${s}`));
          const n = this.popoutList.querySelector(`[${Jr}]`);
          n &&
            n.hasAttribute(`${Jr}`) &&
            (n.removeAttribute(`${Jr}`),
            e.currentTarget.setAttribute(`${Jr}`, "true")),
            "" !== t &&
              ((this.popoutToggle.textContent = t),
              this.outsidePopupToggle &&
                (this.outsidePopupToggle.textContent = t)),
            this.popupToggleFocusout(e),
            this.popupListFocusout(e);
        } else this._submitForm(t);
      }
    }
    updatePopout(e) {
      const t = this.popoutList.querySelector(
        `[${Ur}="${this.popoutInput.value}"]`
      );
      t &&
        t.dispatchEvent(
          new CustomEvent("theme:popout:click", {
            cancelable: !0,
            bubbles: !0,
            detail: { preventTrigger: !0 },
          })
        );
    }
    containerKeyup(e) {
      "Escape" === e.code && (this._hideList(), this.popoutToggle.focus());
    }
    bodyClick(e) {
      const t = this.container.contains(e.target),
        i = this.popoutList.classList.contains(Qr);
      this.outsidePopupToggle, e.target, i && !t && this._hideList();
    }
    _connectToggle() {
      this.popoutToggle.addEventListener(
        "click",
        this.popupToggleClick.bind(this)
      ),
        this.outsidePopupToggle &&
          this.outsidePopupToggle.addEventListener(
            "click",
            this.popupToggleClick.bind(this)
          );
    }
    _connectOptions() {
      this.popoutOptions.length &&
        this.popoutOptions.forEach((e) => {
          e.addEventListener(
            "theme:popout:click",
            this.popupOptionsClick.bind(this)
          ),
            e.addEventListener(
              "click",
              this._connectOptionsDispatch.bind(this)
            );
        });
    }
    _connectOptionsDispatch(e) {
      const t = new CustomEvent("theme:popout:click", {
        cancelable: !0,
        bubbles: !0,
        detail: { preventTrigger: !1 },
      });
      e.target.dispatchEvent(t) || e.preventDefault();
    }
    _onFocusOut() {
      this.popoutToggle.addEventListener(
        "focusout",
        this.popupToggleFocusout.bind(this)
      ),
        this.outsidePopupToggle &&
          this.outsidePopupToggle.addEventListener(
            "focusout",
            this.popupToggleFocusout.bind(this)
          ),
        this.popoutList.addEventListener(
          "focusout",
          this.popupListFocusout.bind(this)
        ),
        this.container.addEventListener(
          "keyup",
          this.containerKeyup.bind(this)
        ),
        document.body.addEventListener("click", this.bodyClick.bind(this));
    }
    _submitForm(e) {
      const t = this.container.closest("form");
      t && t.submit();
    }
    _hideList() {
      this.popoutList.classList.remove(Qr),
        this.popoutToggle.setAttribute(Gr, !1),
        this.outsidePopupToggle && this.outsidePopupToggle.setAttribute(Gr, !1);
    }
    constructor() {
      super(),
        (this.container = this.querySelector(Fr)),
        (this.popoutList = this.container.querySelector(Br)),
        (this.popoutToggle = this.container.querySelector(`[${Nr}]`)),
        (this.outsidePopupToggle = document.querySelector(
          `[${Nr}="${this.popoutList.id}"]`
        )),
        (this.popoutInput = this.container.querySelector(Rr)),
        (this.popoutOptions = this.container.querySelectorAll(jr)),
        (this.popoutPrevent = "true" === this.container.getAttribute(zr)),
        this._connectOptions(),
        this._connectToggle(),
        this._onFocusOut(),
        this.popupListMaxWidth(),
        this.popoutInput &&
          this.popoutInput.hasAttribute(Vr) &&
          document.addEventListener(
            "theme:popout:update",
            this.updatePopout.bind(this)
          ),
        document.addEventListener("theme:resize", () => {
          this.popupListMaxWidth();
        });
    }
  };
  const Xr = (e, t = 500, i = !0) => {
      let s = window.getComputedStyle(e).display;
      if (i && "none" !== s) return;
      e.style.removeProperty("display"),
        "none" === s && (s = "block"),
        (e.style.display = s);
      let r = e.offsetHeight;
      (e.style.overflow = "hidden"),
        (e.style.height = 0),
        (e.style.paddingTop = 0),
        (e.style.paddingBottom = 0),
        (e.style.marginTop = 0),
        (e.style.marginBottom = 0),
        e.offsetHeight,
        (e.style.boxSizing = "border-box"),
        (e.style.transitionTimingFunction =
          "cubic-bezier(0.215, 0.61, 0.355, 1)"),
        (e.style.transitionProperty = "height, margin, padding"),
        (e.style.transitionDuration = t + "ms"),
        (e.style.height = r + "px"),
        e.style.removeProperty("padding-top"),
        e.style.removeProperty("padding-bottom"),
        e.style.removeProperty("margin-top"),
        e.style.removeProperty("margin-bottom"),
        window.setTimeout(() => {
          e.style.removeProperty("height"),
            e.style.removeProperty("overflow"),
            e.style.removeProperty("transition-duration"),
            e.style.removeProperty("transition-property"),
            e.style.removeProperty("transition-timing-function");
        }, t);
    },
    Zr = (e, t = 500) => {
      (e.style.transitionProperty = "height, margin, padding"),
        (e.style.transitionTimingFunction =
          "cubic-bezier(0.215, 0.61, 0.355, 1)"),
        (e.style.transitionDuration = t + "ms"),
        (e.style.boxSizing = "border-box"),
        (e.style.height = e.offsetHeight + "px"),
        e.offsetHeight,
        (e.style.overflow = "hidden"),
        (e.style.height = 0),
        (e.style.paddingTop = 0),
        (e.style.paddingBottom = 0),
        (e.style.marginTop = 0),
        (e.style.marginBottom = 0),
        window.setTimeout(() => {
          (e.style.display = "none"),
            e.style.removeProperty("height"),
            e.style.removeProperty("padding-top"),
            e.style.removeProperty("padding-bottom"),
            e.style.removeProperty("margin-top"),
            e.style.removeProperty("margin-bottom"),
            e.style.removeProperty("overflow"),
            e.style.removeProperty("transition-duration"),
            e.style.removeProperty("transition-property"),
            e.style.removeProperty("transition-timing-function");
        }, t);
    },
    en = "[data-accordion-group]",
    tn = "data-accordion-trigger",
    sn = "[data-accordion-body]",
    rn = "data-accordion-body-mobile",
    nn = "data-range-holder",
    on = "[data-section-id]",
    an = "accordion-is-open";
  let ln = {},
    cn = class {
      mobileAccordions() {
        window.innerWidth < window.theme.sizes.medium
          ? (this.init(), this.setDefaultState())
          : (this.resetMobileAccordions(), this.body.removeAttribute("style")),
          document.addEventListener("theme:resize", () => {
            window.innerWidth < window.theme.sizes.medium
              ? (this.init(), this.setDefaultState())
              : (this.resetMobileAccordions(),
                this.body.removeAttribute("style"));
          });
      }
      init() {
        this.trigger.setAttribute("aria-haspopup", !0),
          this.trigger.setAttribute("aria-expanded", !1),
          this.trigger.setAttribute("aria-controls", this.key),
          this.setDefaultState(),
          this.trigger.addEventListener("click", this.toggleEvent),
          this.body.addEventListener("keyup", this.keyboardEvent),
          this.body.addEventListener("theme:accordion:close", this.hideEvent);
      }
      hideEvents() {
        this.hideAccordion();
      }
      clickEvents(e) {
        e.preventDefault(), this.toggleState();
      }
      keyboardEvents(e) {
        "Escape" === e.code && (this.hideAccordion(), this.trigger.focus());
      }
      resetMobileAccordions() {
        this.trigger.removeEventListener("click", this.toggleEvent),
          this.body.removeEventListener("keyup", this.keyboardEvent),
          this.body.removeEventListener(
            "theme:accordion:close",
            this.hideEvent
          );
      }
      setDefaultState() {
        this.trigger.classList.contains(an)
          ? W(this.body)
          : this.hideAccordion();
      }
      getSiblings() {
        const e = [...this.body.closest(on).querySelectorAll(en)]
          .filter((e) => e.contains(this.body))
          .shift();
        if (e) {
          return [...e.querySelectorAll(sn)].filter(
            (e) => !e.contains(this.body)
          );
        }
        return [];
      }
      closeSiblings() {
        this.syncBodies.forEach((e) => {
          e.dispatchEvent(
            new CustomEvent("theme:accordion:close", { bubbles: !1 })
          );
        });
      }
      toggleState() {
        this.trigger.classList.contains(an)
          ? this.hideAccordion()
          : (this.showAccordion(),
            this.closeSiblings(),
            this.body.hasAttribute(nn) &&
              setTimeout(() => {
                document.dispatchEvent(
                  new CustomEvent("theme:price-range:reset", { bubbles: !1 })
                );
              }, 400));
      }
      hideAccordion() {
        this.trigger.classList.remove(an), Zr(this.body);
      }
      showAccordion() {
        this.trigger.classList.add(an),
          Xr(this.body),
          setTimeout(() => {
            this.checkInViewportAndScrollTo();
          }, 600);
      }
      checkInViewportAndScrollTo() {
        const e = this.trigger.getBoundingClientRect(),
          t =
            (window.pageYOffset || document.documentElement.scrollTop) -
            (document.documentElement.clientTop || 0);
        (e.top >= 0 &&
          e.left >= 0 &&
          e.bottom <=
            (window.innerHeight || document.documentElement.clientHeight) &&
          e.right <=
            (window.innerWidth || document.documentElement.clientWidth)) ||
          window.scrollTo({ top: t + e.top, left: 0, behavior: "smooth" });
      }
      onBlockSelect(e) {
        this.body.contains(e.target) && this.showAccordion();
      }
      onBlockDeselect(e) {
        this.body.contains(e.target) && this.hideAccordion();
      }
      constructor(e) {
        (this.body = e), (this.key = this.body.id);
        const t = `[${tn}='${this.key}']`;
        (this.trigger = document.querySelector(t)),
          (this.toggleEvent = (e) => this.clickEvents(e)),
          (this.keyboardEvent = (e) => this.keyboardEvents(e)),
          (this.hideEvent = () => this.hideEvents()),
          (this.syncBodies = this.getSiblings()),
          this.body.hasAttribute(rn) ? this.mobileAccordions() : this.init();
      }
    };
  const hn = {
      onLoad() {
        ln[this.id] = [];
        this.container.querySelectorAll(sn).forEach((e) => {
          ln[this.id].push(new cn(e));
        });
      },
      onUnload: function () {
        ln[this.id].forEach((e) => {
          "function" == typeof e.unload && e.unload();
        });
      },
      onSelect: function () {
        "accordion-single" === this.type &&
          this.container.querySelector(`[${tn}]`).click();
      },
      onDeselect: function () {
        "accordion-single" === this.type &&
          this.container.querySelector(`[${tn}]`).click();
      },
      onBlockSelect(e) {
        ln[this.id].forEach((t) => {
          "function" == typeof t.onBlockSelect && t.onBlockSelect(e);
        });
      },
      onBlockDeselect(e) {
        ln[this.id].forEach((t) => {
          "function" == typeof t.onBlockSelect && t.onBlockDeselect(e);
        });
      },
    },
    dn = (e) => {
      e && (e.style.display = "none");
    },
    un = 'input[type="search"]',
    pn = '[aria-selected="true"] a',
    mn = 'button[type="reset"]',
    fn = "is-hidden";
  let gn = class extends HTMLElement {
    toggleResetButton() {
      const e = this.resetButton.classList.contains(fn);
      this.input.value.length > 0 && e
        ? this.resetButton.classList.remove(fn)
        : 0 !== this.input.value.length ||
          e ||
          this.resetButton.classList.add(fn);
    }
    onChange() {
      this.toggleResetButton();
    }
    shouldResetForm() {
      return !document.querySelector(pn);
    }
    onFormReset(e) {
      e.preventDefault(),
        this.shouldResetForm() &&
          ((this.input.value = ""),
          this.toggleResetButton(),
          e.target.querySelector(un).focus());
    }
    constructor() {
      super(),
        (this.input = this.querySelector(un)),
        (this.resetButton = this.querySelector(mn)),
        this.input &&
          (this.input.form.addEventListener(
            "reset",
            this.onFormReset.bind(this)
          ),
          this.input.addEventListener(
            "input",
            T((e) => {
              this.onChange(e);
            }, 300).bind(this)
          ));
    }
  };
  customElements.define("header-search-form", gn);
  const yn = '[role="option"]',
    vn = '[aria-selected="true"]',
    bn = "predictive-search",
    wn = "[data-predictive-search-results]",
    Sn = "[data-predictive-search-status]",
    En = "[data-predictive-search-input]",
    Ln = "[data-predictive-search-live-region-count-value]",
    kn = "data-search-results-groups-wrapper",
    Tn = "[data-predictive-search-search-for-text]",
    xn = "#shopify-section-predictive-search",
    _n = '[aria-selected="true"] a',
    An = '[aria-selected="true"] a, button[aria-selected="true"]',
    qn = "[data-loading-indicator]";
  let Cn = class extends gn {
    connectedCallback() {
      this.input.addEventListener("focus", this.onFocus.bind(this)),
        this.input.form.addEventListener(
          "submit",
          this.onFormSubmit.bind(this)
        ),
        this.addEventListener("focusout", this.onFocusOut.bind(this)),
        this.addEventListener("keyup", this.onKeyup.bind(this)),
        this.addEventListener("keydown", this.onKeydown.bind(this));
    }
    getQuery() {
      return this.input.value.trim();
    }
    onChange() {
      super.onChange();
      const e = this.getQuery();
      var t;
      (this.searchTerm && e.startsWith(this.searchTerm)) ||
        null === (t = this.querySelector(kn)) ||
        void 0 === t ||
        t.remove();
      this.updateSearchForTerm(this.searchTerm, e),
        (this.searchTerm = e),
        this.searchTerm.length
          ? this.getSearchResults(this.searchTerm)
          : this.reset();
    }
    onFormSubmit(e) {
      (this.getQuery().length && !this.querySelector(_n)) || e.preventDefault();
    }
    onFormReset(e) {
      super.onFormReset(e),
        super.shouldResetForm() &&
          ((this.searchTerm = ""),
          this.abortController.abort(),
          (this.abortController = new AbortController()),
          this.closeResults(!0));
    }
    shouldResetForm() {
      return !document.querySelector(_n);
    }
    onFocus() {
      const e = this.getQuery();
      e.length &&
        (this.searchTerm !== e
          ? this.onChange()
          : "true" === this.getAttribute("results")
          ? this.open()
          : this.getSearchResults(this.searchTerm));
    }
    onFocusOut() {
      setTimeout(() => {
        this.contains(document.activeElement) || this.close();
      });
    }
    onKeyup(e) {
      switch (
        (this.getQuery().length || this.close(!0), e.preventDefault(), e.code)
      ) {
        case "ArrowUp":
          this.switchOption("up");
          break;
        case "ArrowDown":
          this.switchOption("down");
          break;
        case "Enter":
          this.selectOption();
      }
    }
    onKeydown(e) {
      ("ArrowUp" !== e.code && "ArrowDown" !== e.code) || e.preventDefault();
    }
    updateSearchForTerm(e, t) {
      const i = this.querySelector(Tn),
        s = null == i ? void 0 : i.innerText;
      if (s) {
        var r;
        if ((null === (r = s.match(e)) || void 0 === r ? void 0 : r.length) > 1)
          return;
        const n = s.replace(e, t);
        i.innerText = n;
      }
    }
    switchOption(e) {
      if (!this.getAttribute("open")) return;
      const t = "up" === e,
        i = this.querySelector(vn),
        s = Array.from(this.querySelectorAll(yn)).filter(
          (e) => null !== e.offsetParent
        );
      let r = 0;
      if (t && !i) return;
      let n = -1,
        o = 0;
      for (; -1 === n && o <= s.length; ) s[o] === i && (n = o), o++;
      if (
        ((this.statusElement.textContent = ""),
        !t && i
          ? (r = n === s.length - 1 ? 0 : n + 1)
          : t && (r = 0 === n ? s.length - 1 : n - 1),
        r === n)
      )
        return;
      const a = s[r];
      a.setAttribute("aria-selected", !0),
        i && i.setAttribute("aria-selected", !1),
        this.input.setAttribute("aria-activedescendant", a.id);
    }
    selectOption() {
      const e = this.querySelector(An);
      e && e.click();
    }
    getSearchResults(e) {
      const t = e.replace(" ", "-").toLowerCase();
      this.setLiveRegionLoadingState(),
        this.cachedResults[t]
          ? this.renderSearchResults(this.cachedResults[t])
          : (W(this.loader),
            fetch(
              `${theme.routes.predictive_search_url}?q=${encodeURIComponent(
                e
              )}&section_id=predictive-search`,
              { signal: this.abortController.signal }
            )
              .then(this.handleErrors)
              .then((e) => e.text())
              .then((e) => {
                const i = new DOMParser()
                  .parseFromString(e, "text/html")
                  .querySelector(xn).innerHTML;
                this.allPredictiveSearchInstances.forEach((e) => {
                  e.cachedResults[t] = i;
                }),
                  this.renderSearchResults(i);
              })
              .catch((e) => {
                console.error(e);
              })
              .finally(() => {
                dn(this.loader);
              }));
    }
    setLiveRegionLoadingState() {
      (this.statusElement = this.statusElement || this.querySelector(Sn)),
        (this.loadingText =
          this.loadingText || this.getAttribute("data-loading-text")),
        this.setLiveRegionText(this.loadingText),
        this.setAttribute("loading", !0);
    }
    setLiveRegionText(e) {
      this.statusElement.setAttribute("aria-hidden", "false"),
        (this.statusElement.textContent = e),
        setTimeout(() => {
          this.statusElement.setAttribute("aria-hidden", "true");
        }, 1e3);
    }
    renderSearchResults(e) {
      (this.predictiveSearchResults.innerHTML = e),
        this.setAttribute("results", !0),
        this.setLiveRegionResults(),
        this.open();
    }
    setLiveRegionResults() {
      this.removeAttribute("loading"),
        this.setLiveRegionText(this.querySelector(Ln).textContent);
    }
    open() {
      this.setAttribute("open", !0),
        this.input.setAttribute("aria-expanded", !0),
        (this.isOpen = !0);
    }
    close(e = !1) {
      this.closeResults(e), (this.isOpen = !1);
    }
    closeResults(e = !1) {
      var t;
      e && ((this.input.value = ""), this.removeAttribute("results"));
      const i = this.querySelector(vn);
      i && i.setAttribute("aria-selected", !1),
        this.input.setAttribute("aria-activedescendant", ""),
        this.removeAttribute("loading"),
        this.removeAttribute("open"),
        this.input.setAttribute("aria-expanded", !1),
        null === (t = this.predictiveSearchResults) ||
          void 0 === t ||
          t.removeAttribute("style");
    }
    reset() {
      (this.predictiveSearchResults.innerHTML = ""),
        (this.input.val = ""),
        this.a11y.removeTrapFocus();
    }
    handleErrors(e) {
      return e.ok
        ? e
        : e.json().then(function (t) {
            throw new N({ status: e.statusText, headers: e.headers, json: t });
          });
    }
    constructor() {
      super(),
        (this.wrapper = this),
        (this.a11y = oi),
        (this.abortController = new AbortController()),
        (this.allPredictiveSearchInstances = document.querySelectorAll(bn)),
        (this.cachedResults = {}),
        (this.input = this.wrapper.querySelector(En)),
        (this.isOpen = !1),
        (this.predictiveSearchResults = this.querySelector(wn)),
        (this.searchTerm = ""),
        (this.loader = this.wrapper.querySelector(qn));
    }
  };
  function Pn() {
    return (
      (window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth) >= window.theme.sizes.small
    );
  }
  const $n = 'input[type="search"]';
  let In = class extends gn {
    setupEventListeners() {
      let e = [];
      this.allSearchInputs.forEach((t) => e.push(t.form)),
        this.input.addEventListener("focus", this.onInputFocus.bind(this)),
        e.length < 2 ||
          (e.forEach((e) =>
            e.addEventListener("reset", this.onFormReset.bind(this))
          ),
          this.allSearchInputs.forEach((e) =>
            e.addEventListener("input", this.onInput.bind(this))
          ));
    }
    onFormReset(e) {
      super.onFormReset(e),
        super.shouldResetForm() && this.keepInSync("", this.input);
    }
    onInput(e) {
      const t = e.target;
      this.keepInSync(t.value, t);
    }
    onInputFocus() {
      Pn() || this.scrollIntoView({ behavior: "smooth" });
    }
    keepInSync(e, t) {
      this.allSearchInputs.forEach((i) => {
        i !== t && (i.value = e);
      });
    }
    constructor() {
      super(),
        (this.allSearchInputs = document.querySelectorAll($n)),
        this.setupEventListeners();
    }
  };
  const Mn = {
      drawer: "data-drawer-scrolls",
      slideruleOpen: "data-sliderule-open",
      slideruleClose: "data-sliderule-close",
      sliderulePane: "data-sliderule-pane",
      slideruleWrappper: "[data-sliderule]",
      dataAnimates: "data-animates",
      children:
        ":scope > [data-animates],\n             :scope > * > [data-animates],\n             :scope > * > * >[data-animates],\n             :scope .sliderule-grid  > *",
    },
    Dn = "is-visible",
    On = "is-hiding",
    Hn = "is-hidden";
  let Fn = {};
  const Bn = {
      onLoad() {
        Fn[this.id] = [];
        this.container.querySelectorAll(Mn.slideruleWrappper).forEach((e) => {
          Fn[this.id].push(
            new (class {
              clickEvents() {
                this.trigger.addEventListener(
                  "click",
                  function () {
                    this.showSliderule();
                  }.bind(this)
                ),
                  this.exit.forEach((e) => {
                    e.addEventListener(
                      "click",
                      function () {
                        this.hideSliderule();
                      }.bind(this)
                    );
                  });
              }
              keyboardEvents() {
                this.trigger.addEventListener(
                  "keyup",
                  function (e) {
                    "Space" === e.code && this.showSliderule();
                  }.bind(this)
                ),
                  this.sliderule.addEventListener(
                    "keyup",
                    function (e) {
                      "Escape" === e.code &&
                        (this.hideSliderule(), this.buttons[0].focus());
                    }.bind(this)
                  );
              }
              staggerChildAnimations(e = !1) {
                (e
                  ? Array.prototype.slice.call(this.children).slice().reverse()
                  : this.children
                ).forEach((e, t) => {
                  e.style.transitionDelay = 50 * t + 10 + "ms";
                });
              }
              hideSliderule(e = !1) {
                const t = window.getComputedStyle(this.pane),
                  i =
                    1e3 * parseFloat(t.getPropertyValue("transition-duration")),
                  s = e ? this.pane.querySelectorAll(`.${Dn}`) : this.children;
                this.pane.style.setProperty("--sliderule-height", "auto"),
                  this.staggerChildAnimations(!0),
                  this.pane.classList.add(On),
                  this.sliderule.classList.add(On),
                  this.sliderule.classList.remove(Dn),
                  s.forEach((e) => {
                    e.classList.remove(Dn);
                  });
                const r = parseInt(this.pane.dataset.sliderulePane, 10) - 1;
                this.pane.setAttribute(Mn.sliderulePane, r);
                const n = e
                    ? `[${Mn.dataAnimates}].${Hn}`
                    : `[${Mn.dataAnimates}="${r}"].${Hn}`,
                  o = this.pane.querySelectorAll(n);
                o.length &&
                  o.forEach((e) => {
                    e.classList.remove(Hn);
                  }),
                  setTimeout(() => {
                    this.pane.classList.remove(On),
                      this.sliderule.classList.remove(On),
                      this.staggerChildAnimations();
                  }, i);
              }
              showSliderule() {
                this.pane.style.setProperty("--sliderule-height", "auto"),
                  this.sliderule.classList.add(Dn),
                  this.children.forEach((e) => {
                    e.classList.add(Dn);
                  });
                const e = parseInt(this.pane.dataset.sliderulePane, 10),
                  t = e + 1;
                this.pane.setAttribute(Mn.sliderulePane, t);
                const i = this.pane.querySelectorAll(
                  `[${Mn.dataAnimates}="${e}"]`
                );
                if (i.length) {
                  const e =
                    1e3 *
                    parseFloat(
                      window
                        .getComputedStyle(i[0])
                        .getPropertyValue("transition-duration")
                    );
                  setTimeout(() => {
                    i.forEach((e) => {
                      e.classList.add(Hn);
                    });
                  }, e);
                }
                const s = parseInt(
                  this.trigger.nextElementSibling.offsetHeight
                );
                this.pane.style.setProperty("--sliderule-height", `${s}px`);
                const r = this.drawer.scrollTop,
                  n = this.pane.offsetTop;
                n < r &&
                  this.pane.offsetHeight >= this.drawer.offsetHeight &&
                  this.drawer.scrollTo({ top: n, left: 0, behavior: "smooth" });
              }
              closeSliderule() {
                this.pane &&
                  this.pane.hasAttribute(Mn.sliderulePane) &&
                  parseInt(this.pane.getAttribute(Mn.sliderulePane)) > 0 &&
                  (this.hideSliderule(!0),
                  parseInt(this.pane.getAttribute(Mn.sliderulePane)) > 0 &&
                    this.pane.setAttribute(Mn.sliderulePane, 0));
              }
              constructor(e) {
                (this.sliderule = e),
                  (this.wrapper = e.closest(Mn.wrapper)),
                  (this.key = this.sliderule.id);
                const t = `[${Mn.slideruleOpen}='${this.key}']`,
                  i = `[${Mn.slideruleClose}='${this.key}']`;
                (this.trigger = document.querySelector(t)),
                  (this.drawer = document.querySelector(`[${Mn.drawer}]`)),
                  (this.exit = document.querySelectorAll(i)),
                  (this.pane = document.querySelector(`[${Mn.sliderulePane}]`)),
                  (this.children = this.sliderule.querySelectorAll(
                    Mn.children
                  )),
                  this.trigger.setAttribute("aria-haspopup", !0),
                  this.trigger.setAttribute("aria-expanded", !1),
                  this.trigger.setAttribute("aria-controls", this.key),
                  this.clickEvents(),
                  this.staggerChildAnimations(),
                  document.addEventListener(
                    "theme:sliderule:close",
                    this.closeSliderule.bind(this)
                  );
              }
            })(e)
          );
        });
      },
    },
    Wn = "[data-takes-space]",
    Nn = "[data-header-desktop]",
    Rn = "js__header__clone",
    jn = "js__show__mobile",
    zn = "[data-header-backfill]",
    Vn = "data-header-transparent",
    Un = "header-override-border",
    Gn = ".main-content > .shopify-section:first-child [data-overlay-header]",
    Jn =
      ".main-content > .shopify-section:first-child [data-prevent-transparent-header]",
    Qn = '.navlink[href="#"]',
    Kn = "has-overlay";
  let Yn = {};
  Gt("header", [
    {
      onLoad() {
        Yn = new (class {
          unload() {
            document.removeEventListener("theme:resize", this.checkWidth);
          }
          checkForImage() {
            this.overlayedImages = document.querySelectorAll(Gn);
            let e = document.querySelectorAll(Jn).length;
            this.overlayedImages.length && !e && this.transparent
              ? ((document.querySelector(zn).style.display = "none"),
                this.listenOverlay())
              : this.wrapper.setAttribute(Vn, !1),
              !this.overlayedImages.length ||
                e ||
                this.transparent ||
                (this.wrapper.classList.add(Un), this.subtractHeaderHeight());
          }
          listenOverlay() {
            document.addEventListener(
              "theme:resize",
              this.checkWidth.bind(this)
            ),
              this.subtractAnnouncementHeight();
          }
          listenWidth() {
            document.addEventListener(
              "theme:resize",
              this.checkWidth.bind(this)
            ),
              this.checkWidth();
          }
          killDeadLinks() {
            this.deadLinks.forEach((e) => {
              e.onclick = (e) => {
                e.preventDefault();
              };
            });
          }
          subtractAnnouncementHeight() {
            const { windowHeight: e, announcementHeight: t } = y();
            this.overlayedImages.forEach((i) => {
              i.style.setProperty("--full-screen", e - t + "px"),
                i.classList.add(Kn);
            });
          }
          subtractHeaderHeight() {
            const { windowHeight: e, headerHeight: t } = y();
            this.overlayedImages.forEach((i) => {
              i.style.setProperty("--full-screen", e - t + "px");
            });
          }
          checkWidth() {
            document.body.clientWidth < this.minWidth
              ? this.wrapper.classList.add(jn)
              : this.wrapper.classList.remove(jn);
          }
          getMinWidth() {
            const e = this.wrapper.cloneNode(!0);
            e.classList.add(Rn), document.body.appendChild(e);
            const t = e.querySelectorAll(Wn);
            let i = 0;
            return (
              (i =
                3 === t.length
                  ? (function (e) {
                      let t = [];
                      return (
                        e.forEach((e) => {
                          t.push(e.clientWidth);
                        }),
                        t[0] > t[2] ? (t[2] = t[0]) : (t[0] = t[2]),
                        t.reduce((e, t) => e + t)
                      );
                    })(t)
                  : (function (e) {
                      let t = 0;
                      return (
                        e.forEach((e) => {
                          t += e.clientWidth;
                        }),
                        t
                      );
                    })(t)),
              document.body.removeChild(e),
              i + 20 * t.length
            );
          }
          constructor(e) {
            (this.wrapper = e),
              (this.style = this.wrapper.dataset.style),
              (this.desktop = this.wrapper.querySelector(Nn)),
              (this.transparent = "false" !== this.wrapper.getAttribute(Vn)),
              (this.overlayedImages = document.querySelectorAll(Gn)),
              (this.deadLinks = document.querySelectorAll(Qn)),
              this.killDeadLinks(),
              "drawer" !== this.style &&
                this.desktop &&
                ((this.minWidth = this.getMinWidth()), this.listenWidth()),
              this.checkForImage(),
              window.dispatchEvent(new Event("resize")),
              document.addEventListener(
                "theme:header:check",
                this.checkForImage.bind(this)
              );
          }
        })(this.container);
      },
      onUnload: function () {
        "function" == typeof Yn.unload && Yn.unload();
      },
    },
    fs,
    Bn,
    ks,
    Fs,
    Js,
    Xs,
    ar,
    yr,
    Je,
    hn,
    _i,
  ]),
    customElements.get("popout-select") ||
      customElements.define("popout-select", Yr),
    customElements.get("radio-swatch") ||
      customElements.define("radio-swatch", Ue),
    customElements.get("product-grid-item") ||
      customElements.define("product-grid-item", br),
    customElements.get("product-grid-item-variant") ||
      customElements.define("product-grid-item-variant", Mr),
    customElements.get("product-grid-item-image") ||
      customElements.define("product-grid-item-image", Hr),
    customElements.get("predictive-search") ||
      customElements.define("predictive-search", Cn),
    customElements.get("main-search") ||
      customElements.define("main-search", In);
  const Xn = "[data-newsletter-form]",
    Zn = "has-success",
    eo = "has-error",
    to = {};
  const io = {
      onLoad() {
        to[this.id] = [];
        this.container.querySelectorAll(Xn).forEach((e) => {
          to[this.id].push(
            new (class {
              init() {
                this.newsletter.addEventListener(
                  "submit",
                  this.newsletterSubmit
                ),
                  this.showMessage();
              }
              newsletterSubmitEvent(e) {
                this.stopSubmit &&
                  (e.preventDefault(),
                  e.stopImmediatePropagation(),
                  this.removeStorage(),
                  this.writeStorage(),
                  (this.stopSubmit = !1),
                  this.newsletter.submit());
              }
              checkForChallengePage() {
                this.isChallengePage =
                  "/challenge" === window.location.pathname;
              }
              writeStorage() {
                void 0 !== this.sessionStorage &&
                  this.sessionStorage.setItem(
                    "newsletter_form_id",
                    this.newsletter.id
                  );
              }
              readStorage() {
                this.formID = this.sessionStorage.getItem("newsletter_form_id");
              }
              removeStorage() {
                this.sessionStorage.removeItem("newsletter_form_id");
              }
              showMessage() {
                if ((this.readStorage(), this.newsletter.id === this.formID)) {
                  const e = document.getElementById(this.formID);
                  -1 !== window.location.search.indexOf("?customer_posted=true")
                    ? (e.classList.remove(eo), e.classList.add(Zn))
                    : -1 !==
                        window.location.search.indexOf("accepts_marketing") &&
                      (e.classList.remove(Zn), e.classList.add(eo)),
                    this.removeStorage(),
                    this.scrollToForm(e);
                }
              }
              scrollToForm(e) {
                const t = e.getBoundingClientRect();
                (t.top >= 0 &&
                  t.left >= 0 &&
                  t.bottom <=
                    (window.innerHeight ||
                      document.documentElement.clientHeight) &&
                  t.right <=
                    (window.innerWidth ||
                      document.documentElement.clientWidth)) ||
                  setTimeout(() => {
                    window.scroll({ top: t.top, left: 0, behavior: "smooth" });
                  }, 400);
              }
              unload() {
                this.newsletter.removeEventListener(
                  "submit",
                  this.newsletterSubmit
                );
              }
              constructor(e) {
                (this.sessionStorage = window.sessionStorage),
                  (this.newsletter = e),
                  (this.stopSubmit = !0),
                  (this.isChallengePage = !1),
                  (this.formID = null),
                  this.checkForChallengePage(),
                  (this.newsletterSubmit = (e) =>
                    this.newsletterSubmitEvent(e)),
                  this.isChallengePage || this.init();
              }
            })(e)
          );
        });
      },
      onUnload() {
        to[this.id].forEach((e) => {
          "function" == typeof e.unload && e.unload();
        });
      },
    },
    so = "[data-shop-pay-wrapper]",
    ro = "shop-login-button",
    no = "shop-follow-button",
    oo = "follow-on-shop-button",
    ao = "heart-icon",
    lo = "shop-logo",
    co = {};
  const ho = {
    onLoad() {
      co[this.id] = new (class {
        init() {
          this.shopLoginButton &&
            this.shopPayWrapper &&
            ((this.mainButtonStyles = `\n      :host {\n        --bg-color: ${this.shopPayWrapper.dataset.bg};\n        --text-color: ${this.shopPayWrapper.dataset.text};\n        --hover-color: ${this.shopPayWrapper.dataset.hover};\n      }\n\n      .follow-icon-wrapper:before {\n        background: var(--bg-color);\n        border-color: var(--text-color);\n      }\n\n      .button:not(.button--following):focus-visible .follow-icon-wrapper:before,\n      .button:not(.button--following):hover .follow-icon-wrapper:before {\n        background: var(--bg-color);\n        border-color: var(--hover-color);\n      }\n\n      .button {\n        background: transparent;\n        color: var(--text-color);\n      }\n\n      .following-text {\n        color: var(--text-color);\n      }\n\n      .button--following:focus-visible,\n      .button--following:hover {\n        background: var(--bg-color);\n      }\n\n      .button:not(.button--following):focus-visible .follow-icon-wrapper:before,\n      .button:not(.button--following):hover .follow-icon-wrapper:before {\n        background: var(--bg-color);\n        border-color: var(--hover-color);\n      }\n    `),
            (this.svgIconsStyles = `\n      :host {\n        color: ${this.shopPayWrapper.dataset.text};\n      }\n    `),
            customElements.whenDefined(ro).then((e) => {
              requestAnimationFrame(() => {
                const e = this.shopLoginButton.shadowRoot,
                  t = null == e ? void 0 : e.querySelector(no),
                  i = null == t ? void 0 : t.shadowRoot,
                  s = null == i ? void 0 : i.querySelector(oo),
                  r = null == s ? void 0 : s.shadowRoot;
                r &&
                  this.overwriteStyles(
                    r.host.shadowRoot,
                    this.mainButtonStyles
                  );
                const n = r.querySelector(ao),
                  o = null == n ? void 0 : n.shadowRoot,
                  a = r.querySelector(lo),
                  l = null == a ? void 0 : a.shadowRoot;
                o &&
                  this.overwriteStyles(o.host.shadowRoot, this.svgIconsStyles),
                  l &&
                    this.overwriteStyles(
                      l.host.shadowRoot,
                      this.svgIconsStyles
                    );
              });
            }));
        }
        overwriteStyles(e, t) {
          let i = document.createElement("style");
          (i.innerHTML = t), e.appendChild(i);
        }
        constructor(e) {
          (this.container = e),
            (this.shopPayWrapper = document.querySelector(so)),
            (this.shopLoginButton = document.querySelector(ro)),
            this.init();
        }
      })(this.container);
    },
  };
  Gt("footer", [hn, io, ho]),
    customElements.get("popout-select") ||
      customElements.define("popout-select", Yr);
  const uo = {
      cc_load_policy: 1,
      iv_load_policy: 3,
      modestbranding: 1,
      playsinline: 1,
      controls: 1,
      showinfo: 0,
      ecver: 2,
      fs: 1,
      rel: 0,
    },
    po = "iframe, [data-replace]",
    mo = "data-video-id";
  function fo(e, t) {
    const i = { ...uo, ...t },
      s = document.querySelector(`[data-player="${e}"]`),
      r = s.querySelector(po),
      n = s.querySelector(`[${mo}]`).getAttribute(mo);
    xe({ url: "https://www.youtube.com/iframe_api" });
    return window.youtubeLoaderPromise
      .then(() => {
        let e = new window.YT.Player(r, {
          videoId: n,
          playerVars: { ...i },
          events: {
            onStateChange: (e) => {
              1 == e.data
                ? s.dispatchEvent(new CustomEvent("play"))
                : 2 == e.data && s.dispatchEvent(new CustomEvent("pause"));
            },
          },
        });
        return (
          s.addEventListener("pause", () => {
            try {
              e.pauseVideo();
            } catch (e) {
              console.warn(e);
            }
          }),
          s.addEventListener("play", () => {
            try {
              e.playVideo
                ? e.playVideo()
                : e.addEventListener("onReady", () => {
                    e.playVideo();
                  });
            } catch (e) {
              console.warn(e);
            }
          }),
          s.addEventListener("destroy", () => {
            try {
              e.destroy && e.destroy();
            } catch (e) {
              console.warn(e);
            }
          }),
          e
        );
      })
      .catch((e) => {
        console.error(e);
      });
  }
  window.youtubeLoaderPromise = new Promise((e) => {
    window.onYouTubeIframeAPIReady = function () {
      e();
    };
  });
  const go = {
      autoplay: !0,
      loop: !0,
      controls: !0,
      muted: !1,
      playsinline: !0,
    },
    yo = "iframe, [data-replace]",
    vo = "data-video-id";
  function bo(e, t) {
    const i = { ...go, ...t },
      s = document.querySelector(`[data-player="${e}"]`),
      r = s.querySelector(yo),
      n = s.querySelector(`[${vo}]`).getAttribute(vo),
      o = xe({ url: "https://player.vimeo.com/api/player.js" }),
      a = `select-${e}`;
    r.setAttribute("id", a);
    return o
      .then(() => {
        const e = new window.Vimeo.Player(a, { ...i, id: n });
        return (
          e.on("play", () => {
            s.dispatchEvent(new CustomEvent("play"));
          }),
          e.on("pause", () => {
            s.dispatchEvent(new CustomEvent("pause"));
          }),
          s.addEventListener("pause", () => {
            try {
              e.pause && e.pause();
            } catch (e) {
              console.warn(e);
            }
          }),
          s.addEventListener("play", () => {
            e.play &&
              e.getPaused().then((t) => {
                t && e.play();
              });
          }),
          s.addEventListener("destroy", () => {
            try {
              e.destroy && e.destroy();
            } catch (e) {
              console.log(e);
            }
          }),
          e
        );
      })
      .catch((e) => {
        console.error(e);
      });
  }
  const wo = "[data-video-popup]",
    So = "[data-video-autoplay]",
    Eo = "data-unique",
    Lo = "data-video-id",
    ko = "data-video-type",
    To = "data-player";
  const xo = {
      onLoad() {
        new (class {
          init() {
            this.triggers.forEach((e) => {
              const t = e.getAttribute(Eo),
                i = e.getAttribute(Lo),
                s = e.getAttribute(ko),
                r = `${i}-${t}`,
                o = document.querySelector(`[${To}="${r}"]`);
              n.init({
                onShow: () => {
                  this.backgroundVideo &&
                    "function" == typeof this.backgroundVideo.pause &&
                    this.backgroundVideo.pause();
                  let e = {};
                  "youtube" === s ? (e = fo(r)) : "vimeo" === s && (e = bo(r)),
                    e.then(() => {
                      o.dispatchEvent(new CustomEvent("play"));
                    });
                },
                onClose: (e, t, i) => {
                  i.preventDefault(),
                    o.dispatchEvent(new CustomEvent("destroy")),
                    this.backgroundVideo &&
                      "function" == typeof this.backgroundVideo.play &&
                      this.backgroundVideo.play();
                },
                openTrigger: `data-trigger-${i}-${t}`,
              });
            });
          }
          constructor(e) {
            (this.container = e.container),
              (this.triggers = this.container.querySelectorAll(wo)),
              (this.backgroundVideo = this.container.querySelector(So)),
              this.init();
          }
        })(this);
      },
    },
    _o = "[data-scroll-down]";
  const Ao = {
    onLoad() {
      this.scrollButton = new (class {
        init() {
          const e = this.wrapper.querySelectorAll(_o);
          e &&
            e.forEach((e) => {
              e.addEventListener("click", this.scroll.bind(this));
            });
        }
        scroll() {
          const e = this.wrapper.offsetTop + this.wrapper.clientHeight;
          window.scroll({ top: e, left: 0, behavior: "smooth" });
        }
        constructor(e) {
          (this.wrapper = e), this.init();
        }
      })(this.container);
    },
    onUnload: function () {
      delete this.scrollButton;
    },
  };
  Gt("video", [fi, Ao, xo]), Gt("page-faq", hn), Gt("hero", [fi, Ao, tt]);
  const qo = "[data-slider]",
    Co = "[data-grid-slide]",
    Po = "[data-wrapper]",
    $o = "data-custom-scrollbar-items",
    Io = "data-show-dots",
    Mo = "wrapper",
    Do = "wrapper--full",
    Oo = window.innerWidth - document.documentElement.clientWidth,
    Ho = 112,
    Fo = {};
  const Bo = {
    onLoad() {
      Fo[this.id] = [];
      this.container.querySelectorAll(qo).forEach((e) => {
        Fo[this.id].push(
          new (class {
            init() {
              const e = this,
                t = {
                  initialIndex: 0,
                  accessibility: !0,
                  autoPlay: !1,
                  contain: !0,
                  pageDots: this.pageDots,
                  adaptiveHeight: !1,
                  wrapAround: !1,
                  groupCells: !1,
                  cellAlign: "left",
                  freeScroll: !0,
                  prevNextButtons: !0,
                  draggable: !0,
                  rightToLeft: window.isRTL,
                  watchCSS: !0,
                  arrowShape: {
                    x0: 10,
                    x1: 60,
                    y1: 50,
                    x2: 65,
                    y2: 45,
                    x3: 20,
                  },
                  on: {
                    ready: function () {
                      e.removeIncorrectAria();
                    },
                  },
                };
              (this.flkty = new s(this.slideshow, t)),
                this.container.addEventListener("theme:tab:change", () => {
                  this.flkty.resize();
                }),
                this.toggleWrapperModifier(),
                document.addEventListener(
                  "theme:resize:width",
                  this.toggleWrapperModifier.bind(this)
                ),
                this.slideshow.hasAttribute($o) && new et(this.container),
                new Q(this.container);
            }
            toggleWrapperModifier() {
              this.wrapper.classList.contains(Mo) &&
                this.wrapper.classList.toggle(
                  Do,
                  this.wrapperWidthWithGutter >= window.innerWidth
                );
            }
            removeIncorrectAria() {
              this.slideshow
                .querySelectorAll('[aria-hidden="true"]')
                .forEach((e) => e.removeAttribute("aria-hidden"));
            }
            onUnload() {
              this.slideshow &&
                this.flkty &&
                ((this.flkty.options.watchCSS = !1), this.flkty.destroy());
            }
            constructor(e, t) {
              if (
                ((this.container = e),
                (this.slideshow = t),
                (this.wrapper = this.container.querySelector(Po)),
                (this.wrapperWidth = Number(
                  getComputedStyle(document.documentElement)
                    .getPropertyValue("--LAYOUT-WIDTH")
                    .replace("px", "")
                )),
                (this.wrapperWidthWithGutter = this.wrapperWidth + Ho + Oo),
                (this.pageDots = "true" === this.slideshow.getAttribute(Io)),
                (this.firstPhoto = this.container.querySelector(Co)),
                this.firstPhoto)
              ) {
                const e = this.firstPhoto.offsetHeight / 2;
                this.slideshow.style.setProperty("--buttons-top", `${e}px`);
              }
              this.slideshow && ((this.flkty = null), this.init());
            }
          })(this.container, e)
        );
      });
    },
    onUnload(e) {
      Fo[this.id].forEach((t) => {
        "function" == typeof t.onUnload && t.onUnload(e);
      });
    },
  };
  Gt("custom-content", [fi, xo, Je, Bo]),
    customElements.get("radio-swatch") ||
      customElements.define("radio-swatch", Ue),
    customElements.get("product-grid-item") ||
      customElements.define("product-grid-item", br),
    customElements.get("product-grid-item-variant") ||
      customElements.define("product-grid-item-variant", Mr),
    customElements.get("product-grid-item-image") ||
      customElements.define("product-grid-item-image", Hr);
  const Wo = [],
    No = "[data-slideshow-wrapper]",
    Ro = "data-slideshow-speed",
    jo = "data-slideshow-autoplay",
    zo = "data-slideshow-slides",
    Vo = "[data-slide-custom-prev]",
    Uo = "[data-slide-custom-next]",
    Go = "data-slideshow-index",
    Jo = "flickity-enabled";
  Gt("slideshow", [
    {
      onLoad() {
        Wo[this.id] = new (class {
          init() {
            const e = {
              autoPlay:
                !(!this.autoplay || !this.speed) && parseInt(this.speed),
              contain: !1,
              pageDots: !0,
              adaptiveHeight: !0,
              accessibility: !0,
              wrapAround: 2 !== this.slideCount,
              prevNextButtons: !1,
              draggable: !0,
              fade: !0,
              rightToLeft: window.isRTL,
            };
            (this.flkty = new t(this.wrapper, e)),
              this.prevButtons.length &&
                this.prevButtons.forEach((e) => {
                  e.onclick = () => {
                    this.flkty.previous(!0, !1);
                  };
                }),
              this.nextButtons.length &&
                this.nextButtons.forEach((e) => {
                  e.onclick = () => {
                    this.flkty.next(!0, !1);
                  };
                }),
              document.addEventListener("theme:scroll", this.scrollEvent);
          }
          scrollEvents() {
            if (this.flkty && this.autoplay && this.speed) {
              const e = this.flkty.element,
                t =
                  e.getBoundingClientRect().top +
                  window.scrollY +
                  e.offsetHeight;
              window.pageYOffset > t
                ? "playing" === this.flkty.player.state &&
                  this.flkty.pausePlayer()
                : "paused" === this.flkty.player.state &&
                  this.flkty.playPlayer();
            }
          }
          unload() {
            document.removeEventListener("theme:scroll", this.scrollEvent),
              this.flkty &&
                this.wrapper &&
                this.wrapper.classList.contains(Jo) &&
                this.flkty.destroy();
          }
          onBlockSelect(e) {
            const t = e.target.closest(`[${Go}]`).getAttribute(Go),
              i = parseInt(t);
            this.flkty.selectCell(i), this.flkty.stopPlayer();
          }
          onBlockDeselect() {
            this.autoplay && this.flkty.playPlayer();
          }
          constructor(e) {
            (this.container = e.container),
              (this.wrapper = e.container.querySelector(No)),
              (this.speed = this.wrapper.getAttribute(Ro)),
              (this.autoplay = "true" === this.wrapper.getAttribute(jo)),
              (this.slideCount = parseInt(this.wrapper.getAttribute(zo), 10)),
              (this.prevButtons = this.wrapper.querySelectorAll(Vo)),
              (this.nextButtons = this.wrapper.querySelectorAll(Uo)),
              (this.flkty = null),
              (this.scrollEvent = () => this.scrollEvents()),
              this.init();
          }
        })(this);
      },
      onUnload() {
        "function" == typeof Wo[this.id].unload && Wo[this.id].unload();
      },
      onBlockSelect(e) {
        "function" == typeof Wo[this.id].onBlockSelect &&
          Wo[this.id].onBlockSelect(e);
      },
      onBlockDeselect(e) {
        "function" == typeof Wo[this.id].onBlockSelect &&
          Wo[this.id].onBlockDeselect(e);
      },
    },
    fi,
    Ao,
  ]);
  const Qo = "[data-range-slider]",
    Ko = "[data-range-left]",
    Yo = "[data-range-right]",
    Xo = "[data-range-line]",
    Zo = "[data-range-holder]",
    ea = "data-se-min",
    ta = "data-se-max",
    ia = "data-se-min-value",
    sa = "data-se-max-value",
    ra = "data-se-step",
    na = "data-range-filter-update",
    oa = "[data-field-price-min]",
    aa = "[data-field-price-max]",
    la = "is-initialized";
  let ca = class {
    init() {
      this.setDefaultValues(),
        this.touchLeft.addEventListener("mousedown", this.onStartEvent),
        this.touchRight.addEventListener("mousedown", this.onStartEvent),
        this.touchLeft.addEventListener("touchstart", this.onStartEvent),
        this.touchRight.addEventListener("touchstart", this.onStartEvent),
        this.slider.classList.add(la);
    }
    setDefaultValues() {
      let e = this.min;
      this.slider.hasAttribute(ia) &&
        (e = parseFloat(this.slider.getAttribute(ia)));
      let t = this.max;
      this.slider.hasAttribute(sa) &&
        (t = parseFloat(this.slider.getAttribute(sa))),
        e < this.min && (e = this.min),
        t > this.max && (t = this.max),
        e > t && (e = t),
        this.slider.getAttribute(ra) &&
          (this.step = Math.abs(parseFloat(this.slider.getAttribute(ra)))),
        this.reset(),
        (this.maxX = this.slider.offsetWidth - this.touchRight.offsetWidth),
        (this.selectedTouch = null),
        (this.initialValue = this.lineSpan.offsetWidth - this.normalizeFact),
        this.setMinValue(e),
        this.setMaxValue(t);
    }
    reset() {
      (this.touchLeft.style.left = "0px"),
        (this.touchRight.style.left =
          this.slider.offsetWidth - this.touchLeft.offsetWidth + "px"),
        (this.lineSpan.style.marginLeft = "0px"),
        (this.lineSpan.style.width =
          this.slider.offsetWidth - this.touchLeft.offsetWidth + "px"),
        (this.startX = 0),
        (this.x = 0);
    }
    setMinValue(e) {
      const t = (e - this.min) / (this.max - this.min);
      (this.touchLeft.style.left =
        Math.ceil(
          t *
            (this.slider.offsetWidth -
              (this.touchLeft.offsetWidth + this.normalizeFact))
        ) + "px"),
        (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
        (this.lineSpan.style.width =
          this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
        this.slider.setAttribute(ia, e);
    }
    setMaxValue(e) {
      const t = (e - this.min) / (this.max - this.min);
      (this.touchRight.style.left =
        Math.ceil(
          t *
            (this.slider.offsetWidth -
              (this.touchLeft.offsetWidth + this.normalizeFact)) +
            this.normalizeFact
        ) + "px"),
        (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
        (this.lineSpan.style.width =
          this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
        this.slider.setAttribute(sa, e);
    }
    onStart(e) {
      e.preventDefault();
      let t = e;
      e.touches && (t = e.touches[0]),
        e.currentTarget === this.touchLeft
          ? (this.x = this.touchLeft.offsetLeft)
          : e.currentTarget === this.touchRight &&
            (this.x = this.touchRight.offsetLeft),
        (this.startX = t.pageX - this.x),
        (this.selectedTouch = e.currentTarget),
        document.addEventListener("mousemove", this.onMoveEvent),
        document.addEventListener("mouseup", this.onStopEvent),
        document.addEventListener("touchmove", this.onMoveEvent),
        document.addEventListener("touchend", this.onStopEvent);
    }
    onMove(e) {
      let t = e;
      if (
        (e.touches && (t = e.touches[0]),
        (this.x = t.pageX - this.startX),
        this.selectedTouch === this.touchLeft
          ? (this.x >
            this.touchRight.offsetLeft - this.selectedTouch.offsetWidth + 10
              ? (this.x =
                  this.touchRight.offsetLeft -
                  this.selectedTouch.offsetWidth +
                  10)
              : this.x < 0 && (this.x = 0),
            (this.selectedTouch.style.left = this.x + "px"))
          : this.selectedTouch === this.touchRight &&
            (this.x <
            this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10
              ? (this.x =
                  this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10)
              : this.x > this.maxX && (this.x = this.maxX),
            (this.selectedTouch.style.left = this.x + "px")),
        (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
        (this.lineSpan.style.width =
          this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
        this.calculateValue(),
        this.slider.getAttribute("on-change"))
      ) {
        new Function("min, max", this.slider.getAttribute("on-change"))(
          this.slider.getAttribute(ia),
          this.slider.getAttribute(sa)
        );
      }
      this.onChange(this.slider.getAttribute(ia), this.slider.getAttribute(sa));
    }
    onStop(e) {
      document.removeEventListener("mousemove", this.onMoveEvent),
        document.removeEventListener("mouseup", this.onStopEvent),
        document.removeEventListener("touchmove", this.onMoveEvent),
        document.removeEventListener("touchend", this.onStopEvent),
        (this.selectedTouch = null),
        this.calculateValue(),
        this.onChanged(
          this.slider.getAttribute(ia),
          this.slider.getAttribute(sa)
        );
    }
    onChange(e, t) {
      const i = this.slider.closest(Zo);
      if (i) {
        const s = i.querySelector(oa),
          r = i.querySelector(aa);
        s && r && ((s.value = e), (r.value = t));
      }
    }
    onChanged(e, t) {
      this.slider.hasAttribute(na) &&
        this.slider.dispatchEvent(
          new CustomEvent("theme:range:update", { bubbles: !0 })
        );
    }
    calculateValue() {
      const e =
        (this.lineSpan.offsetWidth - this.normalizeFact) / this.initialValue;
      let t = this.lineSpan.offsetLeft / this.initialValue,
        i = t + e;
      if (
        ((t = t * (this.max - this.min) + this.min),
        (i = i * (this.max - this.min) + this.min),
        0 !== this.step)
      ) {
        let e = Math.floor(t / this.step);
        (t = this.step * e),
          (e = Math.floor(i / this.step)),
          (i = this.step * e);
      }
      this.selectedTouch === this.touchLeft && this.slider.setAttribute(ia, t),
        this.selectedTouch === this.touchRight &&
          this.slider.setAttribute(sa, i);
    }
    constructor(e) {
      (this.container = e.container),
        (this.slider = e.querySelector(Qo)),
        this.slider &&
          ((this.onMoveEvent = (e) => this.onMove(e)),
          (this.onStopEvent = (e) => this.onStop(e)),
          (this.onStartEvent = (e) => this.onStart(e)),
          (this.startX = 0),
          (this.x = 0),
          (this.touchLeft = this.slider.querySelector(Ko)),
          (this.touchRight = this.slider.querySelector(Yo)),
          (this.lineSpan = this.slider.querySelector(Xo)),
          (this.min = parseFloat(this.slider.getAttribute(ea))),
          (this.max = parseFloat(this.slider.getAttribute(ta))),
          (this.step = 0),
          (this.normalizeFact = 26),
          this.init(),
          document.addEventListener("theme:price-range:reset", () => {
            this.setDefaultValues();
          }));
    }
  };
  const ha = (e, t) => {
      let i, s;
      return function r(...n) {
        const o = Date.now();
        (s = clearTimeout(s)),
          !i || o - i >= t
            ? (e.apply(null, n), (i = o))
            : (s = setTimeout(r.bind(null, ...n), t - (o - i)));
      };
    },
    da = "data-filters",
    ua = "[data-filters-underlay]",
    pa = "data-default-hide",
    ma = "data-filters-toggle",
    fa =
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
    ga = "data-group-heading",
    ya = "data-show-more",
    va = "drawer--visible",
    ba = "filters--default-visible",
    wa = "hidden",
    Sa = "is-hidden",
    Ea = "focus-enabled",
    La = {};
  let ka = class {
    unload() {
      this.filtersToggleButtons.length &&
        this.filtersToggleButtons.forEach((e) => {
          e.removeEventListener("click", this.connectToggleMemory);
        }),
        this.showMoreButtons.length &&
          this.showMoreButtons.forEach((e) => {
            e.removeEventListener("click", this.connectShowHiddenOptions);
          });
    }
    expandingEvents() {
      this.showMoreButtons.length &&
        this.showMoreButtons.forEach((e) => {
          e.addEventListener("click", ha(this.connectShowHiddenOptions, 500));
        });
    }
    showHiddenOptions(e) {
      const t = e.target.hasAttribute(ya)
        ? e.target
        : e.target.closest(`[${ya}]`);
      t.classList.add(Sa),
        t.previousElementSibling.querySelectorAll(`.${Sa}`).forEach((e) => {
          e.classList.remove(Sa);
        });
    }
    connectToggle(e = !1) {
      this.filtersToggleButtons.forEach((t) => {
        const i = null !== t.closest(`[${da}]`);
        ((i && e) || (i && !e) || (!i && !e)) &&
          t.addEventListener("click", this.connectToggleMemory.bind(this));
      });
    }
    connectToggleFunction(e) {
      "true" === e.currentTarget.getAttribute("aria-expanded")
        ? this.hideFilters()
        : this.showFilters();
    }
    onFocusOut() {
      this.container.addEventListener(
        "focusout",
        function (e) {
          if (window.innerWidth >= window.theme.sizes.medium) return;
          const t = e.currentTarget.contains(e.relatedTarget),
            i = this.container.classList.contains(va);
          document.body.classList.contains(Ea) && i && !t && this.hideFilters();
        }.bind(this)
      ),
        this.container.addEventListener(
          "keyup",
          function (e) {
            "Escape" === e.code &&
              (this.hideFilters(), this.filtersToggleButtons[0].focus());
          }.bind(this)
        ),
        this.underlay.addEventListener(
          "click",
          function () {
            this.hideFilters();
          }.bind(this)
        );
    }
    getShowOnLoad() {
      const e = `[${pa}='false']`,
        t = document.querySelector(e),
        i = window.innerWidth >= window.theme.sizes.medium;
      return !(!t || !i);
    }
    showFilters() {
      (this.filtersToggleButtons = document.querySelectorAll(this.selector)),
        this.container.classList.remove(wa),
        setTimeout(() => {
          this.filtersToggleButtons.forEach((e) =>
            e.setAttribute("aria-expanded", !0)
          ),
            this.filtersToggleButtons.forEach((e) => e.classList.add(va)),
            this.container.classList.add(va),
            this.container.querySelector(fa).focus();
        }, 1);
    }
    hideFilters() {
      (this.filtersToggleButtons = document.querySelectorAll(this.selector)),
        this.filtersToggleButtons.forEach((e) =>
          e.setAttribute("aria-expanded", !1)
        ),
        this.container.classList.remove(va),
        this.container.classList.remove(ba),
        this.filtersToggleButtons.forEach((e) => e.classList.remove(va)),
        this.filtersToggleButtons.forEach((e) => e.classList.remove(ba)),
        setTimeout(() => {
          this.container.classList.contains(va) ||
            this.container.classList.add(wa);
        }, 800);
    }
    constructor(e, t = !1) {
      (this.container = e),
        (this.underlay = this.container.querySelector(ua)),
        (this.groupHeadings = this.container.querySelectorAll(`[${ga}]`)),
        (this.showMoreButtons = this.container.querySelectorAll(`[${ya}]`)),
        (this.triggerKey = this.container.getAttribute(da)),
        (this.selector = `[${ma}='${this.triggerKey}']`),
        (this.filtersToggleButtons = document.querySelectorAll(this.selector)),
        (this.connectToggleMemory = (e) => this.connectToggleFunction(e)),
        (this.connectShowHiddenOptions = (e) => this.showHiddenOptions(e)),
        this.connectToggle(t),
        this.onFocusOut(),
        this.expandingEvents(),
        this.getShowOnLoad() ? this.showFilters() : this.hideFilters();
    }
  };
  const Ta = {
      onLoad() {
        La[this.id] = [];
        this.container.querySelectorAll(`[${da}]`).forEach((e) => {
          La[this.id].push(new ka(e));
        });
      },
      onUnload: function () {
        La[this.id].forEach((e) => {
          "function" == typeof e.unload && e.unload();
        });
      },
    },
    xa = {
      collectionSidebar: "[data-collection-sidebar]",
      form: "[data-sidebar-filter-form]",
      inputs: "input, select, label, textarea",
      priceMin: "data-field-price-min",
      priceMax: "data-field-price-max",
      rangeMin: "data-se-min-value",
      rangeMax: "data-se-max-value",
      rangeMinDefault: "data-se-min",
      rangeMaxDefault: "data-se-max",
      productsContainer: "[data-products-grid]",
      filterUpdateUrlButton: "[data-filter-update-url]",
      activeFiltersHolder: "[data-active-filters]",
      activeFiltersCount: "[data-active-filters-count]",
      productsCount: "[data-products-count]",
      dataSort: "data-sort-enabled",
      collectionTools: "[data-collection-tools]",
      filtersWrappper: "[data-filters]",
      headerSticky: '[data-header-sticky="sticky"]',
      headerHeight: "[data-header-height]",
      gridLarge: "data-grid-large",
      gridSmall: "data-grid-small",
      accordionBody: "[data-accordion-body]",
      checkedOption: "input:checked",
      optionHolder: "[data-option-holder]",
    },
    _a = "is-hidden",
    Aa = "is-loading",
    qa = 1e3,
    Ca = 1e3;
  const Pa = {
    onLoad() {
      this.filterForm = new (class {
        init() {
          this.showAllOptions(),
            this.form &&
              (new ca(this.form),
              this.sidebar.addEventListener(
                "input",
                T((e) => {
                  const t = e.type,
                    i = e.target;
                  if (
                    !xa.inputs.includes(t) ||
                    !this.form ||
                    "function" != typeof this.form.submit
                  )
                    return;
                  const s = this.form.querySelector(`[${xa.priceMin}]`),
                    r = this.form.querySelector(`[${xa.priceMax}]`);
                  if (
                    i.hasAttribute(xa.priceMin) ||
                    i.hasAttribute(xa.priceMax)
                  ) {
                    const e = this.form.querySelector(`[${xa.rangeMin}]`),
                      t = this.form.querySelector(`[${xa.rangeMax}]`),
                      i = parseInt(e.getAttribute(xa.rangeMinDefault)),
                      n = parseInt(t.getAttribute(xa.rangeMaxDefault));
                    s.value && !r.value && (r.value = n),
                      r.value && !s.value && (s.value = i),
                      s.value <= i &&
                        r.value >= n &&
                        ((s.placeholder = i),
                        (r.placeholder = n),
                        (s.value = ""),
                        (r.value = ""));
                  }
                  this.filtering(e);
                }, 1500)
              ),
              this.form.addEventListener("theme:range:update", (e) =>
                this.updateRange(e)
              )),
            this.sidebar &&
              this.sidebar.addEventListener("click", (e) =>
                this.updateFilterFromUrl(e)
              ),
            this.activeFiltersHolder &&
              this.activeFiltersHolder.addEventListener("click", (e) =>
                this.updateFilterFromUrl(e)
              ),
            this.productsContainer &&
              this.productsContainer.addEventListener("click", (e) =>
                this.updateFilterFromUrl(e)
              ),
            Pe(this.sidebar);
        }
        updateRange(e) {
          if (this.form && "function" == typeof this.form.submit) {
            const t = this.form.querySelector(`[${xa.rangeMin}]`),
              i = this.form.querySelector(`[${xa.rangeMax}]`),
              s = this.form.querySelector(`[${xa.priceMin}]`),
              r = this.form.querySelector(`[${xa.priceMax}]`);
            if (
              t &&
              i &&
              s &&
              r &&
              t.hasAttribute(xa.rangeMin) &&
              i.hasAttribute(xa.rangeMax)
            ) {
              const n = parseInt(s.placeholder),
                o = parseInt(r.placeholder),
                a = parseInt(t.getAttribute(xa.rangeMin)),
                l = parseInt(i.getAttribute(xa.rangeMax));
              (n === a && o === l) ||
                ((s.value = a), (r.value = l), this.filtering(e));
            }
          }
        }
        updateFilterFromUrl(e) {
          const t = e.target;
          if (
            t.matches(xa.filterUpdateUrlButton) ||
            (t.closest(xa.filterUpdateUrlButton) && t)
          ) {
            e.preventDefault();
            const i = t.matches(xa.filterUpdateUrlButton)
              ? t
              : t.closest(xa.filterUpdateUrlButton);
            this.filtering(e, i.getAttribute("href"));
          }
        }
        addToHistory(e, t = "") {
          const i = this.sort ? this.sort.getAttribute(xa.dataSort) : "";
          if (!e || (e && "popstate" !== e.type)) {
            if ("" === t) {
              const t = new window.URL(window.location.href).searchParams,
                s = Object.fromEntries(t),
                r = t.toString();
              if (
                r.includes("filter.") ||
                r.includes("sort_by") ||
                r.includes("page")
              )
                for (const e in s)
                  (e.includes("filter.") ||
                    e.includes("sort_by") ||
                    e.includes("page")) &&
                    t.delete(e);
              if (this.form) {
                const e = new URLSearchParams(new FormData(this.form));
                for (let [i, s] of e.entries())
                  i.includes("filter.") && s && t.append(i, s);
                const i = this.form.querySelector(`[${xa.rangeMin}]`),
                  s = this.form.querySelector(`[${xa.rangeMax}]`),
                  r = this.form.querySelector(`[${xa.priceMin}]`),
                  n = this.form.querySelector(`[${xa.priceMax}]`);
                if (
                  i &&
                  s &&
                  r &&
                  n &&
                  i.hasAttribute(xa.rangeMinDefault) &&
                  s.hasAttribute(xa.rangeMaxDefault)
                ) {
                  const e = parseFloat(i.getAttribute(xa.rangeMinDefault), 10),
                    o = parseFloat(s.getAttribute(xa.rangeMaxDefault), 10),
                    a =
                      "" === r.value
                        ? parseFloat(r.placeholder, 10)
                        : parseFloat(r.value, 10),
                    l =
                      "" === n.value
                        ? parseFloat(n.placeholder, 10)
                        : parseFloat(n.value, 10);
                  a <= e &&
                    l >= o &&
                    (t.delete("filter.v.price.gte"),
                    t.delete("filter.v.price.lte"));
                }
              }
              if (i || (e && e.detail && e.detail.href)) {
                const s = i || e.detail.params;
                t.set("sort_by", s);
              }
              const n = t.toString(),
                o = n ? `?${n}` : location.pathname;
              return void window.history.pushState(null, "", o);
            }
            window.history.pushState(null, "", t);
          }
        }
        getFilterResult() {
          this.productsContainer.classList.add(Aa), this.getGridValues();
          const e = new window.URL(window.location.href);
          e.searchParams.set("section_id", this.section.id),
            fetch(`${window.location.pathname}${e.search}`)
              .then((e) => e.text())
              .then((e) => {
                const t = document.createElement("div");
                (t.innerHTML = e),
                  this.sidebar &&
                    (this.sidebar.innerHTML = t.querySelector(
                      xa.collectionSidebar
                    ).innerHTML),
                  this.activeFiltersCount &&
                    (this.activeFiltersCount.innerHTML = t.querySelector(
                      xa.activeFiltersCount
                    ).innerHTML),
                  (this.productsContainer.innerHTML = t.querySelector(
                    xa.productsContainer
                  ).innerHTML),
                  (this.activeFiltersHolder.innerHTML = t.querySelector(
                    xa.activeFiltersHolder
                  ).innerHTML),
                  this.activeFiltersHolder.parentNode.classList.toggle(
                    _a,
                    "" === this.activeFiltersHolder.innerHTML
                  ),
                  this.productsCount &&
                    (this.productsCount.innerHTML = t.querySelector(
                      xa.productsCount
                    ).innerHTML),
                  this.setGridValues(),
                  this.refreshFunctionalities(),
                  setTimeout(() => {
                    this.productsContainer.classList.remove(Aa);
                  }, qa);
              });
        }
        refreshFunctionalities() {
          (this.form = this.container.querySelector(xa.form)),
            this.form &&
              (new ca(this.form),
              this.form.addEventListener("theme:range:update", (e) =>
                this.updateRange(e)
              )),
            this.container.querySelectorAll(xa.filtersWrappper).forEach((e) => {
              new ka(e, !0);
            }),
            this.container.querySelectorAll(xa.accordionBody).forEach((e) => {
              new cn(e);
            }),
            new Q(this.container),
            this.sidebar && Pe(this.sidebar),
            Ge(this.container),
            this.showAllOptions();
        }
        getGridValues() {
          this.layoutLarge &&
            (this.layoutLargeValue = this.layoutLarge.getAttribute(
              xa.gridLarge
            )),
            this.layoutSmall &&
              (this.layoutSmallValue = this.layoutSmall.getAttribute(
                xa.gridSmall
              ));
        }
        setGridValues() {
          this.layoutLarge &&
            ((this.layoutLarge = this.container.querySelector(
              `[${xa.gridLarge}]`
            )),
            this.layoutLarge.setAttribute(xa.gridLarge, this.layoutLargeValue)),
            this.layoutSmall &&
              ((this.layoutSmall = this.container.querySelector(
                `[${xa.gridSmall}]`
              )),
              this.layoutSmall.setAttribute(
                xa.gridSmall,
                this.layoutSmallValue
              ));
        }
        showAllOptions() {
          this.container.querySelectorAll(xa.checkedOption).forEach((e) => {
            if (
              e.closest(xa.optionHolder) &&
              e.closest(xa.optionHolder).classList.contains(_a)
            ) {
              const t = e.closest(xa.accordionBody).nextElementSibling;
              t.classList.contains(xa.classHidden) ||
                t.dispatchEvent(new Event("click"));
            }
          });
        }
        filtering(e, t = "") {
          const i = this.headerIsSticky
              ? document.querySelector(xa.headerHeight).getBoundingClientRect()
                  .height
              : 0,
            s = this.container.offsetTop - i,
            r = new IntersectionObserver(
              (i) => {
                const [n] = i;
                setTimeout(
                  () => {
                    this.addToHistory(e, t), this.getFilterResult();
                  },
                  n.isIntersecting ? 10 : Ca
                ),
                  r.unobserve(this.productsContainer),
                  n.isIntersecting ||
                    window.scrollTo({ top: s, left: 0, behavior: "smooth" });
              },
              { root: null, rootMargin: `${i}px`, threshold: 1 }
            );
          r.observe(this.productsContainer);
        }
        constructor(e) {
          (this.section = e),
            (this.container = this.section.container),
            (this.sidebar = this.container.querySelector(xa.collectionSidebar)),
            (this.form = e.container.querySelector(xa.form)),
            (this.sort = this.container.querySelector(`[${xa.dataSort}]`)),
            (this.productsContainer = this.container.querySelector(
              xa.productsContainer
            )),
            (this.activeFiltersHolder = this.container.querySelector(
              xa.activeFiltersHolder
            )),
            (this.activeFiltersCount = this.container.querySelector(
              xa.activeFiltersCount
            )),
            (this.productsCount = this.container.querySelector(
              xa.productsCount
            )),
            (this.headerIsSticky =
              null !== document.querySelector(xa.headerSticky)),
            (this.layoutLarge = this.container.querySelector(
              `[${xa.gridLarge}]`
            )),
            (this.layoutSmall = this.container.querySelector(
              `[${xa.gridSmall}]`
            )),
            this.productsContainer && this.sidebar && this.init(),
            this.sort &&
              this.container.addEventListener("theme:form:filter", (e) =>
                this.filtering(e)
              ),
            (this.sidebar || this.sort) &&
              window.addEventListener("popstate", (e) => this.filtering(e));
        }
      })(this);
    },
    onUnload() {
      this.filterForm &&
        "function" == typeof this.filterForm.unload &&
        this.filterForm.unload();
    },
  };
  Gt("search-page", [Ta, Pa, Je, hn]),
    customElements.get("popout-select") ||
      customElements.define("popout-select", Yr),
    customElements.get("radio-swatch") ||
      customElements.define("radio-swatch", Ue),
    customElements.get("product-grid-item") ||
      customElements.define("product-grid-item", br),
    customElements.get("product-grid-item-variant") ||
      customElements.define("product-grid-item-variant", Mr),
    customElements.get("product-grid-item-image") ||
      customElements.define("product-grid-item-image", Hr);
  const $a = "[data-image-zoom]",
    Ia = "[data-modal-container]",
    Ma = "data-unique",
    Da = "data-src";
  const Oa = {
    onLoad() {
      new (class {
        init() {
          this.triggers.forEach((e) => {
            const t = e.getAttribute(Ma),
              i = this.modalContainer.querySelector(`#zoom-${t}`);
            if (i) {
              const e = this.container.querySelector(`#zoom-${t}`);
              e &&
                (i.parentNode.removeChild(i),
                this.modalContainer.appendChild(e));
            }
            n.init({
              disableScroll: !0,
              openTrigger: `data-popup-${t}`,
              onShow: (e) => {
                e.querySelectorAll(`[${Da}]`, e).forEach((e) => {
                  if (null === e.getAttribute("src")) {
                    const t = e.getAttribute(Da);
                    e.setAttribute("src", t);
                  }
                });
              },
              onClose: (e, t, i) => {
                i.preventDefault();
              },
            });
          });
        }
        constructor(e) {
          (this.container = e),
            (this.triggers = this.container.querySelectorAll($a)),
            (this.modalContainer = document.querySelector(Ia)),
            this.init();
        }
      })(this.container);
    },
  };
  Gt("gallery", [Oa, xo, tt]);
  const Ha = (e, t) => {
    const {
      el: i,
      elStyle: s,
      elHeight: r,
      rowsLimit: n,
      rowsWrapped: o,
      options: a,
    } = e;
    let l = e.buffer,
      c = l;
    if (o === n + 1) return { ...e };
    const h = l;
    let d = o,
      u = r;
    return (
      (i.innerHTML = c =
        l.length
          ? `${l}${a.delimiter}${t}${a.replaceStr}`
          : `${t}${a.replaceStr}`),
      parseFloat(s.height) > parseFloat(r) && (d++, (u = s.height), d === n + 1)
        ? ((i.innerHTML = c =
            "." === h[h.length - 1] && "..." === a.replaceStr
              ? `${h}..`
              : `${h}${a.replaceStr}`),
          { ...e, elHeight: u, rowsWrapped: d })
        : ((i.innerHTML = c = h.length ? `${h}${a.delimiter}${t}` : `${t}`),
          { ...e, buffer: c, elHeight: u, rowsWrapped: d })
    );
  };
  !(function () {
    const e =
      "ontouchstart" in window ||
      navigator.maxTouchPoints > 0 ||
      navigator.msMaxTouchPoints > 0;
    document.documentElement.classList.toggle("supports-touch", e);
  })();
  let Fa = {},
    Ba = {},
    Wa = {};
  const Na = "[data-product-slideshow]",
    Ra = "[data-shopify-xr]",
    ja = "data-media-id",
    za = "data-model-id",
    Va = "model-viewer",
    Ua = "data-shopify-model3d-id",
    Ga = "#ModelJson-";
  function Ja(e) {
    if (e) console.warn(e);
    else if (window.ShopifyXR) {
      for (const e in Fa)
        if (Fa.hasOwnProperty(e)) {
          const t = Fa[e];
          if (t.loaded) continue;
          const i = document.querySelector(`${Ga}${e}`);
          i &&
            (window.ShopifyXR.addModels(JSON.parse(i.innerHTML)),
            (t.loaded = !0));
        }
      window.ShopifyXR.setupXRElements();
    } else
      document.addEventListener("shopify_xr_initialized", function () {
        Ja();
      });
  }
  function Qa(e) {
    if (e) console.warn(e);
    else
      for (const e in Ba)
        if (Ba.hasOwnProperty(e)) {
          const t = Ba[e];
          t.modelViewerUi ||
            (t.modelViewerUi = new Shopify.ModelViewerUI(t.$element)),
            Ka(t);
        }
  }
  function Ka(e) {
    const t = Wa[e.sectionId];
    e.$container.addEventListener("pause", function () {
      e.modelViewerUi.pause && e.modelViewerUi.pause();
    }),
      e.$container.addEventListener("play", function () {
        e.modelViewerUi.play &&
          (e.modelViewerUi.play(),
          t &&
            t.$element &&
            e &&
            e.modelId &&
            Ua &&
            t.$element.setAttribute(Ua, e.modelId));
      }),
      e.$element.addEventListener("shopify_model_viewer_ui_toggle_play", () => {
        e.$container.dispatchEvent(new CustomEvent("theme:media:play"));
      }),
      e.$element.addEventListener(
        "shopify_model_viewer_ui_toggle_pause",
        () => {
          e.$container.dispatchEvent(new CustomEvent("theme:media:pause"));
        }
      );
  }
  async function Ya(e) {
    const t = document.querySelector(`[data-player="${e}"]`),
      i = t.querySelector("video");
    await xe({ name: "video-ui", version: "1.0" });
    const s = new window.Shopify.Plyr(i);
    return (
      t.addEventListener("pause", () => {
        s.pause && s.pause();
      }),
      t.addEventListener("play", () => {
        try {
          s.play
            ? s.paused && s.play()
            : s.addEventListener("onReady", () => {
                s.play();
              });
        } catch (e) {
          console.warn(e);
        }
      }),
      t.addEventListener("destroy", () => {
        try {
          s.destroy && s.destroy();
        } catch (e) {
          console.warn(e);
        }
      }),
      s
    );
  }
  const Xa = {
      productSlideshow: "[data-product-slideshow]",
      slideshowMobileStyle: "data-slideshow-mobile-style",
      slideshowDesktopStyle: "data-slideshow-desktop-style",
      productThumbs: "[data-product-thumbs]",
      leftThumbsHolder: "[data-thumbs-holder]",
      thumbImage: "[data-slideshow-thumbnail]",
      mediaSlide: "[data-media-slide]",
      dataMediaId: "data-media-id",
      dataMediaSelect: "data-media-select",
      mediaType: "data-type",
      videoPlayerExternal: '[data-type="external_video"]',
      videoPlayerNative: '[data-type="video"]',
      modelViewer: '[data-type="model"]',
      modelViewerTag: "model-viewer",
      allPlayers: "[data-player]",
      loopVideo: "data-enable-video-looping",
      verticalAlignment: "[data-thumbnails-left]",
      arrowPrev: "[data-thumbs-arrow-prev]",
      arrowNext: "[data-thumbs-arrow-next]",
      aspectRatio: "data-aspect-ratio",
      flickitylockHeight: "flickity-lock-height",
    },
    Za = "is-activated",
    el = "show",
    tl = "enable-video-draggable",
    il = "hide";
  function sl(e, t) {
    return (
      "youtube" === t
        ? e.addEventListener("onStateChange", (e) => {
            0 === e.data && e.target.playVideo();
          })
        : "vimeo" === t &&
          e.on("ended", () => {
            e.play();
          }),
      e
    );
  }
  const rl = "data-store-availability-container",
    nl = "[data-api-content]",
    ol = "[data-pickup-drawer]",
    al = "[data-pickup-drawer-open]",
    ll = "[data-pickup-drawer-close]",
    cl = "[data-pickup-body]",
    hl = "drawer--visible",
    dl = "hide",
    ul = "is-pickup-visible";
  let pl = {};
  const ml = {
      onLoad() {
        pl[this.id] = new (class {
          fetchPickupAvailability(e) {
            const t = this.container.querySelector(`[${rl}]`);
            if (!t) return;
            const i =
              e && e.detail.variant ? e.detail.variant.id : t.getAttribute(rl);
            !e || e.detail.variant
              ? i &&
                fetch(
                  `${window.theme.routes.root_url}variants/${i}/?section_id=api-pickup-availability`
                )
                  .then(this.handleErrors)
                  .then((e) => e.text())
                  .then((e) => {
                    const i = new DOMParser()
                      .parseFromString(e, "text/html")
                      .querySelector(nl).innerHTML;
                    (t.innerHTML = i),
                      t.classList.remove(dl),
                      (this.drawer = this.container.querySelector(ol)),
                      (this.buttonDrawerOpen =
                        this.container.querySelector(al)),
                      (this.buttonDrawerClose =
                        this.container.querySelectorAll(ll)),
                      (this.drawerBody = this.container.querySelector(cl)),
                      this.buttonDrawerOpen &&
                        this.buttonDrawerOpen.addEventListener("click", () =>
                          this.openDrawer()
                        ),
                      this.buttonDrawerClose.length &&
                        this.buttonDrawerClose.forEach((e) => {
                          e.addEventListener("click", () => this.closeDrawer());
                        });
                  })
                  .catch((e) => {
                    console.error(e);
                  })
              : t.classList.add(dl);
          }
          openDrawer() {
            this.drawer &&
              (document.body.classList.add(ul),
              this.drawer.classList.add(hl),
              this.drawer.dispatchEvent(
                new CustomEvent("theme:scroll:lock", { bubbles: !0 })
              ),
              this.drawerBody.dispatchEvent(
                new CustomEvent("theme:scroll:lock", { bubbles: !0 })
              ));
          }
          closeDrawer() {
            this.drawer &&
              (document.body.classList.remove(ul),
              this.drawer.classList.remove(hl),
              this.drawer.dispatchEvent(
                new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
              ),
              this.drawerBody.dispatchEvent(
                new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
              ));
          }
          handleErrors(e) {
            return e.ok
              ? e
              : e.json().then(function (t) {
                  throw new N({
                    status: e.statusText,
                    headers: e.headers,
                    json: t,
                  });
                });
          }
          constructor(e) {
            (this.container = e.container),
              (this.drawer = null),
              (this.buttonDrawerOpen = null),
              (this.buttonDrawerClose = null),
              (this.drawerBody = null),
              this.fetchPickupAvailability(),
              this.container.addEventListener("theme:variant:change", (e) =>
                this.fetchPickupAvailability(e)
              );
          }
        })(this);
      },
    },
    fl = "[data-quantity-selector]",
    gl = "[data-increase-quantity]",
    yl = "[data-decrease-quantity]",
    vl = "[data-quantity-input]";
  function bl(e) {
    e.querySelectorAll(fl).forEach((e) => {
      new (class {
        initButtons() {
          this.increase.addEventListener(
            "click",
            function (e) {
              e.preventDefault();
              let t = parseInt(this.input.value, 10);
              (t = isNaN(t) ? 0 : t),
                t++,
                (this.input.value = t),
                this.input.dispatchEvent(new Event("change"));
            }.bind(this)
          ),
            this.decrease.addEventListener(
              "click",
              function (e) {
                e.preventDefault();
                let t = parseInt(this.input.value, 10);
                (t = isNaN(t) ? 0 : t),
                  t--,
                  (t = Math.max(this.min, t)),
                  (this.input.value = t),
                  this.input.dispatchEvent(new Event("change"));
              }.bind(this)
            );
        }
        constructor(e) {
          (this.wrapper = e),
            (this.increase = this.wrapper.querySelector(gl)),
            (this.decrease = this.wrapper.querySelector(yl)),
            (this.input = this.wrapper.querySelector(vl)),
            (this.min = parseInt(this.input.getAttribute("min"), 10)),
            this.initButtons();
        }
      })(e);
    });
  }
  const wl = "[data-product-form]",
    Sl = "data-option-position",
    El = '[name^="options"], [data-popout-option]',
    Ll = "data-value",
    kl = "sold-out",
    Tl = "unavailable";
  const xl = "[data-section-id]",
    _l = "[data-quickview-modal]",
    Al = "[data-product-form-wrapper]",
    ql = "[data-product-form]",
    Cl = "[data-product-slideshow]",
    Pl = "[data-add-to-cart]",
    $l = "[data-add-to-cart-text]",
    Il = "[data-compare-price]",
    Ml = "[data-compare-text]",
    Dl = "[data-buttons-wrapper]",
    Ol = "[data-product-select]",
    Hl = "[data-price-wrapper]",
    Fl = "[data-button-price]",
    Bl = "[data-product-json]",
    Wl = "[data-product-price]",
    Nl = "[data-product-unit-price]",
    Rl = "[data-product-base]",
    jl = "[data-product-unit]",
    zl = "data-enable-history-state",
    Vl = "data-option-position",
    Ul = "[data-option-value]",
    Gl = "[data-subscription-watch-price]",
    Jl = "[data-subscription-selectors]",
    Ql = "[data-price-off]",
    Kl = "[data-price-off-type]",
    Yl = "[data-price-off-amount]",
    Xl = "[data-toggles-group]",
    Zl = "data-group-toggle",
    ec = "[data-plan-description]",
    tc = "[data-remaining-count]",
    ic = "data-remaining-max",
    sc = "[data-remaining-wrapper]",
    rc = "[data-product-remaining-json]",
    nc = "[data-product-preorder]",
    oc = "hide",
    ac = "variant--soldout",
    lc = "variant--unavailable",
    cc = "product__price--sale",
    hc = "count-is-low",
    dc = "count-is-in",
    uc = "count-is-out",
    pc = "count-is-unavailable";
  let mc = class extends HTMLElement {
      connectedCallback() {
        (this.outerSection = this.container.closest(xl)),
          (this.quickview = this.container.closest(_l)),
          (this.outerWrapper = this.quickview
            ? this.quickview
            : this.outerSection),
          (this.productFormWrapper = this.container.closest(Al)),
          (this.productFormElement = this.container.querySelector(ql)),
          (this.productForm = this.container.querySelector(ql)),
          (this.slideshow = this.outerWrapper.querySelector(Cl)),
          (this.enableHistoryState =
            !(!this.outerSection || !this.outerSection.hasAttribute(zl)) &&
            "true" === this.outerSection.getAttribute(zl)),
          (this.hasUnitPricing = this.outerWrapper.querySelector(jl)),
          (this.subSelectors = this.outerWrapper.querySelector(Jl)),
          (this.subPrices = this.outerWrapper.querySelector(Gl)),
          (this.priceOffWrap = this.outerWrapper.querySelector(Ql)),
          (this.priceOffAmount = this.outerWrapper.querySelector(Yl)),
          (this.priceOffType = this.outerWrapper.querySelector(Kl)),
          (this.planDecription = this.outerWrapper.querySelector(ec)),
          (this.isPreOrder = this.container.querySelector(nc)),
          (this.remainingWrapper = this.outerWrapper.querySelector(sc));
        const e = this.outerWrapper.querySelector(`[${ic}]`);
        (this.sellout = null),
          this.remainingWrapper &&
            e &&
            ((this.remainingMaxInt = parseInt(e.getAttribute(ic), 10)),
            (this.remainingCount = this.outerWrapper.querySelector(tc)),
            (this.remainingJSONWrapper = this.outerWrapper.querySelector(rc)),
            (this.remainingJSON = null),
            this.remainingJSONWrapper &&
            "" !== this.remainingJSONWrapper.innerHTML
              ? (this.remainingJSON = JSON.parse(
                  this.remainingJSONWrapper.innerHTML
                ))
              : console.warn("Missing product quantity JSON")),
          bl(this.outerWrapper);
        let t = null;
        this.productJSON = null;
        const i = this.outerWrapper.querySelector(Bl);
        i && (t = i.innerHTML),
          t && this.productForm
            ? ((this.productJSON = JSON.parse(t)),
              (this.sellout = new (class {
                init() {
                  this.update();
                }
                update() {
                  this.getCurrentState(),
                    this.optionElements.forEach((e) => {
                      const t = e.value || e.getAttribute(Ll),
                        i = e.closest(`[${Sl}]`).getAttribute(Sl),
                        s = parseInt(i, 10) - 1;
                      let r = [...this.selections];
                      r[s] = t;
                      const n = this.productJSON.variants.find((e) => {
                        let t = !0;
                        for (let i = 0; i < r.length; i++)
                          e.options[i] !== r[i] && (t = !1);
                        return t;
                      });
                      e.classList.remove(kl, Tl),
                        void 0 === n
                          ? e.classList.add(Tl)
                          : n && !1 === n.available && e.classList.add(kl);
                    });
                }
                getCurrentState() {
                  for (var e of ((this.formData = new FormData(this.form)),
                  (this.selections = []),
                  this.formData.entries()))
                    e[0].includes("options[") && this.selections.push(e[1]);
                }
                constructor(e, t) {
                  (this.container = e),
                    (this.productJSON = t),
                    (this.form = this.container.querySelector(wl)),
                    (this.formData = new FormData(this.form)),
                    (this.optionElements = this.container.querySelectorAll(El)),
                    this.productJSON && this.form && this.init();
                }
              })(this.outerWrapper, this.productJSON)),
              this.linkForm())
            : console.warn("Missing product form or product JSON"),
          this.productJSON &&
            new (class {
              updateCookie() {
                let e = this.cookie.read();
                const t = e.indexOf(this.handle);
                -1 === t
                  ? (e.unshift(this.handle), (e = e.splice(0, ee)))
                  : (e.splice(t, 1), e.unshift(this.handle)),
                  this.cookie.write(e);
              }
              constructor(e) {
                (this.handle = e),
                  (this.cookie = new X(ue)),
                  void 0 !== this.handle &&
                    (me.push(this.handle), this.updateCookie());
              }
            })(this.productJSON.handle);
      }
      destroy() {
        this.productForm.destroy();
      }
      linkForm() {
        (this.productForm = new (class {
          destroy() {
            this._listeners.removeAll();
          }
          options() {
            return this._serializeInputValues(this.optionInputs, function (e) {
              return (
                (e.name = /(?:^(options\[))(.*?)(?:\])/.exec(e.name)[2]), e
              );
            });
          }
          variant() {
            const e = this.options();
            return e.length ? ve(this.product, e) : this.product.variants[0];
          }
          plan(e) {
            let t = { allocation: null, group: null, detail: null };
            const i = new FormData(this.form).get("selling_plan");
            if (
              e &&
              e.selling_plan_allocations &&
              e.selling_plan_allocations.length > 0
            ) {
              const t = [
                  ...new Set(
                    e.selling_plan_allocations.map(
                      (e) => e.selling_plan_group_id
                    )
                  ),
                ],
                i = this.element.querySelectorAll("[data-subscription-group]");
              if (!i.length) return;
              i.forEach((e) => (e.style.display = "none")),
                t.forEach((e) => {
                  this.element.querySelector(
                    `[data-selling-plan-group="${e}"]`
                  ).style.display = "block";
                });
            }
            return (
              i &&
                e &&
                (t.allocation = e.selling_plan_allocations.find(function (e) {
                  return e.selling_plan_id.toString() === i.toString();
                })),
              t.allocation &&
                (t.group = this.product.selling_plan_groups.find(function (e) {
                  return (
                    e.id.toString() ===
                    t.allocation.selling_plan_group_id.toString()
                  );
                })),
              t.group &&
                (t.detail = t.group.selling_plans.find(function (e) {
                  return e.id.toString() === i.toString();
                })),
              t && t.allocation && t.detail && t.allocation ? t : null
            );
          }
          properties() {
            return this._serializeInputValues(
              this.propertyInputs,
              function (e) {
                return (
                  (e.name = /(?:^(properties\[))(.*?)(?:\])/.exec(e.name)[2]), e
                );
              }
            );
          }
          quantity() {
            return this.quantityInputs[0]
              ? Number.parseInt(this.quantityInputs[0].value, 10)
              : 1;
          }
          getFormState() {
            const e = this.variant();
            return {
              options: this.options(),
              variant: e,
              properties: this.properties(),
              quantity: this.quantity(),
              plan: this.plan(e),
            };
          }
          _setIdInputValue(e) {
            e && e.id
              ? (this.variantElement.value = e.id.toString())
              : (this.variantElement.value = ""),
              this.variantElement.dispatchEvent(new Event("change"));
          }
          _onSubmit(e, t) {
            (t.dataset = this.getFormState()),
              e.onFormSubmit && e.onFormSubmit(t);
          }
          _onOptionChange(e) {
            this._setIdInputValue(e.dataset.variant);
          }
          _onFormEvent(e) {
            return void 0 === e
              ? Function.prototype
              : function (t) {
                  (t.dataset = this.getFormState()),
                    this._setIdInputValue(t.dataset.variant),
                    e(t);
                }.bind(this);
          }
          _initInputs(e, t) {
            return Array.prototype.slice
              .call(this.element.querySelectorAll(e))
              .map(
                function (e) {
                  return (
                    this._listeners.add(e, "change", this._onFormEvent(t)), e
                  );
                }.bind(this)
              );
          }
          _serializeInputValues(e, t) {
            return e.reduce(function (e, i) {
              return (
                (i.checked || ("radio" !== i.type && "checkbox" !== i.type)) &&
                  e.push(t({ name: i.name, value: i.value })),
                e
              );
            }, []);
          }
          _validateProductObject(e) {
            if ("object" != typeof e)
              throw new TypeError(e + " is not an object.");
            if (void 0 === e.variants[0].options)
              throw new TypeError(
                "Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route"
              );
            return e;
          }
          constructor(e, t, i, s) {
            (this.element = e),
              (this.form = "FORM" == t.tagName ? t : t.querySelector("form")),
              (this.product = this._validateProductObject(i)),
              (this.variantElement = this.form.querySelector(we)),
              (s = s || {}),
              (this.clickedElement = null),
              (this._listeners = new ye()),
              this._listeners.add(
                this.element,
                "submit",
                this._onSubmit.bind(this, s)
              ),
              (this.optionInputs = this._initInputs(Ee, s.onOptionChange)),
              (this.planInputs = this._initInputs(Se, s.onPlanChange)),
              (this.quantityInputs = this._initInputs(Le, s.onQuantityChange)),
              (this.propertyInputs = this._initInputs(ke, s.onPropertyChange));
          }
        })(this.outerWrapper, this.productFormElement, this.productJSON, {
          onOptionChange: this.onOptionChange.bind(this),
          onPlanChange: this.onPlanChange.bind(this),
          onQuantityChange: this.onQuantityChange.bind(this),
        })),
          this.pushState(this.productForm.getFormState(), !0),
          this.subsToggleListeners();
      }
      onOptionChange(e) {
        this.pushState(e.dataset);
      }
      onPlanChange(e) {
        this.subPrices && this.pushState(e.dataset);
      }
      onQuantityChange(e) {
        const t = e.dataset;
        (this.productState = this.setProductState(t)),
          this.updateButtonPrices(t);
      }
      pushState(e, t = !1) {
        (this.productState = this.setProductState(e)),
          this.updateProductImage(e),
          this.updateAddToCartState(e),
          this.updateProductPrices(e),
          this.updateSaleText(e),
          this.updateSubscriptionText(e),
          this.updateLegend(e),
          this.updateRemaining(e),
          this.fireHookEvent(e),
          this.sellout && this.sellout.update(e),
          this.enableHistoryState && !t && this.updateHistoryState(e);
      }
      updateAddToCartState(e) {
        const t = e.variant;
        let i = theme.strings.addToCart;
        const s = this.outerWrapper.querySelectorAll(Hl),
          r = this.outerWrapper.querySelector(Dl),
          n = null == r ? void 0 : r.querySelectorAll(Pl),
          o = null == r ? void 0 : r.querySelectorAll($l);
        if (
          (this.isPreOrder && (i = theme.strings.preOrder),
          s.length &&
            t &&
            s.forEach((e) => {
              e.classList.remove(oc);
            }),
          (null == n ? void 0 : n.length) &&
            n.forEach((e) => {
              t && t.available ? (e.disabled = !1) : (e.disabled = !0);
            }),
          (null == o ? void 0 : o.length) &&
            o.forEach((e) => {
              t
                ? t.available
                  ? (e.innerHTML = i)
                  : (e.innerHTML = theme.strings.soldOut)
                : (e.innerHTML = theme.strings.unavailable);
            }),
          r && t)
        ) {
          const e = r.querySelector(Ol);
          e && (e.value = t.id);
        }
        r &&
          this.productFormWrapper &&
          (t
            ? t.available
              ? this.productFormWrapper.classList.remove(ac, lc)
              : (this.productFormWrapper.classList.add(ac),
                this.productFormWrapper.classList.remove(lc))
            : (this.productFormWrapper.classList.add(lc),
              this.productFormWrapper.classList.remove(ac)));
      }
      updateLegend(e) {
        const t = e.variant;
        if (t) {
          this.container.parentNode.querySelectorAll(Ul).forEach((e) => {
            const i = e.closest(`[${Vl}]`);
            if (i) {
              const s = i.getAttribute(Vl),
                r = parseInt(s, 10) - 1;
              (this.newValue = t.options[r]), (e.innerHTML = this.newValue);
            }
          });
        }
      }
      updateHistoryState(e) {
        const t = e.variant,
          i = e.plan,
          s = window.location.href;
        if (t && s.includes("/product")) {
          const e = new window.URL(s),
            r = e.searchParams;
          r.set("variant", t.id),
            i && i.detail && i.detail.id && this.productState.hasPlan
              ? r.set("selling_plan", i.detail.id)
              : r.delete("selling_plan"),
            (e.search = r.toString());
          const n = e.toString();
          window.history.replaceState({ path: n }, "", n);
        }
      }
      updateRemaining(e) {
        const t = e.variant;
        if (
          t &&
          this.remainingWrapper &&
          this.remainingJSON &&
          this.remainingCount
        ) {
          const e = this.remainingJSON[t.id];
          e && e <= this.remainingMaxInt && e > 0
            ? (this.remainingWrapper.classList.remove(dc, uc, pc),
              this.remainingWrapper.classList.add(hc),
              (this.remainingCount.innerHTML = e))
            : this.productState.soldOut
            ? (this.remainingWrapper.classList.remove(hc, dc, pc),
              this.remainingWrapper.classList.add(uc))
            : this.productState.available &&
              (this.remainingWrapper.classList.remove(hc, uc, pc),
              this.remainingWrapper.classList.add(dc));
        } else
          this.remainingWrapper &&
            (this.remainingWrapper.classList.remove(dc, uc, hc),
            this.remainingWrapper.classList.add(pc));
      }
      getBaseUnit(e) {
        return 1 === e.unit_price_measurement.reference_value
          ? e.unit_price_measurement.reference_unit
          : e.unit_price_measurement.reference_value +
              e.unit_price_measurement.reference_unit;
      }
      subsToggleListeners() {
        this.outerWrapper.querySelectorAll(Xl).forEach((e) => {
          e.addEventListener(
            "change",
            function (e) {
              const t = e.target.value.toString(),
                i = this.outerWrapper.querySelector(`[${Zl}="${t}"]`),
                s = this.outerWrapper.querySelectorAll(`[${Zl}]`);
              if (i) {
                i.classList.remove(oc);
                const e = i.querySelector('[name="selling_plan"]');
                (e.checked = !0), e.dispatchEvent(new Event("change"));
              }
              s.forEach((e) => {
                if (e !== i) {
                  e.classList.add(oc);
                  e.querySelectorAll('[name="selling_plan"]').forEach((e) => {
                    (e.checked = !1), e.dispatchEvent(new Event("change"));
                  });
                }
              });
            }.bind(this)
          );
        });
      }
      updateSaleText(e) {
        this.productState.planSale
          ? this.updateSaleTextSubscription(e)
          : this.productState.onSale
          ? this.updateSaleTextStandard(e)
          : this.priceOffWrap && this.priceOffWrap.classList.add(oc);
      }
      updateSaleTextStandard(e) {
        if (!this.priceOffType) return;
        this.priceOffType.innerHTML = window.theme.strings.sale || "sale";
        const t = e.variant;
        if (
          window.theme.settings.badge_sale_type &&
          "percentage" === window.theme.settings.badge_sale_type
        ) {
          const e = (t.compare_at_price - t.price) / t.compare_at_price,
            i = Math.floor(100 * e);
          this.priceOffAmount.innerHTML = `${i}%`;
        } else {
          const e = t.compare_at_price - t.price;
          this.priceOffAmount.innerHTML = this.formattingMoney(e);
        }
        this.priceOffWrap.classList.remove(oc);
      }
      updateSaleTextSubscription(e) {
        this.priceOffType.innerHTML =
          window.theme.strings.subscription || "subscripton";
        const t = e.variant,
          i = e.plan.detail.price_adjustments[0],
          s = i.value;
        i && "percentage" === i.value_type
          ? (this.priceOffAmount.innerHTML = `${s}%`)
          : i && "price" === i.value_type
          ? (this.priceOffAmount.innerHTML = this.formattingMoney(
              t.price - i.value
            ))
          : (this.priceOffAmount.innerHTML = this.formattingMoney(s)),
          this.priceOffWrap.classList.remove(oc);
      }
      updateSubscriptionText(e) {
        e.plan && this.planDecription && null !== e.plan.detail.description
          ? ((this.planDecription.innerHTML = e.plan.detail.description),
            this.planDecription.classList.remove(oc))
          : this.planDecription && this.planDecription.classList.add(oc);
      }
      getPrices(e) {
        const t = e.variant,
          i = e.plan;
        let s = "",
          r = "";
        return (
          this.productState.available &&
            ((s = t.compare_at_price), (r = t.price)),
          this.productState.hasPlan && (r = i.allocation.price),
          this.productState.planSale &&
            ((s = i.allocation.compare_at_price), (r = i.allocation.price)),
          { price: r, comparePrice: s }
        );
      }
      updateButtonPrices(e) {
        const t = this.outerWrapper.querySelectorAll(Fl),
          { price: i } = this.getPrices(e);
        t.length &&
          t.forEach((t) => {
            const s = e.quantity * i;
            t.innerHTML = this.formattingMoney(s);
          });
      }
      updateProductPrices(e) {
        const t = e.variant,
          i = this.outerWrapper.querySelectorAll(Hl),
          s = this.outerWrapper.querySelectorAll(Fl),
          { price: r, comparePrice: n } = this.getPrices(e);
        i.forEach((e) => {
          const i = e.querySelector(Il),
            s = e.querySelector(Wl),
            o = e.querySelector(Ml);
          i &&
            (this.productState.onSale || this.productState.planSale
              ? (i.classList.remove(oc),
                o.classList.remove(oc),
                s.classList.add(cc))
              : (i.classList.add(oc),
                o.classList.add(oc),
                s.classList.remove(cc)),
            (i.innerHTML = this.formattingMoney(n))),
            s && (s.innerHTML = t ? this.formattingMoney(r) : "&nbsp;");
        }),
          s.length &&
            s.forEach((t) => {
              const i = e.quantity * r;
              t.innerHTML = this.formattingMoney(i);
            }),
          this.hasUnitPricing && this.updateProductUnits(e);
      }
      updateProductUnits(e) {
        const t = e.variant,
          i = e.plan;
        let s = null;
        if (
          (t && t.unit_price && (s = t.unit_price),
          i &&
            i.allocation &&
            i.allocation.unit_price &&
            (s = i.allocation.unit_price),
          s)
        ) {
          const e = this.getBaseUnit(t);
          (this.outerWrapper.querySelector(Nl).innerHTML =
            this.formattingMoney(s)),
            (this.outerWrapper.querySelector(Rl).innerHTML = e),
            W(this.outerWrapper.querySelector(jl));
        } else dn(this.outerWrapper.querySelector(jl));
      }
      fireHookEvent(e) {
        const t = e.variant;
        this.container.dispatchEvent(
          new CustomEvent("theme:variant:change", {
            detail: { variant: t },
            bubbles: !0,
          })
        );
      }
      setProductState(e) {
        const t = e.variant,
          i = e.plan,
          s = {
            available: !0,
            soldOut: !1,
            onSale: !1,
            showUnitPrice: !1,
            requiresPlan: !1,
            hasPlan: !1,
            planPerDelivery: !1,
            planSale: !1,
          };
        return (
          !t || (t.requires_selling_plan && !i)
            ? (s.available = !1)
            : (t.available || (s.soldOut = !0),
              t.compare_at_price > t.price && (s.onSale = !0),
              t.unit_price && (s.showUnitPrice = !0),
              this.productJSON &&
                this.productJSON.requires_selling_plan &&
                (s.requiresPlan = !0),
              i &&
                this.subPrices &&
                ((s.hasPlan = !0),
                i.allocation.per_delivery_price !== i.allocation.price &&
                  (s.planPerDelivery = !0),
                i.allocation.compare_at_price > i.allocation.price &&
                  (s.planSale = !0))),
          s
        );
      }
      updateProductImage(e) {
        const t = e.variant;
        t &&
          this.slideshow &&
          t.featured_media &&
          t.featured_media.id &&
          this.slideshow.dispatchEvent(
            new CustomEvent("theme:image:change", {
              detail: { id: t.featured_media.id },
            })
          );
      }
      formattingMoney(e) {
        return theme.settings.currency_code_enable
          ? a.formatMoney(e, theme.moneyFormat) + ` ${theme.currencyCode}`
          : a.formatMoney(e, theme.moneyFormat);
      }
      constructor() {
        super(), (this.container = this);
      }
    },
    fc = class extends HTMLElement {
      connectedCallback() {
        fetch(this.dataset.url)
          .then((e) => e.text())
          .then((e) => {
            const t = document.createElement("div");
            t.innerHTML = e;
            const i = t.querySelector("[data-api-content]");
            i && (this.innerHTML = i.innerHTML);
            const s = this.closest("[data-product-complimentary-loaded]");
            s && "" !== i.innerHTML.trim() && s.classList.remove("js-unloaded");
          })
          .catch((e) => {
            console.error(e);
          });
      }
      constructor() {
        super();
      }
    };
  const gc = "[data-product-slideshow]",
    yc = "[data-product-image]",
    vc = "[data-zoom-button]",
    bc = "[data-zoom-wrapper]",
    wc = "data-media-id";
  const Sc = "body",
    Ec = "[data-related-section]",
    Lc = "[data-tabs-holder]",
    kc = "data-tab",
    Tc = "data-tab-index",
    xc = "data-block-id",
    _c = ".tabs > button",
    Ac = ".tab-link",
    qc = ".tab-link__recent",
    Cc = ".tab-content",
    Pc = "[data-scrollbar]",
    $c = "a:first-child, input:first-child",
    Ic = "current",
    Mc = "hide",
    Dc = "alt",
    Oc = "is-focused",
    Hc = {};
  const Fc = {
      onLoad() {
        Hc[this.id] = [];
        this.container.querySelectorAll(Lc).forEach((e) => {
          Hc[this.id].push(
            new (class {
              init() {
                const e = this.container,
                  t = e.querySelectorAll(_c),
                  i = e.querySelector(`${Ac}-0`),
                  s = e.querySelector(`${Cc}-0`);
                s && s.classList.add(Ic),
                  i && i.classList.add(Ic),
                  this.checkVisibleTabLinks(),
                  this.container.addEventListener("theme:tabs:check", () =>
                    this.checkRecentTab()
                  ),
                  this.container.addEventListener("theme:tabs:hide", () =>
                    this.hideRelatedTab()
                  ),
                  t.length &&
                    t.forEach((t) => {
                      const i = parseInt(t.getAttribute(kc)),
                        s = e.querySelector(`${Cc}-${i}`);
                      t.addEventListener("click", () => {
                        this.tabChange(t, s);
                      }),
                        t.addEventListener("keyup", (e) => {
                          ("Space" !== e.code && "Enter" !== e.code) ||
                            !this.body.classList.contains(Oc) ||
                            (this.tabChange(t, s),
                            s.querySelector("a, input") &&
                              ((this.accessibility.lastFocused = t),
                              this.accessibility.a11y.trapFocus(s, {
                                elementToFocus: s.querySelector($c),
                              })));
                        });
                    });
              }
              tabChange(e, t) {
                this.container
                  .querySelector(`${_c}.${Ic}`)
                  .classList.remove(Ic),
                  this.container
                    .querySelector(`${Cc}.${Ic}`)
                    .classList.remove(Ic),
                  e.classList.add(Ic),
                  t.classList.add(Ic),
                  e.classList.contains(Mc) && t.classList.add(Mc),
                  this.checkVisibleTabLinks(),
                  this.container.dispatchEvent(
                    new CustomEvent("theme:tab:change")
                  );
              }
              initNativeScrollbar() {
                this.scrollbarHolder.length &&
                  this.scrollbarHolder.forEach((e) => {
                    new G(e);
                  });
              }
              checkVisibleTabLinks() {
                const e = this.container.querySelectorAll(_c),
                  t = this.container.querySelectorAll(`${Ac}.${Mc}`);
                e.length - t.length < 2
                  ? this.container.classList.add(Dc)
                  : this.container.classList.remove(Dc);
              }
              checkRecentTab() {
                const e = this.container.querySelector(qc);
                if (e) {
                  e.classList.remove(Mc);
                  const t = parseInt(e.getAttribute(kc)),
                    i = this.container.querySelector(`${Cc}[${Tc}="${t}"]`);
                  i && i.classList.remove(Mc),
                    this.checkVisibleTabLinks(),
                    this.initNativeScrollbar();
                }
              }
              hideRelatedTab() {
                const e = this.container.querySelector(Ec);
                if (!e) return;
                const t = e.closest(`${Cc}.${Ic}`);
                if (!t) return;
                const i = parseInt(t.getAttribute(Tc)),
                  s = this.container.querySelectorAll(_c);
                if (s.length > i) {
                  const e = s[i].nextElementSibling;
                  e &&
                    (s[i].classList.add(Mc),
                    e.dispatchEvent(new Event("click")),
                    this.initNativeScrollbar());
                }
              }
              onBlockSelect(e) {
                const t = this.container.querySelector(
                  `${Ac}[${xc}="${e.detail.blockId}"]`
                );
                t &&
                  (t.dispatchEvent(new Event("click")),
                  t.parentNode.scrollTo({
                    top: 0,
                    left: t.offsetLeft - t.clientWidth,
                    behavior: "smooth",
                  }));
              }
              constructor(e) {
                (this.container = e),
                  (this.body = document.querySelector(Sc)),
                  (this.accessibility = window.accessibility),
                  this.container &&
                    ((this.scrollbarHolder =
                      this.container.querySelectorAll(Pc)),
                    this.init(),
                    this.initNativeScrollbar());
              }
            })(e)
          );
        });
      },
      onBlockSelect(e) {
        Hc[this.id].forEach((t) => {
          "function" == typeof t.onBlockSelect && t.onBlockSelect(e);
        });
      },
    },
    Bc = "[data-share-url]",
    Wc = "data-section-type",
    Nc = "[data-share-details]",
    Rc = "[data-share-summary]",
    jc = "[data-share-copy]",
    zc = "[data-share-button]",
    Vc = "[data-close-button]",
    Uc = "[data-success-message]",
    Gc = "[data-share-holder]",
    Jc = "is-hidden";
  let Qc = class extends HTMLElement {
    init() {
      navigator.share
        ? (this.mainDetailsToggle.classList.add(Jc),
          this.shareButton.classList.remove(Jc),
          this.shareButton.addEventListener("click", () => {
            navigator.share({ url: this.urlToShare, title: document.title });
          }))
        : (this.mainDetailsToggle.addEventListener(
            "toggle",
            this.toggleDetails.bind(this)
          ),
          this.mainDetailsToggle.addEventListener("focusout", () => {
            setTimeout(() => {
              this.contains(document.activeElement) || this.close();
            });
          }),
          this.shareCopy.addEventListener(
            "click",
            this.copyToClipboard.bind(this)
          ),
          this.closeButton.addEventListener("click", this.close.bind(this)),
          this.container.addEventListener(
            "keyup",
            this.keyboardEvents.bind(this)
          ));
    }
    updateShareLink() {
      "product" == this.container.getAttribute(Wc) &&
        this.container.addEventListener("theme:variant:change", (e) => {
          e.detail.variant &&
            ((this.urlToShare = `${this.urlToShare.split("?")[0]}?variant=${
              e.detail.variant.id
            }`),
            this.urlInput &&
              (this.urlInput.value = `${
                this.urlToShare.split("?")[0]
              }?variant=${e.detail.variant.id}`));
        });
    }
    toggleDetails() {
      this.mainDetailsToggle.open ||
        (this.successMessage.classList.add(Jc),
        (this.successMessage.textContent = ""),
        this.closeButton.classList.add(Jc),
        this.shareCopy.focus());
    }
    copyToClipboard() {
      navigator.clipboard.writeText(this.urlInput.value).then(() => {
        this.successMessage.classList.remove(Jc),
          (this.successMessage.textContent = theme.strings.successMessage),
          this.closeButton.classList.remove(Jc),
          this.closeButton.focus();
      });
    }
    close() {
      this.mainDetailsToggle.removeAttribute("open"),
        this.shareSummary.setAttribute("aria-expanded", !1);
    }
    keyboardEvents(e) {
      "Escape" === e.code && (this.mainDetailsToggle.focus(), this.close());
    }
    constructor() {
      super(),
        (this.container = this.closest(`[${Wc}]`)),
        (this.mainDetailsToggle = this.querySelector(Nc)),
        (this.shareButton = this.querySelector(zc)),
        (this.shareCopy = this.querySelector(jc)),
        (this.shareSummary = this.querySelector(Rc)),
        (this.closeButton = this.querySelector(Vc)),
        (this.successMessage = this.querySelector(Uc)),
        (this.shareHolder = this.querySelector(Gc)),
        (this.urlInput = this.querySelector(Bc)),
        (this.urlToShare = this.urlInput
          ? this.urlInput.value
          : document.location.href),
        this.init(),
        this.updateShareLink();
    }
  };
  const Kc = "data-image-filter",
    Yc = "[data-product-slideshow]",
    Xc = "[data-product-thumbs]",
    Zc = "[data-slideshow-thumbnail]",
    eh = "[data-media-slide]",
    th = "hide",
    ih = "flickity-enabled";
  const sh = "[data-size-button]",
    rh = "[data-media-slide]",
    nh = "is-expanded";
  let oh = class {
    init() {
      this.sizeButtons.forEach((e) => {
        e.addEventListener("click", () => {
          e.classList.toggle(nh), e.closest(rh).classList.toggle(nh);
        });
      });
    }
    constructor(e) {
      (this.container = e),
        (this.sizeButtons = this.container.querySelectorAll(sh)),
        this.sizeButtons.length > 0 && this.init();
    }
  };
  const ah = "[data-product-json]",
    lh = "[data-zoom-button]",
    ch = "[data-truncated-holder]",
    hh = "[data-truncated-button]",
    dh = "data-truncated-content",
    uh = "is-expanded",
    ph = "is-visible",
    mh = [];
  const fh = {
    onLoad() {
      mh[this.id] = new (class {
        init() {
          var e, t;
          (this.zoomEnabled = null !== this.container.querySelector(lh)),
            this.zoomEnabled &&
              ((e = this.container),
              (t = this.product),
              xe({ url: window.theme.assets.photoswipe })
                .then(() => {
                  const i = window.themePhotoswipe.PhotoSwipe.default,
                    s = window.themePhotoswipe.PhotoSwipeUI.default;
                  e.querySelectorAll(vc).forEach((r) => {
                    r.addEventListener("click", (r) => {
                      const n = e.querySelector(bc),
                        o = r.target
                          .closest(`[${wc}]`)
                          .getAttribute(wc)
                          .toString(),
                        a = [];
                      for (let e = 0; e < t.media.length; e++)
                        "image" === t.media[e].media_type &&
                          (a[a.length] = {
                            src: t.media[e].src,
                            w: t.media[e].width,
                            h: t.media[e].height,
                            id: t.media[e].id,
                          });
                      const l = {
                        index: a.findIndex((e) => e.id.toString() === o),
                        showHideOpacity: !0,
                        showAnimationDuration: 150,
                        hideAnimationDuration: 250,
                        bgOpacity: 1,
                        spacing: 0,
                        allowPanToNext: !1,
                        maxSpreadZoom: 3,
                        history: !1,
                        loop: !0,
                        pinchToClose: !1,
                        modal: !1,
                        closeOnScroll: !1,
                        closeOnVerticalDrag: !0,
                        getDoubleTapZoom: function (e, t) {
                          return e ? 1.67 : t.initialZoomLevel < 0.7 ? 1 : 1.3;
                        },
                        getThumbBoundsFn: function () {
                          let t = e.querySelector(gc);
                          t || (t = e.querySelector(yc));
                          const i =
                              window.pageYOffset ||
                              document.documentElement.scrollTop,
                            s = t.getBoundingClientRect();
                          return { x: s.left, y: s.top + i, w: s.width };
                        },
                      };
                      n.dispatchEvent(
                        new CustomEvent("theme:scroll:lock", { bubbles: !0 })
                      );
                      const c = new i(n, s, a, l);
                      c.init(),
                        c.listen("close", function () {
                          document.dispatchEvent(
                            new CustomEvent("theme:scroll:unlock", {
                              bubbles: !0,
                            })
                          );
                        });
                    });
                  });
                })
                .catch((e) => console.error(e))),
            this.truncateElementHolder &&
              this.truncateElement &&
              (setTimeout(this.resizeEventTruncate, 50),
              document.addEventListener(
                "theme:resize",
                this.resizeEventTruncate
              )),
            new oh(this.container);
        }
        truncateText() {
          if (this.truncateElementHolder.classList.contains(ph)) return;
          const e = this.truncateElement.querySelectorAll("style");
          e.length &&
            e.forEach((e) => {
              this.truncateElementHolder.prepend(e);
            });
          const t = this.truncateElement.cloneNode(!0),
            i = this.truncateElement.getAttribute(dh),
            s = this.truncateElement.nextElementSibling;
          s && s.remove(), this.truncateElement.parentElement.append(t);
          const r = this.truncateElement.nextElementSibling;
          r.classList.add(i),
            r.removeAttribute(dh),
            W(r),
            ((e = "", t = 1, i = {}) => {
              const s = {
                  replaceStr: "...",
                  debounceDelay: 250,
                  delimiter: " ",
                  ...i,
                },
                r =
                  e &&
                  (e instanceof NodeList
                    ? e
                    : 1 === e.nodeType
                    ? [e]
                    : document.querySelectorAll(e));
              for (let e = 0; e < r.length; e++) {
                const i = r[e],
                  n = /<!--[\s\S]*?-->/g,
                  o = i.innerHTML.replace(n, "").split(s.delimiter);
                i.innerHTML = "";
                const a = window.getComputedStyle(i);
                o.reduce(Ha, {
                  el: i,
                  buffer: i.innerHTML,
                  elStyle: a,
                  elHeight: 0,
                  rowsLimit: t,
                  rowsWrapped: 0,
                  options: s,
                });
              }
            })(r, 5, { replaceStr: "", delimiter: " " }),
            dn(r),
            this.truncateElement.innerHTML !== r.innerHTML
              ? this.truncateElementHolder.classList.add(uh)
              : (r.remove(), this.truncateElementHolder.classList.remove(uh)),
            this.toggleTruncatedContent(this.truncateElementHolder);
        }
        toggleTruncatedContent(e) {
          const t = e.querySelector(hh);
          t &&
            t.addEventListener("click", (t) => {
              t.preventDefault(), e.classList.remove(uh), e.classList.add(ph);
            });
        }
        onBlockSelect(e) {
          const t = this.container.querySelector(
            `[data-block-id="${e.detail.blockId}"]`
          );
          t && t.dispatchEvent(new Event("click"));
        }
        onBlockDeselect(e) {
          const t = this.container.querySelector(
            `[data-block-id="${e.detail.blockId}"]`
          );
          t && t.dispatchEvent(new Event("click"));
        }
        onUnload() {
          this.media.destroy(),
            this.truncateElementHolder &&
              this.truncateElement &&
              document.removeEventListener(
                "theme:resize",
                this.resizeEventTruncate
              );
        }
        constructor(e) {
          (this.section = e),
            (this.id = e.id),
            (this.container = e.container),
            (this.settings = e.settings),
            li(this.id),
            (this.media = new (class {
              init() {
                this.storeEvents(),
                  this.connectSliderMediaEvents(),
                  this.detectVideos(),
                  this.detect3d(),
                  this.scrollThumbs(),
                  document.addEventListener("theme:resize:width", () => {
                    this.scrollThumbs();
                  }),
                  ge.onChange(() => {
                    this.connectSliderMediaEvents();
                  });
              }
              connectSliderMediaEvents() {
                ge.isMobile()
                  ? this.createMobileSlider()
                  : this.createDesktopSlider();
              }
              createMobileSlider() {
                this.hasDesktopSlider &&
                  this.flkty &&
                  (this.destroySlider(), (this.hasDesktopSlider = !1));
                const e = {
                  autoPlay: !1,
                  prevNextButtons: !1,
                  pageDots: !1,
                  adaptiveHeight: !0,
                  accessibility: !0,
                  watchCSS: !1,
                  wrapAround: !0,
                  rightToLeft: window.isRTL,
                  dragThreshold: 80,
                  contain: !0,
                  fade: !0,
                };
                "carousel" == this.mobileStyle &&
                  ((e.contain = !1), (e.dragThreshold = 10), (e.fade = !1)),
                  "slideshow" == this.mobileStyle &&
                    ((e.pageDots = !0), (e.fade = !1), (e.dragThreshold = 10)),
                  this.createSlider(e),
                  (this.hasMobileSlider = !0);
              }
              createDesktopSlider() {
                if (
                  (this.hasMobileSlider &&
                    this.flkty &&
                    (this.destroySlider(), (this.hasMobileSlider = !1)),
                  "none" == this.desktopStyle)
                )
                  return;
                const e = {
                  autoPlay: !1,
                  prevNextButtons: !1,
                  pageDots: !1,
                  adaptiveHeight: !0,
                  accessibility: !0,
                  watchCSS: !1,
                  wrapAround: !0,
                  rightToLeft: window.isRTL,
                  dragThreshold: 80,
                  contain: !0,
                  fade: !0,
                };
                this.createSlider(e), (this.hasDesktopSlider = !0);
              }
              createSlider(e) {
                (this.flkty = new s(this.slideshow, e)),
                  this.flkty.resize(),
                  (this.currentSlide = this.slideshow.querySelectorAll(
                    Xa.mediaSlide
                  )[0]),
                  this.setDraggable(),
                  this.addEventListeners();
              }
              destroySlider() {
                this.removeEventListeners(), this.flkty.destroy();
              }
              storeEvents() {
                (this.storeFlktyChange = (e) => this.doFlktyChange(e)),
                  (this.storeFlktySettle = (e) => this.doFlktySettle(e)),
                  (this.storeImageChange = (e) => this.doImageChange(e)),
                  (this.storeArrowPrevClick = (e) => this.doArrowPrevClick(e)),
                  (this.storeArrowNextClick = (e) => this.doArrowNextClick(e)),
                  (this.storeThumbClick = (e) => this.doThumbClick(e)),
                  (this.storeThumbContainerScroll = (e) =>
                    this.doThumbContainerScroll(e));
              }
              addEventListeners() {
                var e, t, i;
                this.flkty.on("change", this.storeFlktyChange),
                  this.flkty.on("settle", this.storeFlktySettle),
                  this.slideshow.addEventListener(
                    "theme:image:change",
                    this.storeImageChange
                  ),
                  null === (e = this.arrowPrev) ||
                    void 0 === e ||
                    e.addEventListener("click", this.storeArrowPrevClick),
                  null === (t = this.arrowNext) ||
                    void 0 === t ||
                    t.addEventListener("click", this.storeArrowNextClick),
                  null === (i = this.thumbs) ||
                    void 0 === i ||
                    i.addEventListener(
                      "scroll",
                      this.storeThumbContainerScroll
                    ),
                  this.thumbImages.forEach((e) => {
                    e.addEventListener("click", this.storeThumbClick);
                  });
              }
              removeEventListeners() {
                var e, t, i;
                this.flkty.on("change", this.storeFlktyChange),
                  this.flkty.on("settle", this.storeFlktySettle),
                  this.slideshow.removeEventListener(
                    "theme:image:change",
                    this.storeImageChange
                  ),
                  null === (e = this.arrowPrev) ||
                    void 0 === e ||
                    e.removeEventListener("click", this.storeArrowPrevClick),
                  null === (t = this.arrowNext) ||
                    void 0 === t ||
                    t.removeEventListener("click", this.storeArrowNextClick),
                  null === (i = this.thumbs) ||
                    void 0 === i ||
                    i.removeEventListener(
                      "scroll",
                      this.storeThumbContainerScroll
                    ),
                  this.thumbImages.forEach((e) => {
                    e.removeEventListener("click", this.storeThumbClick);
                  });
              }
              addMediaEventListeners(e) {
                e &&
                  (e.addEventListener("play", () => {
                    (ge.isMobile() || ge.isTouch()) && this.updateDraggable(!1);
                  }),
                  e.addEventListener("pause", () => {
                    (ge.isMobile() || ge.isTouch()) && this.updateDraggable(!0);
                  }));
              }
              doFlktyChange(e) {
                var t, i;
                ("model" !== this.mediaType &&
                  "video" !== this.mediaType &&
                  "external_video" !== this.mediaType) ||
                  this.currentSlide.dispatchEvent(new CustomEvent("pause")),
                  (this.currentSlide = this.flkty.cells[e].element),
                  this.slideshow.classList.remove(Xa.flickitylockHeight);
                const s = this.currentSlide.getAttribute(Xa.dataMediaId),
                  r =
                    null === (t = this.thumbWrapper) || void 0 === t
                      ? void 0
                      : t.querySelector(`[${Xa.dataMediaSelect}="${s}"]`);
                null === (i = this.thumbWrapper) ||
                  void 0 === i ||
                  i.querySelector(`.${Za}`).classList.remove(Za),
                  null == r || r.classList.add(Za),
                  this.scrollThumbs(),
                  setTimeout(() => {
                    (null == r ? void 0 : r.classList.contains(il)) &&
                      (this.lastMediaSelect
                        ? this.slideshow.dispatchEvent(
                            new CustomEvent("theme:image:change", {
                              detail: { id: this.lastMediaSelect },
                            })
                          )
                        : window.location.reload());
                  });
              }
              doFlktySettle(e) {
                (this.allSlides = this.flkty.cells),
                  (this.currentSlide = this.flkty.cells[e].element),
                  this.setDraggable(),
                  document.body.classList.contains(Xa.focusEnabled) &&
                    this.currentSlide.dispatchEvent(new Event("focus")),
                  this.scrollThumbs();
              }
              doImageChange(e) {
                var t = e.detail.id;
                this.lastMediaSelect = t;
                const i = `[${Xa.dataMediaId}="${t}"]`,
                  s = this.flkty.cells.findIndex((e) => e.element.matches(i));
                this.flkty.select(s), this.scrollThumbs();
              }
              doThumbContainerScroll() {
                this.scrollThumbs("scroll");
              }
              doArrowPrevClick() {
                this.scrollThumbs("clickPrev");
              }
              doArrowNextClick() {
                this.scrollThumbs("clickNext");
              }
              doThumbClick(e) {
                const t = e.currentTarget.getAttribute(Xa.dataMediaSelect);
                this.slideshow.dispatchEvent(
                  new CustomEvent("theme:image:change", { detail: { id: t } })
                );
              }
              setDraggable() {
                this.currentSlide &&
                  ((this.mediaType = this.currentSlide.getAttribute(
                    Xa.mediaType
                  )),
                  "model" === this.mediaType ||
                  "video" === this.mediaType ||
                  "external_video" === this.mediaType
                    ? ge.isMobile() && ge.isTouch()
                      ? this.updateDraggable(!0)
                      : (this.currentSlide.dispatchEvent(
                          new CustomEvent("play")
                        ),
                        this.updateDraggable(!1))
                    : this.updateDraggable(!0));
              }
              updateDraggable(e) {
                this.flkty &&
                  ((this.flkty.options.draggable = e),
                  this.flkty.updateDraggable(),
                  this.slideshow.classList.toggle(tl, e));
              }
              detect3d() {
                const e = this.container.querySelectorAll(Xa.modelViewer);
                e &&
                  (e.forEach((e) => {
                    !(function (e, t) {
                      Fa[t] = { loaded: !1 };
                      const i = e.getAttribute(ja),
                        s = e.querySelector(Va),
                        r = s.getAttribute(za);
                      if (null !== e.closest(Na)) {
                        const i = e.closest(Na).parentElement.querySelector(Ra);
                        Wa[t] = { $element: i, defaultId: r };
                      }
                      (Ba[i] = {
                        modelId: r,
                        mediaId: i,
                        sectionId: t,
                        $container: e,
                        $element: s,
                      }),
                        window.Shopify.loadFeatures([
                          { name: "shopify-xr", version: "1.0", onLoad: Ja },
                          {
                            name: "model-viewer-ui",
                            version: "1.0",
                            onLoad: Qa,
                          },
                        ]);
                    })(e, this.section.id),
                      e.addEventListener("theme:media:play", () => {
                        this.updateDraggable(!1);
                      }),
                      e.addEventListener("theme:media:pause", () => {
                        this.updateDraggable(!0);
                      });
                  }),
                  document.addEventListener(
                    "shopify_xr_launch",
                    function () {
                      this.container
                        .querySelectorAll(Xa.allPlayers)
                        .forEach((e) => {
                          e.dispatchEvent(new CustomEvent("pause"));
                        });
                    }.bind(this)
                  ));
              }
              detectVideos() {
                const e = this.section.container.querySelectorAll(
                  `${Xa.videoPlayerExternal}, ${Xa.videoPlayerNative}`
                );
                for (var t of e) {
                  const e = t.dataset.player,
                    i = t.dataset.host;
                  let s;
                  (s = "youtube" === i ? fo(e) : "vimeo" === i ? bo(e) : Ya(e)),
                    !0 === this.loopVideo &&
                      s
                        .then((e) => (i ? sl(e, i) : ((e.loop = !0), e)))
                        .catch((e) => {
                          console.error(e);
                        }),
                    this.addMediaEventListeners(t);
                }
              }
              pauseAllMedia() {
                this.container
                  .querySelector(Xa.mediaSlide)
                  .dispatchEvent(new CustomEvent("pause"));
              }
              pauseOtherMedia(e) {
                this.container
                  .querySelector(`${Xa.mediaSlide}:not([data-player="${e}"])`)
                  .dispatchEvent(new CustomEvent("pause"));
              }
              destroy() {
                this.container.querySelectorAll(Xa.allPlayers).forEach((e) => {
                  e.dispatchEvent(new CustomEvent("destroy"));
                });
              }
              scrollThumbs(e) {
                if (
                  ((this.thumbs = this.container.querySelector(
                    Xa.productThumbs
                  )),
                  this.thumbs)
                ) {
                  if (
                    ((this.thumb = this.thumbs.querySelector(`.${Za}`)),
                    (this.thumbItems = this.container.querySelectorAll(
                      Xa.thumbImage
                    )),
                    (this.lastThumb =
                      this.thumbItems[this.thumbItems.length - 1]),
                    !this.thumb)
                  )
                    return;
                  (this.thumbsScrollTop = this.thumbs.scrollTop),
                    (this.thumbsScrollLeft = this.thumbs.scrollLeft),
                    (this.thumbsWidth = this.thumbs.offsetWidth),
                    (this.thumbsHeight =
                      this.slideshow.offsetWidth /
                      this.thumb.getAttribute(Xa.aspectRatio)),
                    (this.thumbsPositionBottom =
                      this.thumbsScrollTop + this.thumbsHeight),
                    (this.thumbsPositionRight =
                      this.thumbsScrollLeft + this.thumbsWidth),
                    this.checkThumbPositions(),
                    this.toggleToActiveThumb(e),
                    this.toggleArrows();
                }
              }
              checkThumbPositions() {
                (this.thumbWidth = this.thumb.offsetWidth),
                  (this.thumbHeight = this.thumb.offsetHeight),
                  (this.thumbPosTop = this.thumb.offsetTop),
                  (this.thumbPosLeft = this.thumb.offsetLeft),
                  (this.lastThumbRightPos =
                    this.lastThumb.offsetLeft + this.thumbWidth),
                  (this.lastThumbBottomPos =
                    this.lastThumb.offsetTop + this.thumbHeight),
                  (this.scrollTopPosition =
                    this.thumbPosTop +
                    this.thumbHeight / 2 -
                    this.thumbsHeight / 2),
                  (this.scrollLeftPosition =
                    this.thumbPosLeft +
                    this.thumbWidth / 2 -
                    this.thumbsWidth / 2),
                  (this.topCheck = this.thumbsScrollTop > 0),
                  (this.bottomCheck =
                    this.thumbsPositionBottom < this.lastThumbBottomPos),
                  (this.leftCheck = this.thumbsScrollLeft > 0),
                  (this.rightCheck =
                    this.thumbsPositionRight < this.lastThumbRightPos),
                  (this.verticalCheck = this.bottomCheck || this.topCheck),
                  (this.horizontalCheck = this.rightCheck || this.leftCheck);
              }
              toggleToActiveThumb(e) {
                "scroll" !== e &&
                  ("clickPrev" == e &&
                    (this.verticalCheck
                      ? ((this.scrollTopPosition =
                          this.thumbsScrollTop - this.thumbsHeight),
                        (this.scrollLeftPosition = 0))
                      : ((this.scrollTopPosition = 0),
                        (this.scrollLeftPosition =
                          this.thumbsScrollLeft - this.thumbsWidth))),
                  "clickNext" == e &&
                    (this.verticalCheck
                      ? ((this.scrollTopPosition =
                          this.thumbsScrollTop + this.thumbsHeight),
                        (this.scrollLeftPosition = 0))
                      : ((this.scrollTopPosition = 0),
                        (this.scrollLeftPosition =
                          this.thumbsScrollLeft + this.thumbsWidth))),
                  this.thumbs.scrollTo({
                    top: this.scrollTopPosition,
                    left: this.scrollLeftPosition,
                    behavior: "smooth",
                  }));
              }
              toggleArrows() {
                (this.verticalCheck ||
                  (this.verticalAlignment && !this.verticalCheck)) &&
                  (this.arrowPrev.classList.toggle(el, this.topCheck),
                  this.arrowNext.classList.toggle(el, this.bottomCheck)),
                  (this.horizontalCheck ||
                    (!this.verticalAlignment && !this.horizontalCheck)) &&
                    (this.arrowPrev.classList.toggle(el, this.leftCheck),
                    this.arrowNext.classList.toggle(el, this.rightCheck));
              }
              constructor(e) {
                (this.section = e),
                  (this.container = e.container),
                  (this.slideshow = this.container.querySelector(
                    Xa.productSlideshow
                  )),
                  (this.mobileStyle = this.slideshow.getAttribute(
                    Xa.slideshowMobileStyle
                  )),
                  (this.desktopStyle = this.slideshow.getAttribute(
                    Xa.slideshowDesktopStyle
                  )),
                  (this.arrowPrev = this.container.querySelector(Xa.arrowPrev)),
                  (this.arrowNext = this.container.querySelector(Xa.arrowNext)),
                  (this.leftThumbsHolder = this.container.querySelector(
                    Xa.leftThumbsHolder
                  )),
                  (this.thumbWrapper = this.container.querySelector(
                    Xa.productThumbs
                  )),
                  (this.thumbImages = this.container.querySelectorAll(
                    Xa.thumbImage
                  )),
                  (this.loopVideo =
                    "true" === this.container.getAttribute(Xa.loopVideo)),
                  (this.verticalAlignment = Boolean(
                    this.container.querySelector(Xa.verticalAlignment)
                  )),
                  (this.flkty = null),
                  (this.lastMediaSelect = null),
                  (this.thumbs = this.container.querySelector(
                    Xa.productThumbs
                  )),
                  (this.currentSlide = null),
                  (this.mediaType = null),
                  (this.hasMobileSlider = !1),
                  (this.hasDesktopSlider = !1),
                  this.init();
              }
            })(e)),
            new (class {
              listen() {
                this.container.addEventListener("theme:variant:change", (e) => {
                  e.detail.variant &&
                    ((this.variantImage = e.detail.variant.featured_image),
                    this.filterImages());
                });
              }
              filterImages() {
                null !== this.variantImage && null !== this.variantImage.alt
                  ? ((this.variantImageAlt =
                      this.variantImage.alt.split("#")[1]),
                    this.showImages())
                  : this.resetImages(),
                  this.refreshSliders();
              }
              resetImages() {
                this.thumbs.forEach((e) => e.classList.remove(th)),
                  this.slides.forEach((e) => e.classList.remove(th));
              }
              showImages() {
                this.thumbs.forEach((e) => {
                  "" === e.getAttribute(Kc) ||
                  e.getAttribute(Kc) === this.variantImageAlt
                    ? e.classList.remove(th)
                    : e.classList.add(th);
                }),
                  this.slides.forEach((e) => {
                    "" === e.getAttribute(Kc) ||
                    e.getAttribute(Kc) === this.variantImageAlt
                      ? e.classList.remove(th)
                      : e.classList.add(th);
                  });
              }
              refreshSliders() {
                if (
                  null !== this.slider &&
                  this.slider.classList.contains(ih)
                ) {
                  const e = t.data(this.slider);
                  void 0 !== e && e.reloadCells();
                }
                if (
                  null !== this.thumbSlider &&
                  this.thumbSlider.classList.contains(ih)
                ) {
                  const e = c.data(this.thumbSlider);
                  void 0 !== e && e.reloadCells();
                }
              }
              constructor(e) {
                (this.section = e),
                  (this.container = e.container),
                  (this.slider = this.container.querySelector(Yc)),
                  (this.thumbSlider = this.container.querySelector(Xc)),
                  (this.thumbs = this.container.querySelectorAll(Zc)),
                  (this.slides = this.container.querySelectorAll(eh)),
                  (this.variantImage = null),
                  this.listen();
              }
            })(e);
          const i = this.container.querySelector(ah);
          i && "" !== i.innerHTML
            ? ((this.product = JSON.parse(i.innerHTML)),
              (this.truncateElementHolder = this.container.querySelector(ch)),
              (this.truncateElement = this.container.querySelector(`[${dh}]`)),
              (this.resizeEventTruncate = () => this.truncateText()),
              this.init())
            : console.error("Missing product JSON");
        }
      })(this);
    },
    onUnload() {
      "function" == typeof mh[this.id].unload && mh[this.id].unload();
    },
    onBlockSelect(e) {
      "function" == typeof mh[this.id].onBlockSelect &&
        mh[this.id].onBlockSelect(e);
    },
    onBlockDeselect(e) {
      "function" == typeof mh[this.id].onBlockDeselect &&
        mh[this.id].onBlockDeselect(e);
    },
  };
  Gt("product", [fh, ml, hn, Fc, $e]),
    customElements.get("product-form") ||
      customElements.define("product-form", mc),
    customElements.get("product-complimentary") ||
      customElements.define("product-complimentary", fc),
    customElements.get("radio-swatch") ||
      customElements.define("radio-swatch", Ue),
    customElements.get("popout-select") ||
      customElements.define("popout-select", Yr),
    customElements.get("share-button") ||
      customElements.define("share-button", Qc);
  const gh = "data-toggle-grid",
    yh = "data-grid-large",
    vh = "data-grid-small",
    bh = "is-active",
    wh = window.theme.sizes.small;
  var Sh = {};
  const Eh = {
      onLoad() {
        Sh[this.id] = [];
        this.container.querySelectorAll(`[${gh}]`).forEach((e) => {
          Sh[this.id].push(
            new (class {
              init() {
                this.toggle.addEventListener("click", this.toggleFunction),
                  document.addEventListener(
                    "theme:resize:width",
                    this.toggleFunction
                  ),
                  this.toggleEvent(!1);
              }
              unload() {
                this.toggle.removeEventListener("click", this.toggleFunction),
                  document.removeEventListener(
                    "theme:resize:width",
                    this.toggleFunction
                  );
              }
              toggleEvent(e = !0) {
                const t = e && "click" === e.type,
                  i = window.innerWidth >= wh ? yh : vh,
                  s = this.container.querySelector(`[${i}]`),
                  r = s.getAttribute(i),
                  n = this.toggle.parentElement.querySelector(`[${gh}].${bh}`);
                let o = this.toggle.parentElement.querySelector(
                  `[${gh}="${r}"]`
                );
                t && ((o = this.toggle), s.setAttribute(i, this.value)),
                  n && n.classList.remove(bh),
                  o && o.classList.add(bh);
              }
              constructor(e, t) {
                (this.container = t || document),
                  (this.toggle = e),
                  (this.value = this.toggle.getAttribute(gh)),
                  (this.toggleFunction = (e) => this.toggleEvent(e)),
                  this.init();
              }
            })(e, this.container)
          );
        });
      },
      onUnload: function () {
        Sh[this.id].forEach((e) => {
          "function" == typeof e.unload && e.unload();
        });
      },
    },
    Lh = "data-sort-enabled",
    kh = "[data-sort-link]",
    Th = "[data-sort-button-text]",
    xh = "data-value",
    _h = "popout-list__item--current";
  var Ah = "data-swatch";
  Gt("collection", [
    {
      onLoad() {
        this.collection = new (class {
          init() {
            new (class {
              init() {
                this.sortLinks.forEach((e) => {
                  e.addEventListener("click", (e) => {
                    e.preventDefault(), this.sortingResults(e);
                  });
                });
              }
              sortingResults(e) {
                const t = e.currentTarget,
                  i = t.getAttribute(xh),
                  s = t.innerText;
                (this.sortButtonText.innerText = s),
                  this.sortButtonText.parentNode.dispatchEvent(
                    new Event("click")
                  ),
                  this.sort.querySelector(`.${_h}`).classList.remove(_h),
                  t.parentNode.classList.add(_h),
                  this.sort.setAttribute(Lh, i),
                  this.container.dispatchEvent(
                    new CustomEvent("theme:form:filter", {
                      bubbles: !0,
                      detail: { params: i },
                    })
                  );
              }
              constructor(e) {
                (this.container = e.container),
                  (this.sort = this.container.querySelector(`[${Lh}]`)),
                  (this.sortLinks = this.container.querySelectorAll(kh)),
                  (this.sortButtonText = this.container.querySelector(Th)),
                  this.sort && this.init();
              }
            })(this.section);
          }
          constructor(e) {
            (this.section = e),
              (this.container = this.section.container),
              (this.swatches = this.container.querySelectorAll(`[${Ah}]`)),
              this.init();
          }
        })(this);
      },
    },
    Ta,
    Pa,
    Eh,
    Je,
    hn,
    K,
  ]),
    customElements.get("popout-select") ||
      customElements.define("popout-select", Yr),
    customElements.get("radio-swatch") ||
      customElements.define("radio-swatch", Ue),
    customElements.get("product-grid-item") ||
      customElements.define("product-grid-item", br),
    customElements.get("product-grid-item-variant") ||
      customElements.define("product-grid-item-variant", Mr),
    customElements.get("product-grid-item-image") ||
      customElements.define("product-grid-item-image", Hr),
    Gt("collection-row", [Je, K, tt]),
    customElements.get("radio-swatch") ||
      customElements.define("radio-swatch", Ue),
    customElements.get("product-grid-item") ||
      customElements.define("product-grid-item", br),
    customElements.get("product-grid-item-variant") ||
      customElements.define("product-grid-item-variant", Mr),
    customElements.get("product-grid-item-image") ||
      customElements.define("product-grid-item-image", Hr),
    Gt("collection-tabs", [Fc, Bo, Je]),
    customElements.get("radio-swatch") ||
      customElements.define("radio-swatch", Ue),
    customElements.get("product-grid-item") ||
      customElements.define("product-grid-item", br),
    customElements.get("product-grid-item-variant") ||
      customElements.define("product-grid-item-variant", Mr),
    customElements.get("product-grid-item-image") ||
      customElements.define("product-grid-item-image", Hr);
  var qh = {};
  function Ch(e) {
    return qh[e];
  }
  (qh.basic = []),
    (qh.light = [
      {
        featureType: "administrative",
        elementType: "labels",
        stylers: [
          { visibility: "on" },
          { lightness: "64" },
          { hue: "#ff0000" },
        ],
      },
      {
        featureType: "administrative",
        elementType: "labels.text.fill",
        stylers: [{ color: "#bdbdbd" }],
      },
      {
        featureType: "administrative",
        elementType: "labels.icon",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "landscape",
        elementType: "all",
        stylers: [{ color: "#f0f0f0" }, { visibility: "simplified" }],
      },
      {
        featureType: "landscape.natural.landcover",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "landscape.natural.terrain",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "poi",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "poi",
        elementType: "geometry.fill",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "poi",
        elementType: "labels",
        stylers: [{ lightness: "100" }],
      },
      {
        featureType: "poi.park",
        elementType: "all",
        stylers: [{ visibility: "on" }],
      },
      {
        featureType: "poi.park",
        elementType: "geometry",
        stylers: [{ saturation: "-41" }, { color: "#e8ede7" }],
      },
      {
        featureType: "poi.park",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road",
        elementType: "all",
        stylers: [{ saturation: "-100" }],
      },
      {
        featureType: "road",
        elementType: "labels",
        stylers: [
          { lightness: "25" },
          { gamma: "1.06" },
          { saturation: "-100" },
        ],
      },
      {
        featureType: "road.highway",
        elementType: "all",
        stylers: [{ visibility: "simplified" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{ gamma: "10.00" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0.01" }, { visibility: "simplified" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels.text.fill",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels.text.stroke",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.fill",
        stylers: [{ weight: "0.8" }],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.arterial",
        elementType: "labels.icon",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road.local",
        elementType: "geometry.fill",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [{ gamma: "10.00" }, { lightness: "100" }, { weight: "0.4" }],
      },
      {
        featureType: "road.local",
        elementType: "labels",
        stylers: [
          { visibility: "simplified" },
          { weight: "0.01" },
          { lightness: "39" },
        ],
      },
      {
        featureType: "road.local",
        elementType: "labels.text.stroke",
        stylers: [{ weight: "0.50" }, { gamma: "10.00" }, { lightness: "100" }],
      },
      {
        featureType: "transit",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "water",
        elementType: "all",
        stylers: [{ color: "#cfe5ee" }, { visibility: "on" }],
      },
    ]),
    (qh.light_blank = [
      {
        featureType: "all",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "administrative",
        elementType: "labels",
        stylers: [
          { visibility: "off" },
          { lightness: "64" },
          { hue: "#ff0000" },
        ],
      },
      {
        featureType: "administrative",
        elementType: "labels.text.fill",
        stylers: [{ color: "#bdbdbd" }],
      },
      {
        featureType: "administrative",
        elementType: "labels.icon",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "landscape",
        elementType: "all",
        stylers: [{ color: "#f0f0f0" }, { visibility: "simplified" }],
      },
      {
        featureType: "landscape.natural.landcover",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "landscape.natural.terrain",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "poi",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "poi",
        elementType: "geometry.fill",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "poi",
        elementType: "labels",
        stylers: [{ lightness: "100" }],
      },
      {
        featureType: "poi.park",
        elementType: "all",
        stylers: [{ visibility: "on" }],
      },
      {
        featureType: "poi.park",
        elementType: "geometry",
        stylers: [{ saturation: "-41" }, { color: "#e8ede7" }],
      },
      {
        featureType: "poi.park",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road",
        elementType: "all",
        stylers: [{ saturation: "-100" }],
      },
      {
        featureType: "road",
        elementType: "labels",
        stylers: [
          { lightness: "25" },
          { gamma: "1.06" },
          { saturation: "-100" },
          { visibility: "off" },
        ],
      },
      {
        featureType: "road.highway",
        elementType: "all",
        stylers: [{ visibility: "simplified" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{ gamma: "10.00" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0.01" }, { visibility: "simplified" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels.text.fill",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels.text.stroke",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.fill",
        stylers: [{ weight: "0.8" }],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.arterial",
        elementType: "labels.icon",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road.local",
        elementType: "geometry.fill",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [{ gamma: "10.00" }, { lightness: "100" }, { weight: "0.4" }],
      },
      {
        featureType: "road.local",
        elementType: "labels",
        stylers: [
          { visibility: "off" },
          { weight: "0.01" },
          { lightness: "39" },
        ],
      },
      {
        featureType: "road.local",
        elementType: "labels.text.stroke",
        stylers: [{ weight: "0.50" }, { gamma: "10.00" }, { lightness: "100" }],
      },
      {
        featureType: "transit",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "water",
        elementType: "all",
        stylers: [{ color: "#cfe5ee" }, { visibility: "on" }],
      },
    ]),
    (qh.white_blank = [
      {
        featureType: "all",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "administrative",
        elementType: "labels.text.fill",
        stylers: [{ color: "#444444" }],
      },
      {
        featureType: "landscape",
        elementType: "all",
        stylers: [{ color: "#f2f2f2" }],
      },
      {
        featureType: "poi",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road",
        elementType: "all",
        stylers: [{ saturation: -100 }, { lightness: 45 }],
      },
      {
        featureType: "road.highway",
        elementType: "all",
        stylers: [{ visibility: "simplified" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{ weight: "0.8" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0.8" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels.text.fill",
        stylers: [{ weight: "0.8" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels.text.stroke",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0" }],
      },
      {
        featureType: "road.arterial",
        elementType: "labels.icon",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "transit",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "water",
        elementType: "all",
        stylers: [{ color: "#e4e4e4" }, { visibility: "on" }],
      },
    ]),
    (qh.white_label = [
      {
        featureType: "all",
        elementType: "all",
        stylers: [{ visibility: "simplified" }],
      },
      {
        featureType: "all",
        elementType: "labels",
        stylers: [{ visibility: "simplified" }],
      },
      {
        featureType: "administrative",
        elementType: "labels",
        stylers: [{ gamma: "3.86" }, { lightness: "100" }],
      },
      {
        featureType: "administrative",
        elementType: "labels.text.fill",
        stylers: [{ color: "#cccccc" }],
      },
      {
        featureType: "landscape",
        elementType: "all",
        stylers: [{ color: "#f2f2f2" }],
      },
      {
        featureType: "poi",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road",
        elementType: "all",
        stylers: [{ saturation: -100 }, { lightness: 45 }],
      },
      {
        featureType: "road.highway",
        elementType: "all",
        stylers: [{ visibility: "simplified" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{ weight: "0.8" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0.8" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels.text.fill",
        stylers: [{ weight: "0.8" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels.text.stroke",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0" }],
      },
      {
        featureType: "road.arterial",
        elementType: "labels.icon",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.local",
        elementType: "labels.text",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "transit",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "water",
        elementType: "all",
        stylers: [{ color: "#e4e4e4" }, { visibility: "on" }],
      },
    ]),
    (qh.dark_blank = [
      {
        featureType: "all",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "all",
        elementType: "labels.text.fill",
        stylers: [{ saturation: 36 }, { color: "#000000" }, { lightness: 40 }],
      },
      {
        featureType: "all",
        elementType: "labels.text.stroke",
        stylers: [
          { visibility: "on" },
          { color: "#000000" },
          { lightness: 16 },
        ],
      },
      {
        featureType: "all",
        elementType: "labels.icon",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "administrative",
        elementType: "geometry.fill",
        stylers: [{ color: "#000000" }, { lightness: 20 }],
      },
      {
        featureType: "administrative",
        elementType: "geometry.stroke",
        stylers: [{ color: "#000000" }, { lightness: 17 }, { weight: 1.2 }],
      },
      {
        featureType: "administrative",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "landscape",
        elementType: "geometry",
        stylers: [{ color: "#000000" }, { lightness: 20 }],
      },
      {
        featureType: "landscape",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "poi",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "poi",
        elementType: "geometry",
        stylers: [{ color: "#000000" }, { lightness: 21 }],
      },
      {
        featureType: "road",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{ color: "#000000" }, { lightness: 17 }, { weight: "0.8" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{ color: "#000000" }, { lightness: 29 }, { weight: "0.01" }],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry",
        stylers: [{ color: "#000000" }, { lightness: 18 }],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.local",
        elementType: "geometry",
        stylers: [{ color: "#000000" }, { lightness: 16 }],
      },
      {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "transit",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "transit",
        elementType: "geometry",
        stylers: [{ color: "#000000" }, { lightness: 19 }],
      },
      {
        featureType: "water",
        elementType: "geometry",
        stylers: [{ color: "#000000" }, { lightness: 17 }],
      },
    ]),
    (qh.dark_label = [
      {
        featureType: "all",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "all",
        elementType: "labels.text.fill",
        stylers: [{ saturation: 36 }, { color: "#000000" }, { lightness: 40 }],
      },
      {
        featureType: "all",
        elementType: "labels.text.stroke",
        stylers: [
          { visibility: "on" },
          { color: "#000000" },
          { lightness: 16 },
        ],
      },
      {
        featureType: "all",
        elementType: "labels.icon",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "administrative",
        elementType: "geometry.fill",
        stylers: [{ color: "#000000" }, { lightness: 20 }],
      },
      {
        featureType: "administrative",
        elementType: "geometry.stroke",
        stylers: [{ color: "#000000" }, { lightness: 17 }, { weight: 1.2 }],
      },
      {
        featureType: "administrative",
        elementType: "labels",
        stylers: [{ visibility: "simplified" }, { lightness: "-82" }],
      },
      {
        featureType: "administrative",
        elementType: "labels.text.stroke",
        stylers: [{ invert_lightness: !0 }, { weight: "7.15" }],
      },
      {
        featureType: "landscape",
        elementType: "geometry",
        stylers: [{ color: "#000000" }, { lightness: 20 }],
      },
      {
        featureType: "landscape",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "poi",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "poi",
        elementType: "geometry",
        stylers: [{ color: "#000000" }, { lightness: 21 }],
      },
      {
        featureType: "road",
        elementType: "labels",
        stylers: [{ visibility: "simplified" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{ color: "#000000" }, { lightness: 17 }, { weight: "0.8" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{ color: "#000000" }, { lightness: 29 }, { weight: "0.01" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry",
        stylers: [{ color: "#000000" }, { lightness: 18 }],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.local",
        elementType: "geometry",
        stylers: [{ color: "#000000" }, { lightness: 16 }],
      },
      {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.local",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "transit",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "transit",
        elementType: "geometry",
        stylers: [{ color: "#000000" }, { lightness: 19 }],
      },
      {
        featureType: "water",
        elementType: "geometry",
        stylers: [{ color: "#000000" }, { lightness: 17 }],
      },
    ]),
    (window.theme.allMaps = window.theme.allMaps || {});
  let Ph = window.theme.allMaps;
  const $h = "[data-map-container]",
    Ih = "data-style",
    Mh = "data-api-key",
    Dh = "data-zoom",
    Oh = "data-address",
    Hh = "data-latlong-correction",
    Fh = "data-lat",
    Bh = "data-long";
  const Wh = {
    onLoad() {
      Ph[this.id] = new (class {
        initMaps() {
          xe({ url: `https://maps.googleapis.com/maps/api/js?key=${this.key}` })
            .then(() => {
              return "true" === this.enableCorrection &&
                "" !== this.lat &&
                "" !== this.long
                ? new window.google.maps.LatLng(this.lat, this.long)
                : ((e = this.address),
                  new Promise((t, i) => {
                    new window.google.maps.Geocoder().geocode(
                      { address: e },
                      function (e, s) {
                        if ("OK" == s) {
                          var r = {
                            lat: e[0].geometry.location.lat(),
                            lng: e[0].geometry.location.lng(),
                          };
                          t(r);
                        } else i(s);
                      }
                    );
                  }));
              var e;
            })
            .then((e) => {
              var t = {
                zoom: parseInt(this.zoomString, 10),
                styles: Ch(this.styleString),
                center: e,
                draggable: !0,
                clickableIcons: !1,
                scrollwheel: !1,
                zoomControl: !1,
                disableDefaultUI: !0,
              };
              const i = (function (e, t) {
                var i = new window.google.maps.Map(e, t),
                  s = i.getCenter();
                return (
                  new window.google.maps.Marker({ map: i, position: s }),
                  window.google.maps.event.addDomListener(
                    window,
                    "resize",
                    function () {
                      window.google.maps.event.trigger(i, "resize"),
                        i.setCenter(s);
                    }
                  ),
                  i
                );
              })(this.mapWrap, t);
              return i;
            })
            .then((e) => {
              (this.map = e), (Ph[this.id] = e);
            })
            .catch((e) => {
              console.log("Failed to load Google Map"), console.log(e);
            });
        }
        onUnload() {
          void 0 !== window.google &&
            window.google.maps.event.clearListeners(this.map, "resize");
        }
        constructor(e) {
          (this.container = e.container),
            (this.mapWrap = this.container.querySelector($h)),
            (this.styleString = this.container.getAttribute(Ih) || ""),
            (this.key = this.container.getAttribute(Mh)),
            (this.zoomString = this.container.getAttribute(Dh) || 14),
            (this.address = this.container.getAttribute(Oh)),
            (this.enableCorrection = this.container.getAttribute(Hh)),
            (this.lat = this.container.getAttribute(Fh)),
            (this.long = this.container.getAttribute(Bh)),
            this.key && this.initMaps();
        }
      })(this);
    },
    onUnload() {
      "function" == typeof Ph[this.id].unload && Ph[this.id].unload();
    },
  };
  Gt("section-map", Wh), Gt("section-columns", [xo, tt]);
  const Nh = "[data-related-section]",
    Rh = "[data-grid-item]",
    jh = "[data-carousel]",
    zh = "data-limit",
    Vh = "data-minimum",
    Uh = "data-layout-desktop",
    Gh = "data-layout-tablet",
    Jh = "data-layout-mobile",
    Qh = "[data-recent-wrapper]",
    Kh = "[data-recently-viewed-wrapper]",
    Yh = "data-product-id";
  Gt("related", [
    {
      onLoad() {
        this.section = new (class {
          init() {
            const e = this.container.querySelector(Nh);
            if (!e) return;
            const t = e.getAttribute(Yh),
              i = e.getAttribute(zh),
              s = e.getAttribute(Uh),
              r = e.getAttribute(Gh),
              n = e.getAttribute(Jh),
              o = `${
                window.theme.routes.product_recommendations_url ||
                "/recommendations/products/"
              }?section_id=related&limit=${i}&product_id=${t}`;
            l.get(o)
              .then((t) => {
                const i = document.createElement("div");
                i.innerHTML = t.data;
                const o = i.querySelector(Nh);
                if (o.querySelector(Rh)) {
                  const t = o.innerHTML;
                  (e.innerHTML = t),
                    e
                      .querySelector(jh)
                      .style.setProperty("--grid-large-items", s),
                    e
                      .querySelector(jh)
                      .style.setProperty("--grid-medium-items", r),
                    e
                      .querySelector(jh)
                      .style.setProperty("--grid-small-items", n),
                    e.dispatchEvent(
                      new CustomEvent("theme:related-products:added", {
                        bubbles: !0,
                      })
                    );
                } else
                  e.dispatchEvent(
                    new CustomEvent("theme:tabs:hide", { bubbles: !0 })
                  );
              })
              .catch(function (e) {
                console.warn(e);
              });
          }
          recent() {
            const e = this.container.querySelector(Qh),
              t = this.container.querySelector(Kh),
              i = this.container.querySelectorAll(Rh),
              s = e.hasAttribute(Vh) ? parseInt(e.getAttribute(Vh)) : 4,
              r = !t && i.length > 0,
              n = t && i.length >= s;
            (r || n) &&
              e.dispatchEvent(
                new CustomEvent("theme:tabs:check", { bubbles: !0 })
              );
          }
          constructor(e) {
            (this.section = e),
              (this.container = e.container),
              this.init(),
              this.container.addEventListener(
                "theme:recent-products:added",
                () => {
                  this.recent();
                }
              );
          }
        })(this);
      },
    },
    Fc,
    fe,
  ]),
    customElements.get("radio-swatch") ||
      customElements.define("radio-swatch", Ue),
    customElements.get("product-grid-item") ||
      customElements.define("product-grid-item", br),
    customElements.get("product-grid-item-variant") ||
      customElements.define("product-grid-item-variant", Mr),
    customElements.get("product-grid-item-image") ||
      customElements.define("product-grid-item-image", Hr);
  const Xh = "[data-cart-note]";
  class Zh {
    initInputs() {
      this.inputs.forEach((e) => {
        e.addEventListener(
          "change",
          function (e) {
            const t = e.target.value.toString() || "";
            this.saveNotes(t);
          }.bind(this)
        );
      });
    }
    saveNotes(e) {
      window
        .fetch(`${window.theme.routes.cart}/update.js`, {
          method: "post",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ note: e }),
        })
        .catch((e) => {
          console.error(e);
        });
    }
    constructor(e) {
      (this.inputs = e.querySelectorAll(Xh)), this.initInputs();
    }
  }
  const ed = (e, t = [], i = !1) => {
      const s = Object.keys(e)
        .map((s) => {
          let r = e[s];
          if (
            "[object Object]" === Object.prototype.toString.call(r) ||
            Array.isArray(r)
          )
            return (
              Array.isArray(e) ? t.push("") : t.push(s),
              ed(r, t, Array.isArray(r))
            );
          {
            let e = s;
            if (t.length > 0) {
              e = (i ? t : [...t, s]).reduce(
                (e, t) => ("" === e ? t : `${e}[${t}]`),
                ""
              );
            }
            return i ? `${e}[]=${r}` : `${e}=${r}`;
          }
        })
        .join("&");
      return t.pop(), s;
    },
    td = "html",
    id = "[data-submit-shipping]",
    sd = "[data-shipping-estimate-form]",
    rd = "[data-response-template]",
    nd = "#estimate_address_country",
    od = "#estimate_address_province",
    ad = "#estimate_address_zip",
    ld = "[data-response-wrapper]",
    cd = "lang",
    hd = "data-default",
    dd = "shipping--success",
    ud = "errors",
    pd = "disabled";
  class md {
    enableButtons() {
      this.button.removeAttribute("disabled"), this.button.classList.remove(pd);
    }
    disableButtons() {
      this.button.setAttribute("disabled", "disabled"),
        this.button.classList.add(pd);
    }
    render(e) {
      if (this.template && this.ratesWrapper) {
        const t = u.render(this.template, e);
        this.ratesWrapper.innerHTML = t;
      }
      this.enableButtons(), this.ratesWrapper.style.removeProperty("display");
    }
    estimate(e) {
      const t = encodeURI(ed({ shipping_address: e })),
        i = `${window.theme.routes.cart}/shipping_rates.json?${t}`,
        s = this;
      l.get(i)
        .then(function (e) {
          const t = s.sanitize(e);
          s.render(t),
            s.enableButtons(),
            s.ratesWrapper.style.removeProperty("display");
        })
        .catch(function (e) {
          const t = s.sanitizeErrors(e);
          s.render(t);
        });
    }
    sanitize(e) {
      const t = {};
      if (
        ((t.class = dd),
        (t.items = []),
        e.data.shipping_rates && e.data.shipping_rates.length > 0)
      ) {
        e.data.shipping_rates.forEach((e) => {
          let i = {};
          (i.title = e.presentment_name),
            (i.value = a.formatMoney(e.price, theme.moneyFormat)),
            t.items.push(i);
        });
      } else t.items[0] = { value: theme.strings.noShippingAvailable };
      return t;
    }
    sanitizeErrors(e) {
      const t = {};
      if (((t.class = ud), (t.items = []), "object" == typeof e.data))
        for (const [i, s] of Object.entries(e.data)) {
          let e = {};
          (e.title = i.toString()), (e.value = s.toString()), t.items.push(e);
        }
      else t.items[0] = { value: theme.strings.noShippingAvailable };
      return t;
    }
    init() {
      const e = document.querySelector(td);
      let t = "en";
      e.hasAttribute(cd) &&
        "" !== e.getAttribute(cd) &&
        (t = e.getAttribute(cd)),
        this.form && h.AddressForm(this.form, t, { shippingCountriesOnly: !0 }),
        this.country &&
          this.country.hasAttribute(hd) &&
          this.province &&
          this.province.hasAttribute(hd) &&
          this.country.addEventListener("change", function () {
            this.country.removeAttribute(hd), this.province.removeAttribute(hd);
          }),
        this.button &&
          this.button.addEventListener(
            "click",
            function (e) {
              for (
                e.preventDefault(), this.disableButtons();
                this.ratesWrapper.firstChild;

              )
                this.ratesWrapper.removeChild(this.ratesWrapper.firstChild);
              this.ratesWrapper.style.display = "none";
              const t = {};
              let i = this.country.value,
                s = this.province.value;
              const r = this.country.getAttribute(hd);
              "" === i && r && "" !== r && (i = r);
              const n = this.province.getAttribute(hd);
              "" === s && n && "" !== n && (s = n),
                (t.zip = this.zip.value || ""),
                (t.country = i || ""),
                (t.province = s || ""),
                this.estimate(t);
            }.bind(this)
          );
    }
    constructor(e) {
      (this.button = e.container.querySelector(id)),
        (this.template = e.container.querySelector(rd).innerHTML),
        (this.ratesWrapper = e.container.querySelector(ld)),
        (this.form = e.container.querySelector(sd)),
        (this.country = e.container.querySelector(nd)),
        (this.province = e.container.querySelector(od)),
        (this.zip = e.container.querySelector(ad)),
        this.init();
    }
  }
  const fd = '[data-drawer="drawer-cart"]',
    gd = "[data-shipping-estimate-form]",
    yd = "[data-cart-loading]",
    vd = "[data-cart-form]",
    bd = "[data-cart-empty]",
    wd = "[data-cart-progress]",
    Sd = "[data-line-items]",
    Ed = "[data-cart-subtotal]",
    Ld = "[data-cart-bottom]",
    kd = "[data-form-errors]",
    Td = "[data-cart-item]",
    xd = "[data-cart-final]",
    _d = "data-update-cart",
    Ad = "data-remove-key",
    qd = "[data-cart-page-upsell-wrapper]",
    Cd = '[data-section-type="cart"]',
    Pd = "[data-cart-bar]",
    $d = "[data-cart-message]",
    Id = "[data-item-loadbar]",
    Md = "[data-cart-message-container]",
    Dd = "[data-api-content]",
    Od = "cart--hidden",
    Hd = "cart--loading";
  let Fd = class {
    listen() {
      document.addEventListener(
        "theme:cart:change",
        function (e) {
          (this.cart = e.detail.cart), (this.stale = !0);
        }.bind(this)
      ),
        document.addEventListener(
          "theme:cart:init",
          function () {
            this.init();
          }.bind(this)
        ),
        document.addEventListener(
          "theme:cart:reload",
          function () {
            (this.stale = !0),
              this.cart
                ? this.loadHTML()
                : this.init().then(() => this.loadHTML());
          }.bind(this)
        ),
        this.drawer &&
          (this.drawer.addEventListener(
            "theme:drawer:open",
            function () {
              this.cart
                ? this.loadHTML()
                : this.init().then(() => this.loadHTML()),
                (window.theme.state.cartOpen = !0);
            }.bind(this)
          ),
          this.drawer.addEventListener("theme:drawer:close", function () {
            window.theme.state.cartOpen = !1;
          })),
        new Zh(this.container),
        new Fi(this.container);
    }
    init() {
      return window
        .fetch(`${window.theme.routes.cart}.js`)
        .then(this.handleErrors)
        .then((e) => e.json())
        .then((e) => ((this.cart = e), this.fireChange(e), e))
        .catch((e) => {
          console.error(e);
        });
    }
    loadHTML(e = !1) {
      this.stale &&
        (this.cart && this.cart.item_count > 0
          ? this.loadForm(e)
          : (this.showEmpty(),
            this.cartMessages.forEach((e) => {
              new Fi(e);
            }))),
        (this.stale = !1);
    }
    initInputs() {
      (this.inputs = this.container.querySelectorAll(`[${_d}]`)),
        this.inputs.forEach((e) => {
          const t = e.getAttribute(_d);
          e.addEventListener(
            "change",
            function (e) {
              const i = parseInt(e.target.value, 10);
              (this.latestClick = e.target.closest(Td)),
                this.lockState(),
                this.updateCart(t, i);
            }.bind(this)
          );
        });
    }
    initRemove() {
      (this.removers = this.container.querySelectorAll(`[${Ad}]`)),
        this.removers.forEach((e) => {
          const t = e.getAttribute(Ad);
          e.addEventListener(
            "click",
            function (e) {
              e.preventDefault(),
                (this.latestClick = e.target.closest(Td)),
                this.lockState(),
                this.updateCart(t, 0);
            }.bind(this)
          );
        });
    }
    lockState() {
      (this.latestClick.querySelector(Id).style.display = "block"),
        this.loader.classList.add(Hd);
    }
    updateCart(e, t) {
      window
        .fetch(`${window.theme.routes.cart}/change.js`, {
          method: "post",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: e, quantity: t }),
        })
        .then(this.handleErrors)
        .then((e) => e.json())
        .then((e) => {
          (this.cart = e),
            Zr(this.errors),
            this.fireChange(e),
            (this.stale = !0),
            this.loadHTML();
        })
        .catch((e) => {
          if (!(e instanceof N)) {
            let t = `<p>${
              e.message ||
              window.theme.strings.stockout ||
              "Could not update cart, please reload"
            }</p>`;
            throw (this.showError(t), e);
          }
          {
            var t, i;
            let s = `<p>${
                (null === (t = e.json) || void 0 === t ? void 0 : t.message) ||
                e.message ||
                window.theme.strings.stockout ||
                "Could not update cart, please reload"
              }</p>`,
              r =
                (null === (i = e.json) || void 0 === i
                  ? void 0
                  : i.description) || "";
            this.showError([s, r].join(" ")), this.loadForm();
          }
        });
    }
    fireChange(e) {
      document.dispatchEvent(
        new CustomEvent("theme:cart:change", {
          detail: { cart: e },
          bubbles: !0,
        })
      );
    }
    updateTotal() {
      if (this.cart && null != this.cart.total_price) {
        const e = a.formatMoney(this.cart.total_price, theme.moneyFormat);
        this.finalPrice.innerHTML = e + ` ${theme.currencyCode}`;
      }
      this.subtotal &&
        this.cart &&
        window
          .fetch(`${window.theme.routes.root_url}?section_id=api-cart-subtotal`)
          .then(this.handleErrors)
          .then((e) => e.text())
          .then((e) => {
            const t = document.createElement("div");
            (t.innerHTML = e),
              (this.subtotal.innerHTML = t.querySelector(Dd).innerHTML);
          });
    }
    showError(e) {
      Zr(this.errors),
        (this.errors.innerHTML = e),
        window.setTimeout(() => {
          Xr(this.errors);
        }, 600);
    }
    loadForm(e = !1) {
      if (e)
        return (
          this.showForm(),
          this.initQuantity(),
          this.initQuickview(),
          void this.updateTotal()
        );
      window
        .fetch(`${window.theme.routes.root_url}?section_id=api-cart-items`)
        .then(this.handleErrors)
        .then((e) => e.text())
        .then((e) => {
          const t = document.createElement("div");
          (t.innerHTML = e),
            (this.items.innerHTML = t.querySelector(Dd).innerHTML),
            this.showForm(),
            this.initQuantity(),
            this.initQuickview(),
            this.updateTotal();
        });
    }
    initQuickview() {
      const e = this.items.querySelector(qd),
        t = this.bottom.querySelector(qd);
      t && t.remove(),
        this.cartPage &&
          e &&
          (this.bottom.insertBefore(e, this.bottom.firstChild),
          Alpine.initTree(this.bottom));
    }
    initQuantity() {
      bl(this.container), this.initInputs(), this.initRemove();
    }
    showForm() {
      this.bar && this.bar.classList.remove(Od),
        this.ship && this.ship.classList.remove(Od),
        this.progress && this.progress.classList.remove(Od),
        this.form.classList.remove(Od),
        this.bottom.classList.remove(Od),
        this.loader.classList.remove(Hd),
        this.emptystate.classList.add(Od);
    }
    showEmpty() {
      this.bar && this.bar.classList.add(Od),
        this.ship && this.ship.classList.add(Od),
        this.progress && this.progress.classList.add(Od),
        this.emptystate.classList.remove(Od),
        this.loader.classList.remove(Hd),
        this.form.classList.add(Od),
        this.bottom.classList.add(Od);
    }
    handleErrors(e) {
      return e.ok
        ? e
        : e.json().then(function (t) {
            throw new N({ status: e.statusText, headers: e.headers, json: t });
          });
    }
    constructor(e) {
      (this.section = e),
        (this.container = e.container),
        (this.cartMessages = document.querySelectorAll(Md)),
        (this.bar = this.container.querySelector(Pd)),
        (this.ship = this.container.querySelector($d)),
        (this.drawer = this.container.querySelector(fd)),
        (this.form = this.container.querySelector(vd)),
        (this.loader = this.container.querySelector(yd)),
        (this.bottom = this.container.querySelector(Ld)),
        (this.items = this.container.querySelector(Sd)),
        (this.subtotal = this.container.querySelector(Ed)),
        (this.errors = this.container.querySelector(kd)),
        (this.finalPrice = this.container.querySelector(xd)),
        (this.emptystate = this.container.querySelector(bd)),
        (this.progress = this.container.querySelector(wd)),
        (this.latestClick = null),
        (this.cart = null),
        (this.stale = !0),
        (this.cartPage = document.querySelector(Cd)),
        this.listen();
    }
  };
  const Bd = {
      onLoad() {
        document.querySelector(fd) && (this.cart = new Fd(this));
        this.container.querySelector(gd) && new md(this);
      },
      onUnload: function () {
        this.cart &&
          "function" == typeof this.cart.unload &&
          this.cart.unload();
      },
    },
    Wd = {
      ajaxDisable: "data-ajax-disable",
      shipping: "[data-shipping-estimate-form]",
      input: "[data-update-cart]",
      update: "[data-update-button]",
      bottom: "[data-cart-bottom]",
      upsellWrapper: "[data-cart-page-upsell-wrapper]",
    },
    Nd = "cart--dirty",
    Rd = "heart-beat",
    jd = {
      onLoad() {
        if (
          (this.container.querySelector(Wd.shipping) && new md(this),
          (this.disabled =
            "true" == this.container.getAttribute(Wd.ajaxDisable)),
          this.disabled)
        )
          return void (this.cart = new zd(this));
        this.cart = new Fd(this);
        this.cart.init().then(() => {
          this.cart.loadHTML(!0);
        });
      },
    };
  let zd = class {
    initQuantity() {
      bl(this.container);
    }
    moveUpsell() {
      const e = this.container.querySelector(Wd.bottom);
      e.insertBefore(this.upsellWrapper, e.firstChild);
    }
    initInputs() {
      this.inputs.forEach((e) => {
        e.addEventListener(
          "change",
          function () {
            this.updateBtn.classList.add(Nd),
              this.updateBtn.classList.add(Rd),
              setTimeout(
                function () {
                  this.updateBtn.classList.remove(Rd);
                }.bind(this),
                1300
              );
          }.bind(this)
        );
      });
    }
    constructor(e) {
      (window.theme.state.cartOpen = !0),
        (this.section = e),
        (this.container = e.container),
        (this.inputs = this.container.querySelectorAll(Wd.input)),
        (this.quantityWrappers = this.container.querySelectorAll(Wd.qty)),
        (this.updateBtn = this.container.querySelector(Wd.update)),
        (this.upsellWrapper = this.container.querySelector(Wd.upsellWrapper)),
        this.initQuantity(),
        this.initInputs(),
        this.upsellWrapper && this.moveUpsell(),
        document.addEventListener(
          "theme:cart:reload",
          function () {
            window.location.reload();
          }.bind(this)
        );
    }
  };
  Gt("cart", [jd, hn]),
    Gt("cart-drawer", [fs, Bd, hn]),
    Gt("accordion-single", hn);
  const Vd = (e, t, i = null) => {
      (e.style.opacity = 0),
        (e.style.display = t || "block"),
        (function t() {
          let s = parseFloat(e.style.opacity);
          (s += 0.1) > 1 || ((e.style.opacity = s), requestAnimationFrame(t)),
            1 === s && "function" == typeof i && i();
        })();
    },
    Ud = (e, t = null) => {
      (e.style.opacity = 1),
        (function i() {
          (e.style.opacity -= 0.1) < 0
            ? (e.style.display = "none")
            : requestAnimationFrame(i),
            0 === parseFloat(e.style.opacity) && "function" == typeof t && t();
        })();
    },
    Gd = "[data-tracking-consent]",
    Jd = "[data-confirm-cookies]",
    Qd = "[data-close-modal]",
    Kd = "[data-popup-inner]",
    Yd = "[data-newsletter]",
    Xd = "[data-newsletter-holder]",
    Zd = "[data-newsletter-field]",
    eu = "[data-newsletter-form]",
    tu = "[data-promo-text]",
    iu = "data-popup-delay",
    su = "data-cookie-name",
    ru = "data-target-referrer",
    nu = "has-value",
    ou = "has-success",
    au = "has-error",
    lu = "desktop",
    cu = "mobile";
  let hu = {},
    du = class {
      write() {
        ((-1 !== document.cookie.indexOf("; ") &&
          !document.cookie.split("; ").find((e) => e.startsWith(this.name))) ||
          -1 === document.cookie.indexOf("; ")) &&
          (document.cookie = `${this.name}=${this.value}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`);
      }
      read() {
        if (
          -1 !== document.cookie.indexOf("; ") &&
          document.cookie.split("; ").find((e) => e.startsWith(this.name))
        ) {
          return document.cookie
            .split("; ")
            .find((e) => e.startsWith(this.name))
            .split("=")[1];
        }
        return !1;
      }
      destroy() {
        document.cookie.split("; ").find((e) => e.startsWith(this.name)) &&
          (document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`);
      }
      constructor(e, t) {
        (this.configuration = {
          expires: null,
          path: "/",
          domain: window.location.hostname,
        }),
          (this.name = e),
          (this.value = t);
      }
    },
    uu = class {
      hide() {
        this.show = !1;
      }
      always() {
        this.show && Vd(this.element);
      }
      delayed() {
        setTimeout(() => {
          this.always();
        }, 1e4);
      }
      bottom() {
        let e;
        const t = () => {
          e && window.cancelAnimationFrame(e),
            (e = window.requestAnimationFrame(() => {
              window.requestIdleCallback(
                () => {
                  Math.round(window.scrollY + window.innerHeight) >=
                    Math.round(document.body.clientHeight) &&
                    (this.always(),
                    window.removeEventListener("scroll", t, { passive: !0 }));
                },
                { timeout: 300 }
              );
            }));
        };
        window.addEventListener("scroll", t, { passive: !0 });
      }
      onScroll() {}
      idle() {
        let e = 0;
        const t = [
            "mousemove",
            "mousedown",
            "click",
            "touchmove",
            "touchstart",
            "touchend",
            "keydown",
            "keypress",
          ],
          i = ["load", "resize", "scroll"],
          s = () => {
            (e = setTimeout(() => {
              (e = 0), this.always();
            }, 6e4)),
              t.forEach((e) => {
                document.addEventListener(e, r);
              }),
              i.forEach((e) => {
                window.addEventListener(e, r);
              });
          },
          r = () => {
            e && clearTimeout(e),
              t.forEach((e) => {
                document.removeEventListener(e, r);
              }),
              i.forEach((e) => {
                window.removeEventListener(e, r);
              }),
              s();
          };
        s();
      }
      constructor(e, t) {
        (this.show = !0),
          (this.element = t),
          (this.delay = e.getAttribute(iu)),
          "always" === this.delay && this.always(),
          "delayed" === this.delay && this.delayed(),
          "bottom" === this.delay && this.bottom(),
          "idle" === this.delay && this.idle();
      }
    },
    pu = class {
      init() {
        -1 !== this.locationPath.indexOf(this.el.getAttribute(ru)) ||
          window.Shopify.designMode ||
          this.el.parentNode.removeChild(this.el);
      }
      constructor(e) {
        (this.el = e),
          (this.locationPath = location.href),
          this.el.hasAttribute(ru) && this.init();
      }
    };
  Gt("popups", [
    io,
    {
      onLoad() {
        hu[this.id] = [];
        this.container.querySelectorAll(Gd).forEach((e) => {
          hu[this.id].push(
            new (class {
              init() {
                this.showPopup && Vd(this.modalInner), this.clickEvents();
              }
              clickEvents() {
                this.close.addEventListener("click", (e) => {
                  e.preventDefault(),
                    window.Shopify.customerPrivacy.setTrackingConsent(!1, () =>
                      Ud(this.modalInner)
                    );
                }),
                  this.acceptButton.addEventListener("click", (e) => {
                    e.preventDefault(),
                      window.Shopify.customerPrivacy.setTrackingConsent(
                        !0,
                        () => Ud(this.modalInner)
                      );
                  }),
                  document.addEventListener(
                    "trackingConsentAccepted",
                    function () {
                      console.log("trackingConsentAccepted event fired");
                    }
                  );
              }
              onBlockSelect(e) {
                this.popup.contains(e.target) &&
                  this.showPopup &&
                  Vd(this.modalInner);
              }
              onBlockDeselect(e) {
                this.popup.contains(e.target) && Ud(this.modalInner);
              }
              constructor(e) {
                (this.popup = e),
                  (this.modal = document.querySelector(Gd)),
                  (this.modalInner = this.popup.querySelector(Kd)),
                  (this.close = this.modal.querySelector(Qd)),
                  (this.acceptButton = this.modal.querySelector(Jd)),
                  (this.enable =
                    "true" === this.modal.getAttribute("data-enable")),
                  (this.showPopup = !1),
                  window.Shopify.loadFeatures(
                    [{ name: "consent-tracking-api", version: "0.1" }],
                    (e) => {
                      if (e) throw e;
                      const t =
                          window.Shopify.customerPrivacy.userCanBeTracked(),
                        i = window.Shopify.customerPrivacy.getTrackingConsent();
                      (this.showPopup =
                        !t && "no_interaction" === i && this.enable),
                        window.Shopify.designMode && (this.showPopup = !0),
                        this.init();
                    }
                  );
              }
            })(e)
          );
        });
        this.container.querySelectorAll(Yd).forEach((e) => {
          hu[this.id].push(
            new (class {
              init() {
                (!1 !== this.cookie.read() && !window.Shopify.designMode) ||
                  (this.show(), this.checkForSuccess());
              }
              show() {
                window.Shopify.designMode
                  ? Vd(this.popupInner)
                  : (this.delayShow = new uu(this.popup, this.popupInner)),
                  this.inputField(),
                  this.closePopup();
              }
              preventDelayShow() {
                this.delayShow && this.delayShow.hide();
              }
              checkForSuccess() {
                const e = this.form.classList.contains(au),
                  t = this.form.classList.contains(ou);
                (t || e) &&
                  (Vd(this.popupInner),
                  this.preventDelayShow(),
                  t && this.cookie.write());
              }
              closePopup() {
                this.close.addEventListener("click", (e) => {
                  e.preventDefault(),
                    Ud(this.popupInner),
                    this.cookie.write(),
                    this.preventDelayShow();
                });
              }
              inputField() {
                this.newsletterField.addEventListener("input", () => {
                  "" !== this.newsletterField.value &&
                    this.holder.classList.add(
                      nu,
                      "" !== this.newsletterField.value
                    );
                }),
                  this.newsletterField.addEventListener("focus", () => {
                    "" !== this.newsletterField.value &&
                      this.holder.classList.add(
                        nu,
                        "" !== this.newsletterField.value
                      );
                  }),
                  this.newsletterField.addEventListener("focusout", () => {
                    setTimeout(() => {
                      this.holder.classList.remove(nu);
                    }, 2e3);
                  });
              }
              onBlockSelect(e) {
                this.popup.contains(e.target) && Vd(this.popupInner);
              }
              onBlockDeselect(e) {
                this.popup.contains(e.target) && Ud(this.popupInner);
              }
              constructor(e) {
                (this.popup = e),
                  (this.popupInner = this.popup.querySelector(Kd)),
                  (this.holder = this.popup.querySelector(Xd)),
                  (this.close = this.popup.querySelector(Qd)),
                  (this.newsletterField = this.popup.querySelector(Zd)),
                  (this.cookie = new du(
                    this.popup.getAttribute(su),
                    "newsletter_is_closed"
                  )),
                  (this.form = this.popup.querySelector(eu)),
                  (this.isTargeted = new pu(this.popup)),
                  (this.delayShow = null),
                  this.init();
              }
            })(e)
          );
        });
        this.container.querySelectorAll(tu).forEach((e) => {
          hu[this.id].push(
            new (class {
              init() {
                (!1 !== this.cookie.read() && !window.Shopify.designMode) ||
                  (window.Shopify.designMode
                    ? Vd(this.popupInner)
                    : new uu(this.popup, this.popupInner),
                  this.clickEvents());
              }
              clickEvents() {
                this.close.addEventListener("click", (e) => {
                  e.preventDefault(), Ud(this.popupInner), this.cookie.write();
                });
              }
              onBlockSelect(e) {
                this.popup.classList.contains(cu) && (this.hasDeviceClass = cu),
                  this.popup.classList.contains(lu) &&
                    (this.hasDeviceClass = lu),
                  "" !== this.hasDeviceClass &&
                    this.popup.classList.remove(this.hasDeviceClass),
                  this.popup.contains(e.target) && Vd(this.popupInner);
              }
              onBlockDeselect(e) {
                this.popup.contains(e.target) && Ud(this.popupInner),
                  "" !== this.hasDeviceClass &&
                    this.popup.classList.add(this.hasDeviceClass);
              }
              constructor(e) {
                (this.popup = e),
                  (this.popupInner = this.popup.querySelector(Kd)),
                  (this.close = this.popup.querySelector(Qd)),
                  (this.cookie = new du(
                    this.popup.getAttribute(su),
                    "user_has_closed"
                  )),
                  (this.isTargeted = new pu(this.popup)),
                  (this.hasDeviceClass = ""),
                  this.init();
              }
            })(e)
          );
        });
      },
      onBlockSelect(e) {
        hu[this.id].forEach((t) => {
          "function" == typeof t.onBlockSelect && t.onBlockSelect(e);
        });
      },
      onBlockDeselect(e) {
        hu[this.id].forEach((t) => {
          "function" == typeof t.onBlockDeselect && t.onBlockDeselect(e);
        });
      },
    },
  ]);
  const mu = "data-look-dot",
    fu = "data-products-holder",
    gu = "[data-carousel]",
    yu = "[data-button-close-holder]",
    vu = "data-carousel-index",
    bu = "data-block-id",
    wu = "button",
    Su = "is-active",
    Eu = "is-expanded",
    Lu = {};
  Gt("look", [
    {
      onLoad() {
        (Lu[this.id] = []),
          Lu[this.id].push(
            new (class {
              init() {
                (this.keyEvents = (e) =>
                  this.keyboardEventShowProductHolder(e)),
                  (this.keyCloseEvent = (e) => this.hideProductsHolder(e)),
                  (this.clickEventsDot = (e) =>
                    this.clickEventShowProductsHolder(e)),
                  (this.clickEventToClose = (e) =>
                    this.clickEventCloseProductsHolder(e)),
                  (this.toggleOnResize = (e) => T(this.onResize(e), 200)),
                  this.initSlider(),
                  this.addEvents();
              }
              initSlider() {
                this.slider &&
                  ((this.carousel = s.data(this.slider)),
                  (this.carousel.options.wrapAround = !0),
                  (this.carousel.options.freeScroll = !1),
                  this.carousel.resize(),
                  this.carousel.on("change", (e) => {
                    (this.currentDot = this.container.querySelector(
                      `[${mu}="${e}"]`
                    )),
                      this.currentDot.classList.add(Su),
                      this.removeClassOnSiblingDots();
                  }));
              }
              addEvents() {
                this.dots.forEach((e) => {
                  e.addEventListener("click", this.clickEventsDot),
                    e.addEventListener("keyup", this.keyEvents);
                }),
                  document.addEventListener("keyup", this.keyCloseEvent),
                  document.addEventListener(
                    "theme:resize",
                    this.toggleOnResize
                  ),
                  this.buttonClose &&
                    this.buttonClose.addEventListener(
                      "click",
                      this.clickEventToClose
                    );
              }
              showProductsHolder() {
                const e = !this.productsHolder.classList.contains(Eu);
                this.currentDot.classList.toggle(Su),
                  this.productsHolder.classList.toggle(
                    Eu,
                    this.currentDot.classList.contains(Su)
                  ),
                  this.currentDot.classList.contains(Su) &&
                    ((this.hasDefaultOpen = !0),
                    this.carousel.selectCell(
                      Number(this.currentDot.getAttribute(mu)),
                      !0,
                      e
                    )),
                  this.removeClassOnSiblingDots();
              }
              hideProductsHolder(e) {
                "Escape" === e.code &&
                  (this.removeClasses(), ni(), this.currentDot.focus());
              }
              removeClasses() {
                this.productsHolder.classList.remove(Eu),
                  this.currentDot.classList.remove(Su),
                  (this.hasDefaultOpen = !1);
              }
              clickEventShowProductsHolder(e) {
                (this.currentDot = e.currentTarget), this.showProductsHolder();
              }
              clickEventCloseProductsHolder() {
                this.removeClasses();
              }
              keyboardEventShowProductHolder(e) {
                ("Enter" !== e.code && "Space" !== e.code) ||
                  setTimeout(() => {
                    const e = this.productsHolder.querySelector(wu);
                    ri(this.productsHolder, { elementToFocus: e });
                  }, 400);
              }
              onResize() {
                this.currentDot &&
                  (window.innerWidth < window.theme.sizes.medium
                    ? (this.currentDot.classList.remove(Su),
                      this.productsHolder.classList.remove(Eu))
                    : this.hasDefaultOpen &&
                      (this.currentDot.classList.add(Su),
                      this.productsHolder.classList.add(Eu)));
              }
              removeEvents() {
                this.dots.forEach((e) => {
                  e.removeEventListener("click", this.clickEventsDot),
                    e.removeEventListener("keyup", this.keyEvents);
                }),
                  document.removeEventListener("keyup", this.keyCloseEvent),
                  document.removeEventListener(
                    "theme:resize",
                    this.toggleOnResize
                  ),
                  this.buttonClose &&
                    this.buttonClose.removeEventListener(
                      "click",
                      this.clickEventToClose
                    );
              }
              removeClassOnSiblingDots() {
                for (let e of this.currentDot.parentNode.children)
                  e !== this.currentDot && e.classList.remove(Su);
              }
              onUnload() {
                this.slider && this.carousel && this.carousel.destroy(),
                  this.removeEvents();
              }
              onBlockSelect(e) {
                if (this.slider && this.carousel) {
                  const t = this.container.querySelector(
                    `[${bu}="${e.detail.blockId}"]`
                  );
                  this.productsHolder.classList.add(Eu),
                    this.carousel.selectCell(
                      Number(t.getAttribute(vu)),
                      !0,
                      !0
                    );
                }
              }
              onBlockDeselect() {
                window.innerWidth < window.theme.sizes.medium &&
                  (this.productsHolder.classList.remove(Eu),
                  this.currentDot.classList.remove(Su));
              }
              constructor(e) {
                (this.section = e),
                  (this.container = this.section.container),
                  (this.dots = this.container.querySelectorAll(`[${mu}]`)),
                  (this.productsHolder = this.container.querySelector(
                    `[${fu}]`
                  )),
                  (this.slider = this.container.querySelector(gu)),
                  (this.buttonClose = this.container.querySelector(yu)),
                  (this.currentDot = this.container.querySelector(
                    `[${mu}].${Su}`
                  )),
                  (this.hasDefaultOpen = Boolean(this.currentDot)),
                  this.init();
              }
            })(this)
          );
      },
      onUnload() {
        Lu[this.id].forEach((e) => {
          "function" == typeof e.onUnload && e.onUnload();
        });
      },
      onBlockSelect(e) {
        Lu[this.id].forEach((t) => {
          "function" == typeof t.onBlockSelect && t.onBlockSelect(e);
        });
      },
      onBlockDeselect(e) {
        Lu[this.id].forEach((t) => {
          "function" == typeof t.onBlockDeselect && t.onBlockDeselect(e);
        });
      },
    },
  ]);
  const ku = (e, t = "", i) => (
    (i = i || document.createElement("div")).classList.add(t),
    e.parentNode.insertBefore(i, e),
    i.appendChild(e)
  );
  window.theme.settings.animate_scroll && e.init({ once: !0 }),
    document.addEventListener("DOMContentLoaded", function () {
      const e = document.querySelector("[data-header-height]");
      if (e) {
        const t = e.clientHeight || 0;
        document.documentElement.style.setProperty("--menu-height", `${t}px`);
      }
      Jt("*"),
        window.theme.settings.animate_hover &&
          document.body.classList.add("theme-animate-hover");
      document.querySelectorAll(".rte table").forEach((e) => {
        ku(e, "rte__table-wrapper");
      });
      document
        .querySelectorAll(
          '.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"], .rte iframe#admin_bar_iframe'
        )
        .forEach((e) => {
          ku(e, "rte__video-wrapper");
        }),
        document.addEventListener("mousedown", () => {
          document.body.classList.remove("focus-enabled");
        }),
        document.addEventListener("keyup", (e) => {
          "Tab" === e.code && document.body.classList.add("focus-enabled");
        }),
        window.navigator.cookieEnabled &&
          (document.documentElement.className =
            document.documentElement.className.replace(
              "supports-no-cookies",
              "supports-cookies"
            )),
        ei(),
        ti(),
        "scrollBehavior" in document.documentElement.style ||
          xe({ url: window.theme.assets.smoothscroll });
    });
  var Tu = [
      "input",
      "select",
      "textarea",
      "a[href]",
      "button",
      "[tabindex]",
      "audio[controls]",
      "video[controls]",
      '[contenteditable]:not([contenteditable="false"])',
      "details>summary:first-of-type",
      "details",
    ],
    xu = Tu.join(","),
    _u =
      "undefined" == typeof Element
        ? function () {}
        : Element.prototype.matches ||
          Element.prototype.msMatchesSelector ||
          Element.prototype.webkitMatchesSelector,
    Au = function (e, t, i) {
      var s = Array.prototype.slice.apply(e.querySelectorAll(xu));
      return t && _u.call(e, xu) && s.unshift(e), (s = s.filter(i));
    },
    qu = function (e) {
      var t = parseInt(e.getAttribute("tabindex"), 10);
      return isNaN(t)
        ? (function (e) {
            return "true" === e.contentEditable;
          })(e)
          ? 0
          : ("AUDIO" !== e.nodeName &&
              "VIDEO" !== e.nodeName &&
              "DETAILS" !== e.nodeName) ||
            null !== e.getAttribute("tabindex")
          ? e.tabIndex
          : 0
        : t;
    },
    Cu = function (e, t) {
      return e.tabIndex === t.tabIndex
        ? e.documentOrder - t.documentOrder
        : e.tabIndex - t.tabIndex;
    },
    Pu = function (e) {
      return "INPUT" === e.tagName;
    },
    $u = function (e) {
      return (
        (function (e) {
          return Pu(e) && "radio" === e.type;
        })(e) &&
        !(function (e) {
          if (!e.name) return !0;
          var t,
            i = e.form || e.ownerDocument,
            s = function (e) {
              return i.querySelectorAll(
                'input[type="radio"][name="' + e + '"]'
              );
            };
          if (
            "undefined" != typeof window &&
            void 0 !== window.CSS &&
            "function" == typeof window.CSS.escape
          )
            t = s(window.CSS.escape(e.name));
          else
            try {
              t = s(e.name);
            } catch (e) {
              return (
                console.error(
                  "Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s",
                  e.message
                ),
                !1
              );
            }
          var r = (function (e, t) {
            for (var i = 0; i < e.length; i++)
              if (e[i].checked && e[i].form === t) return e[i];
          })(t, e.form);
          return !r || r === e;
        })(e)
      );
    },
    Iu = function (e, t) {
      return !(
        t.disabled ||
        (function (e) {
          return Pu(e) && "hidden" === e.type;
        })(t) ||
        (function (e, t) {
          if ("hidden" === getComputedStyle(e).visibility) return !0;
          var i = _u.call(e, "details>summary:first-of-type")
            ? e.parentElement
            : e;
          if (_u.call(i, "details:not([open]) *")) return !0;
          if (t && "full" !== t) {
            if ("non-zero-area" === t) {
              var s = e.getBoundingClientRect(),
                r = s.width,
                n = s.height;
              return 0 === r && 0 === n;
            }
          } else
            for (; e; ) {
              if ("none" === getComputedStyle(e).display) return !0;
              e = e.parentElement;
            }
          return !1;
        })(t, e.displayCheck) ||
        (function (e) {
          return (
            "DETAILS" === e.tagName &&
            Array.prototype.slice.apply(e.children).some(function (e) {
              return "SUMMARY" === e.tagName;
            })
          );
        })(t) ||
        (function (e) {
          if (
            Pu(e) ||
            "SELECT" === e.tagName ||
            "TEXTAREA" === e.tagName ||
            "BUTTON" === e.tagName
          )
            for (var t = e.parentElement; t; ) {
              if ("FIELDSET" === t.tagName && t.disabled) {
                for (var i = 0; i < t.children.length; i++) {
                  var s = t.children.item(i);
                  if ("LEGEND" === s.tagName) return !s.contains(e);
                }
                return !0;
              }
              t = t.parentElement;
            }
          return !1;
        })(t)
      );
    },
    Mu = function (e, t) {
      return !(!Iu(e, t) || $u(t) || qu(t) < 0);
    },
    Du = function (e, t) {
      var i = [],
        s = [];
      return (
        Au(e, (t = t || {}).includeContainer, Mu.bind(null, t)).forEach(
          function (e, t) {
            var r = qu(e);
            0 === r
              ? i.push(e)
              : s.push({ documentOrder: t, tabIndex: r, node: e });
          }
        ),
        s
          .sort(Cu)
          .map(function (e) {
            return e.node;
          })
          .concat(i)
      );
    },
    Ou = Tu.concat("iframe").join(","),
    Hu = function (e, t) {
      if (((t = t || {}), !e)) throw new Error("No node provided");
      return !1 !== _u.call(e, Ou) && Iu(t, e);
    };
  function Fu(e, t) {
    var i = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var s = Object.getOwnPropertySymbols(e);
      t &&
        (s = s.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })),
        i.push.apply(i, s);
    }
    return i;
  }
  function Bu(e, t, i) {
    return (
      t in e
        ? Object.defineProperty(e, t, {
            value: i,
            enumerable: !0,
            configurable: !0,
            writable: !0,
          })
        : (e[t] = i),
      e
    );
  }
  var Wu,
    Nu =
      ((Wu = []),
      {
        activateTrap: function (e) {
          if (Wu.length > 0) {
            var t = Wu[Wu.length - 1];
            t !== e && t.pause();
          }
          var i = Wu.indexOf(e);
          -1 === i || Wu.splice(i, 1), Wu.push(e);
        },
        deactivateTrap: function (e) {
          var t = Wu.indexOf(e);
          -1 !== t && Wu.splice(t, 1),
            Wu.length > 0 && Wu[Wu.length - 1].unpause();
        },
      }),
    Ru = function (e) {
      return setTimeout(e, 0);
    },
    ju = function (e, t) {
      var i = -1;
      return (
        e.every(function (e, s) {
          return !t(e) || ((i = s), !1);
        }),
        i
      );
    },
    zu = function (e) {
      for (
        var t = arguments.length, i = new Array(t > 1 ? t - 1 : 0), s = 1;
        s < t;
        s++
      )
        i[s - 1] = arguments[s];
      return "function" == typeof e ? e.apply(void 0, i) : e;
    },
    Vu = function (e, t) {
      var i,
        s = document,
        r = (function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var i = null != arguments[t] ? arguments[t] : {};
            t % 2
              ? Fu(Object(i), !0).forEach(function (t) {
                  Bu(e, t, i[t]);
                })
              : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i))
              : Fu(Object(i)).forEach(function (t) {
                  Object.defineProperty(
                    e,
                    t,
                    Object.getOwnPropertyDescriptor(i, t)
                  );
                });
          }
          return e;
        })(
          {
            returnFocusOnDeactivate: !0,
            escapeDeactivates: !0,
            delayInitialFocus: !0,
          },
          t
        ),
        n = {
          containers: [],
          tabbableGroups: [],
          nodeFocusedBeforeActivation: null,
          mostRecentlyFocusedNode: null,
          active: !1,
          paused: !1,
          delayInitialFocusTimer: void 0,
        },
        o = function (e, t, i) {
          return e && void 0 !== e[t] ? e[t] : r[i || t];
        },
        a = function (e) {
          return n.containers.some(function (t) {
            return t.contains(e);
          });
        },
        l = function (e) {
          var t = r[e];
          if (!t) return null;
          var i = t;
          if ("string" == typeof t && !(i = s.querySelector(t)))
            throw new Error("`".concat(e, "` refers to no known node"));
          if ("function" == typeof t && !(i = t()))
            throw new Error("`".concat(e, "` did not return a node"));
          return i;
        },
        c = function () {
          var e;
          if (!1 === o({}, "initialFocus")) return !1;
          if (null !== l("initialFocus")) e = l("initialFocus");
          else if (a(s.activeElement)) e = s.activeElement;
          else {
            var t = n.tabbableGroups[0];
            e = (t && t.firstTabbableNode) || l("fallbackFocus");
          }
          if (!e)
            throw new Error(
              "Your focus-trap needs to have at least one focusable element"
            );
          return e;
        },
        h = function () {
          if (
            ((n.tabbableGroups = n.containers
              .map(function (e) {
                var t = Du(e);
                if (t.length > 0)
                  return {
                    container: e,
                    firstTabbableNode: t[0],
                    lastTabbableNode: t[t.length - 1],
                  };
              })
              .filter(function (e) {
                return !!e;
              })),
            n.tabbableGroups.length <= 0 && !l("fallbackFocus"))
          )
            throw new Error(
              "Your focus-trap must have at least one container with at least one tabbable node in it at all times"
            );
        },
        d = function e(t) {
          !1 !== t &&
            t !== s.activeElement &&
            (t && t.focus
              ? (t.focus({ preventScroll: !!r.preventScroll }),
                (n.mostRecentlyFocusedNode = t),
                (function (e) {
                  return (
                    e.tagName &&
                    "input" === e.tagName.toLowerCase() &&
                    "function" == typeof e.select
                  );
                })(t) && t.select())
              : e(c()));
        },
        u = function (e) {
          var t = l("setReturnFocus");
          return t || e;
        },
        p = function (e) {
          a(e.target) ||
            (zu(r.clickOutsideDeactivates, e)
              ? i.deactivate({
                  returnFocus: r.returnFocusOnDeactivate && !Hu(e.target),
                })
              : zu(r.allowOutsideClick, e) || e.preventDefault());
        },
        m = function (e) {
          var t = a(e.target);
          t || e.target instanceof Document
            ? t && (n.mostRecentlyFocusedNode = e.target)
            : (e.stopImmediatePropagation(),
              d(n.mostRecentlyFocusedNode || c()));
        },
        f = function (e) {
          if (
            (function (e) {
              return "Escape" === e.key || "Esc" === e.key || 27 === e.keyCode;
            })(e) &&
            !1 !== zu(r.escapeDeactivates)
          )
            return e.preventDefault(), void i.deactivate();
          (function (e) {
            return "Tab" === e.key || 9 === e.keyCode;
          })(e) &&
            (function (e) {
              h();
              var t = null;
              if (n.tabbableGroups.length > 0) {
                var i = ju(n.tabbableGroups, function (t) {
                  return t.container.contains(e.target);
                });
                if (i < 0)
                  t = e.shiftKey
                    ? n.tabbableGroups[n.tabbableGroups.length - 1]
                        .lastTabbableNode
                    : n.tabbableGroups[0].firstTabbableNode;
                else if (e.shiftKey) {
                  var s = ju(n.tabbableGroups, function (t) {
                    var i = t.firstTabbableNode;
                    return e.target === i;
                  });
                  if (
                    (s < 0 &&
                      n.tabbableGroups[i].container === e.target &&
                      (s = i),
                    s >= 0)
                  ) {
                    var r = 0 === s ? n.tabbableGroups.length - 1 : s - 1;
                    t = n.tabbableGroups[r].lastTabbableNode;
                  }
                } else {
                  var o = ju(n.tabbableGroups, function (t) {
                    var i = t.lastTabbableNode;
                    return e.target === i;
                  });
                  if (
                    (o < 0 &&
                      n.tabbableGroups[i].container === e.target &&
                      (o = i),
                    o >= 0)
                  ) {
                    var a = o === n.tabbableGroups.length - 1 ? 0 : o + 1;
                    t = n.tabbableGroups[a].firstTabbableNode;
                  }
                }
              } else t = l("fallbackFocus");
              t && (e.preventDefault(), d(t));
            })(e);
        },
        g = function (e) {
          zu(r.clickOutsideDeactivates, e) ||
            a(e.target) ||
            zu(r.allowOutsideClick, e) ||
            (e.preventDefault(), e.stopImmediatePropagation());
        },
        y = function () {
          if (n.active)
            return (
              Nu.activateTrap(i),
              (n.delayInitialFocusTimer = r.delayInitialFocus
                ? Ru(function () {
                    d(c());
                  })
                : d(c())),
              s.addEventListener("focusin", m, !0),
              s.addEventListener("mousedown", p, { capture: !0, passive: !1 }),
              s.addEventListener("touchstart", p, { capture: !0, passive: !1 }),
              s.addEventListener("click", g, { capture: !0, passive: !1 }),
              s.addEventListener("keydown", f, { capture: !0, passive: !1 }),
              i
            );
        },
        v = function () {
          if (n.active)
            return (
              s.removeEventListener("focusin", m, !0),
              s.removeEventListener("mousedown", p, !0),
              s.removeEventListener("touchstart", p, !0),
              s.removeEventListener("click", g, !0),
              s.removeEventListener("keydown", f, !0),
              i
            );
        };
      return (
        (i = {
          activate: function (e) {
            if (n.active) return this;
            var t = o(e, "onActivate"),
              i = o(e, "onPostActivate"),
              r = o(e, "checkCanFocusTrap");
            r || h(),
              (n.active = !0),
              (n.paused = !1),
              (n.nodeFocusedBeforeActivation = s.activeElement),
              t && t();
            var a = function () {
              r && h(), y(), i && i();
            };
            return r
              ? (r(n.containers.concat()).then(a, a), this)
              : (a(), this);
          },
          deactivate: function (e) {
            if (!n.active) return this;
            clearTimeout(n.delayInitialFocusTimer),
              (n.delayInitialFocusTimer = void 0),
              v(),
              (n.active = !1),
              (n.paused = !1),
              Nu.deactivateTrap(i);
            var t = o(e, "onDeactivate"),
              s = o(e, "onPostDeactivate"),
              r = o(e, "checkCanReturnFocus");
            t && t();
            var a = o(e, "returnFocus", "returnFocusOnDeactivate"),
              l = function () {
                Ru(function () {
                  a && d(u(n.nodeFocusedBeforeActivation)), s && s();
                });
              };
            return a && r
              ? (r(u(n.nodeFocusedBeforeActivation)).then(l, l), this)
              : (l(), this);
          },
          pause: function () {
            return n.paused || !n.active || ((n.paused = !0), v()), this;
          },
          unpause: function () {
            return n.paused && n.active
              ? ((n.paused = !1), h(), y(), this)
              : this;
          },
          updateContainerElements: function (e) {
            var t = [].concat(e).filter(Boolean);
            return (
              (n.containers = t.map(function (e) {
                return "string" == typeof e ? s.querySelector(e) : e;
              })),
              n.active && h(),
              this
            );
          },
        }).updateContainerElements(e),
        i
      );
    };
  function Uu(e) {
    let t = [];
    return (
      Gu(e, (e) => {
        let i = e.hasAttribute("aria-hidden");
        e.setAttribute("aria-hidden", "true"),
          t.push(() => i || e.removeAttribute("aria-hidden"));
      }),
      () => {
        for (; t.length; ) t.pop()();
      }
    );
  }
  function Gu(e, t) {
    !e.isSameNode(document.body) &&
      e.parentNode &&
      Array.from(e.parentNode.children).forEach((i) => {
        i.isSameNode(e) ? Gu(e.parentNode, t) : t(i);
      });
  }
  var Ju,
    Qu,
    Ku,
    Yu,
    Xu = function (e) {
      let t, i;
      window.addEventListener("focusin", () => {
        (t = i), (i = document.activeElement);
      }),
        e.magic("focus", (e) => {
          let s = e;
          return {
            __noscroll: !1,
            __wrapAround: !1,
            within(e) {
              return (s = e), this;
            },
            withoutScrolling() {
              return (this.__noscroll = !0), this;
            },
            noscroll() {
              return (this.__noscroll = !0), this;
            },
            withWrapAround() {
              return (this.__wrapAround = !0), this;
            },
            wrap() {
              return this.withWrapAround();
            },
            focusable: (e) => Hu(e),
            previouslyFocused: () => t,
            lastFocused: () => t,
            focused: () => i,
            focusables: () =>
              Array.isArray(s)
                ? s
                : (function (e, t) {
                    return Au(
                      e,
                      (t = t || {}).includeContainer,
                      Iu.bind(null, t)
                    );
                  })(s, { displayCheck: "none" }),
            all() {
              return this.focusables();
            },
            isFirst(e) {
              let t = this.all();
              return t[0] && t[0].isSameNode(e);
            },
            isLast(e) {
              let t = this.all();
              return t.length && t.slice(-1)[0].isSameNode(e);
            },
            getFirst() {
              return this.all()[0];
            },
            getLast() {
              return this.all().slice(-1)[0];
            },
            getNext() {
              let e = this.all(),
                t = document.activeElement;
              if (-1 !== e.indexOf(t))
                return this.__wrapAround && e.indexOf(t) === e.length - 1
                  ? e[0]
                  : e[e.indexOf(t) + 1];
            },
            getPrevious() {
              let e = this.all(),
                t = document.activeElement;
              if (-1 !== e.indexOf(t))
                return this.__wrapAround && 0 === e.indexOf(t)
                  ? e.slice(-1)[0]
                  : e[e.indexOf(t) - 1];
            },
            first() {
              this.focus(this.getFirst());
            },
            last() {
              this.focus(this.getLast());
            },
            next() {
              this.focus(this.getNext());
            },
            previous() {
              this.focus(this.getPrevious());
            },
            prev() {
              return this.previous();
            },
            focus(e) {
              e &&
                setTimeout(() => {
                  e.hasAttribute("tabindex") || e.setAttribute("tabindex", "0"),
                    e.focus({ preventScroll: this._noscroll });
                });
            },
          };
        }),
        e.directive(
          "trap",
          e.skipDuringClone(
            (
              e,
              { expression: t, modifiers: i },
              { effect: s, evaluateLater: r, cleanup: n }
            ) => {
              let o = r(t),
                a = !1,
                l = Vu(e, {
                  escapeDeactivates: !1,
                  allowOutsideClick: !0,
                  fallbackFocus: () => e,
                  initialFocus: e.querySelector("[autofocus]"),
                }),
                c = () => {},
                h = () => {};
              const d = () => {
                c(),
                  (c = () => {}),
                  h(),
                  (h = () => {}),
                  l.deactivate({ returnFocus: !i.includes("noreturn") });
              };
              s(() =>
                o((t) => {
                  a !== t &&
                    (t &&
                      !a &&
                      setTimeout(() => {
                        i.includes("inert") && (c = Uu(e)),
                          i.includes("noscroll") &&
                            (h = (function () {
                              let e = document.documentElement.style.overflow,
                                t = document.documentElement.style.paddingRight,
                                i =
                                  window.innerWidth -
                                  document.documentElement.clientWidth;
                              return (
                                (document.documentElement.style.overflow =
                                  "hidden"),
                                (document.documentElement.style.paddingRight = `${i}px`),
                                () => {
                                  (document.documentElement.style.overflow = e),
                                    (document.documentElement.style.paddingRight =
                                      t);
                                }
                              );
                            })()),
                          l.activate();
                      }),
                    !t && a && d(),
                    (a = !!t));
                })
              ),
                n(d);
            },
            (e, { expression: t, modifiers: i }, { evaluate: s }) => {
              i.includes("inert") && s(t) && Uu(e);
            }
          )
        );
    },
    Zu = !1,
    ep = !1,
    tp = [],
    ip = -1;
  function sp(e) {
    !(function (e) {
      tp.includes(e) || tp.push(e);
      ep || Zu || ((Zu = !0), queueMicrotask(np));
    })(e);
  }
  function rp(e) {
    let t = tp.indexOf(e);
    -1 !== t && t > ip && tp.splice(t, 1);
  }
  function np() {
    (Zu = !1), (ep = !0);
    for (let e = 0; e < tp.length; e++) tp[e](), (ip = e);
    (tp.length = 0), (ip = -1), (ep = !1);
  }
  var op = !0;
  function ap(e) {
    Qu = e;
  }
  var lp = [],
    cp = [],
    hp = [];
  function dp(e, t) {
    "function" == typeof t
      ? (e._x_cleanups || (e._x_cleanups = []), e._x_cleanups.push(t))
      : ((t = e), cp.push(t));
  }
  function up(e, t) {
    e._x_attributeCleanups &&
      Object.entries(e._x_attributeCleanups).forEach(([i, s]) => {
        (void 0 === t || t.includes(i)) &&
          (s.forEach((e) => e()), delete e._x_attributeCleanups[i]);
      });
  }
  var pp = new MutationObserver(Ep),
    mp = !1;
  function fp() {
    pp.observe(document, {
      subtree: !0,
      childList: !0,
      attributes: !0,
      attributeOldValue: !0,
    }),
      (mp = !0);
  }
  function gp() {
    (yp = yp.concat(pp.takeRecords())).length &&
      !vp &&
      ((vp = !0),
      queueMicrotask(() => {
        Ep(yp), (yp.length = 0), (vp = !1);
      })),
      pp.disconnect(),
      (mp = !1);
  }
  var yp = [],
    vp = !1;
  function bp(e) {
    if (!mp) return e();
    gp();
    let t = e();
    return fp(), t;
  }
  var wp = !1,
    Sp = [];
  function Ep(e) {
    if (wp) return void (Sp = Sp.concat(e));
    let t = [],
      i = [],
      s = new Map(),
      r = new Map();
    for (let n = 0; n < e.length; n++)
      if (
        !e[n].target._x_ignoreMutationObserver &&
        ("childList" === e[n].type &&
          (e[n].addedNodes.forEach((e) => 1 === e.nodeType && t.push(e)),
          e[n].removedNodes.forEach((e) => 1 === e.nodeType && i.push(e))),
        "attributes" === e[n].type)
      ) {
        let t = e[n].target,
          i = e[n].attributeName,
          o = e[n].oldValue,
          a = () => {
            s.has(t) || s.set(t, []),
              s.get(t).push({ name: i, value: t.getAttribute(i) });
          },
          l = () => {
            r.has(t) || r.set(t, []), r.get(t).push(i);
          };
        t.hasAttribute(i) && null === o
          ? a()
          : t.hasAttribute(i)
          ? (l(), a())
          : l();
      }
    r.forEach((e, t) => {
      up(t, e);
    }),
      s.forEach((e, t) => {
        lp.forEach((i) => i(t, e));
      });
    for (let e of i)
      if (!t.includes(e) && (cp.forEach((t) => t(e)), e._x_cleanups))
        for (; e._x_cleanups.length; ) e._x_cleanups.pop()();
    t.forEach((e) => {
      (e._x_ignoreSelf = !0), (e._x_ignore = !0);
    });
    for (let e of t)
      i.includes(e) ||
        (e.isConnected &&
          (delete e._x_ignoreSelf,
          delete e._x_ignore,
          hp.forEach((t) => t(e)),
          (e._x_ignore = !0),
          (e._x_ignoreSelf = !0)));
    t.forEach((e) => {
      delete e._x_ignoreSelf, delete e._x_ignore;
    }),
      (t = null),
      (i = null),
      (s = null),
      (r = null);
  }
  function Lp(e) {
    return xp(Tp(e));
  }
  function kp(e, t, i) {
    return (
      (e._x_dataStack = [t, ...Tp(i || e)]),
      () => {
        e._x_dataStack = e._x_dataStack.filter((e) => e !== t);
      }
    );
  }
  function Tp(e) {
    return e._x_dataStack
      ? e._x_dataStack
      : "function" == typeof ShadowRoot && e instanceof ShadowRoot
      ? Tp(e.host)
      : e.parentNode
      ? Tp(e.parentNode)
      : [];
  }
  function xp(e) {
    let t = new Proxy(
      {},
      {
        ownKeys: () => Array.from(new Set(e.flatMap((e) => Object.keys(e)))),
        has: (t, i) => e.some((e) => e.hasOwnProperty(i)),
        get: (i, s) =>
          (e.find((e) => {
            if (e.hasOwnProperty(s)) {
              let i = Object.getOwnPropertyDescriptor(e, s);
              if (
                (i.get && i.get._x_alreadyBound) ||
                (i.set && i.set._x_alreadyBound)
              )
                return !0;
              if ((i.get || i.set) && i.enumerable) {
                let r = i.get,
                  n = i.set,
                  o = i;
                (r = r && r.bind(t)),
                  (n = n && n.bind(t)),
                  r && (r._x_alreadyBound = !0),
                  n && (n._x_alreadyBound = !0),
                  Object.defineProperty(e, s, { ...o, get: r, set: n });
              }
              return !0;
            }
            return !1;
          }) || {})[s],
        set: (t, i, s) => {
          let r = e.find((e) => e.hasOwnProperty(i));
          return r ? (r[i] = s) : (e[e.length - 1][i] = s), !0;
        },
      }
    );
    return t;
  }
  function _p(e) {
    let t = (i, s = "") => {
      Object.entries(Object.getOwnPropertyDescriptors(i)).forEach(
        ([r, { value: n, enumerable: o }]) => {
          if (!1 === o || void 0 === n) return;
          let a = "" === s ? r : `${s}.${r}`;
          var l;
          "object" == typeof n && null !== n && n._x_interceptor
            ? (i[r] = n.initialize(e, a, r))
            : "object" != typeof (l = n) ||
              Array.isArray(l) ||
              null === l ||
              n === i ||
              n instanceof Element ||
              t(n, a);
        }
      );
    };
    return t(e);
  }
  function Ap(e, t = () => {}) {
    let i = {
      initialValue: void 0,
      _x_interceptor: !0,
      initialize(t, i, s) {
        return e(
          this.initialValue,
          () =>
            (function (e, t) {
              return t.split(".").reduce((e, t) => e[t], e);
            })(t, i),
          (e) => qp(t, i, e),
          i,
          s
        );
      },
    };
    return (
      t(i),
      (e) => {
        if ("object" == typeof e && null !== e && e._x_interceptor) {
          let t = i.initialize.bind(i);
          i.initialize = (s, r, n) => {
            let o = e.initialize(s, r, n);
            return (i.initialValue = o), t(s, r, n);
          };
        } else i.initialValue = e;
        return i;
      }
    );
  }
  function qp(e, t, i) {
    if (("string" == typeof t && (t = t.split(".")), 1 !== t.length)) {
      if (0 === t.length) throw error;
      return e[t[0]] || (e[t[0]] = {}), qp(e[t[0]], t.slice(1), i);
    }
    e[t[0]] = i;
  }
  var Cp = {};
  function Pp(e, t) {
    Cp[e] = t;
  }
  function $p(e, t) {
    return (
      Object.entries(Cp).forEach(([i, s]) => {
        let r = null;
        Object.defineProperty(e, `$${i}`, {
          get: () =>
            s(
              t,
              (function () {
                if (r) return r;
                {
                  let [e, i] = Xp(t);
                  return (r = { interceptor: Ap, ...e }), dp(t, i), r;
                }
              })()
            ),
          enumerable: !1,
        });
      }),
      e
    );
  }
  function Ip(e, t, i, ...s) {
    try {
      return i(...s);
    } catch (i) {
      Mp(i, e, t);
    }
  }
  function Mp(e, t, i) {
    Object.assign(e, { el: t, expression: i }),
      console.warn(
        `Alpine Expression Error: ${e.message}\n\n${
          i ? 'Expression: "' + i + '"\n\n' : ""
        }`,
        t
      ),
      setTimeout(() => {
        throw e;
      }, 0);
  }
  var Dp = !0;
  function Op(e) {
    let t = Dp;
    Dp = !1;
    let i = e();
    return (Dp = t), i;
  }
  function Hp(e, t, i = {}) {
    let s;
    return Fp(e, t)((e) => (s = e), i), s;
  }
  function Fp(...e) {
    return Bp(...e);
  }
  var Bp = Wp;
  function Wp(e, t) {
    let i = {};
    $p(i, e);
    let s = [i, ...Tp(e)],
      r =
        "function" == typeof t
          ? (function (e, t) {
              return (i = () => {}, { scope: s = {}, params: r = [] } = {}) => {
                Rp(i, t.apply(xp([s, ...e]), r));
              };
            })(s, t)
          : (function (e, t, i) {
              let s = (function (e, t) {
                if (Np[e]) return Np[e];
                let i = Object.getPrototypeOf(async function () {}).constructor,
                  s =
                    /^[\n\s]*if.*\(.*\)/.test(e) || /^(let|const)\s/.test(e)
                      ? `(async()=>{ ${e} })()`
                      : e;
                let r = (() => {
                  try {
                    return new i(
                      ["__self", "scope"],
                      `with (scope) { __self.result = ${s} }; __self.finished = true; return __self.result;`
                    );
                  } catch (i) {
                    return Mp(i, t, e), Promise.resolve();
                  }
                })();
                return (Np[e] = r), r;
              })(t, i);
              return (r = () => {}, { scope: n = {}, params: o = [] } = {}) => {
                (s.result = void 0), (s.finished = !1);
                let a = xp([n, ...e]);
                if ("function" == typeof s) {
                  let e = s(s, a).catch((e) => Mp(e, i, t));
                  s.finished
                    ? (Rp(r, s.result, a, o, i), (s.result = void 0))
                    : e
                        .then((e) => {
                          Rp(r, e, a, o, i);
                        })
                        .catch((e) => Mp(e, i, t))
                        .finally(() => (s.result = void 0));
                }
              };
            })(s, t, e);
    return Ip.bind(null, e, t, r);
  }
  var Np = {};
  function Rp(e, t, i, s, r) {
    if (Dp && "function" == typeof t) {
      let n = t.apply(i, s);
      n instanceof Promise
        ? n.then((t) => Rp(e, t, i, s)).catch((e) => Mp(e, r, t))
        : e(n);
    } else
      "object" == typeof t && t instanceof Promise ? t.then((t) => e(t)) : e(t);
  }
  var jp = "x-";
  function zp(e = "") {
    return jp + e;
  }
  var Vp = {};
  function Up(e, t) {
    return (
      (Vp[e] = t),
      {
        before(t) {
          if (!Vp[t])
            return void console.warn(
              "Cannot find directive `${directive}`. `${name}` will use the default order of execution"
            );
          const i = om.indexOf(t);
          om.splice(i >= 0 ? i : om.indexOf("DEFAULT"), 0, e);
        },
      }
    );
  }
  function Gp(e, t, i) {
    if (((t = Array.from(t)), e._x_virtualDirectives)) {
      let i = Object.entries(e._x_virtualDirectives).map(([e, t]) => ({
          name: e,
          value: t,
        })),
        s = Jp(i);
      (i = i.map((e) =>
        s.find((t) => t.name === e.name)
          ? { name: `x-bind:${e.name}`, value: `"${e.value}"` }
          : e
      )),
        (t = t.concat(i));
    }
    let s = {},
      r = t
        .map(em((e, t) => (s[e] = t)))
        .filter(sm)
        .map(
          (function (e, t) {
            return ({ name: i, value: s }) => {
              let r = i.match(rm()),
                n = i.match(/:([a-zA-Z0-9\-:]+)/),
                o = i.match(/\.[^.\]]+(?=[^\]]*$)/g) || [],
                a = t || e[i] || i;
              return {
                type: r ? r[1] : null,
                value: n ? n[1] : null,
                modifiers: o.map((e) => e.replace(".", "")),
                expression: s,
                original: a,
              };
            };
          })(s, i)
        )
        .sort(am);
    return r.map((t) =>
      (function (e, t) {
        let i = () => {},
          s = Vp[t.type] || i,
          [r, n] = Xp(e);
        !(function (e, t, i) {
          e._x_attributeCleanups || (e._x_attributeCleanups = {}),
            e._x_attributeCleanups[t] || (e._x_attributeCleanups[t] = []),
            e._x_attributeCleanups[t].push(i);
        })(e, t.original, n);
        let o = () => {
          e._x_ignore ||
            e._x_ignoreSelf ||
            (s.inline && s.inline(e, t, r),
            (s = s.bind(s, e, t, r)),
            Qp ? Kp.get(Yp).push(s) : s());
        };
        return (o.runCleanups = n), o;
      })(e, t)
    );
  }
  function Jp(e) {
    return Array.from(e)
      .map(em())
      .filter((e) => !sm(e));
  }
  var Qp = !1,
    Kp = new Map(),
    Yp = Symbol();
  function Xp(e) {
    let t = [],
      [i, s] = (function (e) {
        let t = () => {};
        return [
          (i) => {
            let s = Qu(i);
            return (
              e._x_effects ||
                ((e._x_effects = new Set()),
                (e._x_runEffects = () => {
                  e._x_effects.forEach((e) => e());
                })),
              e._x_effects.add(s),
              (t = () => {
                void 0 !== s && (e._x_effects.delete(s), Ku(s));
              }),
              s
            );
          },
          () => {
            t();
          },
        ];
      })(e);
    t.push(s);
    return [
      {
        Alpine: Qm,
        effect: i,
        cleanup: (e) => t.push(e),
        evaluateLater: Fp.bind(Fp, e),
        evaluate: Hp.bind(Hp, e),
      },
      () => t.forEach((e) => e()),
    ];
  }
  var Zp =
    (e, t) =>
    ({ name: i, value: s }) => (
      i.startsWith(e) && (i = i.replace(e, t)), { name: i, value: s }
    );
  function em(e = () => {}) {
    return ({ name: t, value: i }) => {
      let { name: s, value: r } = tm.reduce((e, t) => t(e), {
        name: t,
        value: i,
      });
      return s !== t && e(s, t), { name: s, value: r };
    };
  }
  var tm = [];
  function im(e) {
    tm.push(e);
  }
  function sm({ name: e }) {
    return rm().test(e);
  }
  var rm = () => new RegExp(`^${jp}([^:^.]+)\\b`);
  var nm = "DEFAULT",
    om = [
      "ignore",
      "ref",
      "data",
      "id",
      "bind",
      "init",
      "for",
      "model",
      "modelable",
      "transition",
      "show",
      "if",
      nm,
      "teleport",
    ];
  function am(e, t) {
    let i = -1 === om.indexOf(e.type) ? nm : e.type,
      s = -1 === om.indexOf(t.type) ? nm : t.type;
    return om.indexOf(i) - om.indexOf(s);
  }
  function lm(e, t, i = {}) {
    e.dispatchEvent(
      new CustomEvent(t, {
        detail: i,
        bubbles: !0,
        composed: !0,
        cancelable: !0,
      })
    );
  }
  function cm(e, t) {
    if ("function" == typeof ShadowRoot && e instanceof ShadowRoot)
      return void Array.from(e.children).forEach((e) => cm(e, t));
    let i = !1;
    if ((t(e, () => (i = !0)), i)) return;
    let s = e.firstElementChild;
    for (; s; ) cm(s, t), (s = s.nextElementSibling);
  }
  function hm(e, ...t) {
    console.warn(`Alpine Warning: ${e}`, ...t);
  }
  var dm = !1;
  var um = [],
    pm = [];
  function mm() {
    return um.map((e) => e());
  }
  function fm() {
    return um.concat(pm).map((e) => e());
  }
  function gm(e) {
    um.push(e);
  }
  function ym(e) {
    pm.push(e);
  }
  function vm(e, t = !1) {
    return bm(e, (e) => {
      if ((t ? fm() : mm()).some((t) => e.matches(t))) return !0;
    });
  }
  function bm(e, t) {
    if (e) {
      if (t(e)) return e;
      if ((e._x_teleportBack && (e = e._x_teleportBack), e.parentElement))
        return bm(e.parentElement, t);
    }
  }
  var wm = [];
  function Sm(e, t = cm, i = () => {}) {
    !(function (e) {
      Qp = !0;
      let t = Symbol();
      (Yp = t), Kp.set(t, []);
      let i = () => {
        for (; Kp.get(t).length; ) Kp.get(t).shift()();
        Kp.delete(t);
      };
      e(i), (Qp = !1), i();
    })(() => {
      t(e, (e, t) => {
        i(e, t),
          wm.forEach((i) => i(e, t)),
          Gp(e, e.attributes).forEach((e) => e()),
          e._x_ignore && t();
      });
    });
  }
  function Em(e) {
    cm(e, (e) => up(e));
  }
  var Lm = [],
    km = !1;
  function Tm(e = () => {}) {
    return (
      queueMicrotask(() => {
        km ||
          setTimeout(() => {
            xm();
          });
      }),
      new Promise((t) => {
        Lm.push(() => {
          e(), t();
        });
      })
    );
  }
  function xm() {
    for (km = !1; Lm.length; ) Lm.shift()();
  }
  function _m(e, t) {
    return Array.isArray(t)
      ? Am(e, t.join(" "))
      : "object" == typeof t && null !== t
      ? (function (e, t) {
          let i = (e) => e.split(" ").filter(Boolean),
            s = Object.entries(t)
              .flatMap(([e, t]) => !!t && i(e))
              .filter(Boolean),
            r = Object.entries(t)
              .flatMap(([e, t]) => !t && i(e))
              .filter(Boolean),
            n = [],
            o = [];
          return (
            r.forEach((t) => {
              e.classList.contains(t) && (e.classList.remove(t), o.push(t));
            }),
            s.forEach((t) => {
              e.classList.contains(t) || (e.classList.add(t), n.push(t));
            }),
            () => {
              o.forEach((t) => e.classList.add(t)),
                n.forEach((t) => e.classList.remove(t));
            }
          );
        })(e, t)
      : "function" == typeof t
      ? _m(e, t())
      : Am(e, t);
  }
  function Am(e, t) {
    return (
      (t = !0 === t ? (t = "") : t || ""),
      ((t) => (
        e.classList.add(...t),
        () => {
          e.classList.remove(...t);
        }
      ))(
        t
          .split(" ")
          .filter((t) => !e.classList.contains(t))
          .filter(Boolean)
      )
    );
  }
  function qm(e, t) {
    return "object" == typeof t && null !== t
      ? (function (e, t) {
          let i = {};
          return (
            Object.entries(t).forEach(([t, s]) => {
              (i[t] = e.style[t]),
                t.startsWith("--") ||
                  (t = t.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()),
                e.style.setProperty(t, s);
            }),
            setTimeout(() => {
              0 === e.style.length && e.removeAttribute("style");
            }),
            () => {
              qm(e, i);
            }
          );
        })(e, t)
      : (function (e, t) {
          let i = e.getAttribute("style", t);
          return (
            e.setAttribute("style", t),
            () => {
              e.setAttribute("style", i || "");
            }
          );
        })(e, t);
  }
  function Cm(e, t = () => {}) {
    let i = !1;
    return function () {
      i ? t.apply(this, arguments) : ((i = !0), e.apply(this, arguments));
    };
  }
  function Pm(e, t, i = {}) {
    e._x_transition ||
      (e._x_transition = {
        enter: { during: i, start: i, end: i },
        leave: { during: i, start: i, end: i },
        in(i = () => {}, s = () => {}) {
          Im(
            e,
            t,
            {
              during: this.enter.during,
              start: this.enter.start,
              end: this.enter.end,
            },
            i,
            s
          );
        },
        out(i = () => {}, s = () => {}) {
          Im(
            e,
            t,
            {
              during: this.leave.during,
              start: this.leave.start,
              end: this.leave.end,
            },
            i,
            s
          );
        },
      });
  }
  function $m(e) {
    let t = e.parentNode;
    if (t) return t._x_hidePromise ? t : $m(t);
  }
  function Im(
    e,
    t,
    { during: i, start: s, end: r } = {},
    n = () => {},
    o = () => {}
  ) {
    if (
      (e._x_transitioning && e._x_transitioning.cancel(),
      0 === Object.keys(i).length &&
        0 === Object.keys(s).length &&
        0 === Object.keys(r).length)
    )
      return n(), void o();
    let a, l, c;
    !(function (e, t) {
      let i,
        s,
        r,
        n = Cm(() => {
          bp(() => {
            (i = !0),
              s || t.before(),
              r || (t.end(), xm()),
              t.after(),
              e.isConnected && t.cleanup(),
              delete e._x_transitioning;
          });
        });
      (e._x_transitioning = {
        beforeCancels: [],
        beforeCancel(e) {
          this.beforeCancels.push(e);
        },
        cancel: Cm(function () {
          for (; this.beforeCancels.length; ) this.beforeCancels.shift()();
          n();
        }),
        finish: n,
      }),
        bp(() => {
          t.start(), t.during();
        }),
        (km = !0),
        requestAnimationFrame(() => {
          if (i) return;
          let n =
              1e3 *
              Number(
                getComputedStyle(e)
                  .transitionDuration.replace(/,.*/, "")
                  .replace("s", "")
              ),
            o =
              1e3 *
              Number(
                getComputedStyle(e)
                  .transitionDelay.replace(/,.*/, "")
                  .replace("s", "")
              );
          0 === n &&
            (n =
              1e3 *
              Number(getComputedStyle(e).animationDuration.replace("s", ""))),
            bp(() => {
              t.before();
            }),
            (s = !0),
            requestAnimationFrame(() => {
              i ||
                (bp(() => {
                  t.end();
                }),
                xm(),
                setTimeout(e._x_transitioning.finish, n + o),
                (r = !0));
            });
        });
    })(e, {
      start() {
        a = t(e, s);
      },
      during() {
        l = t(e, i);
      },
      before: n,
      end() {
        a(), (c = t(e, r));
      },
      after: o,
      cleanup() {
        l(), c();
      },
    });
  }
  function Mm(e, t, i) {
    if (-1 === e.indexOf(t)) return i;
    const s = e[e.indexOf(t) + 1];
    if (!s) return i;
    if ("scale" === t && isNaN(s)) return i;
    if ("duration" === t || "delay" === t) {
      let e = s.match(/([0-9]+)ms/);
      if (e) return e[1];
    }
    return "origin" === t &&
      ["top", "right", "left", "center", "bottom"].includes(e[e.indexOf(t) + 2])
      ? [s, e[e.indexOf(t) + 2]].join(" ")
      : s;
  }
  Up(
    "transition",
    (e, { value: t, modifiers: i, expression: s }, { evaluate: r }) => {
      "function" == typeof s && (s = r(s)),
        !1 !== s &&
          (s && "boolean" != typeof s
            ? (function (e, t, i) {
                Pm(e, _m, "");
                let s = {
                  enter: (t) => {
                    e._x_transition.enter.during = t;
                  },
                  "enter-start": (t) => {
                    e._x_transition.enter.start = t;
                  },
                  "enter-end": (t) => {
                    e._x_transition.enter.end = t;
                  },
                  leave: (t) => {
                    e._x_transition.leave.during = t;
                  },
                  "leave-start": (t) => {
                    e._x_transition.leave.start = t;
                  },
                  "leave-end": (t) => {
                    e._x_transition.leave.end = t;
                  },
                };
                s[i](t);
              })(e, s, t)
            : (function (e, t, i) {
                Pm(e, qm);
                let s = !t.includes("in") && !t.includes("out") && !i,
                  r = s || t.includes("in") || ["enter"].includes(i),
                  n = s || t.includes("out") || ["leave"].includes(i);
                t.includes("in") &&
                  !s &&
                  (t = t.filter((e, i) => i < t.indexOf("out")));
                t.includes("out") &&
                  !s &&
                  (t = t.filter((e, i) => i > t.indexOf("out")));
                let o = !t.includes("opacity") && !t.includes("scale"),
                  a = o || t.includes("opacity"),
                  l = o || t.includes("scale"),
                  c = a ? 0 : 1,
                  h = l ? Mm(t, "scale", 95) / 100 : 1,
                  d = Mm(t, "delay", 0) / 1e3,
                  u = Mm(t, "origin", "center"),
                  p = "opacity, transform",
                  m = Mm(t, "duration", 150) / 1e3,
                  f = Mm(t, "duration", 75) / 1e3,
                  g = "cubic-bezier(0.4, 0.0, 0.2, 1)";
                r &&
                  ((e._x_transition.enter.during = {
                    transformOrigin: u,
                    transitionDelay: `${d}s`,
                    transitionProperty: p,
                    transitionDuration: `${m}s`,
                    transitionTimingFunction: g,
                  }),
                  (e._x_transition.enter.start = {
                    opacity: c,
                    transform: `scale(${h})`,
                  }),
                  (e._x_transition.enter.end = {
                    opacity: 1,
                    transform: "scale(1)",
                  }));
                n &&
                  ((e._x_transition.leave.during = {
                    transformOrigin: u,
                    transitionDelay: `${d}s`,
                    transitionProperty: p,
                    transitionDuration: `${f}s`,
                    transitionTimingFunction: g,
                  }),
                  (e._x_transition.leave.start = {
                    opacity: 1,
                    transform: "scale(1)",
                  }),
                  (e._x_transition.leave.end = {
                    opacity: c,
                    transform: `scale(${h})`,
                  }));
              })(e, i, t));
    }
  ),
    (window.Element.prototype._x_toggleAndCascadeWithTransitions = function (
      e,
      t,
      i,
      s
    ) {
      const r =
        "visible" === document.visibilityState
          ? requestAnimationFrame
          : setTimeout;
      let n = () => r(i);
      t
        ? e._x_transition && (e._x_transition.enter || e._x_transition.leave)
          ? e._x_transition.enter &&
            (Object.entries(e._x_transition.enter.during).length ||
              Object.entries(e._x_transition.enter.start).length ||
              Object.entries(e._x_transition.enter.end).length)
            ? e._x_transition.in(i)
            : n()
          : e._x_transition
          ? e._x_transition.in(i)
          : n()
        : ((e._x_hidePromise = e._x_transition
            ? new Promise((t, i) => {
                e._x_transition.out(
                  () => {},
                  () => t(s)
                ),
                  e._x_transitioning.beforeCancel(() =>
                    i({ isFromCancelledTransition: !0 })
                  );
              })
            : Promise.resolve(s)),
          queueMicrotask(() => {
            let t = $m(e);
            t
              ? (t._x_hideChildren || (t._x_hideChildren = []),
                t._x_hideChildren.push(e))
              : r(() => {
                  let t = (e) => {
                    let i = Promise.all([
                      e._x_hidePromise,
                      ...(e._x_hideChildren || []).map(t),
                    ]).then(([e]) => e());
                    return delete e._x_hidePromise, delete e._x_hideChildren, i;
                  };
                  t(e).catch((e) => {
                    if (!e.isFromCancelledTransition) throw e;
                  });
                });
          }));
    });
  var Dm = !1;
  function Om(e, t = () => {}) {
    return (...i) => (Dm ? t(...i) : e(...i));
  }
  function Hm(e, t, i, s = []) {
    switch (
      (e._x_bindings || (e._x_bindings = Ju({})),
      (e._x_bindings[t] = i),
      (t = s.includes("camel")
        ? t.toLowerCase().replace(/-(\w)/g, (e, t) => t.toUpperCase())
        : t))
    ) {
      case "value":
        !(function (e, t) {
          if ("radio" === e.type)
            void 0 === e.attributes.value && (e.value = t),
              window.fromModel && (e.checked = Bm(e.value, t));
          else if ("checkbox" === e.type)
            Number.isInteger(t)
              ? (e.value = t)
              : Number.isInteger(t) ||
                Array.isArray(t) ||
                "boolean" == typeof t ||
                [null, void 0].includes(t)
              ? Array.isArray(t)
                ? (e.checked = t.some((t) => Bm(t, e.value)))
                : (e.checked = !!t)
              : (e.value = String(t));
          else if ("SELECT" === e.tagName)
            !(function (e, t) {
              const i = [].concat(t).map((e) => e + "");
              Array.from(e.options).forEach((e) => {
                e.selected = i.includes(e.value);
              });
            })(e, t);
          else {
            if (e.value === t) return;
            e.value = t;
          }
        })(e, i);
        break;
      case "style":
        !(function (e, t) {
          e._x_undoAddedStyles && e._x_undoAddedStyles();
          e._x_undoAddedStyles = qm(e, t);
        })(e, i);
        break;
      case "class":
        !(function (e, t) {
          e._x_undoAddedClasses && e._x_undoAddedClasses();
          e._x_undoAddedClasses = _m(e, t);
        })(e, i);
        break;
      case "selected":
      case "checked":
        !(function (e, t, i) {
          Fm(e, t, i),
            (function (e, t, i) {
              e[t] !== i && (e[t] = i);
            })(e, t, i);
        })(e, t, i);
        break;
      default:
        Fm(e, t, i);
    }
  }
  function Fm(e, t, i) {
    [null, void 0, !1].includes(i) &&
    (function (e) {
      return ![
        "aria-pressed",
        "aria-checked",
        "aria-expanded",
        "aria-selected",
      ].includes(e);
    })(t)
      ? e.removeAttribute(t)
      : (Wm(t) && (i = t),
        (function (e, t, i) {
          e.getAttribute(t) != i && e.setAttribute(t, i);
        })(e, t, i));
  }
  function Bm(e, t) {
    return e == t;
  }
  function Wm(e) {
    return [
      "disabled",
      "checked",
      "required",
      "readonly",
      "hidden",
      "open",
      "selected",
      "autofocus",
      "itemscope",
      "multiple",
      "novalidate",
      "allowfullscreen",
      "allowpaymentrequest",
      "formnovalidate",
      "autoplay",
      "controls",
      "loop",
      "muted",
      "playsinline",
      "default",
      "ismap",
      "reversed",
      "async",
      "defer",
      "nomodule",
    ].includes(e);
  }
  function Nm(e, t, i) {
    let s = e.getAttribute(t);
    return null === s
      ? "function" == typeof i
        ? i()
        : i
      : "" === s || (Wm(t) ? !![t, "true"].includes(s) : s);
  }
  function Rm(e, t) {
    var i;
    return function () {
      var s = this,
        r = arguments,
        n = function () {
          (i = null), e.apply(s, r);
        };
      clearTimeout(i), (i = setTimeout(n, t));
    };
  }
  function jm(e, t) {
    let i;
    return function () {
      let s = this,
        r = arguments;
      i || (e.apply(s, r), (i = !0), setTimeout(() => (i = !1), t));
    };
  }
  var zm = {},
    Vm = !1;
  var Um = {};
  function Gm(e, t, i) {
    let s = [];
    for (; s.length; ) s.pop()();
    let r = Object.entries(t).map(([e, t]) => ({ name: e, value: t })),
      n = Jp(r);
    (r = r.map((e) =>
      n.find((t) => t.name === e.name)
        ? { name: `x-bind:${e.name}`, value: `"${e.value}"` }
        : e
    )),
      Gp(e, r, i).map((e) => {
        s.push(e.runCleanups), e();
      });
  }
  var Jm = {};
  var Qm = {
    get reactive() {
      return Ju;
    },
    get release() {
      return Ku;
    },
    get effect() {
      return Qu;
    },
    get raw() {
      return Yu;
    },
    version: "3.12.3",
    flushAndStopDeferringMutations: function () {
      (wp = !1), Ep(Sp), (Sp = []);
    },
    dontAutoEvaluateFunctions: Op,
    disableEffectScheduling: function (e) {
      (op = !1), e(), (op = !0);
    },
    startObservingMutations: fp,
    stopObservingMutations: gp,
    setReactivityEngine: function (e) {
      (Ju = e.reactive),
        (Ku = e.release),
        (Qu = (t) =>
          e.effect(t, {
            scheduler: (e) => {
              op ? sp(e) : e();
            },
          })),
        (Yu = e.raw);
    },
    closestDataStack: Tp,
    skipDuringClone: Om,
    onlyDuringClone: function (e) {
      return (...t) => Dm && e(...t);
    },
    addRootSelector: gm,
    addInitSelector: ym,
    addScopeToNode: kp,
    deferMutations: function () {
      wp = !0;
    },
    mapAttributes: im,
    evaluateLater: Fp,
    interceptInit: function (e) {
      wm.push(e);
    },
    setEvaluator: function (e) {
      Bp = e;
    },
    mergeProxies: xp,
    extractProp: function (e, t, i, s = !0) {
      if (e._x_bindings && void 0 !== e._x_bindings[t]) return e._x_bindings[t];
      if (e._x_inlineBindings && void 0 !== e._x_inlineBindings[t]) {
        let i = e._x_inlineBindings[t];
        return (i.extract = s), Op(() => Hp(e, i.expression));
      }
      return Nm(e, t, i);
    },
    findClosest: bm,
    closestRoot: vm,
    destroyTree: Em,
    interceptor: Ap,
    transition: Im,
    setStyles: qm,
    mutateDom: bp,
    directive: Up,
    throttle: jm,
    debounce: Rm,
    evaluate: Hp,
    initTree: Sm,
    nextTick: Tm,
    prefixed: zp,
    prefix: function (e) {
      jp = e;
    },
    plugin: function (e) {
      (Array.isArray(e) ? e : [e]).forEach((e) => e(Qm));
    },
    magic: Pp,
    store: function (e, t) {
      if ((Vm || ((zm = Ju(zm)), (Vm = !0)), void 0 === t)) return zm[e];
      (zm[e] = t),
        "object" == typeof t &&
          null !== t &&
          t.hasOwnProperty("init") &&
          "function" == typeof t.init &&
          zm[e].init(),
        _p(zm[e]);
    },
    start: function () {
      var e;
      dm &&
        hm(
          "Alpine has already been initialized on this page. Calling Alpine.start() more than once can cause problems."
        ),
        (dm = !0),
        document.body ||
          hm(
            "Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?"
          ),
        lm(document, "alpine:init"),
        lm(document, "alpine:initializing"),
        fp(),
        (e = (e) => Sm(e, cm)),
        hp.push(e),
        dp((e) => Em(e)),
        (function (e) {
          lp.push(e);
        })((e, t) => {
          Gp(e, t).forEach((e) => e());
        }),
        Array.from(document.querySelectorAll(fm()))
          .filter((e) => !vm(e.parentElement, !0))
          .forEach((e) => {
            Sm(e);
          }),
        lm(document, "alpine:initialized");
    },
    clone: function (e, t) {
      t._x_dataStack || (t._x_dataStack = e._x_dataStack),
        (Dm = !0),
        (function (e) {
          let t = Qu;
          ap((e, i) => {
            let s = t(e);
            return Ku(s), () => {};
          }),
            e(),
            ap(t);
        })(() => {
          !(function (e) {
            let t = !1;
            Sm(e, (e, i) => {
              cm(e, (e, s) => {
                if (
                  t &&
                  (function (e) {
                    return mm().some((t) => e.matches(t));
                  })(e)
                )
                  return s();
                (t = !0), i(e, s);
              });
            });
          })(t);
        }),
        (Dm = !1);
    },
    bound: function (e, t, i) {
      return e._x_bindings && void 0 !== e._x_bindings[t]
        ? e._x_bindings[t]
        : Nm(e, t, i);
    },
    $data: Lp,
    walk: cm,
    data: function (e, t) {
      Jm[e] = t;
    },
    bind: function (e, t) {
      let i = "function" != typeof t ? () => t : t;
      e instanceof Element ? Gm(e, i()) : (Um[e] = i);
    },
  };
  function Km(e, t) {
    const i = Object.create(null),
      s = e.split(",");
    for (let e = 0; e < s.length; e++) i[s[e]] = !0;
    return t ? (e) => !!i[e.toLowerCase()] : (e) => !!i[e];
  }
  var Ym = Object.freeze({});
  Object.freeze([]);
  var Xm,
    Zm = Object.assign,
    ef = Object.prototype.hasOwnProperty,
    tf = (e, t) => ef.call(e, t),
    sf = Array.isArray,
    rf = (e) => "[object Map]" === lf(e),
    nf = (e) => "symbol" == typeof e,
    of = (e) => null !== e && "object" == typeof e,
    af = Object.prototype.toString,
    lf = (e) => af.call(e),
    cf = (e) => lf(e).slice(8, -1),
    hf = (e) =>
      "string" == typeof e &&
      "NaN" !== e &&
      "-" !== e[0] &&
      "" + parseInt(e, 10) === e,
    df = ((e) => {
      const t = Object.create(null);
      return (i) => t[i] || (t[i] = e(i));
    })((e) => e.charAt(0).toUpperCase() + e.slice(1)),
    uf = (e, t) => e !== t && (e == e || t == t),
    pf = new WeakMap(),
    mf = [],
    ff = Symbol("iterate"),
    gf = Symbol("Map key iterate");
  var yf = 0;
  function vf(e) {
    const { deps: t } = e;
    if (t.length) {
      for (let i = 0; i < t.length; i++) t[i].delete(e);
      t.length = 0;
    }
  }
  var bf = !0,
    wf = [];
  function Sf() {
    const e = wf.pop();
    bf = void 0 === e || e;
  }
  function Ef(e, t, i) {
    if (!bf || void 0 === Xm) return;
    let s = pf.get(e);
    s || pf.set(e, (s = new Map()));
    let r = s.get(i);
    r || s.set(i, (r = new Set())),
      r.has(Xm) ||
        (r.add(Xm),
        Xm.deps.push(r),
        Xm.options.onTrack &&
          Xm.options.onTrack({ effect: Xm, target: e, type: t, key: i }));
  }
  function Lf(e, t, i, s, r, n) {
    const o = pf.get(e);
    if (!o) return;
    const a = new Set(),
      l = (e) => {
        e &&
          e.forEach((e) => {
            (e !== Xm || e.allowRecurse) && a.add(e);
          });
      };
    if ("clear" === t) o.forEach(l);
    else if ("length" === i && sf(e))
      o.forEach((e, t) => {
        ("length" === t || t >= s) && l(e);
      });
    else
      switch ((void 0 !== i && l(o.get(i)), t)) {
        case "add":
          sf(e)
            ? hf(i) && l(o.get("length"))
            : (l(o.get(ff)), rf(e) && l(o.get(gf)));
          break;
        case "delete":
          sf(e) || (l(o.get(ff)), rf(e) && l(o.get(gf)));
          break;
        case "set":
          rf(e) && l(o.get(ff));
      }
    a.forEach((o) => {
      o.options.onTrigger &&
        o.options.onTrigger({
          effect: o,
          target: e,
          key: i,
          type: t,
          newValue: s,
          oldValue: r,
          oldTarget: n,
        }),
        o.options.scheduler ? o.options.scheduler(o) : o();
    });
  }
  var kf = Km("__proto__,__v_isRef,__isVue"),
    Tf = new Set(
      Object.getOwnPropertyNames(Symbol)
        .map((e) => Symbol[e])
        .filter(nf)
    ),
    xf = Pf(),
    _f = Pf(!1, !0),
    Af = Pf(!0),
    qf = Pf(!0, !0),
    Cf = {};
  function Pf(e = !1, t = !1) {
    return function (i, s, r) {
      if ("__v_isReactive" === s) return !e;
      if ("__v_isReadonly" === s) return e;
      if ("__v_raw" === s && r === (e ? (t ? og : ng) : t ? rg : sg).get(i))
        return i;
      const n = sf(i);
      if (!e && n && tf(Cf, s)) return Reflect.get(Cf, s, r);
      const o = Reflect.get(i, s, r);
      if (nf(s) ? Tf.has(s) : kf(s)) return o;
      if ((e || Ef(i, "get", s), t)) return o;
      if (dg(o)) {
        return !n || !hf(s) ? o.value : o;
      }
      return of(o) ? (e ? lg(o) : ag(o)) : o;
    };
  }
  function $f(e = !1) {
    return function (t, i, s, r) {
      let n = t[i];
      if (!e && ((s = hg(s)), (n = hg(n)), !sf(t) && dg(n) && !dg(s)))
        return (n.value = s), !0;
      const o = sf(t) && hf(i) ? Number(i) < t.length : tf(t, i),
        a = Reflect.set(t, i, s, r);
      return (
        t === hg(r) &&
          (o ? uf(s, n) && Lf(t, "set", i, s, n) : Lf(t, "add", i, s)),
        a
      );
    };
  }
  ["includes", "indexOf", "lastIndexOf"].forEach((e) => {
    const t = Array.prototype[e];
    Cf[e] = function (...e) {
      const i = hg(this);
      for (let e = 0, t = this.length; e < t; e++) Ef(i, "get", e + "");
      const s = t.apply(i, e);
      return -1 === s || !1 === s ? t.apply(i, e.map(hg)) : s;
    };
  }),
    ["push", "pop", "shift", "unshift", "splice"].forEach((e) => {
      const t = Array.prototype[e];
      Cf[e] = function (...e) {
        wf.push(bf), (bf = !1);
        const i = t.apply(this, e);
        return Sf(), i;
      };
    });
  var If = {
      get: xf,
      set: $f(),
      deleteProperty: function (e, t) {
        const i = tf(e, t),
          s = e[t],
          r = Reflect.deleteProperty(e, t);
        return r && i && Lf(e, "delete", t, void 0, s), r;
      },
      has: function (e, t) {
        const i = Reflect.has(e, t);
        return (nf(t) && Tf.has(t)) || Ef(e, "has", t), i;
      },
      ownKeys: function (e) {
        return Ef(e, "iterate", sf(e) ? "length" : ff), Reflect.ownKeys(e);
      },
    },
    Mf = {
      get: Af,
      set: (e, t) => (
        console.warn(
          `Set operation on key "${String(t)}" failed: target is readonly.`,
          e
        ),
        !0
      ),
      deleteProperty: (e, t) => (
        console.warn(
          `Delete operation on key "${String(t)}" failed: target is readonly.`,
          e
        ),
        !0
      ),
    };
  Zm({}, If, { get: _f, set: $f(!0) }), Zm({}, Mf, { get: qf });
  var Df = (e) => (of(e) ? ag(e) : e),
    Of = (e) => (of(e) ? lg(e) : e),
    Hf = (e) => e,
    Ff = (e) => Reflect.getPrototypeOf(e);
  function Bf(e, t, i = !1, s = !1) {
    const r = hg((e = e.__v_raw)),
      n = hg(t);
    t !== n && !i && Ef(r, "get", t), !i && Ef(r, "get", n);
    const { has: o } = Ff(r),
      a = s ? Hf : i ? Of : Df;
    return o.call(r, t)
      ? a(e.get(t))
      : o.call(r, n)
      ? a(e.get(n))
      : void (e !== r && e.get(t));
  }
  function Wf(e, t = !1) {
    const i = this.__v_raw,
      s = hg(i),
      r = hg(e);
    return (
      e !== r && !t && Ef(s, "has", e),
      !t && Ef(s, "has", r),
      e === r ? i.has(e) : i.has(e) || i.has(r)
    );
  }
  function Nf(e, t = !1) {
    return (
      (e = e.__v_raw), !t && Ef(hg(e), "iterate", ff), Reflect.get(e, "size", e)
    );
  }
  function Rf(e) {
    e = hg(e);
    const t = hg(this);
    return Ff(t).has.call(t, e) || (t.add(e), Lf(t, "add", e, e)), this;
  }
  function jf(e, t) {
    t = hg(t);
    const i = hg(this),
      { has: s, get: r } = Ff(i);
    let n = s.call(i, e);
    n ? ig(i, s, e) : ((e = hg(e)), (n = s.call(i, e)));
    const o = r.call(i, e);
    return (
      i.set(e, t),
      n ? uf(t, o) && Lf(i, "set", e, t, o) : Lf(i, "add", e, t),
      this
    );
  }
  function zf(e) {
    const t = hg(this),
      { has: i, get: s } = Ff(t);
    let r = i.call(t, e);
    r ? ig(t, i, e) : ((e = hg(e)), (r = i.call(t, e)));
    const n = s ? s.call(t, e) : void 0,
      o = t.delete(e);
    return r && Lf(t, "delete", e, void 0, n), o;
  }
  function Vf() {
    const e = hg(this),
      t = 0 !== e.size,
      i = rf(e) ? new Map(e) : new Set(e),
      s = e.clear();
    return t && Lf(e, "clear", void 0, void 0, i), s;
  }
  function Uf(e, t) {
    return function (i, s) {
      const r = this,
        n = r.__v_raw,
        o = hg(n),
        a = t ? Hf : e ? Of : Df;
      return (
        !e && Ef(o, "iterate", ff),
        n.forEach((e, t) => i.call(s, a(e), a(t), r))
      );
    };
  }
  function Gf(e, t, i) {
    return function (...s) {
      const r = this.__v_raw,
        n = hg(r),
        o = rf(n),
        a = "entries" === e || (e === Symbol.iterator && o),
        l = "keys" === e && o,
        c = r[e](...s),
        h = i ? Hf : t ? Of : Df;
      return (
        !t && Ef(n, "iterate", l ? gf : ff),
        {
          next() {
            const { value: e, done: t } = c.next();
            return t
              ? { value: e, done: t }
              : { value: a ? [h(e[0]), h(e[1])] : h(e), done: t };
          },
          [Symbol.iterator]() {
            return this;
          },
        }
      );
    };
  }
  function Jf(e) {
    return function (...t) {
      {
        const i = t[0] ? `on key "${t[0]}" ` : "";
        console.warn(
          `${df(e)} operation ${i}failed: target is readonly.`,
          hg(this)
        );
      }
      return "delete" !== e && this;
    };
  }
  var Qf = {
      get(e) {
        return Bf(this, e);
      },
      get size() {
        return Nf(this);
      },
      has: Wf,
      add: Rf,
      set: jf,
      delete: zf,
      clear: Vf,
      forEach: Uf(!1, !1),
    },
    Kf = {
      get(e) {
        return Bf(this, e, !1, !0);
      },
      get size() {
        return Nf(this);
      },
      has: Wf,
      add: Rf,
      set: jf,
      delete: zf,
      clear: Vf,
      forEach: Uf(!1, !0),
    },
    Yf = {
      get(e) {
        return Bf(this, e, !0);
      },
      get size() {
        return Nf(this, !0);
      },
      has(e) {
        return Wf.call(this, e, !0);
      },
      add: Jf("add"),
      set: Jf("set"),
      delete: Jf("delete"),
      clear: Jf("clear"),
      forEach: Uf(!0, !1),
    },
    Xf = {
      get(e) {
        return Bf(this, e, !0, !0);
      },
      get size() {
        return Nf(this, !0);
      },
      has(e) {
        return Wf.call(this, e, !0);
      },
      add: Jf("add"),
      set: Jf("set"),
      delete: Jf("delete"),
      clear: Jf("clear"),
      forEach: Uf(!0, !0),
    };
  function Zf(e, t) {
    const i = t ? (e ? Xf : Kf) : e ? Yf : Qf;
    return (t, s, r) =>
      "__v_isReactive" === s
        ? !e
        : "__v_isReadonly" === s
        ? e
        : "__v_raw" === s
        ? t
        : Reflect.get(tf(i, s) && s in t ? i : t, s, r);
  }
  ["keys", "values", "entries", Symbol.iterator].forEach((e) => {
    (Qf[e] = Gf(e, !1, !1)),
      (Yf[e] = Gf(e, !0, !1)),
      (Kf[e] = Gf(e, !1, !0)),
      (Xf[e] = Gf(e, !0, !0));
  });
  var eg = { get: Zf(!1, !1) },
    tg = { get: Zf(!0, !1) };
  function ig(e, t, i) {
    const s = hg(i);
    if (s !== i && t.call(e, s)) {
      const t = cf(e);
      console.warn(
        `Reactive ${t} contains both the raw and reactive versions of the same object${
          "Map" === t ? " as keys" : ""
        }, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`
      );
    }
  }
  var sg = new WeakMap(),
    rg = new WeakMap(),
    ng = new WeakMap(),
    og = new WeakMap();
  function ag(e) {
    return e && e.__v_isReadonly ? e : cg(e, !1, If, eg, sg);
  }
  function lg(e) {
    return cg(e, !0, Mf, tg, ng);
  }
  function cg(e, t, i, s, r) {
    if (!of(e))
      return console.warn(`value cannot be made reactive: ${String(e)}`), e;
    if (e.__v_raw && (!t || !e.__v_isReactive)) return e;
    const n = r.get(e);
    if (n) return n;
    const o =
      (a = e).__v_skip || !Object.isExtensible(a)
        ? 0
        : (function (e) {
            switch (e) {
              case "Object":
              case "Array":
                return 1;
              case "Map":
              case "Set":
              case "WeakMap":
              case "WeakSet":
                return 2;
              default:
                return 0;
            }
          })(cf(a));
    var a;
    if (0 === o) return e;
    const l = new Proxy(e, 2 === o ? s : i);
    return r.set(e, l), l;
  }
  function hg(e) {
    return (e && hg(e.__v_raw)) || e;
  }
  function dg(e) {
    return Boolean(e && !0 === e.__v_isRef);
  }
  Pp("nextTick", () => Tm),
    Pp("dispatch", (e) => lm.bind(lm, e)),
    Pp("watch", (e, { evaluateLater: t, effect: i }) => (s, r) => {
      let n,
        o = t(s),
        a = !0,
        l = i(() =>
          o((e) => {
            JSON.stringify(e),
              a
                ? (n = e)
                : queueMicrotask(() => {
                    r(e, n), (n = e);
                  }),
              (a = !1);
          })
        );
      e._x_effects.delete(l);
    }),
    Pp("store", function () {
      return zm;
    }),
    Pp("data", (e) => Lp(e)),
    Pp("root", (e) => vm(e)),
    Pp(
      "refs",
      (e) => (
        e._x_refs_proxy ||
          (e._x_refs_proxy = xp(
            (function (e) {
              let t = [],
                i = e;
              for (; i; ) i._x_refs && t.push(i._x_refs), (i = i.parentNode);
              return t;
            })(e)
          )),
        e._x_refs_proxy
      )
    );
  var ug = {};
  function pg(e) {
    return ug[e] || (ug[e] = 0), ++ug[e];
  }
  function mg(e, t, i) {
    Pp(t, (t) =>
      hm(
        `You can't use [$${directiveName}] without first installing the "${e}" plugin here: https://alpinejs.dev/plugins/${i}`,
        t
      )
    );
  }
  Pp("id", (e) => (t, i = null) => {
    let s = (function (e, t) {
        return bm(e, (e) => {
          if (e._x_ids && e._x_ids[t]) return !0;
        });
      })(e, t),
      r = s ? s._x_ids[t] : pg(t);
    return i ? `${t}-${r}-${i}` : `${t}-${r}`;
  }),
    Pp("el", (e) => e),
    mg("Focus", "focus", "focus"),
    mg("Persist", "persist", "persist"),
    Up(
      "modelable",
      (e, { expression: t }, { effect: i, evaluateLater: s, cleanup: r }) => {
        let n = s(t),
          o = () => {
            let e;
            return n((t) => (e = t)), e;
          },
          a = s(`${t} = __placeholder`),
          l = (e) => a(() => {}, { scope: { __placeholder: e } }),
          c = o();
        l(c),
          queueMicrotask(() => {
            if (!e._x_model) return;
            e._x_removeModelListeners.default();
            let t = e._x_model.get,
              i = e._x_model.set,
              s = (function ({ get: e, set: t }, { get: i, set: s }) {
                let r,
                  n,
                  o = !0,
                  a = Qu(() => {
                    let a, l;
                    o
                      ? ((a = e()), s(a), (l = i()), (o = !1))
                      : ((a = e()),
                        (l = i()),
                        (n = JSON.stringify(a)),
                        JSON.stringify(l),
                        n !== r ? ((l = i()), s(a), (l = a)) : (t(l), (a = l))),
                      (r = JSON.stringify(a)),
                      JSON.stringify(l);
                  });
                return () => {
                  Ku(a);
                };
              })(
                {
                  get: () => t(),
                  set(e) {
                    i(e);
                  },
                },
                {
                  get: () => o(),
                  set(e) {
                    l(e);
                  },
                }
              );
            r(s);
          });
      }
    );
  var fg = document.createElement("div");
  Up("teleport", (e, { modifiers: t, expression: i }, { cleanup: s }) => {
    "template" !== e.tagName.toLowerCase() &&
      hm("x-teleport can only be used on a <template> tag", e);
    let r = Om(
      () => document.querySelector(i),
      () => fg
    )();
    r || hm(`Cannot find x-teleport element for selector: "${i}"`);
    let n = e.content.cloneNode(!0).firstElementChild;
    (e._x_teleport = n),
      (n._x_teleportBack = e),
      e._x_forwardEvents &&
        e._x_forwardEvents.forEach((t) => {
          n.addEventListener(t, (t) => {
            t.stopPropagation(), e.dispatchEvent(new t.constructor(t.type, t));
          });
        }),
      kp(n, {}, e),
      bp(() => {
        t.includes("prepend")
          ? r.parentNode.insertBefore(n, r)
          : t.includes("append")
          ? r.parentNode.insertBefore(n, r.nextSibling)
          : r.appendChild(n),
          Sm(n),
          (n._x_ignore = !0);
      }),
      s(() => n.remove());
  });
  var gg = () => {};
  function yg(e, t, i, s) {
    let r = e,
      n = (e) => s(e),
      o = {},
      a = (e, t) => (i) => t(e, i);
    if (
      (i.includes("dot") && (t = t.replace(/-/g, ".")),
      i.includes("camel") &&
        (t = (function (e) {
          return e.toLowerCase().replace(/-(\w)/g, (e, t) => t.toUpperCase());
        })(t)),
      i.includes("passive") && (o.passive = !0),
      i.includes("capture") && (o.capture = !0),
      i.includes("window") && (r = window),
      i.includes("document") && (r = document),
      i.includes("debounce"))
    ) {
      let e = i[i.indexOf("debounce") + 1] || "invalid-wait",
        t = vg(e.split("ms")[0]) ? Number(e.split("ms")[0]) : 250;
      n = Rm(n, t);
    }
    if (i.includes("throttle")) {
      let e = i[i.indexOf("throttle") + 1] || "invalid-wait",
        t = vg(e.split("ms")[0]) ? Number(e.split("ms")[0]) : 250;
      n = jm(n, t);
    }
    return (
      i.includes("prevent") &&
        (n = a(n, (e, t) => {
          t.preventDefault(), e(t);
        })),
      i.includes("stop") &&
        (n = a(n, (e, t) => {
          t.stopPropagation(), e(t);
        })),
      i.includes("self") &&
        (n = a(n, (t, i) => {
          i.target === e && t(i);
        })),
      (i.includes("away") || i.includes("outside")) &&
        ((r = document),
        (n = a(n, (t, i) => {
          e.contains(i.target) ||
            (!1 !== i.target.isConnected &&
              ((e.offsetWidth < 1 && e.offsetHeight < 1) ||
                (!1 !== e._x_isShown && t(i))));
        }))),
      i.includes("once") &&
        (n = a(n, (e, i) => {
          e(i), r.removeEventListener(t, n, o);
        })),
      (n = a(n, (e, s) => {
        ((function (e) {
          return ["keydown", "keyup"].includes(e);
        })(t) &&
          (function (e, t) {
            let i = t.filter(
              (e) =>
                ![
                  "window",
                  "document",
                  "prevent",
                  "stop",
                  "once",
                  "capture",
                ].includes(e)
            );
            if (i.includes("debounce")) {
              let e = i.indexOf("debounce");
              i.splice(
                e,
                vg((i[e + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1
              );
            }
            if (i.includes("throttle")) {
              let e = i.indexOf("throttle");
              i.splice(
                e,
                vg((i[e + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1
              );
            }
            if (0 === i.length) return !1;
            if (1 === i.length && bg(e.key).includes(i[0])) return !1;
            const s = ["ctrl", "shift", "alt", "meta", "cmd", "super"].filter(
              (e) => i.includes(e)
            );
            if (((i = i.filter((e) => !s.includes(e))), s.length > 0)) {
              if (
                s.filter(
                  (t) => (
                    ("cmd" !== t && "super" !== t) || (t = "meta"), e[`${t}Key`]
                  )
                ).length === s.length &&
                bg(e.key).includes(i[0])
              )
                return !1;
            }
            return !0;
          })(s, i)) ||
          e(s);
      })),
      r.addEventListener(t, n, o),
      () => {
        r.removeEventListener(t, n, o);
      }
    );
  }
  function vg(e) {
    return !Array.isArray(e) && !isNaN(e);
  }
  function bg(e) {
    if (!e) return [];
    var t;
    e = [" ", "_"].includes((t = e))
      ? t
      : t
          .replace(/([a-z])([A-Z])/g, "$1-$2")
          .replace(/[_\s]/, "-")
          .toLowerCase();
    let i = {
      ctrl: "control",
      slash: "/",
      space: " ",
      spacebar: " ",
      cmd: "meta",
      esc: "escape",
      up: "arrow-up",
      down: "arrow-down",
      left: "arrow-left",
      right: "arrow-right",
      period: ".",
      equal: "=",
      minus: "-",
      underscore: "_",
    };
    return (
      (i[e] = e),
      Object.keys(i)
        .map((t) => {
          if (i[t] === e) return t;
        })
        .filter((e) => e)
    );
  }
  function wg(e) {
    let t = e ? parseFloat(e) : null;
    return (i = t), Array.isArray(i) || isNaN(i) ? e : t;
    var i;
  }
  function Sg(e) {
    return (
      null !== e &&
      "object" == typeof e &&
      "function" == typeof e.get &&
      "function" == typeof e.set
    );
  }
  (gg.inline = (e, { modifiers: t }, { cleanup: i }) => {
    t.includes("self") ? (e._x_ignoreSelf = !0) : (e._x_ignore = !0),
      i(() => {
        t.includes("self") ? delete e._x_ignoreSelf : delete e._x_ignore;
      });
  }),
    Up("ignore", gg),
    Up("effect", (e, { expression: t }, { effect: i }) => i(Fp(e, t))),
    Up(
      "model",
      (e, { modifiers: t, expression: i }, { effect: s, cleanup: r }) => {
        let n = e;
        t.includes("parent") && (n = e.parentNode);
        let o,
          a = Fp(n, i);
        o =
          "string" == typeof i
            ? Fp(n, `${i} = __placeholder`)
            : "function" == typeof i && "string" == typeof i()
            ? Fp(n, `${i()} = __placeholder`)
            : () => {};
        let l = () => {
            let e;
            return a((t) => (e = t)), Sg(e) ? e.get() : e;
          },
          c = (e) => {
            let t;
            a((e) => (t = e)),
              Sg(t) ? t.set(e) : o(() => {}, { scope: { __placeholder: e } });
          };
        "string" == typeof i &&
          "radio" === e.type &&
          bp(() => {
            e.hasAttribute("name") || e.setAttribute("name", i);
          });
        var h =
          "select" === e.tagName.toLowerCase() ||
          ["checkbox", "radio"].includes(e.type) ||
          t.includes("lazy")
            ? "change"
            : "input";
        let d = Dm
          ? () => {}
          : yg(e, h, t, (i) => {
              c(
                (function (e, t, i, s) {
                  return bp(() => {
                    var r;
                    if (i instanceof CustomEvent && void 0 !== i.detail)
                      return null !== (r = i.detail) && void 0 !== r
                        ? r
                        : i.target.value;
                    if ("checkbox" === e.type) {
                      if (Array.isArray(s)) {
                        let e = t.includes("number")
                          ? wg(i.target.value)
                          : i.target.value;
                        return i.target.checked
                          ? s.concat([e])
                          : s.filter((t) => !(t == e));
                      }
                      return i.target.checked;
                    }
                    if ("select" === e.tagName.toLowerCase() && e.multiple)
                      return t.includes("number")
                        ? Array.from(i.target.selectedOptions).map((e) =>
                            wg(e.value || e.text)
                          )
                        : Array.from(i.target.selectedOptions).map(
                            (e) => e.value || e.text
                          );
                    {
                      let e = i.target.value;
                      return t.includes("number")
                        ? wg(e)
                        : t.includes("trim")
                        ? e.trim()
                        : e;
                    }
                  });
                })(e, t, i, l())
              );
            });
        if (
          (t.includes("fill") &&
            [null, ""].includes(l()) &&
            e.dispatchEvent(new Event(h, {})),
          e._x_removeModelListeners || (e._x_removeModelListeners = {}),
          (e._x_removeModelListeners.default = d),
          r(() => e._x_removeModelListeners.default()),
          e.form)
        ) {
          let t = yg(e.form, "reset", [], (t) => {
            Tm(() => e._x_model && e._x_model.set(e.value));
          });
          r(() => t());
        }
        (e._x_model = {
          get: () => l(),
          set(e) {
            c(e);
          },
        }),
          (e._x_forceModelUpdate = (t) => {
            void 0 === (t = void 0 === t ? l() : t) &&
              "string" == typeof i &&
              i.match(/\./) &&
              (t = ""),
              (window.fromModel = !0),
              bp(() => Hm(e, "value", t)),
              delete window.fromModel;
          }),
          s(() => {
            let i = l();
            (t.includes("unintrusive") &&
              document.activeElement.isSameNode(e)) ||
              e._x_forceModelUpdate(i);
          });
      }
    ),
    Up("cloak", (e) =>
      queueMicrotask(() => bp(() => e.removeAttribute(zp("cloak"))))
    ),
    ym(() => `[${zp("init")}]`),
    Up(
      "init",
      Om((e, { expression: t }, { evaluate: i }) =>
        "string" == typeof t ? !!t.trim() && i(t, {}, !1) : i(t, {}, !1)
      )
    ),
    Up("text", (e, { expression: t }, { effect: i, evaluateLater: s }) => {
      let r = s(t);
      i(() => {
        r((t) => {
          bp(() => {
            e.textContent = t;
          });
        });
      });
    }),
    Up("html", (e, { expression: t }, { effect: i, evaluateLater: s }) => {
      let r = s(t);
      i(() => {
        r((t) => {
          bp(() => {
            (e.innerHTML = t),
              (e._x_ignoreSelf = !0),
              Sm(e),
              delete e._x_ignoreSelf;
          });
        });
      });
    }),
    im(Zp(":", zp("bind:")));
  var Eg = (
    e,
    { value: t, modifiers: i, expression: s, original: r },
    { effect: n }
  ) => {
    if (!t) {
      let t = {};
      return (
        (o = t),
        Object.entries(Um).forEach(([e, t]) => {
          Object.defineProperty(o, e, {
            get:
              () =>
              (...e) =>
                t(...e),
          });
        }),
        void Fp(e, s)(
          (t) => {
            Gm(e, t, r);
          },
          { scope: t }
        )
      );
    }
    var o;
    if ("key" === t)
      return (function (e, t) {
        e._x_keyExpression = t;
      })(e, s);
    if (
      e._x_inlineBindings &&
      e._x_inlineBindings[t] &&
      e._x_inlineBindings[t].extract
    )
      return;
    let a = Fp(e, s);
    n(() =>
      a((r) => {
        void 0 === r && "string" == typeof s && s.match(/\./) && (r = ""),
          bp(() => Hm(e, t, r, i));
      })
    );
  };
  function Lg(e, t, i, s) {
    let r = {};
    if (/^\[.*\]$/.test(e.item) && Array.isArray(t)) {
      e.item
        .replace("[", "")
        .replace("]", "")
        .split(",")
        .map((e) => e.trim())
        .forEach((e, i) => {
          r[e] = t[i];
        });
    } else if (
      /^\{.*\}$/.test(e.item) &&
      !Array.isArray(t) &&
      "object" == typeof t
    ) {
      e.item
        .replace("{", "")
        .replace("}", "")
        .split(",")
        .map((e) => e.trim())
        .forEach((e) => {
          r[e] = t[e];
        });
    } else r[e.item] = t;
    return (
      e.index && (r[e.index] = i), e.collection && (r[e.collection] = s), r
    );
  }
  function kg() {}
  function Tg(e, t, i) {
    Up(t, (s) =>
      hm(
        `You can't use [x-${t}] without first installing the "${e}" plugin here: https://alpinejs.dev/plugins/${i}`,
        s
      )
    );
  }
  (Eg.inline = (e, { value: t, modifiers: i, expression: s }) => {
    t &&
      (e._x_inlineBindings || (e._x_inlineBindings = {}),
      (e._x_inlineBindings[t] = { expression: s, extract: !1 }));
  }),
    Up("bind", Eg),
    gm(() => `[${zp("data")}]`),
    Up(
      "data",
      Om((e, { expression: t }, { cleanup: i }) => {
        t = "" === t ? "{}" : t;
        let s = {};
        $p(s, e);
        let r = {};
        var n, o;
        (n = r),
          (o = s),
          Object.entries(Jm).forEach(([e, t]) => {
            Object.defineProperty(n, e, {
              get:
                () =>
                (...e) =>
                  t.bind(o)(...e),
              enumerable: !1,
            });
          });
        let a = Hp(e, t, { scope: r });
        (void 0 !== a && !0 !== a) || (a = {}), $p(a, e);
        let l = Ju(a);
        _p(l);
        let c = kp(e, l);
        l.init && Hp(e, l.init),
          i(() => {
            l.destroy && Hp(e, l.destroy), c();
          });
      })
    ),
    Up("show", (e, { modifiers: t, expression: i }, { effect: s }) => {
      let r = Fp(e, i);
      e._x_doHide ||
        (e._x_doHide = () => {
          bp(() => {
            e.style.setProperty(
              "display",
              "none",
              t.includes("important") ? "important" : void 0
            );
          });
        }),
        e._x_doShow ||
          (e._x_doShow = () => {
            bp(() => {
              1 === e.style.length && "none" === e.style.display
                ? e.removeAttribute("style")
                : e.style.removeProperty("display");
            });
          });
      let n,
        o = () => {
          e._x_doHide(), (e._x_isShown = !1);
        },
        a = () => {
          e._x_doShow(), (e._x_isShown = !0);
        },
        l = () => setTimeout(a),
        c = Cm(
          (e) => (e ? a() : o()),
          (t) => {
            "function" == typeof e._x_toggleAndCascadeWithTransitions
              ? e._x_toggleAndCascadeWithTransitions(e, t, a, o)
              : t
              ? l()
              : o();
          }
        ),
        h = !0;
      s(() =>
        r((e) => {
          (h || e !== n) &&
            (t.includes("immediate") && (e ? l() : o()),
            c(e),
            (n = e),
            (h = !1));
        })
      );
    }),
    Up("for", (e, { expression: t }, { effect: i, cleanup: s }) => {
      let r = (function (e) {
          let t = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/,
            i = /^\s*\(|\)\s*$/g,
            s = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/,
            r = e.match(s);
          if (!r) return;
          let n = {};
          n.items = r[2].trim();
          let o = r[1].replace(i, "").trim(),
            a = o.match(t);
          a
            ? ((n.item = o.replace(t, "").trim()),
              (n.index = a[1].trim()),
              a[2] && (n.collection = a[2].trim()))
            : (n.item = o);
          return n;
        })(t),
        n = Fp(e, r.items),
        o = Fp(e, e._x_keyExpression || "index");
      (e._x_prevKeys = []),
        (e._x_lookup = {}),
        i(() =>
          (function (e, t, i, s) {
            let r = (e) => "object" == typeof e && !Array.isArray(e),
              n = e;
            i((i) => {
              var o;
              (o = i),
                !Array.isArray(o) &&
                  !isNaN(o) &&
                  i >= 0 &&
                  (i = Array.from(Array(i).keys(), (e) => e + 1)),
                void 0 === i && (i = []);
              let a = e._x_lookup,
                l = e._x_prevKeys,
                c = [],
                h = [];
              if (r(i))
                i = Object.entries(i).map(([e, r]) => {
                  let n = Lg(t, r, e, i);
                  s((e) => h.push(e), { scope: { index: e, ...n } }), c.push(n);
                });
              else
                for (let e = 0; e < i.length; e++) {
                  let r = Lg(t, i[e], e, i);
                  s((e) => h.push(e), { scope: { index: e, ...r } }), c.push(r);
                }
              let d = [],
                u = [],
                p = [],
                m = [];
              for (let e = 0; e < l.length; e++) {
                let t = l[e];
                -1 === h.indexOf(t) && p.push(t);
              }
              l = l.filter((e) => !p.includes(e));
              let f = "template";
              for (let e = 0; e < h.length; e++) {
                let t = h[e],
                  i = l.indexOf(t);
                if (-1 === i) l.splice(e, 0, t), d.push([f, e]);
                else if (i !== e) {
                  let t = l.splice(e, 1)[0],
                    s = l.splice(i - 1, 1)[0];
                  l.splice(e, 0, s), l.splice(i, 0, t), u.push([t, s]);
                } else m.push(t);
                f = t;
              }
              for (let e = 0; e < p.length; e++) {
                let t = p[e];
                a[t]._x_effects && a[t]._x_effects.forEach(rp),
                  a[t].remove(),
                  (a[t] = null),
                  delete a[t];
              }
              for (let e = 0; e < u.length; e++) {
                let [t, i] = u[e],
                  s = a[t],
                  r = a[i],
                  o = document.createElement("div");
                bp(() => {
                  r || hm('x-for ":key" is undefined or invalid', n),
                    r.after(o),
                    s.after(r),
                    r._x_currentIfEl && r.after(r._x_currentIfEl),
                    o.before(s),
                    s._x_currentIfEl && s.after(s._x_currentIfEl),
                    o.remove();
                }),
                  r._x_refreshXForScope(c[h.indexOf(i)]);
              }
              for (let e = 0; e < d.length; e++) {
                let [t, i] = d[e],
                  s = "template" === t ? n : a[t];
                s._x_currentIfEl && (s = s._x_currentIfEl);
                let r = c[i],
                  o = h[i],
                  l = document.importNode(n.content, !0).firstElementChild,
                  u = Ju(r);
                kp(l, u, n),
                  (l._x_refreshXForScope = (e) => {
                    Object.entries(e).forEach(([e, t]) => {
                      u[e] = t;
                    });
                  }),
                  bp(() => {
                    s.after(l), Sm(l);
                  }),
                  "object" == typeof o &&
                    hm(
                      "x-for key cannot be an object, it must be a string or an integer",
                      n
                    ),
                  (a[o] = l);
              }
              for (let e = 0; e < m.length; e++)
                a[m[e]]._x_refreshXForScope(c[h.indexOf(m[e])]);
              n._x_prevKeys = h;
            });
          })(e, r, n, o)
        ),
        s(() => {
          Object.values(e._x_lookup).forEach((e) => e.remove()),
            delete e._x_prevKeys,
            delete e._x_lookup;
        });
    }),
    (kg.inline = (e, { expression: t }, { cleanup: i }) => {
      let s = vm(e);
      s._x_refs || (s._x_refs = {}),
        (s._x_refs[t] = e),
        i(() => delete s._x_refs[t]);
    }),
    Up("ref", kg),
    Up("if", (e, { expression: t }, { effect: i, cleanup: s }) => {
      let r = Fp(e, t);
      i(() =>
        r((t) => {
          t
            ? (() => {
                if (e._x_currentIfEl) return e._x_currentIfEl;
                let t = e.content.cloneNode(!0).firstElementChild;
                kp(t, {}, e),
                  bp(() => {
                    e.after(t), Sm(t);
                  }),
                  (e._x_currentIfEl = t),
                  (e._x_undoIf = () => {
                    cm(t, (e) => {
                      e._x_effects && e._x_effects.forEach(rp);
                    }),
                      t.remove(),
                      delete e._x_currentIfEl;
                  });
              })()
            : e._x_undoIf && (e._x_undoIf(), delete e._x_undoIf);
        })
      ),
        s(() => e._x_undoIf && e._x_undoIf());
    }),
    Up("id", (e, { expression: t }, { evaluate: i }) => {
      i(t).forEach((t) =>
        (function (e, t) {
          e._x_ids || (e._x_ids = {}), e._x_ids[t] || (e._x_ids[t] = pg(t));
        })(e, t)
      );
    }),
    im(Zp("@", zp("on:"))),
    Up(
      "on",
      Om((e, { value: t, modifiers: i, expression: s }, { cleanup: r }) => {
        let n = s ? Fp(e, s) : () => {};
        "template" === e.tagName.toLowerCase() &&
          (e._x_forwardEvents || (e._x_forwardEvents = []),
          e._x_forwardEvents.includes(t) || e._x_forwardEvents.push(t));
        let o = yg(e, t, i, (e) => {
          n(() => {}, { scope: { $event: e }, params: [e] });
        });
        r(() => o());
      })
    ),
    Tg("Collapse", "collapse", "collapse"),
    Tg("Intersect", "intersect", "intersect"),
    Tg("Focus", "trap", "focus"),
    Tg("Mask", "mask", "mask"),
    Qm.setEvaluator(Wp),
    Qm.setReactivityEngine({
      reactive: ag,
      effect: function (e, t = Ym) {
        (function (e) {
          return e && !0 === e._isEffect;
        })(e) && (e = e.raw);
        const i = (function (e, t) {
          const i = function () {
            if (!i.active) return e();
            if (!mf.includes(i)) {
              vf(i);
              try {
                return wf.push(bf), (bf = !0), mf.push(i), (Xm = i), e();
              } finally {
                mf.pop(), Sf(), (Xm = mf[mf.length - 1]);
              }
            }
          };
          return (
            (i.id = yf++),
            (i.allowRecurse = !!t.allowRecurse),
            (i._isEffect = !0),
            (i.active = !0),
            (i.raw = e),
            (i.deps = []),
            (i.options = t),
            i
          );
        })(e, t);
        return t.lazy || i(), i;
      },
      release: function (e) {
        e.active &&
          (vf(e), e.options.onStop && e.options.onStop(), (e.active = !1));
      },
      raw: hg,
    });
  var xg = Qm;
  const _g = 0,
    Ag = 1,
    qg = 2,
    Cg = 3,
    Pg = "[data-product-add-popdown-wrapper]",
    $g = "[data-add-action-errors]",
    Ig = "[data-error-boundary]",
    Mg = "[data-error-display]",
    Dg = "[data-quickview-modal]",
    Og = "[data-cart-page-upsell-wrapper]",
    Hg = '[data-section-type="cart"]',
    Fg = '[data-ajax-disable="true"]',
    Bg = { durationAddButtonDisable: 3500, hideErrorTime: 5e3 };
  const Wg = 0,
    Ng = 1,
    Rg = "data-quickview-holder",
    jg = "[data-product-quickview-ajax]",
    zg = "[data-quickview-modal]",
    Vg = "[data-drawer-scrolls]",
    Ug = "[data-quickview-modal-template]",
    Gg = "[data-quickview-head]",
    Jg = "[data-quickview-form-area]",
    Qg = "[data-toggle-button]",
    Kg = "[data-media-slide]",
    Yg = "[data-media-id]",
    Xg = 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
    Zg = "hide",
    ey = "is-active",
    ty = "is-expanded",
    iy = "loading",
    sy = 250,
    ry = 400;
  const ny = '[role="tablist"]',
    oy = '[role="tab"]';
  xg.data("productAddButtonForm", function (e = {}) {
    const t = { ...Bg, ...e.times };
    return {
      state: _g,
      error: "",
      isUpsell: !1,
      isInCartPage: !1,
      get cartPageUpsellWrapper() {
        return this.$el.closest(Og);
      },
      get sectionTypeCart() {
        return this.$el.closest(Hg);
      },
      get form() {
        return this.isUpsell && this.isInCartPage
          ? this.$el.closest("form")
          : this.$el.querySelector("form");
      },
      get button() {
        return this.$el.querySelector("button");
      },
      get popdown() {
        return document.querySelector(Pg);
      },
      get errorDisplay() {
        let e = this.$el.querySelector($g);
        if (!e) {
          const t = this.$el.closest(Ig);
          t && (e = t.querySelector(Mg));
        }
        return e || (e = this.$el.querySelector(Mg)), e;
      },
      get quickViewModal() {
        return this.$el.closest(Dg);
      },
      get isInitial() {
        return this.state === _g;
      },
      get isLoading() {
        return this.state === Ag;
      },
      get isSuccess() {
        return this.state === qg;
      },
      get isError() {
        return this.state === Cg;
      },
      get isDisabled() {
        return this.isLoading;
      },
      get isAjaxDisabled() {
        return !!this.$el.closest(Fg);
      },
      get isInsideQuickViewModal() {
        return Boolean(this.quickViewModal);
      },
      handleClickAddButton(e) {
        const monster_active = !!document.querySelector('script[src*="/cart_renderer."]');
        if(monster_active) return;
        e.preventDefault(), (this.state = Ag);
        const t = new FormData(this.form);
        this.addToCart(t)
          .then(this.handleSuccess.bind(this))
          .catch(this.handleError.bind(this));
      },
      handleSuccess(e) {
        const i = e.data;
        (this.state = qg),
          this.updateHeaderTotal(),
          setTimeout(() => {
            this.state = _g;
          }, t.durationAddButtonDisable),
          this.isInsideQuickViewModal && this.closeQuickView(),
          window.theme.state.cartOpen || this.isInCartPage || this.isOnCartPage
            ? this.reloadCart()
            : this.openPopdown(i);
      },
      handleError(e) {
        if (!(null == e ? void 0 : e.data)) throw e;
        if (
          ((this.state = Cg),
          e.data.description && "string" == typeof e.data.description
            ? (this.error = e.data.description)
            : e.data.message && "string" == typeof e.data.message
            ? (this.error = e.data.message)
            : e.data.description && "object" == typeof e.data.description
            ? (this.error = Object.keys(e.data.description)
                .map((t) => `${t}: ${e.data.description[t]}`)
                .join("<br>"))
            : (this.error = "Network error: please try again"),
          this.errorDisplay)
        ) {
          const e = `<div class="errors">${this.error}</div>`;
          (this.errorDisplay.innerHTML = e),
            Xr(this.errorDisplay),
            setTimeout(() => {
              Zr(this.errorDisplay);
            }, t.hideErrorTime);
        }
      },
      addToCart(e) {
        const monster_active = !!document.querySelector('script[src*="/cart_renderer."]');
        if(monster_active) return;
        const t = `${window.theme.routes.cart}/add.js`,
          i = new URLSearchParams(e).toString();
        return l.post(t, i, {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            "Content-Type": "application/x-www-form-urlencoded",
          },
        });
      },
      updateHeaderTotal: () =>
        l
          .get(`${window.theme.routes.cart}.js`)
          .then((e) => {
            document.dispatchEvent(
              new CustomEvent("theme:cart:change", {
                detail: { cart: e.data },
                bubbles: !0,
              })
            );
          })
          .catch((e) => {
            console.error(e);
          }),
      closeQuickView() {
        this.quickViewModal.dispatchEvent(
          new CustomEvent("theme:quickview:close")
        );
      },
      reloadCart() {
        document.dispatchEvent(
          new CustomEvent("theme:cart:reload", { bubbles: !0 })
        );
      },
      openPopdown(e) {
        this.popdown.dispatchEvent(
          new CustomEvent("theme:cart:popdown", {
            detail: { variant: e },
            bubbles: !0,
          })
        );
      },
      get isInCartPage() {
        return Boolean(this.sectionTypeCart);
      },
      get isOnCartPage() {
        return Boolean(document.body.querySelector(Hg));
      },
      get isUpsell() {
        return Boolean(this.cartPageUpsellWrapper);
      },
      init() {
        this.button.addEventListener(
          "click",
          this.handleClickAddButton.bind(this)
        );
      },
    };
  }),
    xg.data("productQuickViewButton", function (e, t) {
      return {
        state: Wg,
        get quickviewHolder() {
          return this.$el.querySelector(`[${Rg}]`);
        },
        get isInitial() {
          return this.state === Wg;
        },
        get isLoading() {
          return this.state === Ng;
        },
        get isDisabled() {
          return this.isLoading;
        },
        clickQuickviewButton(e) {
          this.modal && this.modalID && (this.modal.id = this.modalID),
            document.documentElement.hasAttribute("data-scroll-locked") &&
              (this.scrollLockEnable = !1),
            (this.state = Ng),
            this.getQuickviewHTML();
        },
        getQuickviewHTML() {
          window
            .fetch(
              `${window.theme.routes.root_url}products/${t}?section_id=api-product-quickview`
            )
            .then(this.handleErrors)
            .then((e) => e.text())
            .then((e) => {
              const t = document.createElement("div");
              (t.innerHTML = e),
                (this.modalContent = this.modal.querySelector(jg)),
                (this.modalContent.innerHTML =
                  t.querySelector("[data-api-content]").innerHTML),
                (this.modalScroll = this.modal.querySelector(Vg));
              const i = this.modalContent.querySelector(Yg);
              if (i) {
                const e = document.createElement("div");
                (e.innerHTML = i.parentElement.innerHTML),
                  this.quickviewHolder.dispatchEvent(
                    new CustomEvent("theme:quickview:media", {
                      bubbles: !0,
                      detail: { media: e },
                    })
                  );
              }
              this.modalCreate(), (this.state = Wg);
            });
        },
        modalCreate() {
          n.show(this.modalID, {
            onShow: (e, t, i) => {
              (this.quickviewHead = e.querySelector(Gg)),
                (this.quickviewFormArea = e.querySelector(Jg)),
                (this.toggleButton = e.querySelector(Qg)),
                this.toggleForm("loading"),
                document.addEventListener(
                  "theme:resize",
                  ha(() => {
                    this.toggleForm("resize");
                  }, 500)
                ),
                this.clickEventToggleForm();
              const s = e.querySelector(Xg);
              ri(e, { elementToFocus: s }),
                this.modal.addEventListener(
                  "theme:quickview:close",
                  this.modalClose
                ),
                document.dispatchEvent(
                  new CustomEvent("theme:scroll:lock", {
                    bubbles: !0,
                    detail: this.modalScroll,
                  })
                ),
                new oh(this.modal);
            },
            onClose: (e, t, i) => {
              e.querySelectorAll(Kg).forEach((e) => {
                e.dispatchEvent(new CustomEvent("pause"));
              }),
                ni(),
                t.focus(),
                this.modal.removeEventListener(
                  "theme:quickview:close",
                  this.modalClose
                ),
                this.scrollLockEnable
                  ? document.dispatchEvent(
                      new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
                    )
                  : (this.scrollLockEnable = !0);
            },
          });
        },
        modalClose() {
          n.close(this.modalID);
        },
        handleErrors: (e) =>
          e.ok
            ? e
            : e.json().then(function (t) {
                throw new N({
                  status: e.statusText,
                  headers: e.headers,
                  json: t,
                });
              }),
        toggleForm(e) {
          (this.windowH === window.innerHeight && "resize" === e) ||
            (this.toggleButton.classList.contains(Zg) ||
              this.toggleButton.classList.add(Zg),
            this.quickviewFormArea.classList.contains(ty) ||
              this.quickviewFormArea.classList.add(ty),
            "resize" === e &&
              (this.quickviewFormArea.classList.add(ty),
              this.toggleButton.classList.add(Zg),
              (this.windowH = window.innerHeight)),
            setTimeout(() => {
              const t =
                  window.innerHeight -
                  this.quickviewHead.offsetHeight -
                  this.quickviewFormArea.offsetHeight,
                i = t < sy;
              (t < ry && t > sy) || i
                ? (this.toggleButton.classList.remove(Zg),
                  this.toggleButton.classList.add(ey))
                : this.toggleButton.classList.add(Zg),
                i
                  ? ("loading" === e &&
                      (this.quickviewFormArea.classList.add(iy),
                      setTimeout(() => {
                        this.quickviewFormArea.classList.remove(iy);
                      }, 50)),
                    this.quickviewFormArea.classList.remove(ty),
                    this.toggleButton.classList.remove(ey))
                  : this.quickviewFormArea.classList.add(ty);
            }, 200));
        },
        clickEventToggleForm() {
          this.toggleButton &&
            this.toggleButton.addEventListener("click", () => {
              this.toggleButton.classList.toggle(ey),
                this.quickviewFormArea.classList.toggle(ty);
            });
        },
        init() {
          if (
            this.quickviewHolder &&
            ((this.modalTemplate = this.quickviewHolder.querySelector(Ug)),
            (this.modal = document.querySelector(zg)),
            (this.modalID = this.quickviewHolder.getAttribute(Rg)),
            (this.modalContent = null),
            (this.modalScroll = null),
            (this.scrollLockEnable = !0),
            (this.windowH = window.innerHeight),
            this.modalTemplate && !this.modal)
          ) {
            const e = this.modalTemplate.innerHTML,
              t = document.createElement("div");
            (t.innerHTML = e),
              (this.modalHtml = t.querySelector(zg)),
              document.body.appendChild(this.modalHtml),
              (this.modal = document.querySelector(zg));
          }
        },
      };
    }),
    xg.data("toggle", function () {
      return {
        isOpen: !1,
        get isClosed() {
          return !this.isOpen;
        },
        toggle() {
          if (this.isOpen) return this.close();
          this.open();
        },
        open() {
          this.isOpen = !0;
        },
        close() {
          this.isOpen && (this.isOpen = !1);
        },
      };
    }),
    xg.data("tabs", function (e = 0) {
      return {
        selectedIndex: null,
        init() {
          this.$nextTick(() => this.select(e));
        },
        get tablist() {
          return this.$el.querySelector(ny);
        },
        get tabs() {
          var e;
          return null === (e = this.tablist) || void 0 === e
            ? void 0
            : e.querySelectorAll(oy);
        },
        getTab(e) {
          var t;
          return null === (t = this.tabs) || void 0 === t ? void 0 : t[e];
        },
        isSelected(e) {
          return this.selectedIndex === e;
        },
        select(e, t = !0) {
          this.selectedIndex = e;
          const i = this.getTab(e);
          i &&
            t &&
            this.tablist.scrollTo({
              top: 0,
              left: i.offsetLeft - i.clientWidth,
              behavior: "smooth",
            });
        },
        bindTabs: { "x-id": "['tab', 'tab-panel']" },
        bindTablist: {
          ":role": "'tablist'",
          "@keydown.right.prevent.stop": "$focus.wrap().next()",
          "@keydown.home.prevent.stop": "$focus.first()",
          "@keydown.page-up.prevent.stop": "$focus.first()",
          "@keydown.left.prevent.stop": "$focus.wrap().prev()",
          "@keydown.end.prevent.stop": "$focus.last()",
          "@keydown.page-down.prevent.stop": "$focus.last()",
        },
        bindTabpanels: {},
        bindTab: (e) => ({
          ":id": `$id('tab', ${e + 1})`,
          ":role": "'tab'",
          "@click": `select(${e})`,
          "@mousedown.prevent": "",
          "@focus": `select(${e})`,
          ":tabindex": `isSelected(${e}) ? 0 : -1`,
          ":aria-selected": `isSelected(${e})`,
          ":aria-controls": `$id('tab-panel', ${e + 1})`,
        }),
        bindTabpanel: (e) => ({
          ":id": `$id('tab-panel', ${e + 1})`,
          ":role": "'tabpanel'",
          "x-show": `isSelected(${e})`,
          ":aria-labelledby": `$id('tab', ${e + 1})`,
        }),
      };
    }),
    xg.data("overflow", function (e = {}) {
      const t = { top: 0, right: 0, bottom: 0, left: 0, ...e.inset };
      return {
        get overflowContainer() {
          return this.$refs.overflowContainer;
        },
        isOverflowing: { top: !1, bottom: !1, left: !1, right: !1 },
        checkOverflow() {
          const e =
              this.overflowContainer.scrollHeight -
              this.overflowContainer.scrollTop -
              t.bottom,
            i =
              this.overflowContainer.scrollWidth -
              this.overflowContainer.scrollLeft -
              t.right;
          (this.isOverflowing.top =
            this.overflowContainer.scrollTop - t.top > 0),
            (this.isOverflowing.bottom =
              e > this.overflowContainer.clientHeight),
            (this.isOverflowing.left =
              this.overflowContainer.scrollLeft - t.left > 0),
            (this.isOverflowing.right = i > this.overflowContainer.clientWidth);
        },
        scrollTo(e) {
          this.overflowContainer.scrollTo(e);
        },
      };
    }),
    xg.magic("nudge", function (e) {
      return (e, { left: t, top: i, ...s }) => {
        e.scrollTo({
          ...(t && {
            left: Math.max(Math.min(e.scrollLeft + t, e.scrollWidth), 0),
          }),
          ...(i && {
            left: Math.max(Math.min(e.scrollTop + i, e.scrollHeight), 0),
          }),
          ...s,
        });
      };
    }),
    xg.directive(
      "hold",
      (e, { modifiers: t, expression: i }, { cleanup: s, evaluate: r }) => {
        let n = null,
          o = t[0] || "",
          a = Number.isInteger(o.split("ms")[0])
            ? Number(o.split("ms")[0])
            : 25;
        const l = () => {
            n = setInterval(() => {
              r(i);
            }, a);
          },
          c = () => {
            clearInterval(n);
          };
        e.addEventListener("mousedown", l),
          e.addEventListener("mouseup", c),
          e.addEventListener("mouseleave", c),
          e.addEventListener("touchstart", l),
          e.addEventListener("touchend", c),
          s(() => {
            e.removeEventListener("mousedown", l),
              e.removeEventListener("mouseup", c),
              e.removeEventListener("mouseleave", c),
              e.removeEventListener("touchstart", l),
              e.removeEventListener("touchend", c);
          });
      }
    ),
    xg.plugin(Xu),
    xg.start(),
    (window.Alpine = xg);
})(
  themeVendor.AOS,
  themeVendor.FlickityFade,
  themeVendor.ScrollLock,
  themeVendor.Flickity,
  themeVendor.Sqrl,
  themeVendor.MicroModal,
  themeVendor.Rellax,
  themeVendor.themeCurrency,
  themeVendor.axios,
  themeVendor.FlickitySync,
  themeVendor.themeAddresses
);

/* Javascript - Show cart drawer when product added to cart */
document.addEventListener("theme:cart:popdown", (e) => {
  document.addEventListener("theme:cart:change", (e) => {
    document.querySelector('[data-drawer="drawer-cart"]').dispatchEvent(
      new CustomEvent("theme:drawer:open", {
        bubbles: false,
      })
    );
  });
});
/* end */
